
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $17751991aa2dcc8b$export$7d04abf91eb22fb;
(function(ShipModelEnum) {
    ShipModelEnum[ShipModelEnum["CobraMk3"] = 0] = "CobraMk3";
    ShipModelEnum[ShipModelEnum["Adder"] = 1] = "Adder";
    ShipModelEnum[ShipModelEnum["Anaconda"] = 2] = "Anaconda";
    ShipModelEnum[ShipModelEnum["Asp"] = 3] = "Asp";
    ShipModelEnum[ShipModelEnum["Asteroid"] = 4] = "Asteroid";
    ShipModelEnum[ShipModelEnum["Boa"] = 5] = "Boa";
    ShipModelEnum[ShipModelEnum["Boulder"] = 6] = "Boulder";
    ShipModelEnum[ShipModelEnum["Cargo"] = 7] = "Cargo";
    ShipModelEnum[ShipModelEnum["CobraMk1"] = 8] = "CobraMk1";
    ShipModelEnum[ShipModelEnum["Constrictor"] = 9] = "Constrictor";
    ShipModelEnum[ShipModelEnum["Coriolis"] = 10] = "Coriolis";
    ShipModelEnum[ShipModelEnum["Dodo"] = 11] = "Dodo";
    ShipModelEnum[ShipModelEnum["EscapePod"] = 12] = "EscapePod";
    ShipModelEnum[ShipModelEnum["FerDeLance"] = 13] = "FerDeLance";
    ShipModelEnum[ShipModelEnum["Gecko"] = 14] = "Gecko";
    ShipModelEnum[ShipModelEnum["Krait"] = 15] = "Krait";
    ShipModelEnum[ShipModelEnum["Mamba"] = 16] = "Mamba";
    ShipModelEnum[ShipModelEnum["Missile"] = 17] = "Missile";
    ShipModelEnum[ShipModelEnum["Moray"] = 18] = "Moray";
    ShipModelEnum[ShipModelEnum["Python"] = 19] = "Python";
    ShipModelEnum[ShipModelEnum["Shuttle"] = 20] = "Shuttle";
    ShipModelEnum[ShipModelEnum["Sidewinder"] = 21] = "Sidewinder";
    ShipModelEnum[ShipModelEnum["Thargoid"] = 22] = "Thargoid";
    ShipModelEnum[ShipModelEnum["Thargon"] = 23] = "Thargon";
    ShipModelEnum[ShipModelEnum["Transporter"] = 24] = "Transporter";
    ShipModelEnum[ShipModelEnum["Viper"] = 25] = "Viper";
    ShipModelEnum[ShipModelEnum["Worm"] = 26] = "Worm";
})($17751991aa2dcc8b$export$7d04abf91eb22fb || ($17751991aa2dcc8b$export$7d04abf91eb22fb = {}));


var $ab7f6dc0910e1ef7$exports = {};

$parcel$export($ab7f6dc0910e1ef7$exports, "create", () => $ab7f6dc0910e1ef7$export$185802fd694ee1f5);
$parcel$export($ab7f6dc0910e1ef7$exports, "clone", () => $ab7f6dc0910e1ef7$export$9cd59f9826255e47);
$parcel$export($ab7f6dc0910e1ef7$exports, "length", () => $ab7f6dc0910e1ef7$export$f24224f1c91d8156);
$parcel$export($ab7f6dc0910e1ef7$exports, "fromValues", () => $ab7f6dc0910e1ef7$export$a82be99ed2a44a7d);
$parcel$export($ab7f6dc0910e1ef7$exports, "copy", () => $ab7f6dc0910e1ef7$export$784d13d8ee351f07);
$parcel$export($ab7f6dc0910e1ef7$exports, "set", () => $ab7f6dc0910e1ef7$export$adaa4cf7ef1b65be);
$parcel$export($ab7f6dc0910e1ef7$exports, "add", () => $ab7f6dc0910e1ef7$export$e16d8520af44a096);
$parcel$export($ab7f6dc0910e1ef7$exports, "subtract", () => $ab7f6dc0910e1ef7$export$4e2d2ead65e5f7e3);
$parcel$export($ab7f6dc0910e1ef7$exports, "multiply", () => $ab7f6dc0910e1ef7$export$2060d2db72cce88f);
$parcel$export($ab7f6dc0910e1ef7$exports, "divide", () => $ab7f6dc0910e1ef7$export$cd007d971a5a2143);
$parcel$export($ab7f6dc0910e1ef7$exports, "ceil", () => $ab7f6dc0910e1ef7$export$803ce6b71a0a94b2);
$parcel$export($ab7f6dc0910e1ef7$exports, "floor", () => $ab7f6dc0910e1ef7$export$a3fe094919f356fd);
$parcel$export($ab7f6dc0910e1ef7$exports, "min", () => $ab7f6dc0910e1ef7$export$96ec731ed4dcb222);
$parcel$export($ab7f6dc0910e1ef7$exports, "max", () => $ab7f6dc0910e1ef7$export$8960430cfd85939f);
$parcel$export($ab7f6dc0910e1ef7$exports, "round", () => $ab7f6dc0910e1ef7$export$2077e0241d6afd3c);
$parcel$export($ab7f6dc0910e1ef7$exports, "scale", () => $ab7f6dc0910e1ef7$export$dcdf75081b88279d);
$parcel$export($ab7f6dc0910e1ef7$exports, "scaleAndAdd", () => $ab7f6dc0910e1ef7$export$19cedf1da84ba854);
$parcel$export($ab7f6dc0910e1ef7$exports, "distance", () => $ab7f6dc0910e1ef7$export$9f17032d917177de);
$parcel$export($ab7f6dc0910e1ef7$exports, "squaredDistance", () => $ab7f6dc0910e1ef7$export$88e6ebb4fe54f538);
$parcel$export($ab7f6dc0910e1ef7$exports, "squaredLength", () => $ab7f6dc0910e1ef7$export$ab44e1323ffc8376);
$parcel$export($ab7f6dc0910e1ef7$exports, "negate", () => $ab7f6dc0910e1ef7$export$aef51622e549b8b0);
$parcel$export($ab7f6dc0910e1ef7$exports, "inverse", () => $ab7f6dc0910e1ef7$export$70ae2c07e401031b);
$parcel$export($ab7f6dc0910e1ef7$exports, "normalize", () => $ab7f6dc0910e1ef7$export$a3295358bff77e);
$parcel$export($ab7f6dc0910e1ef7$exports, "dot", () => $ab7f6dc0910e1ef7$export$94132a0e348806d4);
$parcel$export($ab7f6dc0910e1ef7$exports, "cross", () => $ab7f6dc0910e1ef7$export$bb646b20bb93d339);
$parcel$export($ab7f6dc0910e1ef7$exports, "lerp", () => $ab7f6dc0910e1ef7$export$3a89f8d6f6bf6c9f);
$parcel$export($ab7f6dc0910e1ef7$exports, "hermite", () => $ab7f6dc0910e1ef7$export$ae8865616f30561c);
$parcel$export($ab7f6dc0910e1ef7$exports, "bezier", () => $ab7f6dc0910e1ef7$export$b9c5f84610baddaf);
$parcel$export($ab7f6dc0910e1ef7$exports, "random", () => $ab7f6dc0910e1ef7$export$4385e60b38654f68);
$parcel$export($ab7f6dc0910e1ef7$exports, "transformMat4", () => $ab7f6dc0910e1ef7$export$5ffbd13800309d59);
$parcel$export($ab7f6dc0910e1ef7$exports, "transformMat3", () => $ab7f6dc0910e1ef7$export$f0bfa0a0024626ee);
$parcel$export($ab7f6dc0910e1ef7$exports, "transformQuat", () => $ab7f6dc0910e1ef7$export$c32adef9e939ce85);
$parcel$export($ab7f6dc0910e1ef7$exports, "rotateX", () => $ab7f6dc0910e1ef7$export$a59c8716592e09af);
$parcel$export($ab7f6dc0910e1ef7$exports, "rotateY", () => $ab7f6dc0910e1ef7$export$cf71e4d4ca4d1cfd);
$parcel$export($ab7f6dc0910e1ef7$exports, "rotateZ", () => $ab7f6dc0910e1ef7$export$ea6eae3365de5b9c);
$parcel$export($ab7f6dc0910e1ef7$exports, "angle", () => $ab7f6dc0910e1ef7$export$944b09d2ad10b378);
$parcel$export($ab7f6dc0910e1ef7$exports, "zero", () => $ab7f6dc0910e1ef7$export$7f9972325ebfd559);
$parcel$export($ab7f6dc0910e1ef7$exports, "str", () => $ab7f6dc0910e1ef7$export$42d51816ce590c93);
$parcel$export($ab7f6dc0910e1ef7$exports, "exactEquals", () => $ab7f6dc0910e1ef7$export$f2599a5cf1109d8);
$parcel$export($ab7f6dc0910e1ef7$exports, "equals", () => $ab7f6dc0910e1ef7$export$e9bab7fafb253603);
$parcel$export($ab7f6dc0910e1ef7$exports, "sub", () => $ab7f6dc0910e1ef7$export$f93b5905241a7cca);
$parcel$export($ab7f6dc0910e1ef7$exports, "mul", () => $ab7f6dc0910e1ef7$export$6e3a27864ab166fe);
$parcel$export($ab7f6dc0910e1ef7$exports, "div", () => $ab7f6dc0910e1ef7$export$159d9494db57879b);
$parcel$export($ab7f6dc0910e1ef7$exports, "dist", () => $ab7f6dc0910e1ef7$export$6c4a311cc157c764);
$parcel$export($ab7f6dc0910e1ef7$exports, "sqrDist", () => $ab7f6dc0910e1ef7$export$2422cd6c492a8b3a);
$parcel$export($ab7f6dc0910e1ef7$exports, "len", () => $ab7f6dc0910e1ef7$export$fc1400facf92c78);
$parcel$export($ab7f6dc0910e1ef7$exports, "sqrLen", () => $ab7f6dc0910e1ef7$export$99d8dd3f32a3435);
$parcel$export($ab7f6dc0910e1ef7$exports, "forEach", () => $ab7f6dc0910e1ef7$export$4b80e395e36b5a56);
/**
 * Common utilities
 * @module glMatrix
 */ // Configuration Constants
var $78ae820aa9ececfa$export$fd293b15f47e270 = 0.000001;
var $78ae820aa9ececfa$export$b67359430d3b1b2 = typeof Float32Array !== "undefined" ? Float32Array : Array;
var $78ae820aa9ececfa$export$5ada478c8a628231 = Math.random;
function $78ae820aa9ececfa$export$cb2c0eb57f5e532c(type) {
    $78ae820aa9ececfa$export$b67359430d3b1b2 = type;
}
var $78ae820aa9ececfa$var$degree = Math.PI / 180;
function $78ae820aa9ececfa$export$408b8ee5959eefd5(a) {
    return a * $78ae820aa9ececfa$var$degree;
}
function $78ae820aa9ececfa$export$e9bab7fafb253603(a, b) {
    return Math.abs(a - b) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a), Math.abs(b));
}
if (!Math.hypot) Math.hypot = function() {
    var y = 0, i = arguments.length;
    while(i--)y += arguments[i] * arguments[i];
    return Math.sqrt(y);
};


function $ab7f6dc0910e1ef7$export$185802fd694ee1f5() {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(3);
    if ($78ae820aa9ececfa$export$b67359430d3b1b2 != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
    }
    return out;
}
function $ab7f6dc0910e1ef7$export$9cd59f9826255e47(a) {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(3);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$f24224f1c91d8156(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    return Math.hypot(x, y, z);
}
function $ab7f6dc0910e1ef7$export$a82be99ed2a44a7d(x, y, z) {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(3);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function $ab7f6dc0910e1ef7$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$adaa4cf7ef1b65be(out, x, y, z) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function $ab7f6dc0910e1ef7$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    out[2] = Math.ceil(a[2]);
    return out;
}
function $ab7f6dc0910e1ef7$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    out[2] = Math.floor(a[2]);
    return out;
}
function $ab7f6dc0910e1ef7$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    return out;
}
function $ab7f6dc0910e1ef7$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    return out;
}
function $ab7f6dc0910e1ef7$export$2077e0241d6afd3c(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    out[2] = Math.round(a[2]);
    return out;
}
function $ab7f6dc0910e1ef7$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    return out;
}
function $ab7f6dc0910e1ef7$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    return out;
}
function $ab7f6dc0910e1ef7$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    return Math.hypot(x, y, z);
}
function $ab7f6dc0910e1ef7$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    return x * x + y * y + z * z;
}
function $ab7f6dc0910e1ef7$export$ab44e1323ffc8376(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    return x * x + y * y + z * z;
}
function $ab7f6dc0910e1ef7$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$a3295358bff77e(out, a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var len = x * x + y * y + z * z;
    if (len > 0) //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    out[2] = a[2] * len;
    return out;
}
function $ab7f6dc0910e1ef7$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $ab7f6dc0910e1ef7$export$bb646b20bb93d339(out, a, b) {
    var ax = a[0], ay = a[1], az = a[2];
    var bx = b[0], by = b[1], bz = b[2];
    out[0] = ay * bz - az * by;
    out[1] = az * bx - ax * bz;
    out[2] = ax * by - ay * bx;
    return out;
}
function $ab7f6dc0910e1ef7$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    return out;
}
function $ab7f6dc0910e1ef7$export$ae8865616f30561c(out, a, b, c, d, t) {
    var factorTimes2 = t * t;
    var factor1 = factorTimes2 * (2 * t - 3) + 1;
    var factor2 = factorTimes2 * (t - 2) + t;
    var factor3 = factorTimes2 * (t - 1);
    var factor4 = factorTimes2 * (3 - 2 * t);
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
function $ab7f6dc0910e1ef7$export$b9c5f84610baddaf(out, a, b, c, d, t) {
    var inverseFactor = 1 - t;
    var inverseFactorTimesTwo = inverseFactor * inverseFactor;
    var factorTimes2 = t * t;
    var factor1 = inverseFactorTimesTwo * inverseFactor;
    var factor2 = 3 * t * inverseFactorTimesTwo;
    var factor3 = 3 * factorTimes2 * inverseFactor;
    var factor4 = factorTimes2 * t;
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
function $ab7f6dc0910e1ef7$export$4385e60b38654f68(out, scale) {
    scale = scale || 1.0;
    var r = $78ae820aa9ececfa$export$5ada478c8a628231() * 2.0 * Math.PI;
    var z = $78ae820aa9ececfa$export$5ada478c8a628231() * 2.0 - 1.0;
    var zScale = Math.sqrt(1.0 - z * z) * scale;
    out[0] = Math.cos(r) * zScale;
    out[1] = Math.sin(r) * zScale;
    out[2] = z * scale;
    return out;
}
function $ab7f6dc0910e1ef7$export$5ffbd13800309d59(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    var w = m[3] * x + m[7] * y + m[11] * z + m[15];
    w = w || 1.0;
    out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w;
    out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w;
    out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w;
    return out;
}
function $ab7f6dc0910e1ef7$export$f0bfa0a0024626ee(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    out[0] = x * m[0] + y * m[3] + z * m[6];
    out[1] = x * m[1] + y * m[4] + z * m[7];
    out[2] = x * m[2] + y * m[5] + z * m[8];
    return out;
}
function $ab7f6dc0910e1ef7$export$c32adef9e939ce85(out, a, q) {
    // benchmarks: https://jsperf.com/quaternion-transform-vec3-implementations-fixed
    var qx = q[0], qy = q[1], qz = q[2], qw = q[3];
    var x = a[0], y = a[1], z = a[2]; // var qvec = [qx, qy, qz];
    // var uv = vec3.cross([], qvec, a);
    var uvx = qy * z - qz * y, uvy = qz * x - qx * z, uvz = qx * y - qy * x; // var uuv = vec3.cross([], qvec, uv);
    var uuvx = qy * uvz - qz * uvy, uuvy = qz * uvx - qx * uvz, uuvz = qx * uvy - qy * uvx; // vec3.scale(uv, uv, 2 * w);
    var w2 = qw * 2;
    uvx *= w2;
    uvy *= w2;
    uvz *= w2; // vec3.scale(uuv, uuv, 2);
    uuvx *= 2;
    uuvy *= 2;
    uuvz *= 2; // return vec3.add(out, a, vec3.add(out, uv, uuv));
    out[0] = x + uvx + uuvx;
    out[1] = y + uvy + uuvy;
    out[2] = z + uvz + uuvz;
    return out;
}
function $ab7f6dc0910e1ef7$export$a59c8716592e09af(out, a, b, rad) {
    var p = [], r = []; //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2]; //perform rotation
    r[0] = p[0];
    r[1] = p[1] * Math.cos(rad) - p[2] * Math.sin(rad);
    r[2] = p[1] * Math.sin(rad) + p[2] * Math.cos(rad); //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$cf71e4d4ca4d1cfd(out, a, b, rad) {
    var p = [], r = []; //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2]; //perform rotation
    r[0] = p[2] * Math.sin(rad) + p[0] * Math.cos(rad);
    r[1] = p[1];
    r[2] = p[2] * Math.cos(rad) - p[0] * Math.sin(rad); //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$ea6eae3365de5b9c(out, a, b, rad) {
    var p = [], r = []; //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2]; //perform rotation
    r[0] = p[0] * Math.cos(rad) - p[1] * Math.sin(rad);
    r[1] = p[0] * Math.sin(rad) + p[1] * Math.cos(rad);
    r[2] = p[2]; //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$944b09d2ad10b378(a, b) {
    var ax = a[0], ay = a[1], az = a[2], bx = b[0], by = b[1], bz = b[2], mag1 = Math.sqrt(ax * ax + ay * ay + az * az), mag2 = Math.sqrt(bx * bx + by * by + bz * bz), mag = mag1 * mag2, cosine = mag && $ab7f6dc0910e1ef7$export$94132a0e348806d4(a, b) / mag;
    return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
function $ab7f6dc0910e1ef7$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    out[2] = 0.0;
    return out;
}
function $ab7f6dc0910e1ef7$export$42d51816ce590c93(a) {
    return "vec3(" + a[0] + ", " + a[1] + ", " + a[2] + ")";
}
function $ab7f6dc0910e1ef7$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
}
function $ab7f6dc0910e1ef7$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2];
    var b0 = b[0], b1 = b[1], b2 = b[2];
    return Math.abs(a0 - b0) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a2), Math.abs(b2));
}
var $ab7f6dc0910e1ef7$export$f93b5905241a7cca = $ab7f6dc0910e1ef7$export$4e2d2ead65e5f7e3;
var $ab7f6dc0910e1ef7$export$6e3a27864ab166fe = $ab7f6dc0910e1ef7$export$2060d2db72cce88f;
var $ab7f6dc0910e1ef7$export$159d9494db57879b = $ab7f6dc0910e1ef7$export$cd007d971a5a2143;
var $ab7f6dc0910e1ef7$export$6c4a311cc157c764 = $ab7f6dc0910e1ef7$export$9f17032d917177de;
var $ab7f6dc0910e1ef7$export$2422cd6c492a8b3a = $ab7f6dc0910e1ef7$export$88e6ebb4fe54f538;
var $ab7f6dc0910e1ef7$export$fc1400facf92c78 = $ab7f6dc0910e1ef7$export$f24224f1c91d8156;
var $ab7f6dc0910e1ef7$export$99d8dd3f32a3435 = $ab7f6dc0910e1ef7$export$ab44e1323ffc8376;
var $ab7f6dc0910e1ef7$export$4b80e395e36b5a56 = function() {
    var vec = $ab7f6dc0910e1ef7$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 3;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
        }
        return a;
    };
}();


var $cf8fd949337d3b75$export$a3bb2a5ab3320756;
(function(ShipRoleEnum) {
    ShipRoleEnum[ShipRoleEnum["Missile"] = 0] = "Missile";
    ShipRoleEnum[ShipRoleEnum["EscapePod"] = 1] = "EscapePod";
    ShipRoleEnum[ShipRoleEnum["PlanetaryTrader"] = 2] = "PlanetaryTrader";
    ShipRoleEnum[ShipRoleEnum["Trader"] = 3] = "Trader";
    ShipRoleEnum[ShipRoleEnum["Police"] = 4] = "Police";
    ShipRoleEnum[ShipRoleEnum["Pirate"] = 5] = "Pirate";
    ShipRoleEnum[ShipRoleEnum["BountyHunter"] = 6] = "BountyHunter";
    ShipRoleEnum[ShipRoleEnum["Thargoid"] = 7] = "Thargoid";
    ShipRoleEnum[ShipRoleEnum["Thargon"] = 8] = "Thargon";
    ShipRoleEnum[ShipRoleEnum["Station"] = 9] = "Station";
    ShipRoleEnum[ShipRoleEnum["Asteroid"] = 10] = "Asteroid";
    ShipRoleEnum[ShipRoleEnum["Cargo"] = 11] = "Cargo";
    ShipRoleEnum[ShipRoleEnum["RockHermit"] = 12] = "RockHermit";
})($cf8fd949337d3b75$export$a3bb2a5ab3320756 || ($cf8fd949337d3b75$export$a3bb2a5ab3320756 = {}));
var $cf8fd949337d3b75$export$6c83a620f27ed611;
(function(AttitudeEnum) {
    AttitudeEnum[AttitudeEnum["Hostile"] = 0] = "Hostile";
    AttitudeEnum[AttitudeEnum["Friendly"] = 1] = "Friendly";
})($cf8fd949337d3b75$export$6c83a620f27ed611 || ($cf8fd949337d3b75$export$6c83a620f27ed611 = {}));
var $cf8fd949337d3b75$export$568b6dd3ac70608c;
(function(AccelerationModeEnum) {
    AccelerationModeEnum[AccelerationModeEnum["Accelerating"] = 0] = "Accelerating";
    AccelerationModeEnum[AccelerationModeEnum["Decelerating"] = 1] = "Decelerating";
    AccelerationModeEnum[AccelerationModeEnum["None"] = 2] = "None";
})($cf8fd949337d3b75$export$568b6dd3ac70608c || ($cf8fd949337d3b75$export$568b6dd3ac70608c = {}));
var $cf8fd949337d3b75$export$d0bfecb5b13bed3c;
(function(FlyingTowardsEnum) {
    FlyingTowardsEnum[FlyingTowardsEnum["Planet"] = 0] = "Planet";
    FlyingTowardsEnum[FlyingTowardsEnum["Player"] = 1] = "Player";
    FlyingTowardsEnum[FlyingTowardsEnum["AwayFromPlayer"] = 2] = "AwayFromPlayer";
    FlyingTowardsEnum[FlyingTowardsEnum["None"] = 3] = "None";
})($cf8fd949337d3b75$export$d0bfecb5b13bed3c || ($cf8fd949337d3b75$export$d0bfecb5b13bed3c = {}));


function $91201f5d84ae2499$export$19de0130f5adf0ae(gl, url, smoothScaling = false) {
    return new Promise((resolve)=>{
        const texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, texture);
        // Because images have to be downloaded over the internet
        // they might take a moment until they are ready.
        // Until then put a single pixel in the texture so we can
        // use it immediately. When the image has finished downloading
        // we'll update the texture with the contents of the image.
        const level = 0;
        const internalFormat = gl.RGBA;
        const width = 1;
        const height = 1;
        const border = 0;
        const srcFormat = gl.RGBA;
        const srcType = gl.UNSIGNED_BYTE;
        const pixel = new Uint8Array([
            0,
            0,
            255,
            255
        ]) // opaque blue
        ;
        gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, width, height, border, srcFormat, srcType, pixel);
        const image = new Image();
        image.onload = ()=>{
            gl.bindTexture(gl.TEXTURE_2D, texture);
            gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, srcFormat, srcType, image);
            // WebGL1 has different requirements for power of 2 images
            // vs. non power of 2 images so check if the image is a
            // power of 2 in both dimensions.
            if ($91201f5d84ae2499$var$isPowerOf2(image.width) && $91201f5d84ae2499$var$isPowerOf2(image.height)) // Yes, it's a power of 2. Generate mips.
            gl.generateMipmap(gl.TEXTURE_2D);
            else {
                // No, it's not a power of 2. Turn off mips and set
                // wrapping to clamp to edge
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
                if (smoothScaling) gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
                else {
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
                }
            }
            resolve(texture);
        };
        image.src = url;
    });
}
function $91201f5d84ae2499$var$isPowerOf2(value) {
    return (value & value - 1) === 0;
}


var $4ce98914b6676340$exports = {};

$parcel$export($4ce98914b6676340$exports, "create", () => $4ce98914b6676340$export$185802fd694ee1f5);
$parcel$export($4ce98914b6676340$exports, "clone", () => $4ce98914b6676340$export$9cd59f9826255e47);
$parcel$export($4ce98914b6676340$exports, "fromValues", () => $4ce98914b6676340$export$a82be99ed2a44a7d);
$parcel$export($4ce98914b6676340$exports, "copy", () => $4ce98914b6676340$export$784d13d8ee351f07);
$parcel$export($4ce98914b6676340$exports, "set", () => $4ce98914b6676340$export$adaa4cf7ef1b65be);
$parcel$export($4ce98914b6676340$exports, "add", () => $4ce98914b6676340$export$e16d8520af44a096);
$parcel$export($4ce98914b6676340$exports, "subtract", () => $4ce98914b6676340$export$4e2d2ead65e5f7e3);
$parcel$export($4ce98914b6676340$exports, "multiply", () => $4ce98914b6676340$export$2060d2db72cce88f);
$parcel$export($4ce98914b6676340$exports, "divide", () => $4ce98914b6676340$export$cd007d971a5a2143);
$parcel$export($4ce98914b6676340$exports, "ceil", () => $4ce98914b6676340$export$803ce6b71a0a94b2);
$parcel$export($4ce98914b6676340$exports, "floor", () => $4ce98914b6676340$export$a3fe094919f356fd);
$parcel$export($4ce98914b6676340$exports, "min", () => $4ce98914b6676340$export$96ec731ed4dcb222);
$parcel$export($4ce98914b6676340$exports, "max", () => $4ce98914b6676340$export$8960430cfd85939f);
$parcel$export($4ce98914b6676340$exports, "round", () => $4ce98914b6676340$export$2077e0241d6afd3c);
$parcel$export($4ce98914b6676340$exports, "scale", () => $4ce98914b6676340$export$dcdf75081b88279d);
$parcel$export($4ce98914b6676340$exports, "scaleAndAdd", () => $4ce98914b6676340$export$19cedf1da84ba854);
$parcel$export($4ce98914b6676340$exports, "distance", () => $4ce98914b6676340$export$9f17032d917177de);
$parcel$export($4ce98914b6676340$exports, "squaredDistance", () => $4ce98914b6676340$export$88e6ebb4fe54f538);
$parcel$export($4ce98914b6676340$exports, "length", () => $4ce98914b6676340$export$f24224f1c91d8156);
$parcel$export($4ce98914b6676340$exports, "squaredLength", () => $4ce98914b6676340$export$ab44e1323ffc8376);
$parcel$export($4ce98914b6676340$exports, "negate", () => $4ce98914b6676340$export$aef51622e549b8b0);
$parcel$export($4ce98914b6676340$exports, "inverse", () => $4ce98914b6676340$export$70ae2c07e401031b);
$parcel$export($4ce98914b6676340$exports, "normalize", () => $4ce98914b6676340$export$a3295358bff77e);
$parcel$export($4ce98914b6676340$exports, "dot", () => $4ce98914b6676340$export$94132a0e348806d4);
$parcel$export($4ce98914b6676340$exports, "cross", () => $4ce98914b6676340$export$bb646b20bb93d339);
$parcel$export($4ce98914b6676340$exports, "lerp", () => $4ce98914b6676340$export$3a89f8d6f6bf6c9f);
$parcel$export($4ce98914b6676340$exports, "random", () => $4ce98914b6676340$export$4385e60b38654f68);
$parcel$export($4ce98914b6676340$exports, "transformMat2", () => $4ce98914b6676340$export$b732428d73874bfc);
$parcel$export($4ce98914b6676340$exports, "transformMat2d", () => $4ce98914b6676340$export$3e55bc4b3707dfd3);
$parcel$export($4ce98914b6676340$exports, "transformMat3", () => $4ce98914b6676340$export$f0bfa0a0024626ee);
$parcel$export($4ce98914b6676340$exports, "transformMat4", () => $4ce98914b6676340$export$5ffbd13800309d59);
$parcel$export($4ce98914b6676340$exports, "rotate", () => $4ce98914b6676340$export$bb628a54ab399bc9);
$parcel$export($4ce98914b6676340$exports, "angle", () => $4ce98914b6676340$export$944b09d2ad10b378);
$parcel$export($4ce98914b6676340$exports, "zero", () => $4ce98914b6676340$export$7f9972325ebfd559);
$parcel$export($4ce98914b6676340$exports, "str", () => $4ce98914b6676340$export$42d51816ce590c93);
$parcel$export($4ce98914b6676340$exports, "exactEquals", () => $4ce98914b6676340$export$f2599a5cf1109d8);
$parcel$export($4ce98914b6676340$exports, "equals", () => $4ce98914b6676340$export$e9bab7fafb253603);
$parcel$export($4ce98914b6676340$exports, "len", () => $4ce98914b6676340$export$fc1400facf92c78);
$parcel$export($4ce98914b6676340$exports, "sub", () => $4ce98914b6676340$export$f93b5905241a7cca);
$parcel$export($4ce98914b6676340$exports, "mul", () => $4ce98914b6676340$export$6e3a27864ab166fe);
$parcel$export($4ce98914b6676340$exports, "div", () => $4ce98914b6676340$export$159d9494db57879b);
$parcel$export($4ce98914b6676340$exports, "dist", () => $4ce98914b6676340$export$6c4a311cc157c764);
$parcel$export($4ce98914b6676340$exports, "sqrDist", () => $4ce98914b6676340$export$2422cd6c492a8b3a);
$parcel$export($4ce98914b6676340$exports, "sqrLen", () => $4ce98914b6676340$export$99d8dd3f32a3435);
$parcel$export($4ce98914b6676340$exports, "forEach", () => $4ce98914b6676340$export$4b80e395e36b5a56);

function $4ce98914b6676340$export$185802fd694ee1f5() {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(2);
    if ($78ae820aa9ececfa$export$b67359430d3b1b2 != Float32Array) {
        out[0] = 0;
        out[1] = 0;
    }
    return out;
}
function $4ce98914b6676340$export$9cd59f9826255e47(a) {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(2);
    out[0] = a[0];
    out[1] = a[1];
    return out;
}
function $4ce98914b6676340$export$a82be99ed2a44a7d(x, y) {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(2);
    out[0] = x;
    out[1] = y;
    return out;
}
function $4ce98914b6676340$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    return out;
}
function $4ce98914b6676340$export$adaa4cf7ef1b65be(out, x, y) {
    out[0] = x;
    out[1] = y;
    return out;
}
function $4ce98914b6676340$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    return out;
}
function $4ce98914b6676340$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    return out;
}
function $4ce98914b6676340$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    return out;
}
function $4ce98914b6676340$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    return out;
}
function $4ce98914b6676340$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    return out;
}
function $4ce98914b6676340$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    return out;
}
function $4ce98914b6676340$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    return out;
}
function $4ce98914b6676340$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    return out;
}
function $4ce98914b6676340$export$2077e0241d6afd3c(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    return out;
}
function $4ce98914b6676340$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    return out;
}
function $4ce98914b6676340$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    return out;
}
function $4ce98914b6676340$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return Math.hypot(x, y);
}
function $4ce98914b6676340$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return x * x + y * y;
}
function $4ce98914b6676340$export$f24224f1c91d8156(a) {
    var x = a[0], y = a[1];
    return Math.hypot(x, y);
}
function $4ce98914b6676340$export$ab44e1323ffc8376(a) {
    var x = a[0], y = a[1];
    return x * x + y * y;
}
function $4ce98914b6676340$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    return out;
}
function $4ce98914b6676340$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    return out;
}
function $4ce98914b6676340$export$a3295358bff77e(out, a) {
    var x = a[0], y = a[1];
    var len = x * x + y * y;
    if (len > 0) //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    return out;
}
function $4ce98914b6676340$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1];
}
function $4ce98914b6676340$export$bb646b20bb93d339(out, a, b) {
    var z = a[0] * b[1] - a[1] * b[0];
    out[0] = out[1] = 0;
    out[2] = z;
    return out;
}
function $4ce98914b6676340$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0], ay = a[1];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    return out;
}
function $4ce98914b6676340$export$4385e60b38654f68(out, scale) {
    scale = scale || 1.0;
    var r = $78ae820aa9ececfa$export$5ada478c8a628231() * 2.0 * Math.PI;
    out[0] = Math.cos(r) * scale;
    out[1] = Math.sin(r) * scale;
    return out;
}
function $4ce98914b6676340$export$b732428d73874bfc(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y;
    out[1] = m[1] * x + m[3] * y;
    return out;
}
function $4ce98914b6676340$export$3e55bc4b3707dfd3(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
function $4ce98914b6676340$export$f0bfa0a0024626ee(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[3] * y + m[6];
    out[1] = m[1] * x + m[4] * y + m[7];
    return out;
}
function $4ce98914b6676340$export$5ffbd13800309d59(out, a, m) {
    var x = a[0];
    var y = a[1];
    out[0] = m[0] * x + m[4] * y + m[12];
    out[1] = m[1] * x + m[5] * y + m[13];
    return out;
}
function $4ce98914b6676340$export$bb628a54ab399bc9(out, a, b, rad) {
    //Translate point to the origin
    var p0 = a[0] - b[0], p1 = a[1] - b[1], sinC = Math.sin(rad), cosC = Math.cos(rad); //perform rotation and translate to correct position
    out[0] = p0 * cosC - p1 * sinC + b[0];
    out[1] = p0 * sinC + p1 * cosC + b[1];
    return out;
}
function $4ce98914b6676340$export$944b09d2ad10b378(a, b) {
    var x1 = a[0], y1 = a[1], x2 = b[0], y2 = b[1], // mag is the product of the magnitudes of a and b
    mag = Math.sqrt(x1 * x1 + y1 * y1) * Math.sqrt(x2 * x2 + y2 * y2), // mag &&.. short circuits if mag == 0
    cosine = mag && (x1 * x2 + y1 * y2) / mag; // Math.min(Math.max(cosine, -1), 1) clamps the cosine between -1 and 1
    return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
function $4ce98914b6676340$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    return out;
}
function $4ce98914b6676340$export$42d51816ce590c93(a) {
    return "vec2(" + a[0] + ", " + a[1] + ")";
}
function $4ce98914b6676340$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1];
}
function $4ce98914b6676340$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1];
    var b0 = b[0], b1 = b[1];
    return Math.abs(a0 - b0) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a1), Math.abs(b1));
}
var $4ce98914b6676340$export$fc1400facf92c78 = $4ce98914b6676340$export$f24224f1c91d8156;
var $4ce98914b6676340$export$f93b5905241a7cca = $4ce98914b6676340$export$4e2d2ead65e5f7e3;
var $4ce98914b6676340$export$6e3a27864ab166fe = $4ce98914b6676340$export$2060d2db72cce88f;
var $4ce98914b6676340$export$159d9494db57879b = $4ce98914b6676340$export$cd007d971a5a2143;
var $4ce98914b6676340$export$6c4a311cc157c764 = $4ce98914b6676340$export$9f17032d917177de;
var $4ce98914b6676340$export$2422cd6c492a8b3a = $4ce98914b6676340$export$88e6ebb4fe54f538;
var $4ce98914b6676340$export$99d8dd3f32a3435 = $4ce98914b6676340$export$ab44e1323ffc8376;
var $4ce98914b6676340$export$4b80e395e36b5a56 = function() {
    var vec = $4ce98914b6676340$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 2;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
        }
        return a;
    };
}();



// the positions are 8-bits but a galaxy looks to be sized 102.4x51.2 so we scale here
var $e38eb280d3b76273$exports = {};

$parcel$export($e38eb280d3b76273$exports, "create", () => $e38eb280d3b76273$export$185802fd694ee1f5);
$parcel$export($e38eb280d3b76273$exports, "clone", () => $e38eb280d3b76273$export$9cd59f9826255e47);
$parcel$export($e38eb280d3b76273$exports, "fromValues", () => $e38eb280d3b76273$export$a82be99ed2a44a7d);
$parcel$export($e38eb280d3b76273$exports, "copy", () => $e38eb280d3b76273$export$784d13d8ee351f07);
$parcel$export($e38eb280d3b76273$exports, "set", () => $e38eb280d3b76273$export$adaa4cf7ef1b65be);
$parcel$export($e38eb280d3b76273$exports, "add", () => $e38eb280d3b76273$export$e16d8520af44a096);
$parcel$export($e38eb280d3b76273$exports, "subtract", () => $e38eb280d3b76273$export$4e2d2ead65e5f7e3);
$parcel$export($e38eb280d3b76273$exports, "multiply", () => $e38eb280d3b76273$export$2060d2db72cce88f);
$parcel$export($e38eb280d3b76273$exports, "divide", () => $e38eb280d3b76273$export$cd007d971a5a2143);
$parcel$export($e38eb280d3b76273$exports, "ceil", () => $e38eb280d3b76273$export$803ce6b71a0a94b2);
$parcel$export($e38eb280d3b76273$exports, "floor", () => $e38eb280d3b76273$export$a3fe094919f356fd);
$parcel$export($e38eb280d3b76273$exports, "min", () => $e38eb280d3b76273$export$96ec731ed4dcb222);
$parcel$export($e38eb280d3b76273$exports, "max", () => $e38eb280d3b76273$export$8960430cfd85939f);
$parcel$export($e38eb280d3b76273$exports, "round", () => $e38eb280d3b76273$export$2077e0241d6afd3c);
$parcel$export($e38eb280d3b76273$exports, "scale", () => $e38eb280d3b76273$export$dcdf75081b88279d);
$parcel$export($e38eb280d3b76273$exports, "scaleAndAdd", () => $e38eb280d3b76273$export$19cedf1da84ba854);
$parcel$export($e38eb280d3b76273$exports, "distance", () => $e38eb280d3b76273$export$9f17032d917177de);
$parcel$export($e38eb280d3b76273$exports, "squaredDistance", () => $e38eb280d3b76273$export$88e6ebb4fe54f538);
$parcel$export($e38eb280d3b76273$exports, "length", () => $e38eb280d3b76273$export$f24224f1c91d8156);
$parcel$export($e38eb280d3b76273$exports, "squaredLength", () => $e38eb280d3b76273$export$ab44e1323ffc8376);
$parcel$export($e38eb280d3b76273$exports, "negate", () => $e38eb280d3b76273$export$aef51622e549b8b0);
$parcel$export($e38eb280d3b76273$exports, "inverse", () => $e38eb280d3b76273$export$70ae2c07e401031b);
$parcel$export($e38eb280d3b76273$exports, "normalize", () => $e38eb280d3b76273$export$a3295358bff77e);
$parcel$export($e38eb280d3b76273$exports, "dot", () => $e38eb280d3b76273$export$94132a0e348806d4);
$parcel$export($e38eb280d3b76273$exports, "cross", () => $e38eb280d3b76273$export$bb646b20bb93d339);
$parcel$export($e38eb280d3b76273$exports, "lerp", () => $e38eb280d3b76273$export$3a89f8d6f6bf6c9f);
$parcel$export($e38eb280d3b76273$exports, "random", () => $e38eb280d3b76273$export$4385e60b38654f68);
$parcel$export($e38eb280d3b76273$exports, "transformMat4", () => $e38eb280d3b76273$export$5ffbd13800309d59);
$parcel$export($e38eb280d3b76273$exports, "transformQuat", () => $e38eb280d3b76273$export$c32adef9e939ce85);
$parcel$export($e38eb280d3b76273$exports, "zero", () => $e38eb280d3b76273$export$7f9972325ebfd559);
$parcel$export($e38eb280d3b76273$exports, "str", () => $e38eb280d3b76273$export$42d51816ce590c93);
$parcel$export($e38eb280d3b76273$exports, "exactEquals", () => $e38eb280d3b76273$export$f2599a5cf1109d8);
$parcel$export($e38eb280d3b76273$exports, "equals", () => $e38eb280d3b76273$export$e9bab7fafb253603);
$parcel$export($e38eb280d3b76273$exports, "sub", () => $e38eb280d3b76273$export$f93b5905241a7cca);
$parcel$export($e38eb280d3b76273$exports, "mul", () => $e38eb280d3b76273$export$6e3a27864ab166fe);
$parcel$export($e38eb280d3b76273$exports, "div", () => $e38eb280d3b76273$export$159d9494db57879b);
$parcel$export($e38eb280d3b76273$exports, "dist", () => $e38eb280d3b76273$export$6c4a311cc157c764);
$parcel$export($e38eb280d3b76273$exports, "sqrDist", () => $e38eb280d3b76273$export$2422cd6c492a8b3a);
$parcel$export($e38eb280d3b76273$exports, "len", () => $e38eb280d3b76273$export$fc1400facf92c78);
$parcel$export($e38eb280d3b76273$exports, "sqrLen", () => $e38eb280d3b76273$export$99d8dd3f32a3435);
$parcel$export($e38eb280d3b76273$exports, "forEach", () => $e38eb280d3b76273$export$4b80e395e36b5a56);

function $e38eb280d3b76273$export$185802fd694ee1f5() {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(4);
    if ($78ae820aa9ececfa$export$b67359430d3b1b2 != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
    }
    return out;
}
function $e38eb280d3b76273$export$9cd59f9826255e47(a) {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(4);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
function $e38eb280d3b76273$export$a82be99ed2a44a7d(x, y, z, w) {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(4);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
}
function $e38eb280d3b76273$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
function $e38eb280d3b76273$export$adaa4cf7ef1b65be(out, x, y, z, w) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
}
function $e38eb280d3b76273$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    return out;
}
function $e38eb280d3b76273$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    return out;
}
function $e38eb280d3b76273$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    out[3] = a[3] * b[3];
    return out;
}
function $e38eb280d3b76273$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    out[3] = a[3] / b[3];
    return out;
}
function $e38eb280d3b76273$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    out[2] = Math.ceil(a[2]);
    out[3] = Math.ceil(a[3]);
    return out;
}
function $e38eb280d3b76273$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    out[2] = Math.floor(a[2]);
    out[3] = Math.floor(a[3]);
    return out;
}
function $e38eb280d3b76273$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    out[3] = Math.min(a[3], b[3]);
    return out;
}
function $e38eb280d3b76273$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    out[3] = Math.max(a[3], b[3]);
    return out;
}
function $e38eb280d3b76273$export$2077e0241d6afd3c(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    out[2] = Math.round(a[2]);
    out[3] = Math.round(a[3]);
    return out;
}
function $e38eb280d3b76273$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    return out;
}
function $e38eb280d3b76273$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    return out;
}
function $e38eb280d3b76273$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    var w = b[3] - a[3];
    return Math.hypot(x, y, z, w);
}
function $e38eb280d3b76273$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    var w = b[3] - a[3];
    return x * x + y * y + z * z + w * w;
}
function $e38eb280d3b76273$export$f24224f1c91d8156(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var w = a[3];
    return Math.hypot(x, y, z, w);
}
function $e38eb280d3b76273$export$ab44e1323ffc8376(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var w = a[3];
    return x * x + y * y + z * z + w * w;
}
function $e38eb280d3b76273$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] = -a[3];
    return out;
}
function $e38eb280d3b76273$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    out[3] = 1.0 / a[3];
    return out;
}
function $e38eb280d3b76273$export$a3295358bff77e(out, a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var w = a[3];
    var len = x * x + y * y + z * z + w * w;
    if (len > 0) len = 1 / Math.sqrt(len);
    out[0] = x * len;
    out[1] = y * len;
    out[2] = z * len;
    out[3] = w * len;
    return out;
}
function $e38eb280d3b76273$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
}
function $e38eb280d3b76273$export$bb646b20bb93d339(out, u, v, w) {
    var A = v[0] * w[1] - v[1] * w[0], B = v[0] * w[2] - v[2] * w[0], C = v[0] * w[3] - v[3] * w[0], D = v[1] * w[2] - v[2] * w[1], E = v[1] * w[3] - v[3] * w[1], F = v[2] * w[3] - v[3] * w[2];
    var G = u[0];
    var H = u[1];
    var I = u[2];
    var J = u[3];
    out[0] = H * F - I * E + J * D;
    out[1] = -(G * F) + I * C - J * B;
    out[2] = G * E - H * C + J * A;
    out[3] = -(G * D) + H * B - I * A;
    return out;
}
function $e38eb280d3b76273$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    var aw = a[3];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    out[3] = aw + t * (b[3] - aw);
    return out;
}
function $e38eb280d3b76273$export$4385e60b38654f68(out, scale) {
    scale = scale || 1.0; // Marsaglia, George. Choosing a Point from the Surface of a
    // Sphere. Ann. Math. Statist. 43 (1972), no. 2, 645--646.
    // http://projecteuclid.org/euclid.aoms/1177692644;
    var v1, v2, v3, v4;
    var s1, s2;
    do {
        v1 = $78ae820aa9ececfa$export$5ada478c8a628231() * 2 - 1;
        v2 = $78ae820aa9ececfa$export$5ada478c8a628231() * 2 - 1;
        s1 = v1 * v1 + v2 * v2;
    }while (s1 >= 1);
    do {
        v3 = $78ae820aa9ececfa$export$5ada478c8a628231() * 2 - 1;
        v4 = $78ae820aa9ececfa$export$5ada478c8a628231() * 2 - 1;
        s2 = v3 * v3 + v4 * v4;
    }while (s2 >= 1);
    var d = Math.sqrt((1 - s1) / s2);
    out[0] = scale * v1;
    out[1] = scale * v2;
    out[2] = scale * v3 * d;
    out[3] = scale * v4 * d;
    return out;
}
function $e38eb280d3b76273$export$5ffbd13800309d59(out, a, m) {
    var x = a[0], y = a[1], z = a[2], w = a[3];
    out[0] = m[0] * x + m[4] * y + m[8] * z + m[12] * w;
    out[1] = m[1] * x + m[5] * y + m[9] * z + m[13] * w;
    out[2] = m[2] * x + m[6] * y + m[10] * z + m[14] * w;
    out[3] = m[3] * x + m[7] * y + m[11] * z + m[15] * w;
    return out;
}
function $e38eb280d3b76273$export$c32adef9e939ce85(out, a, q) {
    var x = a[0], y = a[1], z = a[2];
    var qx = q[0], qy = q[1], qz = q[2], qw = q[3]; // calculate quat * vec
    var ix = qw * x + qy * z - qz * y;
    var iy = qw * y + qz * x - qx * z;
    var iz = qw * z + qx * y - qy * x;
    var iw = -qx * x - qy * y - qz * z; // calculate result * inverse quat
    out[0] = ix * qw + iw * -qx + iy * -qz - iz * -qy;
    out[1] = iy * qw + iw * -qy + iz * -qx - ix * -qz;
    out[2] = iz * qw + iw * -qz + ix * -qy - iy * -qx;
    out[3] = a[3];
    return out;
}
function $e38eb280d3b76273$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    out[2] = 0.0;
    out[3] = 0.0;
    return out;
}
function $e38eb280d3b76273$export$42d51816ce590c93(a) {
    return "vec4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ")";
}
function $e38eb280d3b76273$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3];
}
function $e38eb280d3b76273$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    return Math.abs(a0 - b0) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a3), Math.abs(b3));
}
var $e38eb280d3b76273$export$f93b5905241a7cca = $e38eb280d3b76273$export$4e2d2ead65e5f7e3;
var $e38eb280d3b76273$export$6e3a27864ab166fe = $e38eb280d3b76273$export$2060d2db72cce88f;
var $e38eb280d3b76273$export$159d9494db57879b = $e38eb280d3b76273$export$cd007d971a5a2143;
var $e38eb280d3b76273$export$6c4a311cc157c764 = $e38eb280d3b76273$export$9f17032d917177de;
var $e38eb280d3b76273$export$2422cd6c492a8b3a = $e38eb280d3b76273$export$88e6ebb4fe54f538;
var $e38eb280d3b76273$export$fc1400facf92c78 = $e38eb280d3b76273$export$f24224f1c91d8156;
var $e38eb280d3b76273$export$99d8dd3f32a3435 = $e38eb280d3b76273$export$ab44e1323ffc8376;
var $e38eb280d3b76273$export$4b80e395e36b5a56 = function() {
    var vec = $e38eb280d3b76273$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 4;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            vec[3] = a[i + 3];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
            a[i + 3] = vec[3];
        }
        return a;
    };
}();


const $9ecda7333d28e490$export$434491b6b43e3f77 = {
    width: 102.4,
    height: 51.2
};
const $9ecda7333d28e490$export$85309a65275dadab = 4.0;
const $9ecda7333d28e490$export$c4cb53d5b465982a = (0, $e38eb280d3b76273$exports).fromValues(1.0, 1.0, 0.0, 1.0);
const $9ecda7333d28e490$export$a73c70156306c110 = 2;
const $9ecda7333d28e490$export$b7fc5ebeb91e65aa = 4;
const $9ecda7333d28e490$export$9fce40d9d85cc600 = 16;
const $9ecda7333d28e490$export$1829b8ee747d5960 = $9ecda7333d28e490$export$9fce40d9d85cc600 / 4;
const $9ecda7333d28e490$export$36b4d09bff0a6f5b = 0.1;
const $9ecda7333d28e490$export$9d35955117db7cdd = $9ecda7333d28e490$export$36b4d09bff0a6f5b * 4.0;
const $9ecda7333d28e490$export$10ee23b02de09a46 = (0, $ab7f6dc0910e1ef7$exports).divide((0, $ab7f6dc0910e1ef7$exports).create(), (0, $ab7f6dc0910e1ef7$exports).fromValues(0x3300, 0x3300, 0x3300), [
    8,
    8,
    8
]);
const $9ecda7333d28e490$export$f4fcb3cca4d405d6 = 8388607 // max value of a signed 24-bit number
;
const $9ecda7333d28e490$export$c2e6e7197b9c2387 = 20;
const $9ecda7333d28e490$export$44571b2f8b5f4189 = 0.75;
const $9ecda7333d28e490$export$a35ef30cbc57f2cd = 256.0 / 15.0;
const $9ecda7333d28e490$export$62ad7b0c781000e9 = {
    width: 800,
    mainViewHeight: 560,
    dashboardHeight: 200,
    totalHeight: 760,
    crosshairLength: 32,
    crosshairSpace: 20
};
// measured in BBC Elite:
//   1.6 seconds to react max roll speed
//   9.5 seconds for roll to slow to zero
//   3.5 seconds to complete 360 degrees of roll at max roll speed
//   1 second to reach max pitch speed
//   7 seconds for pitch to slow to zero
//   10.6 seconds to complete 360 degrees of pitch at max pitch speed
const $9ecda7333d28e490$var$maxRollSpeed = 2.0 * Math.PI / 3.5;
const $9ecda7333d28e490$var$maxPitchSpeed = 2.0 * Math.PI / 10;
const $9ecda7333d28e490$var$maxSpeed = 30.0;
const $9ecda7333d28e490$export$86972c5fdf46bf97 = {
    maxRollSpeed: $9ecda7333d28e490$var$maxRollSpeed,
    rollAcceleration: $9ecda7333d28e490$var$maxRollSpeed / 2,
    rollDeceleration: $9ecda7333d28e490$var$maxRollSpeed / 7.0,
    maxPitchSpeed: $9ecda7333d28e490$var$maxPitchSpeed,
    pitchAcceleration: $9ecda7333d28e490$var$maxPitchSpeed,
    pitchDeceleration: $9ecda7333d28e490$var$maxPitchSpeed / 7.0,
    maxSpeed: $9ecda7333d28e490$var$maxSpeed,
    speedAcceleration: $9ecda7333d28e490$var$maxSpeed / 3.0
};
const $9ecda7333d28e490$export$8ec305b97fc6225c = 2.0;


function $96fe3a99b59d4e0f$export$86f10caa3f7697c2(vertices) {
    return vertices.reduce((previous, current)=>({
            min: (0, $ab7f6dc0910e1ef7$exports).fromValues(Math.min(previous.min[0], current[0]), Math.min(previous.min[1], current[1]), Math.min(previous.min[2], current[2])),
            max: (0, $ab7f6dc0910e1ef7$exports).fromValues(Math.max(previous.max[0], current[0]), Math.max(previous.max[1], current[1]), Math.max(previous.max[2], current[2]))
        }), {
        min: (0, $ab7f6dc0910e1ef7$exports).fromValues(10000, 10000, 10000),
        max: (0, $ab7f6dc0910e1ef7$exports).fromValues(-10000, -10000, -10000)
    });
}
function $96fe3a99b59d4e0f$export$60b93139888724f0(constraints) {
    const size = $96fe3a99b59d4e0f$export$2a086082147fb4a2(constraints);
    return [
        // Back
        (0, $ab7f6dc0910e1ef7$exports).fromValues(-size[0] / 2, -size[1] / 2, -size[2] / 2),
        (0, $ab7f6dc0910e1ef7$exports).fromValues(size[0] / 2, -size[1] / 2, -size[2] / 2),
        (0, $ab7f6dc0910e1ef7$exports).fromValues(size[0] / 2, size[1] / 2, -size[2] / 2),
        (0, $ab7f6dc0910e1ef7$exports).fromValues(-size[0] / 2, size[1] / 2, -size[2] / 2),
        // Front
        (0, $ab7f6dc0910e1ef7$exports).fromValues(-size[0] / 2, -size[1] / 2, size[2] / 2),
        (0, $ab7f6dc0910e1ef7$exports).fromValues(size[0] / 2, -size[1] / 2, size[2] / 2),
        (0, $ab7f6dc0910e1ef7$exports).fromValues(size[0] / 2, size[1] / 2, size[2] / 2),
        (0, $ab7f6dc0910e1ef7$exports).fromValues(-size[0] / 2, size[1] / 2, size[2] / 2)
    ];
}
function $96fe3a99b59d4e0f$export$6262649942ae2f7() {
    return (0, $9ecda7333d28e490$export$a35ef30cbc57f2cd) + (Math.random() * 3 - 1);
}
function $96fe3a99b59d4e0f$export$2a086082147fb4a2(constraints) {
    return (0, $ab7f6dc0910e1ef7$exports).subtract((0, $ab7f6dc0910e1ef7$exports).create(), constraints.max, constraints.min);
}
function $96fe3a99b59d4e0f$export$2489206f4a0afd08(positions) {
    const result = [];
    for(let i = 0; i < positions.length; i += 3)result.push((0, $ab7f6dc0910e1ef7$exports).fromValues(positions[i], positions[i + 1], positions[i + 2]));
    return result;
}
function $96fe3a99b59d4e0f$export$33998d8024edc958() {
    const size = 100;
    const frameTimes = new Array(size);
    let frameIndex = 0;
    return function updateAverageFrameRate(frameTime) {
        frameTimes[frameIndex] = frameTime;
        frameIndex++;
        if (frameIndex === size) frameIndex = 0;
        return Math.round(1 / (frameTimes.reduce((a, b)=>a + b, 0) / size));
    };
}


const $35806345bc1d62c5$var$materials = {
    darkgray: [
        0.2,
        0.2,
        0.2,
        1.0
    ],
    gray: [
        0.6,
        0.6,
        0.6,
        1.0
    ],
    orange: [
        0xf5 / 255.0,
        0x9e / 255.0,
        0x0b / 255.0,
        1.0
    ],
    lightblue: [
        0x7d / 255.0,
        0xd3 / 255.0,
        0xfd / 255.0,
        1.0
    ],
    red: [
        1.0,
        0.0,
        0.0,
        1.0
    ],
    green: [
        0.0,
        1.0,
        0.0,
        1.0
    ],
    yellow: [
        1.0,
        1.0,
        0.0,
        1.0
    ],
    black: [
        0.0,
        0.0,
        0.0,
        1.0
    ]
};
function $35806345bc1d62c5$var$extractFromWrl(lines, scale, vertices, faceIndices, materialChanges, vertexNormals, vertexTextures) {
    let isReadingFaceInidcies = false;
    let isReadingCoords = false;
    lines.forEach((line)=>{
        const trimmedLine = line.trim();
        if (trimmedLine.indexOf("coordIndex [") > -1) isReadingFaceInidcies = true;
        else if (isReadingFaceInidcies) {
            if (trimmedLine.indexOf("]") > -1) isReadingFaceInidcies = false;
            else {
                const components = trimmedLine.split(",").map((s)=>s.trim()).filter((s)=>s !== "" && s !== "-1");
                // ignore more complex shapes for now
                const newFace = components.reverse().map((index)=>{
                    return {
                        vertexIndex: parseInt(index),
                        textureIndex: null,
                        normalIndex: null
                    };
                });
                faceIndices.push(newFace);
            }
        } else if (trimmedLine.indexOf("coord Coordinate { point [") > -1) isReadingCoords = true;
        else if (isReadingCoords) {
            if (trimmedLine.indexOf("]") > -1) isReadingCoords = false;
            else {
                const components = trimmedLine.replace(",", "").split(" ");
                const newVector = (0, $ab7f6dc0910e1ef7$exports).fromValues(parseFloat(components[0]) * scale, parseFloat(components[1]) * scale, parseFloat(components[2]) * scale);
                vertices.push(newVector);
            }
        }
    });
}
function $35806345bc1d62c5$var$extractFromObj(lines, scale, vertices, faceIndices, materialChanges, vertexNormals, vertexTextures) {
    lines.forEach((line)=>{
        const components = line.split(" ");
        if (components.length > 0) {
            if (components[0] == "v") {
                const newVector = (0, $ab7f6dc0910e1ef7$exports).fromValues(parseFloat(components[1]) * scale, parseFloat(components[2]) * scale, parseFloat(components[3]) * scale);
                vertices.push(newVector);
            } else if (components[0] == "f") {
                // Face can be in the formats:
                // f 1 2 3              indices for positions only
                // f 1/1 2/2 3/3        indices for positions and texcoords
                // f 1/1/1 2/2/2 3/3/3  indices for positions, texcoords, and normals
                // f 1//1 2//2 3//3     indices for positions and normals
                // Currently we deal with format f 1 2 3 and format f 1/1/1 2/2/2 3/3/3
                const newFace = components.slice(1).map((c)=>{
                    if (c.indexOf("/") > 0) {
                        let fc = c.split("/");
                        return {
                            vertexIndex: parseInt(fc[0]) - 1,
                            textureIndex: parseInt(fc[1]) - 1,
                            normalIndex: parseInt(fc[2]) - 1
                        };
                    }
                    return {
                        vertexIndex: parseInt(c) - 1,
                        textureIndex: null,
                        normalIndex: null
                    };
                });
                faceIndices.push(newFace);
            } else if (components[0] == "usemtl") //materialChanges.push({faceIndex: faceIndices.length, material: components[1]})
            {
                if ($35806345bc1d62c5$var$materials[components[1]]) // if we have the material mapped
                materialChanges[faceIndices.length] = components[1];
            } else if (components[0] == "vn") {
                const newNormal = (0, $ab7f6dc0910e1ef7$exports).fromValues(parseFloat(components[1]), parseFloat(components[2]), parseFloat(components[3]));
                vertexNormals.push(newNormal);
            } else if (components[0] === "vt") {
                const newVertexTexture = (0, $4ce98914b6676340$exports).fromValues(parseFloat(components[1]), parseFloat(components[2]));
                vertexTextures.push(newVertexTexture);
            }
        }
    });
}
async function $35806345bc1d62c5$export$86658c5a114b5e4d(path, scale) {
    const response = await fetch(path);
    const text = await response.text();
    const lines = text.split("\n");
    let vertices = [];
    let vertexNormals = [];
    const vertexTextures = [];
    const faceIndices = [];
    //const materialChanges:{[faceIndex:number], material:string}[] = []
    const materialChanges = [];
    if (path.endsWith(".obj")) $35806345bc1d62c5$var$extractFromObj(lines, scale, vertices, faceIndices, materialChanges, vertexNormals, vertexTextures);
    else if (path.endsWith(".wrl")) $35806345bc1d62c5$var$extractFromWrl(lines, scale, vertices, faceIndices, materialChanges, vertexNormals, vertexTextures);
    // Our models all have the nose pointing the wrong way so we rotate them as we load
    vertices = vertices.map((v)=>(0, $ab7f6dc0910e1ef7$exports).rotateY((0, $ab7f6dc0910e1ef7$exports).create(), v, [
            0,
            0,
            0
        ], Math.PI));
    vertexNormals = vertexNormals.map((v)=>(0, $ab7f6dc0910e1ef7$exports).rotateY((0, $ab7f6dc0910e1ef7$exports).create(), v, [
            0,
            0,
            0
        ], Math.PI));
    let currentColor = $35806345bc1d62c5$var$materials.gray;
    const faces = faceIndices.flatMap((face, index)=>{
        const numberOfTriangles = face.length - 2;
        const subFaces = [];
        const newMaterial = materialChanges[index];
        if (newMaterial) currentColor = $35806345bc1d62c5$var$materials[newMaterial];
        for(let subFaceIndex = 0; subFaceIndex < numberOfTriangles; subFaceIndex++){
            //const faceVertices = face.slice(subFaceIndex,subFaceIndex+3).map(index => vertices[index-1])
            const faceVertices = [
                vertices[face[0].vertexIndex],
                vertices[face[subFaceIndex + 1].vertexIndex],
                vertices[face[subFaceIndex + 2].vertexIndex]
            ];
            let normals = [];
            if (face[0].normalIndex !== null) normals = [
                vertexNormals[face[0].normalIndex],
                vertexNormals[face[subFaceIndex + 1].normalIndex],
                vertexNormals[face[subFaceIndex + 2].normalIndex]
            ];
            else {
                // If the model doesn't contain a normal then we calculate it
                // The normal of a triangle is the cross-product of two edges of the triangle, normalised for the lighting
                const edge1 = (0, $ab7f6dc0910e1ef7$exports).create();
                const edge2 = (0, $ab7f6dc0910e1ef7$exports).create();
                const normal = (0, $ab7f6dc0910e1ef7$exports).create();
                if (faceVertices.length < 3) debugger;
                (0, $ab7f6dc0910e1ef7$exports).subtract(edge1, faceVertices[0], faceVertices[1]);
                (0, $ab7f6dc0910e1ef7$exports).subtract(edge2, faceVertices[1], faceVertices[2]);
                (0, $ab7f6dc0910e1ef7$exports).cross(normal, edge1, edge2);
                (0, $ab7f6dc0910e1ef7$exports).normalize(normal, normal);
                normals = [
                    normal,
                    normal,
                    normal
                ];
            }
            subFaces.push({
                vertices: faceVertices,
                normals: normals,
                color: currentColor
            });
        }
        return subFaces;
    });
    return {
        vertices: vertices,
        faces: faces
    };
}
async function $35806345bc1d62c5$export$3b44a5591c39b821(gl, path, scale = 1.0) {
    const { vertices: vertices, faces: faces } = await $35806345bc1d62c5$export$86658c5a114b5e4d(path, scale);
    const models = faces.map((face)=>{
        const positions = face.vertices.flatMap((v)=>[
                v[0],
                v[1],
                v[2]
            ]);
        const normals = face.normals.flatMap((fn)=>[
                fn[0],
                fn[1],
                fn[2]
            ]);
        const indices = [
            0,
            1,
            2
        ];
        const colors = face.vertices.flatMap((_)=>face.color);
        const positionBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(positions), gl.STATIC_DRAW);
        const normalBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, normalBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(normals), gl.STATIC_DRAW);
        const indexBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, indexBuffer);
        gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(indices), gl.STATIC_DRAW);
        const colorBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, colorBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(colors), gl.STATIC_DRAW);
        let constraints = (0, $96fe3a99b59d4e0f$export$86f10caa3f7697c2)(face.vertices);
        return {
            position: positionBuffer,
            color: colorBuffer,
            indices: indexBuffer,
            normals: normalBuffer,
            vertexCount: indices.length,
            textureCoords: 0,
            texture: null,
            boundingBox: (0, $96fe3a99b59d4e0f$export$60b93139888724f0)(constraints),
            boundingBoxSize: (0, $96fe3a99b59d4e0f$export$2a086082147fb4a2)(constraints),
            faceNormal: face.normals[0]
        };
    });
    return models;
}
async function $35806345bc1d62c5$export$5cfea46336e7b8ff(gl, path, scale = 1.0) {
    const { vertices: vertices, faces: faces } = await $35806345bc1d62c5$export$86658c5a114b5e4d(path, scale);
    const positions = faces.flatMap((face)=>face.vertices.flatMap((v)=>[
                v[0],
                v[1],
                v[2]
            ])) // v.entries()
    ;
    const normals = faces.flatMap((face)=>face.normals.flatMap((fn)=>[
                fn[0],
                fn[1],
                fn[2]
            ])) // v.entries()
    ;
    const indices = faces.flatMap((_, index)=>[
            index * 3,
            index * 3 + 1,
            index * 3 + 2
        ]);
    const colors = faces.flatMap((face, index)=>{
        return face.vertices.flatMap((_)=>face.color);
    });
    const positionBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(positions), gl.STATIC_DRAW);
    const normalBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, normalBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(normals), gl.STATIC_DRAW);
    const indexBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, indexBuffer);
    gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(indices), gl.STATIC_DRAW);
    const colorBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, colorBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(colors), gl.STATIC_DRAW);
    let constraints = (0, $96fe3a99b59d4e0f$export$86f10caa3f7697c2)(vertices);
    return {
        position: positionBuffer,
        color: colorBuffer,
        indices: indexBuffer,
        normals: normalBuffer,
        vertexCount: indices.length,
        textureCoords: 0,
        texture: null,
        boundingBox: (0, $96fe3a99b59d4e0f$export$60b93139888724f0)(constraints),
        boundingBoxSize: (0, $96fe3a99b59d4e0f$export$2a086082147fb4a2)(constraints),
        faceNormal: null
    };
}
function $35806345bc1d62c5$export$7c40b2ceeb961577(gl, color, customPositions = null, flippedTexCoords = false) {
    const positions = customPositions === null ? [
        -1,
        -1,
        0.0,
        1.0,
        -1,
        0.0,
        1.0,
        1.0,
        0.0,
        -1,
        1.0,
        0.0
    ] : customPositions;
    const normals = [
        0.0,
        0.0,
        1.0,
        0.0,
        0.0,
        1.0,
        0.0,
        0.0,
        1.0,
        0.0,
        0.0,
        1.0
    ];
    const indices = [
        0,
        1,
        2,
        0,
        2,
        3
    ];
    const textureCoords = flippedTexCoords ? [
        0.0,
        1.0,
        1.0,
        1.0,
        1.0,
        0.0,
        0.0,
        0.0
    ] : [
        0.0,
        0.0,
        1.0,
        0.0,
        1.0,
        1.0,
        0.0,
        1.0
    ];
    const colors = [
        color[0],
        color[1],
        color[2],
        color[3],
        color[0],
        color[1],
        color[2],
        color[3],
        color[0],
        color[1],
        color[2],
        color[3],
        color[0],
        color[1],
        color[2],
        color[3]
    ];
    const positionBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(positions), gl.STATIC_DRAW);
    const normalBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, normalBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(normals), gl.STATIC_DRAW);
    const indexBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, indexBuffer);
    gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(indices), gl.STATIC_DRAW);
    const colorBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, colorBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(colors), gl.STATIC_DRAW);
    const textureCoordBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, textureCoordBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(textureCoords), gl.STATIC_DRAW);
    return {
        position: positionBuffer,
        color: colorBuffer,
        indices: indexBuffer,
        normals: normalBuffer,
        vertexCount: indices.length,
        textureCoords: textureCoordBuffer,
        texture: null
    };
}
function $35806345bc1d62c5$export$fdbdb3a5cc488d7e(gl, texture, flipY = true, topLeftBased = false, smoothScaling = false) {
    const positions = !topLeftBased ? [
        -1,
        -1,
        0.0,
        1.0,
        -1,
        0.0,
        1.0,
        1.0,
        0.0,
        -1,
        1.0,
        0.0
    ] : [
        0,
        0,
        0,
        2,
        0,
        0,
        2,
        2,
        0,
        0,
        2,
        0
    ];
    const normals = [
        0.0,
        0.0,
        1.0,
        0.0,
        0.0,
        1.0,
        0.0,
        0.0,
        1.0,
        0.0,
        0.0,
        1.0
    ];
    const indices = [
        0,
        1,
        2,
        0,
        2,
        3
    ];
    const textureCoords = flipY ? [
        0.0,
        1.0,
        1.0,
        1.0,
        1.0,
        0.0,
        0.0,
        0.0
    ] : [
        0.0,
        0.0,
        1.0,
        0.0,
        1.0,
        1.0,
        0.0,
        1.0
    ];
    //[0.0, 0.0, 1.0, 0.0, 1.0, 1.0, 0.0, 1.0]
    const color = [
        1.0,
        1.0,
        1.0,
        1.0
    ];
    const colors = [
        color[0],
        color[1],
        color[2],
        color[3],
        color[0],
        color[1],
        color[2],
        color[3],
        color[0],
        color[1],
        color[2],
        color[3],
        color[0],
        color[1],
        color[2],
        color[3]
    ];
    const positionBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(positions), gl.STATIC_DRAW);
    const normalBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, normalBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(normals), gl.STATIC_DRAW);
    const indexBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, indexBuffer);
    gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(indices), gl.STATIC_DRAW);
    const colorBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, colorBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(colors), gl.STATIC_DRAW);
    const textureCoordBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, textureCoordBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(textureCoords), gl.STATIC_DRAW);
    return {
        position: positionBuffer,
        color: colorBuffer,
        indices: indexBuffer,
        normals: normalBuffer,
        vertexCount: indices.length,
        textureCoords: textureCoordBuffer,
        texture: texture
    };
}




var $26675c4f95835ef1$exports = {};

$parcel$export($26675c4f95835ef1$exports, "create", () => $26675c4f95835ef1$export$185802fd694ee1f5);
$parcel$export($26675c4f95835ef1$exports, "clone", () => $26675c4f95835ef1$export$9cd59f9826255e47);
$parcel$export($26675c4f95835ef1$exports, "copy", () => $26675c4f95835ef1$export$784d13d8ee351f07);
$parcel$export($26675c4f95835ef1$exports, "fromValues", () => $26675c4f95835ef1$export$a82be99ed2a44a7d);
$parcel$export($26675c4f95835ef1$exports, "set", () => $26675c4f95835ef1$export$adaa4cf7ef1b65be);
$parcel$export($26675c4f95835ef1$exports, "identity", () => $26675c4f95835ef1$export$f0954fd7d5368655);
$parcel$export($26675c4f95835ef1$exports, "transpose", () => $26675c4f95835ef1$export$9cb09a71b7d66923);
$parcel$export($26675c4f95835ef1$exports, "invert", () => $26675c4f95835ef1$export$6897c284b6f9f4dc);
$parcel$export($26675c4f95835ef1$exports, "adjoint", () => $26675c4f95835ef1$export$33f3c024b4ae00a1);
$parcel$export($26675c4f95835ef1$exports, "determinant", () => $26675c4f95835ef1$export$a04698f914c55ed9);
$parcel$export($26675c4f95835ef1$exports, "multiply", () => $26675c4f95835ef1$export$2060d2db72cce88f);
$parcel$export($26675c4f95835ef1$exports, "translate", () => $26675c4f95835ef1$export$d73ee8ef04f5226a);
$parcel$export($26675c4f95835ef1$exports, "scale", () => $26675c4f95835ef1$export$dcdf75081b88279d);
$parcel$export($26675c4f95835ef1$exports, "rotate", () => $26675c4f95835ef1$export$bb628a54ab399bc9);
$parcel$export($26675c4f95835ef1$exports, "rotateX", () => $26675c4f95835ef1$export$a59c8716592e09af);
$parcel$export($26675c4f95835ef1$exports, "rotateY", () => $26675c4f95835ef1$export$cf71e4d4ca4d1cfd);
$parcel$export($26675c4f95835ef1$exports, "rotateZ", () => $26675c4f95835ef1$export$ea6eae3365de5b9c);
$parcel$export($26675c4f95835ef1$exports, "fromTranslation", () => $26675c4f95835ef1$export$bc9e79e74e9fddf6);
$parcel$export($26675c4f95835ef1$exports, "fromScaling", () => $26675c4f95835ef1$export$832ca188ffb1955d);
$parcel$export($26675c4f95835ef1$exports, "fromRotation", () => $26675c4f95835ef1$export$926fc125ff3c666c);
$parcel$export($26675c4f95835ef1$exports, "fromXRotation", () => $26675c4f95835ef1$export$dd47cc2f828c32ef);
$parcel$export($26675c4f95835ef1$exports, "fromYRotation", () => $26675c4f95835ef1$export$7dc997d67d2b7f33);
$parcel$export($26675c4f95835ef1$exports, "fromZRotation", () => $26675c4f95835ef1$export$ad5ddaedc8f405df);
$parcel$export($26675c4f95835ef1$exports, "fromRotationTranslation", () => $26675c4f95835ef1$export$9545ac307f2a256b);
$parcel$export($26675c4f95835ef1$exports, "fromQuat2", () => $26675c4f95835ef1$export$ff497f2be31cc6a);
$parcel$export($26675c4f95835ef1$exports, "getTranslation", () => $26675c4f95835ef1$export$202e99f82f7f0395);
$parcel$export($26675c4f95835ef1$exports, "getScaling", () => $26675c4f95835ef1$export$71dc54d92bd04b57);
$parcel$export($26675c4f95835ef1$exports, "getRotation", () => $26675c4f95835ef1$export$df3937d3b537df0a);
$parcel$export($26675c4f95835ef1$exports, "fromRotationTranslationScale", () => $26675c4f95835ef1$export$ddf9c55c9f2be172);
$parcel$export($26675c4f95835ef1$exports, "fromRotationTranslationScaleOrigin", () => $26675c4f95835ef1$export$1def1f860edc4b1f);
$parcel$export($26675c4f95835ef1$exports, "fromQuat", () => $26675c4f95835ef1$export$2ff2bbe382249af7);
$parcel$export($26675c4f95835ef1$exports, "frustum", () => $26675c4f95835ef1$export$89b5708c387cac6c);
$parcel$export($26675c4f95835ef1$exports, "perspectiveNO", () => $26675c4f95835ef1$export$4cf19729ec9a96b8);
$parcel$export($26675c4f95835ef1$exports, "perspective", () => $26675c4f95835ef1$export$541149539f3a4684);
$parcel$export($26675c4f95835ef1$exports, "perspectiveZO", () => $26675c4f95835ef1$export$294bba99a6af0c0c);
$parcel$export($26675c4f95835ef1$exports, "perspectiveFromFieldOfView", () => $26675c4f95835ef1$export$58ae211c788e338f);
$parcel$export($26675c4f95835ef1$exports, "orthoNO", () => $26675c4f95835ef1$export$c5f65ef3eb668f27);
$parcel$export($26675c4f95835ef1$exports, "ortho", () => $26675c4f95835ef1$export$4f2167e613cfc87b);
$parcel$export($26675c4f95835ef1$exports, "orthoZO", () => $26675c4f95835ef1$export$b1d31ea7b4d854e);
$parcel$export($26675c4f95835ef1$exports, "lookAt", () => $26675c4f95835ef1$export$d924e14fd6d9aa66);
$parcel$export($26675c4f95835ef1$exports, "targetTo", () => $26675c4f95835ef1$export$aa67782f4dc9e52c);
$parcel$export($26675c4f95835ef1$exports, "str", () => $26675c4f95835ef1$export$42d51816ce590c93);
$parcel$export($26675c4f95835ef1$exports, "frob", () => $26675c4f95835ef1$export$326827e8268e9cdb);
$parcel$export($26675c4f95835ef1$exports, "add", () => $26675c4f95835ef1$export$e16d8520af44a096);
$parcel$export($26675c4f95835ef1$exports, "subtract", () => $26675c4f95835ef1$export$4e2d2ead65e5f7e3);
$parcel$export($26675c4f95835ef1$exports, "multiplyScalar", () => $26675c4f95835ef1$export$c697bed75648cdb7);
$parcel$export($26675c4f95835ef1$exports, "multiplyScalarAndAdd", () => $26675c4f95835ef1$export$553579f63bdd7137);
$parcel$export($26675c4f95835ef1$exports, "exactEquals", () => $26675c4f95835ef1$export$f2599a5cf1109d8);
$parcel$export($26675c4f95835ef1$exports, "equals", () => $26675c4f95835ef1$export$e9bab7fafb253603);
$parcel$export($26675c4f95835ef1$exports, "mul", () => $26675c4f95835ef1$export$6e3a27864ab166fe);
$parcel$export($26675c4f95835ef1$exports, "sub", () => $26675c4f95835ef1$export$f93b5905241a7cca);

function $26675c4f95835ef1$export$185802fd694ee1f5() {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(16);
    if ($78ae820aa9ececfa$export$b67359430d3b1b2 != Float32Array) {
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[4] = 0;
        out[6] = 0;
        out[7] = 0;
        out[8] = 0;
        out[9] = 0;
        out[11] = 0;
        out[12] = 0;
        out[13] = 0;
        out[14] = 0;
    }
    out[0] = 1;
    out[5] = 1;
    out[10] = 1;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$9cd59f9826255e47(a) {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(16);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $26675c4f95835ef1$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $26675c4f95835ef1$export$a82be99ed2a44a7d(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(16);
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
function $26675c4f95835ef1$export$adaa4cf7ef1b65be(out, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
function $26675c4f95835ef1$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$9cb09a71b7d66923(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        var a01 = a[1], a02 = a[2], a03 = a[3];
        var a12 = a[6], a13 = a[7];
        var a23 = a[11];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a01;
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a02;
        out[9] = a12;
        out[11] = a[14];
        out[12] = a03;
        out[13] = a13;
        out[14] = a23;
    } else {
        out[0] = a[0];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a[1];
        out[5] = a[5];
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a[2];
        out[9] = a[6];
        out[10] = a[10];
        out[11] = a[14];
        out[12] = a[3];
        out[13] = a[7];
        out[14] = a[11];
        out[15] = a[15];
    }
    return out;
}
function $26675c4f95835ef1$export$6897c284b6f9f4dc(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32; // Calculate the determinant
    var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
    out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
    out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
    out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
    out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
    out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
    out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
    return out;
}
function $26675c4f95835ef1$export$33f3c024b4ae00a1(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    out[0] = a11 * (a22 * a33 - a23 * a32) - a21 * (a12 * a33 - a13 * a32) + a31 * (a12 * a23 - a13 * a22);
    out[1] = -(a01 * (a22 * a33 - a23 * a32) - a21 * (a02 * a33 - a03 * a32) + a31 * (a02 * a23 - a03 * a22));
    out[2] = a01 * (a12 * a33 - a13 * a32) - a11 * (a02 * a33 - a03 * a32) + a31 * (a02 * a13 - a03 * a12);
    out[3] = -(a01 * (a12 * a23 - a13 * a22) - a11 * (a02 * a23 - a03 * a22) + a21 * (a02 * a13 - a03 * a12));
    out[4] = -(a10 * (a22 * a33 - a23 * a32) - a20 * (a12 * a33 - a13 * a32) + a30 * (a12 * a23 - a13 * a22));
    out[5] = a00 * (a22 * a33 - a23 * a32) - a20 * (a02 * a33 - a03 * a32) + a30 * (a02 * a23 - a03 * a22);
    out[6] = -(a00 * (a12 * a33 - a13 * a32) - a10 * (a02 * a33 - a03 * a32) + a30 * (a02 * a13 - a03 * a12));
    out[7] = a00 * (a12 * a23 - a13 * a22) - a10 * (a02 * a23 - a03 * a22) + a20 * (a02 * a13 - a03 * a12);
    out[8] = a10 * (a21 * a33 - a23 * a31) - a20 * (a11 * a33 - a13 * a31) + a30 * (a11 * a23 - a13 * a21);
    out[9] = -(a00 * (a21 * a33 - a23 * a31) - a20 * (a01 * a33 - a03 * a31) + a30 * (a01 * a23 - a03 * a21));
    out[10] = a00 * (a11 * a33 - a13 * a31) - a10 * (a01 * a33 - a03 * a31) + a30 * (a01 * a13 - a03 * a11);
    out[11] = -(a00 * (a11 * a23 - a13 * a21) - a10 * (a01 * a23 - a03 * a21) + a20 * (a01 * a13 - a03 * a11));
    out[12] = -(a10 * (a21 * a32 - a22 * a31) - a20 * (a11 * a32 - a12 * a31) + a30 * (a11 * a22 - a12 * a21));
    out[13] = a00 * (a21 * a32 - a22 * a31) - a20 * (a01 * a32 - a02 * a31) + a30 * (a01 * a22 - a02 * a21);
    out[14] = -(a00 * (a11 * a32 - a12 * a31) - a10 * (a01 * a32 - a02 * a31) + a30 * (a01 * a12 - a02 * a11));
    out[15] = a00 * (a11 * a22 - a12 * a21) - a10 * (a01 * a22 - a02 * a21) + a20 * (a01 * a12 - a02 * a11);
    return out;
}
function $26675c4f95835ef1$export$a04698f914c55ed9(a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32; // Calculate the determinant
    return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
}
function $26675c4f95835ef1$export$2060d2db72cce88f(out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15]; // Cache only the current line of the second matrix
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[4];
    b1 = b[5];
    b2 = b[6];
    b3 = b[7];
    out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[8];
    b1 = b[9];
    b2 = b[10];
    b3 = b[11];
    out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[12];
    b1 = b[13];
    b2 = b[14];
    b3 = b[15];
    out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    return out;
}
function $26675c4f95835ef1$export$d73ee8ef04f5226a(out, a, v) {
    var x = v[0], y = v[1], z = v[2];
    var a00, a01, a02, a03;
    var a10, a11, a12, a13;
    var a20, a21, a22, a23;
    if (a === out) {
        out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
        out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
        out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
        out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
    } else {
        a00 = a[0];
        a01 = a[1];
        a02 = a[2];
        a03 = a[3];
        a10 = a[4];
        a11 = a[5];
        a12 = a[6];
        a13 = a[7];
        a20 = a[8];
        a21 = a[9];
        a22 = a[10];
        a23 = a[11];
        out[0] = a00;
        out[1] = a01;
        out[2] = a02;
        out[3] = a03;
        out[4] = a10;
        out[5] = a11;
        out[6] = a12;
        out[7] = a13;
        out[8] = a20;
        out[9] = a21;
        out[10] = a22;
        out[11] = a23;
        out[12] = a00 * x + a10 * y + a20 * z + a[12];
        out[13] = a01 * x + a11 * y + a21 * z + a[13];
        out[14] = a02 * x + a12 * y + a22 * z + a[14];
        out[15] = a03 * x + a13 * y + a23 * z + a[15];
    }
    return out;
}
function $26675c4f95835ef1$export$dcdf75081b88279d(out, a, v) {
    var x = v[0], y = v[1], z = v[2];
    out[0] = a[0] * x;
    out[1] = a[1] * x;
    out[2] = a[2] * x;
    out[3] = a[3] * x;
    out[4] = a[4] * y;
    out[5] = a[5] * y;
    out[6] = a[6] * y;
    out[7] = a[7] * y;
    out[8] = a[8] * z;
    out[9] = a[9] * z;
    out[10] = a[10] * z;
    out[11] = a[11] * z;
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $26675c4f95835ef1$export$bb628a54ab399bc9(out, a, rad, axis) {
    var x = axis[0], y = axis[1], z = axis[2];
    var len = Math.hypot(x, y, z);
    var s, c, t;
    var a00, a01, a02, a03;
    var a10, a11, a12, a13;
    var a20, a21, a22, a23;
    var b00, b01, b02;
    var b10, b11, b12;
    var b20, b21, b22;
    if (len < $78ae820aa9ececfa$export$fd293b15f47e270) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c;
    a00 = a[0];
    a01 = a[1];
    a02 = a[2];
    a03 = a[3];
    a10 = a[4];
    a11 = a[5];
    a12 = a[6];
    a13 = a[7];
    a20 = a[8];
    a21 = a[9];
    a22 = a[10];
    a23 = a[11]; // Construct the elements of the rotation matrix
    b00 = x * x * t + c;
    b01 = y * x * t + z * s;
    b02 = z * x * t - y * s;
    b10 = x * y * t - z * s;
    b11 = y * y * t + c;
    b12 = z * y * t + x * s;
    b20 = x * z * t + y * s;
    b21 = y * z * t - x * s;
    b22 = z * z * t + c; // Perform rotation-specific matrix multiplication
    out[0] = a00 * b00 + a10 * b01 + a20 * b02;
    out[1] = a01 * b00 + a11 * b01 + a21 * b02;
    out[2] = a02 * b00 + a12 * b01 + a22 * b02;
    out[3] = a03 * b00 + a13 * b01 + a23 * b02;
    out[4] = a00 * b10 + a10 * b11 + a20 * b12;
    out[5] = a01 * b10 + a11 * b11 + a21 * b12;
    out[6] = a02 * b10 + a12 * b11 + a22 * b12;
    out[7] = a03 * b10 + a13 * b11 + a23 * b12;
    out[8] = a00 * b20 + a10 * b21 + a20 * b22;
    out[9] = a01 * b20 + a11 * b21 + a21 * b22;
    out[10] = a02 * b20 + a12 * b21 + a22 * b22;
    out[11] = a03 * b20 + a13 * b21 + a23 * b22;
    if (a !== out) {
        // If the source and destination differ, copy the unchanged last row
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    return out;
}
function $26675c4f95835ef1$export$a59c8716592e09af(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a10 = a[4];
    var a11 = a[5];
    var a12 = a[6];
    var a13 = a[7];
    var a20 = a[8];
    var a21 = a[9];
    var a22 = a[10];
    var a23 = a[11];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged rows
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[3] = a[3];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    } // Perform axis-specific matrix multiplication
    out[4] = a10 * c + a20 * s;
    out[5] = a11 * c + a21 * s;
    out[6] = a12 * c + a22 * s;
    out[7] = a13 * c + a23 * s;
    out[8] = a20 * c - a10 * s;
    out[9] = a21 * c - a11 * s;
    out[10] = a22 * c - a12 * s;
    out[11] = a23 * c - a13 * s;
    return out;
}
function $26675c4f95835ef1$export$cf71e4d4ca4d1cfd(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a00 = a[0];
    var a01 = a[1];
    var a02 = a[2];
    var a03 = a[3];
    var a20 = a[8];
    var a21 = a[9];
    var a22 = a[10];
    var a23 = a[11];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged rows
        out[4] = a[4];
        out[5] = a[5];
        out[6] = a[6];
        out[7] = a[7];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    } // Perform axis-specific matrix multiplication
    out[0] = a00 * c - a20 * s;
    out[1] = a01 * c - a21 * s;
    out[2] = a02 * c - a22 * s;
    out[3] = a03 * c - a23 * s;
    out[8] = a00 * s + a20 * c;
    out[9] = a01 * s + a21 * c;
    out[10] = a02 * s + a22 * c;
    out[11] = a03 * s + a23 * c;
    return out;
}
function $26675c4f95835ef1$export$ea6eae3365de5b9c(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a00 = a[0];
    var a01 = a[1];
    var a02 = a[2];
    var a03 = a[3];
    var a10 = a[4];
    var a11 = a[5];
    var a12 = a[6];
    var a13 = a[7];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged last row
        out[8] = a[8];
        out[9] = a[9];
        out[10] = a[10];
        out[11] = a[11];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    } // Perform axis-specific matrix multiplication
    out[0] = a00 * c + a10 * s;
    out[1] = a01 * c + a11 * s;
    out[2] = a02 * c + a12 * s;
    out[3] = a03 * c + a13 * s;
    out[4] = a10 * c - a00 * s;
    out[5] = a11 * c - a01 * s;
    out[6] = a12 * c - a02 * s;
    out[7] = a13 * c - a03 * s;
    return out;
}
function $26675c4f95835ef1$export$bc9e79e74e9fddf6(out, v) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$832ca188ffb1955d(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = v[1];
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = v[2];
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$926fc125ff3c666c(out, rad, axis) {
    var x = axis[0], y = axis[1], z = axis[2];
    var len = Math.hypot(x, y, z);
    var s, c, t;
    if (len < $78ae820aa9ececfa$export$fd293b15f47e270) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c; // Perform rotation-specific matrix multiplication
    out[0] = x * x * t + c;
    out[1] = y * x * t + z * s;
    out[2] = z * x * t - y * s;
    out[3] = 0;
    out[4] = x * y * t - z * s;
    out[5] = y * y * t + c;
    out[6] = z * y * t + x * s;
    out[7] = 0;
    out[8] = x * z * t + y * s;
    out[9] = y * z * t - x * s;
    out[10] = z * z * t + c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$dd47cc2f828c32ef(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad); // Perform axis-specific matrix multiplication
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = c;
    out[6] = s;
    out[7] = 0;
    out[8] = 0;
    out[9] = -s;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$7dc997d67d2b7f33(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad); // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = 0;
    out[2] = -s;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = s;
    out[9] = 0;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$ad5ddaedc8f405df(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad); // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = s;
    out[2] = 0;
    out[3] = 0;
    out[4] = -s;
    out[5] = c;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$9545ac307f2a256b(out, q, v) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - (yy + zz);
    out[1] = xy + wz;
    out[2] = xz - wy;
    out[3] = 0;
    out[4] = xy - wz;
    out[5] = 1 - (xx + zz);
    out[6] = yz + wx;
    out[7] = 0;
    out[8] = xz + wy;
    out[9] = yz - wx;
    out[10] = 1 - (xx + yy);
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$ff497f2be31cc6a(out, a) {
    var translation = new $78ae820aa9ececfa$export$b67359430d3b1b2(3);
    var bx = -a[0], by = -a[1], bz = -a[2], bw = a[3], ax = a[4], ay = a[5], az = a[6], aw = a[7];
    var magnitude = bx * bx + by * by + bz * bz + bw * bw; //Only scale if it makes sense
    if (magnitude > 0) {
        translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2 / magnitude;
        translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2 / magnitude;
        translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2 / magnitude;
    } else {
        translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2;
        translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2;
        translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2;
    }
    $26675c4f95835ef1$export$9545ac307f2a256b(out, a, translation);
    return out;
}
function $26675c4f95835ef1$export$202e99f82f7f0395(out, mat) {
    out[0] = mat[12];
    out[1] = mat[13];
    out[2] = mat[14];
    return out;
}
function $26675c4f95835ef1$export$71dc54d92bd04b57(out, mat) {
    var m11 = mat[0];
    var m12 = mat[1];
    var m13 = mat[2];
    var m21 = mat[4];
    var m22 = mat[5];
    var m23 = mat[6];
    var m31 = mat[8];
    var m32 = mat[9];
    var m33 = mat[10];
    out[0] = Math.hypot(m11, m12, m13);
    out[1] = Math.hypot(m21, m22, m23);
    out[2] = Math.hypot(m31, m32, m33);
    return out;
}
function $26675c4f95835ef1$export$df3937d3b537df0a(out, mat) {
    var scaling = new $78ae820aa9ececfa$export$b67359430d3b1b2(3);
    $26675c4f95835ef1$export$71dc54d92bd04b57(scaling, mat);
    var is1 = 1 / scaling[0];
    var is2 = 1 / scaling[1];
    var is3 = 1 / scaling[2];
    var sm11 = mat[0] * is1;
    var sm12 = mat[1] * is2;
    var sm13 = mat[2] * is3;
    var sm21 = mat[4] * is1;
    var sm22 = mat[5] * is2;
    var sm23 = mat[6] * is3;
    var sm31 = mat[8] * is1;
    var sm32 = mat[9] * is2;
    var sm33 = mat[10] * is3;
    var trace = sm11 + sm22 + sm33;
    var S = 0;
    if (trace > 0) {
        S = Math.sqrt(trace + 1.0) * 2;
        out[3] = 0.25 * S;
        out[0] = (sm23 - sm32) / S;
        out[1] = (sm31 - sm13) / S;
        out[2] = (sm12 - sm21) / S;
    } else if (sm11 > sm22 && sm11 > sm33) {
        S = Math.sqrt(1.0 + sm11 - sm22 - sm33) * 2;
        out[3] = (sm23 - sm32) / S;
        out[0] = 0.25 * S;
        out[1] = (sm12 + sm21) / S;
        out[2] = (sm31 + sm13) / S;
    } else if (sm22 > sm33) {
        S = Math.sqrt(1.0 + sm22 - sm11 - sm33) * 2;
        out[3] = (sm31 - sm13) / S;
        out[0] = (sm12 + sm21) / S;
        out[1] = 0.25 * S;
        out[2] = (sm23 + sm32) / S;
    } else {
        S = Math.sqrt(1.0 + sm33 - sm11 - sm22) * 2;
        out[3] = (sm12 - sm21) / S;
        out[0] = (sm31 + sm13) / S;
        out[1] = (sm23 + sm32) / S;
        out[2] = 0.25 * S;
    }
    return out;
}
function $26675c4f95835ef1$export$ddf9c55c9f2be172(out, q, v, s) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    var sx = s[0];
    var sy = s[1];
    var sz = s[2];
    out[0] = (1 - (yy + zz)) * sx;
    out[1] = (xy + wz) * sx;
    out[2] = (xz - wy) * sx;
    out[3] = 0;
    out[4] = (xy - wz) * sy;
    out[5] = (1 - (xx + zz)) * sy;
    out[6] = (yz + wx) * sy;
    out[7] = 0;
    out[8] = (xz + wy) * sz;
    out[9] = (yz - wx) * sz;
    out[10] = (1 - (xx + yy)) * sz;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$1def1f860edc4b1f(out, q, v, s, o) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    var sx = s[0];
    var sy = s[1];
    var sz = s[2];
    var ox = o[0];
    var oy = o[1];
    var oz = o[2];
    var out0 = (1 - (yy + zz)) * sx;
    var out1 = (xy + wz) * sx;
    var out2 = (xz - wy) * sx;
    var out4 = (xy - wz) * sy;
    var out5 = (1 - (xx + zz)) * sy;
    var out6 = (yz + wx) * sy;
    var out8 = (xz + wy) * sz;
    var out9 = (yz - wx) * sz;
    var out10 = (1 - (xx + yy)) * sz;
    out[0] = out0;
    out[1] = out1;
    out[2] = out2;
    out[3] = 0;
    out[4] = out4;
    out[5] = out5;
    out[6] = out6;
    out[7] = 0;
    out[8] = out8;
    out[9] = out9;
    out[10] = out10;
    out[11] = 0;
    out[12] = v[0] + ox - (out0 * ox + out4 * oy + out8 * oz);
    out[13] = v[1] + oy - (out1 * ox + out5 * oy + out9 * oz);
    out[14] = v[2] + oz - (out2 * ox + out6 * oy + out10 * oz);
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$2ff2bbe382249af7(out, q) {
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var yx = y * x2;
    var yy = y * y2;
    var zx = z * x2;
    var zy = z * y2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - yy - zz;
    out[1] = yx + wz;
    out[2] = zx - wy;
    out[3] = 0;
    out[4] = yx - wz;
    out[5] = 1 - xx - zz;
    out[6] = zy + wx;
    out[7] = 0;
    out[8] = zx + wy;
    out[9] = zy - wx;
    out[10] = 1 - xx - yy;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$89b5708c387cac6c(out, left, right, bottom, top, near, far) {
    var rl = 1 / (right - left);
    var tb = 1 / (top - bottom);
    var nf = 1 / (near - far);
    out[0] = near * 2 * rl;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = near * 2 * tb;
    out[6] = 0;
    out[7] = 0;
    out[8] = (right + left) * rl;
    out[9] = (top + bottom) * tb;
    out[10] = (far + near) * nf;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[14] = far * near * 2 * nf;
    out[15] = 0;
    return out;
}
function $26675c4f95835ef1$export$4cf19729ec9a96b8(out, fovy, aspect, near, far) {
    var f = 1.0 / Math.tan(fovy / 2), nf;
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[15] = 0;
    if (far != null && far !== Infinity) {
        nf = 1 / (near - far);
        out[10] = (far + near) * nf;
        out[14] = 2 * far * near * nf;
    } else {
        out[10] = -1;
        out[14] = -2 * near;
    }
    return out;
}
var $26675c4f95835ef1$export$541149539f3a4684 = $26675c4f95835ef1$export$4cf19729ec9a96b8;
function $26675c4f95835ef1$export$294bba99a6af0c0c(out, fovy, aspect, near, far) {
    var f = 1.0 / Math.tan(fovy / 2), nf;
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[15] = 0;
    if (far != null && far !== Infinity) {
        nf = 1 / (near - far);
        out[10] = far * nf;
        out[14] = far * near * nf;
    } else {
        out[10] = -1;
        out[14] = -near;
    }
    return out;
}
function $26675c4f95835ef1$export$58ae211c788e338f(out, fov, near, far) {
    var upTan = Math.tan(fov.upDegrees * Math.PI / 180.0);
    var downTan = Math.tan(fov.downDegrees * Math.PI / 180.0);
    var leftTan = Math.tan(fov.leftDegrees * Math.PI / 180.0);
    var rightTan = Math.tan(fov.rightDegrees * Math.PI / 180.0);
    var xScale = 2.0 / (leftTan + rightTan);
    var yScale = 2.0 / (upTan + downTan);
    out[0] = xScale;
    out[1] = 0.0;
    out[2] = 0.0;
    out[3] = 0.0;
    out[4] = 0.0;
    out[5] = yScale;
    out[6] = 0.0;
    out[7] = 0.0;
    out[8] = -((leftTan - rightTan) * xScale * 0.5);
    out[9] = (upTan - downTan) * yScale * 0.5;
    out[10] = far / (near - far);
    out[11] = -1;
    out[12] = 0.0;
    out[13] = 0.0;
    out[14] = far * near / (near - far);
    out[15] = 0.0;
    return out;
}
function $26675c4f95835ef1$export$c5f65ef3eb668f27(out, left, right, bottom, top, near, far) {
    var lr = 1 / (left - right);
    var bt = 1 / (bottom - top);
    var nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 2 * nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = (far + near) * nf;
    out[15] = 1;
    return out;
}
var $26675c4f95835ef1$export$4f2167e613cfc87b = $26675c4f95835ef1$export$c5f65ef3eb668f27;
function $26675c4f95835ef1$export$b1d31ea7b4d854e(out, left, right, bottom, top, near, far) {
    var lr = 1 / (left - right);
    var bt = 1 / (bottom - top);
    var nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = near * nf;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$d924e14fd6d9aa66(out, eye, center, up) {
    var x0, x1, x2, y0, y1, y2, z0, z1, z2, len;
    var eyex = eye[0];
    var eyey = eye[1];
    var eyez = eye[2];
    var upx = up[0];
    var upy = up[1];
    var upz = up[2];
    var centerx = center[0];
    var centery = center[1];
    var centerz = center[2];
    if (Math.abs(eyex - centerx) < $78ae820aa9ececfa$export$fd293b15f47e270 && Math.abs(eyey - centery) < $78ae820aa9ececfa$export$fd293b15f47e270 && Math.abs(eyez - centerz) < $78ae820aa9ececfa$export$fd293b15f47e270) return $26675c4f95835ef1$export$f0954fd7d5368655(out);
    z0 = eyex - centerx;
    z1 = eyey - centery;
    z2 = eyez - centerz;
    len = 1 / Math.hypot(z0, z1, z2);
    z0 *= len;
    z1 *= len;
    z2 *= len;
    x0 = upy * z2 - upz * z1;
    x1 = upz * z0 - upx * z2;
    x2 = upx * z1 - upy * z0;
    len = Math.hypot(x0, x1, x2);
    if (!len) {
        x0 = 0;
        x1 = 0;
        x2 = 0;
    } else {
        len = 1 / len;
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }
    y0 = z1 * x2 - z2 * x1;
    y1 = z2 * x0 - z0 * x2;
    y2 = z0 * x1 - z1 * x0;
    len = Math.hypot(y0, y1, y2);
    if (!len) {
        y0 = 0;
        y1 = 0;
        y2 = 0;
    } else {
        len = 1 / len;
        y0 *= len;
        y1 *= len;
        y2 *= len;
    }
    out[0] = x0;
    out[1] = y0;
    out[2] = z0;
    out[3] = 0;
    out[4] = x1;
    out[5] = y1;
    out[6] = z1;
    out[7] = 0;
    out[8] = x2;
    out[9] = y2;
    out[10] = z2;
    out[11] = 0;
    out[12] = -(x0 * eyex + x1 * eyey + x2 * eyez);
    out[13] = -(y0 * eyex + y1 * eyey + y2 * eyez);
    out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$aa67782f4dc9e52c(out, eye, target, up) {
    var eyex = eye[0], eyey = eye[1], eyez = eye[2], upx = up[0], upy = up[1], upz = up[2];
    var z0 = eyex - target[0], z1 = eyey - target[1], z2 = eyez - target[2];
    var len = z0 * z0 + z1 * z1 + z2 * z2;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        z0 *= len;
        z1 *= len;
        z2 *= len;
    }
    var x0 = upy * z2 - upz * z1, x1 = upz * z0 - upx * z2, x2 = upx * z1 - upy * z0;
    len = x0 * x0 + x1 * x1 + x2 * x2;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }
    out[0] = x0;
    out[1] = x1;
    out[2] = x2;
    out[3] = 0;
    out[4] = z1 * x2 - z2 * x1;
    out[5] = z2 * x0 - z0 * x2;
    out[6] = z0 * x1 - z1 * x0;
    out[7] = 0;
    out[8] = z0;
    out[9] = z1;
    out[10] = z2;
    out[11] = 0;
    out[12] = eyex;
    out[13] = eyey;
    out[14] = eyez;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$42d51816ce590c93(a) {
    return "mat4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ", " + a[8] + ", " + a[9] + ", " + a[10] + ", " + a[11] + ", " + a[12] + ", " + a[13] + ", " + a[14] + ", " + a[15] + ")";
}
function $26675c4f95835ef1$export$326827e8268e9cdb(a) {
    return Math.hypot(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]);
}
function $26675c4f95835ef1$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    out[6] = a[6] + b[6];
    out[7] = a[7] + b[7];
    out[8] = a[8] + b[8];
    out[9] = a[9] + b[9];
    out[10] = a[10] + b[10];
    out[11] = a[11] + b[11];
    out[12] = a[12] + b[12];
    out[13] = a[13] + b[13];
    out[14] = a[14] + b[14];
    out[15] = a[15] + b[15];
    return out;
}
function $26675c4f95835ef1$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    out[6] = a[6] - b[6];
    out[7] = a[7] - b[7];
    out[8] = a[8] - b[8];
    out[9] = a[9] - b[9];
    out[10] = a[10] - b[10];
    out[11] = a[11] - b[11];
    out[12] = a[12] - b[12];
    out[13] = a[13] - b[13];
    out[14] = a[14] - b[14];
    out[15] = a[15] - b[15];
    return out;
}
function $26675c4f95835ef1$export$c697bed75648cdb7(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    out[6] = a[6] * b;
    out[7] = a[7] * b;
    out[8] = a[8] * b;
    out[9] = a[9] * b;
    out[10] = a[10] * b;
    out[11] = a[11] * b;
    out[12] = a[12] * b;
    out[13] = a[13] * b;
    out[14] = a[14] * b;
    out[15] = a[15] * b;
    return out;
}
function $26675c4f95835ef1$export$553579f63bdd7137(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    out[4] = a[4] + b[4] * scale;
    out[5] = a[5] + b[5] * scale;
    out[6] = a[6] + b[6] * scale;
    out[7] = a[7] + b[7] * scale;
    out[8] = a[8] + b[8] * scale;
    out[9] = a[9] + b[9] * scale;
    out[10] = a[10] + b[10] * scale;
    out[11] = a[11] + b[11] * scale;
    out[12] = a[12] + b[12] * scale;
    out[13] = a[13] + b[13] * scale;
    out[14] = a[14] + b[14] * scale;
    out[15] = a[15] + b[15] * scale;
    return out;
}
function $26675c4f95835ef1$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && a[8] === b[8] && a[9] === b[9] && a[10] === b[10] && a[11] === b[11] && a[12] === b[12] && a[13] === b[13] && a[14] === b[14] && a[15] === b[15];
}
function $26675c4f95835ef1$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var a4 = a[4], a5 = a[5], a6 = a[6], a7 = a[7];
    var a8 = a[8], a9 = a[9], a10 = a[10], a11 = a[11];
    var a12 = a[12], a13 = a[13], a14 = a[14], a15 = a[15];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    var b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7];
    var b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11];
    var b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    return Math.abs(a0 - b0) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a7), Math.abs(b7)) && Math.abs(a8 - b8) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a8), Math.abs(b8)) && Math.abs(a9 - b9) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a9), Math.abs(b9)) && Math.abs(a10 - b10) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a10), Math.abs(b10)) && Math.abs(a11 - b11) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a11), Math.abs(b11)) && Math.abs(a12 - b12) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a12), Math.abs(b12)) && Math.abs(a13 - b13) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a13), Math.abs(b13)) && Math.abs(a14 - b14) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a14), Math.abs(b14)) && Math.abs(a15 - b15) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a15), Math.abs(b15));
}
var $26675c4f95835ef1$export$6e3a27864ab166fe = $26675c4f95835ef1$export$2060d2db72cce88f;
var $26675c4f95835ef1$export$f93b5905241a7cca = $26675c4f95835ef1$export$4e2d2ead65e5f7e3;



function $7f388262d447fe43$export$c9fcf1a7df975d78(value) {
    return value * Math.PI / 180;
}
function $7f388262d447fe43$export$c41dd2a8460d3196(value) {
    return value * (180 / Math.PI);
}
function $7f388262d447fe43$export$a4787b691d7e1d4a(object) {
    const roofNoseDp = (0, $ab7f6dc0910e1ef7$exports).dot(object.roofOrientation, object.noseOrientation);
    const projectedRoof = (0, $ab7f6dc0910e1ef7$exports).subtract((0, $ab7f6dc0910e1ef7$exports).create(), object.roofOrientation, (0, $ab7f6dc0910e1ef7$exports).multiply((0, $ab7f6dc0910e1ef7$exports).create(), object.noseOrientation, [
        roofNoseDp,
        roofNoseDp,
        roofNoseDp
    ]));
    return Math.acos((0, $ab7f6dc0910e1ef7$exports).dot(projectedRoof, [
        0,
        1,
        0
    ]) / (0, $ab7f6dc0910e1ef7$exports).length(projectedRoof));
}
function $7f388262d447fe43$export$a5b5f976d1977bf8(object) {
    const noseRoofDp = (0, $ab7f6dc0910e1ef7$exports).dot(object.noseOrientation, object.roofOrientation);
    const projectedNose = (0, $ab7f6dc0910e1ef7$exports).subtract((0, $ab7f6dc0910e1ef7$exports).create(), object.noseOrientation, (0, $ab7f6dc0910e1ef7$exports).multiply((0, $ab7f6dc0910e1ef7$exports).create(), object.roofOrientation, [
        noseRoofDp,
        noseRoofDp,
        noseRoofDp
    ]));
    return Math.asin((0, $ab7f6dc0910e1ef7$exports).dot(projectedNose, object.roofOrientation) / (0, $ab7f6dc0910e1ef7$exports).length(projectedNose));
}
function $7f388262d447fe43$export$ba956a95b4dd3faa(object, roll, pitch) {
    (0, $ab7f6dc0910e1ef7$exports).rotateZ(object.noseOrientation, object.noseOrientation, [
        0,
        0,
        0
    ], roll);
    (0, $ab7f6dc0910e1ef7$exports).rotateZ(object.roofOrientation, object.roofOrientation, [
        0,
        0,
        0
    ], roll);
    (0, $ab7f6dc0910e1ef7$exports).rotateZ(object.rightOrientation, object.rightOrientation, [
        0,
        0,
        0
    ], roll);
    (0, $ab7f6dc0910e1ef7$exports).rotateX(object.noseOrientation, object.noseOrientation, [
        0,
        0,
        0
    ], pitch);
    (0, $ab7f6dc0910e1ef7$exports).rotateX(object.roofOrientation, object.roofOrientation, [
        0,
        0,
        0
    ], pitch);
    (0, $ab7f6dc0910e1ef7$exports).rotateX(object.rightOrientation, object.rightOrientation, [
        0,
        0,
        0
    ], pitch);
    (0, $ab7f6dc0910e1ef7$exports).normalize(object.noseOrientation, object.noseOrientation);
    (0, $ab7f6dc0910e1ef7$exports).normalize(object.roofOrientation, object.roofOrientation);
    (0, $ab7f6dc0910e1ef7$exports).normalize(object.rightOrientation, object.rightOrientation);
}
function $7f388262d447fe43$export$b0c15eba69b661a3(object, roll, pitch) {
    (0, $ab7f6dc0910e1ef7$exports).rotateZ(object.position, object.position, [
        0,
        0,
        0
    ], roll);
    (0, $ab7f6dc0910e1ef7$exports).rotateX(object.position, object.position, [
        0,
        0,
        0
    ], pitch);
}
function $7f388262d447fe43$export$ca0109456ce3ba30(position, noseOrientation, roofOrientation, sideOrientation) {
    const matrix = (0, $26675c4f95835ef1$exports).fromValues(sideOrientation[0], roofOrientation[0], noseOrientation[0], 0, sideOrientation[1], roofOrientation[1], noseOrientation[1], 0, sideOrientation[2], roofOrientation[2], noseOrientation[2], 0, 0, 0, 0, 1);
    return (0, $ab7f6dc0910e1ef7$exports).transformMat4((0, $ab7f6dc0910e1ef7$exports).create(), position, matrix);
}
function $7f388262d447fe43$export$c0dacefa48ee416f(player, timeDelta) {
    const velocity = player.isJumping ? player.blueprint.maxSpeed * timeDelta * (0, $9ecda7333d28e490$export$b7fc5ebeb91e65aa) * (0, $9ecda7333d28e490$export$9fce40d9d85cc600) : player.speed * timeDelta * (0, $9ecda7333d28e490$export$b7fc5ebeb91e65aa);
    return (0, $ab7f6dc0910e1ef7$exports).fromValues(0, 0, velocity);
}
function $7f388262d447fe43$export$f994db713d41a0b0(player) {
    return -player.blueprint.maxRollSpeed / 4 // if we start allowing ships to be bought we need to base this on the Cobra
    ;
}
function $7f388262d447fe43$export$370625d67a2003b1(game) {
    return game.localBubble.planet.radius * 2;
}
function $7f388262d447fe43$export$58abe552d7cf95ed(vector) {
    return (0, $ab7f6dc0910e1ef7$exports).fromValues(vector[0] * -1, vector[1] * -1, vector[2] * -1);
}
function $7f388262d447fe43$export$d947e5f4f4c48d48(object, delta) {
    (0, $ab7f6dc0910e1ef7$exports).add(object.position, object.position, delta);
}
function $7f388262d447fe43$export$49e3e06be0b9aca3(object) {
    const noseAngle = Math.acos((0, $ab7f6dc0910e1ef7$exports).dot(object.noseOrientation, [
        0,
        0,
        -1
    ]) / ((0, $ab7f6dc0910e1ef7$exports).length(object.noseOrientation) * (0, $ab7f6dc0910e1ef7$exports).length([
        0,
        0,
        -1
    ])));
    const roofAngle = Math.acos((0, $ab7f6dc0910e1ef7$exports).dot(object.roofOrientation, [
        0,
        1,
        0
    ]) / ((0, $ab7f6dc0910e1ef7$exports).length(object.roofOrientation) * (0, $ab7f6dc0910e1ef7$exports).length([
        0,
        1,
        0
    ])));
    const sideAngle = Math.acos((0, $ab7f6dc0910e1ef7$exports).dot(object.rightOrientation, [
        1,
        0,
        0
    ]) / ((0, $ab7f6dc0910e1ef7$exports).length(object.rightOrientation) * (0, $ab7f6dc0910e1ef7$exports).length([
        1,
        0,
        0
    ])));
    return [
        noseAngle,
        roofAngle,
        sideAngle
    ];
}
function $7f388262d447fe43$export$db81c1c6139254cd(noseOrientation, roofOrientation, sideOrientation) {
    const noseAngle = Math.acos((0, $ab7f6dc0910e1ef7$exports).dot(noseOrientation, [
        0,
        0,
        -1
    ]) / ((0, $ab7f6dc0910e1ef7$exports).length(noseOrientation) * (0, $ab7f6dc0910e1ef7$exports).length([
        0,
        0,
        -1
    ])));
    const roofAngle = Math.acos((0, $ab7f6dc0910e1ef7$exports).dot(roofOrientation, [
        0,
        1,
        0
    ]) / ((0, $ab7f6dc0910e1ef7$exports).length(roofOrientation) * (0, $ab7f6dc0910e1ef7$exports).length([
        0,
        1,
        0
    ])));
    const sideAngle = Math.acos((0, $ab7f6dc0910e1ef7$exports).dot(sideOrientation, [
        1,
        0,
        0
    ]) / ((0, $ab7f6dc0910e1ef7$exports).length(sideOrientation) * (0, $ab7f6dc0910e1ef7$exports).length([
        1,
        0,
        0
    ])));
    return [
        noseAngle,
        roofAngle,
        sideAngle
    ];
}



function $97e646fb7d266a2f$export$3ed9b644ed65412a(pt, rect) {
    return pt[0] >= rect.left && pt[0] < rect.left + rect.width && pt[1] >= rect.top && pt[1] < rect.top + rect.height;
}
function $97e646fb7d266a2f$export$9f17032d917177de(p1, p2) {
    const xDelta = p2.x - p1.x;
    const yDelta = p2.y - p1.y;
    return Math.sqrt(xDelta * xDelta + yDelta * yDelta);
}
function $97e646fb7d266a2f$export$eb65091739aed595(noseOrientation) {
    const roofOrientation = (0, $ab7f6dc0910e1ef7$exports).rotateX((0, $ab7f6dc0910e1ef7$exports).create(), noseOrientation, [
        0,
        0,
        0
    ], (0, $7f388262d447fe43$export$c9fcf1a7df975d78)(-90));
    const sideOrientation = (0, $ab7f6dc0910e1ef7$exports).rotateY((0, $ab7f6dc0910e1ef7$exports).create(), noseOrientation, [
        0,
        0,
        0
    ], (0, $7f388262d447fe43$export$c9fcf1a7df975d78)(90));
    return {
        noseOrientation: noseOrientation,
        roofOrientation: roofOrientation,
        sideOrientation: sideOrientation
    };
}
function $97e646fb7d266a2f$export$a3c26af9c425194b(p, projectionMatrix) {
    const position = (0, $e38eb280d3b76273$exports).fromValues(p[0], p[1], p[2], 0);
    const projectedPosition = (0, $e38eb280d3b76273$exports).transformMat4((0, $e38eb280d3b76273$exports).create(), position, projectionMatrix);
    const x = projectedPosition[0] / projectedPosition[3];
    const y = projectedPosition[1] / projectedPosition[3];
    const viewportX = (x + 1) / 2 * (0, $9ecda7333d28e490$export$62ad7b0c781000e9).width;
    const viewportY = (1 - y) / 2 * (0, $9ecda7333d28e490$export$62ad7b0c781000e9).mainViewHeight;
    return (0, $4ce98914b6676340$exports).fromValues(viewportX, viewportY);
}


function $523e85573fbedc7e$var$createSingleAudioPlayer(path) {
    return new Promise((resolve)=>{
        const player = new Audio(path);
        player.addEventListener("canplaythrough", ()=>resolve(player), false);
    });
}
async function $523e85573fbedc7e$var$createAudioPlayer(path) {
    const players = [];
    for(let i = 0; i < 4; i++)players.push(await $523e85573fbedc7e$var$createSingleAudioPlayer(path));
    let currentIndex = 0;
    return function(volume = 1.0) {
        players[currentIndex].volume = volume;
        players[currentIndex].play();
        currentIndex++;
        if (currentIndex >= players.length) currentIndex = 0;
    };
}
async function $523e85573fbedc7e$export$6857af9612b3890d() {
    return {
        bootUp: await $523e85573fbedc7e$var$createAudioPlayer("audio/BBC Boot Sound.mp3"),
        docked: await $523e85573fbedc7e$var$createAudioPlayer("audio/Docked.mp3"),
        enemyLaserHit: await $523e85573fbedc7e$var$createAudioPlayer("audio/Enemy Laser Hit.mp3"),
        enemyLaserMiss: await $523e85573fbedc7e$var$createAudioPlayer("audio/Enemy Laser Miss.mp3"),
        hyperspace: await $523e85573fbedc7e$var$createAudioPlayer("audio/Hyperspace.mp3"),
        jumpBlocked: await $523e85573fbedc7e$var$createAudioPlayer("audio/Jump Blocked.mp3"),
        launch: await $523e85573fbedc7e$var$createAudioPlayer("audio/Launch.mp3"),
        playerLaserHit: await $523e85573fbedc7e$var$createAudioPlayer("audio/Player Laser Hit.mp3"),
        playerLaserMiss: await $523e85573fbedc7e$var$createAudioPlayer("audio/Player Laser Miss.mp3"),
        shipExplosion: await $523e85573fbedc7e$var$createAudioPlayer("audio/Ship Explosion.mp3")
    };
}


async function $899aa7500e099a06$var$loadShaderSource(name) {
    const fragResponse = await fetch(`shaders/${name}.frag`);
    const vertResponse = await fetch(`shaders/${name}.vert`);
    return {
        frag: await fragResponse.text(),
        vert: await vertResponse.text()
    };
}
async function $899aa7500e099a06$export$d3d08d944062d7e(gl, instructionsGl) {
    const ships = await $899aa7500e099a06$var$loadShipSpecifications(gl);
    const shaderNames = [
        "stardust",
        "ship",
        "planet",
        "sun",
        "uColor",
        "text",
        "simpleTexture",
        "crt",
        "ambercrt",
        "greencrt",
        "vcr",
        "motionblur"
    ];
    const loadedShaders = await Promise.all(shaderNames.map((sn)=>$899aa7500e099a06$var$loadShaderSource(sn)));
    const namedShaders = new Map(shaderNames.map((sn, index)=>[
            sn,
            loadedShaders[index]
        ]));
    const planets = await Promise.all([
        "./mars.png",
        "./neptune.png",
        "./venusSurface.png",
        "./venusAtmosphere.png",
        "./saturn.png",
        "./uranus.png",
        "./mercury.png",
        "./moon.png",
        "./ceres.png",
        "./eris.png",
        "./haumea.png",
        "./makemake.png"
    ].map((t)=>(0, $91201f5d84ae2499$export$19de0130f5adf0ae)(gl, t)));
    const textureNames = [
        "noise",
        "font",
        "starmask",
        "scanner"
    ];
    const loadedTextures = await Promise.all(textureNames.map((tn)=>(0, $91201f5d84ae2499$export$19de0130f5adf0ae)(gl, `./${tn}.png`)));
    const textures = new Map(loadedTextures.map((t, i)=>[
            textureNames[i],
            t
        ]));
    const instructionFont = await (0, $91201f5d84ae2499$export$19de0130f5adf0ae)(instructionsGl, "font.png");
    const traderIndexes = ships.map((s, i)=>({
            s: s,
            i: i
        })).filter(({ s: s })=>s.canBeTrader).map(({ i: i })=>i);
    const bountyHunterIndexes = ships.map((s, i)=>({
            s: s,
            i: i
        })).filter(({ s: s })=>s.canBeBountyHunter).map(({ i: i })=>i);
    const pirateIndexes = ships.map((s, i)=>({
            s: s,
            i: i
        })).filter(({ s: s })=>s.canBePirate).map(({ i: i })=>i);
    const rockHermitIndexes = ships.map((s, i)=>({
            s: s,
            i: i
        })).filter(({ s: s })=>s.canBeRockHermit).map(({ i: i })=>i);
    return {
        ships: {
            numberOfShips: ships.length,
            traderIndexes: traderIndexes,
            bountyHunterIndexes: bountyHunterIndexes,
            pirateIndexes: pirateIndexes,
            rockHermitIndexes: rockHermitIndexes,
            getInstanceOfModel: (model, position, noseOrientation)=>$899aa7500e099a06$var$toInstance(ships.filter((s)=>s.model === model)[0], position, noseOrientation),
            getRandomShip: ()=>$899aa7500e099a06$var$getRandomShip(ships),
            getIndexedShip: (index, position, noseOrientation)=>$899aa7500e099a06$var$toInstance(ships[index], position, noseOrientation),
            getCobraMk3: (position, noseOrientation)=>$899aa7500e099a06$var$getNamedShip(ships, "Cobra Mk III", position, noseOrientation),
            getThargoid: (position, noseOrientation)=>$899aa7500e099a06$var$getNamedShip(ships, "Thargoid", position, noseOrientation, (0, $cf8fd949337d3b75$export$a3bb2a5ab3320756).Thargoid),
            getCoriolis: (position, noseOrientation)=>$899aa7500e099a06$var$getNamedShip(ships, "Coriolis", position, noseOrientation, (0, $cf8fd949337d3b75$export$a3bb2a5ab3320756).Station),
            getAsteroid: (position, noseOrientation)=>$899aa7500e099a06$var$getNamedShip(ships, "Asteroid", position, noseOrientation, (0, $cf8fd949337d3b75$export$a3bb2a5ab3320756).Asteroid),
            getBoulder: (position, noseOrientation)=>$899aa7500e099a06$var$getNamedShip(ships, "Boulder", position, noseOrientation, (0, $cf8fd949337d3b75$export$a3bb2a5ab3320756).Asteroid),
            getCargo: (position, noseOrientation)=>$899aa7500e099a06$var$getNamedShip(ships, "Thargoid", position, noseOrientation, (0, $cf8fd949337d3b75$export$a3bb2a5ab3320756).Cargo),
            getTransporter: (position, noseOrientation)=>$899aa7500e099a06$var$getNamedShip(ships, "Transporter", position, noseOrientation, (0, $cf8fd949337d3b75$export$a3bb2a5ab3320756).Cargo),
            getShuttle: (position, noseOrientation)=>$899aa7500e099a06$var$getNamedShip(ships, "Shuttle", position, noseOrientation, (0, $cf8fd949337d3b75$export$a3bb2a5ab3320756).Cargo)
        },
        textures: {
            planets: planets,
            noise: textures.get("noise"),
            font: textures.get("font"),
            starmask: textures.get("starmask"),
            scanner: textures.get("scanner"),
            // We load the instructions font separately as its used in a different GL context
            instructionsFont: instructionFont
        },
        shaderSource: {
            stardust: namedShaders.get("stardust"),
            ship: namedShaders.get("ship"),
            planet: namedShaders.get("planet"),
            sun: namedShaders.get("sun"),
            uColor: namedShaders.get("uColor"),
            text: namedShaders.get("text"),
            simpleTexture: namedShaders.get("simpleTexture"),
            crt: namedShaders.get("crt"),
            amberCrt: namedShaders.get("ambercrt"),
            greenCrt: namedShaders.get("greencrt"),
            vcr: namedShaders.get("vcr"),
            motionBlur: namedShaders.get("motionblur")
        },
        soundEffects: await (0, $523e85573fbedc7e$export$6857af9612b3890d)()
    };
}
function $899aa7500e099a06$var$getNamedShip(ships, name, position, noseOrientation, role) {
    return $899aa7500e099a06$var$toInstance(ships.find((s)=>s.name === name), position, noseOrientation, role);
}
function $899aa7500e099a06$var$toInstance(ship, position, noseOrientation, role) {
    const orientations = (0, $97e646fb7d266a2f$export$eb65091739aed595)(noseOrientation);
    return {
        role: role ?? (0, $cf8fd949337d3b75$export$a3bb2a5ab3320756).Trader,
        blueprint: ship,
        position: (0, $ab7f6dc0910e1ef7$exports).copy((0, $ab7f6dc0910e1ef7$exports).create(), position),
        noseOrientation: (0, $ab7f6dc0910e1ef7$exports).copy((0, $ab7f6dc0910e1ef7$exports).create(), noseOrientation),
        roofOrientation: (0, $ab7f6dc0910e1ef7$exports).copy((0, $ab7f6dc0910e1ef7$exports).create(), orientations.roofOrientation),
        rightOrientation: (0, $ab7f6dc0910e1ef7$exports).copy((0, $ab7f6dc0910e1ef7$exports).create(), orientations.sideOrientation),
        roll: 0.0,
        pitch: 0.0,
        speed: 0.0,
        rendering: {
            shininess: 16.0
        },
        boundingBox: ship.renderingModel.boundingBox.map((v)=>(0, $ab7f6dc0910e1ef7$exports).copy((0, $ab7f6dc0910e1ef7$exports).create(), v)),
        aggressionLevel: Math.floor(Math.random() * 32),
        hasECM: false,
        hasEscapePod: false,
        aiEnabled: false,
        missiles: ship.maxAiMissiles,
        attitude: (0, $cf8fd949337d3b75$export$6c83a620f27ed611).Friendly,
        energy: ship.maxAiEnergy,
        timeLeftFiringLasers: null,
        fixedDirectionOfMovement: ship.fixedDirectionOfMovement ? (0, $ab7f6dc0910e1ef7$exports).copy((0, $ab7f6dc0910e1ef7$exports).create(), noseOrientation) : null,
        acceleration: (0, $cf8fd949337d3b75$export$568b6dd3ac70608c).None,
        rollAcceleration: (0, $cf8fd949337d3b75$export$568b6dd3ac70608c).None,
        pitchAcceleration: (0, $cf8fd949337d3b75$export$568b6dd3ac70608c).None,
        isDestroyed: false,
        tacticsState: {
            timeUntilNextStateChange: 0,
            flyingTowards: (0, $cf8fd949337d3b75$export$d0bfecb5b13bed3c).None,
            canApplyTactics: false
        }
    };
}
function $899aa7500e099a06$var$getRandomShip(ships) {
    return ships[Math.floor(Math.random() * ships.length)];
}
async function $899aa7500e099a06$var$loadShipSpecifications(gl) {
    const playerDefaults = {
        rollAcceleration: (0, $9ecda7333d28e490$export$86972c5fdf46bf97).rollAcceleration,
        rollDeceleration: (0, $9ecda7333d28e490$export$86972c5fdf46bf97).rollDeceleration,
        maxRollSpeed: (0, $9ecda7333d28e490$export$86972c5fdf46bf97).maxRollSpeed,
        pitchAcceleration: (0, $9ecda7333d28e490$export$86972c5fdf46bf97).pitchAcceleration,
        pitchDeceleration: (0, $9ecda7333d28e490$export$86972c5fdf46bf97).pitchDeceleration,
        maxPitchSpeed: (0, $9ecda7333d28e490$export$86972c5fdf46bf97).maxPitchSpeed,
        speedAcceleration: (0, $9ecda7333d28e490$export$86972c5fdf46bf97).speedAcceleration,
        numberOfEnergyBanks: 4,
        maxEnergy: 255,
        maxFuel: 70,
        maxCabinTemperature: 255,
        maxLaserTemperature: 255,
        maxAltitude: 255,
        maxForwardShield: 255,
        maxAftShield: 255,
        maxMissiles: 4,
        maxCargo: 20,
        pregameScale: 1
    };
    const loadingShips = [
        {
            name: "Cobra Mk III",
            model: (0, $17751991aa2dcc8b$export$7d04abf91eb22fb).CobraMk3,
            renderingModel: (0, $35806345bc1d62c5$export$5cfea46336e7b8ff)(gl, "ships/cobra3.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            explosion: (0, $35806345bc1d62c5$export$3b44a5591c39b821)(gl, "ships/cobra3.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            ...playerDefaults,
            pregameScale: 2,
            maxSpeed: (0, $9ecda7333d28e490$export$86972c5fdf46bf97).maxSpeed,
            canBeTrader: true,
            canBePirate: true,
            canBeBountyHunter: true,
            fixedDirectionOfMovement: false,
            maxCanistersOnDeath: 3,
            targetableArea: 9025,
            laserPower: 2,
            maxAiMissiles: 3,
            maxAiEnergy: 150,
            bounty: 0,
            canBeRockHermit: false
        },
        {
            name: "Adder",
            model: (0, $17751991aa2dcc8b$export$7d04abf91eb22fb).Adder,
            renderingModel: (0, $35806345bc1d62c5$export$5cfea46336e7b8ff)(gl, "ships/adder.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            explosion: (0, $35806345bc1d62c5$export$3b44a5591c39b821)(gl, "ships/adder.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            ...playerDefaults,
            pregameScale: 4,
            maxSpeed: 24,
            canBeTrader: false,
            canBePirate: false,
            canBeBountyHunter: false,
            fixedDirectionOfMovement: false,
            maxCanistersOnDeath: 0,
            targetableArea: 2500,
            laserPower: 2,
            maxAiMissiles: 0,
            maxAiEnergy: 85,
            bounty: 4.0,
            canBeRockHermit: true
        },
        {
            name: "Anaconda",
            model: (0, $17751991aa2dcc8b$export$7d04abf91eb22fb).Anaconda,
            renderingModel: (0, $35806345bc1d62c5$export$5cfea46336e7b8ff)(gl, "ships/anaconda.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            explosion: (0, $35806345bc1d62c5$export$3b44a5591c39b821)(gl, "ships/anaconda.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            ...playerDefaults,
            pregameScale: 1.5,
            maxSpeed: 14,
            canBeTrader: true,
            canBePirate: false,
            canBeBountyHunter: false,
            fixedDirectionOfMovement: false,
            maxCanistersOnDeath: 7,
            targetableArea: 10000,
            laserPower: 7,
            maxAiMissiles: 7,
            maxAiEnergy: 252,
            bounty: 0,
            canBeRockHermit: false
        },
        {
            name: "Asp",
            model: (0, $17751991aa2dcc8b$export$7d04abf91eb22fb).Asp,
            renderingModel: (0, $35806345bc1d62c5$export$5cfea46336e7b8ff)(gl, "ships/asp2.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            explosion: (0, $35806345bc1d62c5$export$3b44a5591c39b821)(gl, "ships/asp2.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            ...playerDefaults,
            pregameScale: 3,
            maxSpeed: 40,
            canBeTrader: false,
            canBePirate: false,
            canBeBountyHunter: true,
            fixedDirectionOfMovement: false,
            maxCanistersOnDeath: 0,
            targetableArea: 3600,
            laserPower: 5,
            maxAiMissiles: 1,
            maxAiEnergy: 150,
            bounty: 20.0,
            canBeRockHermit: false
        },
        {
            name: "Asteroid",
            model: (0, $17751991aa2dcc8b$export$7d04abf91eb22fb).Asteroid,
            renderingModel: (0, $35806345bc1d62c5$export$5cfea46336e7b8ff)(gl, "ships/asteroid.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            explosion: (0, $35806345bc1d62c5$export$3b44a5591c39b821)(gl, "ships/asteroid.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            ...playerDefaults,
            pregameScale: 2,
            maxSpeed: 10,
            canBeTrader: false,
            canBePirate: false,
            canBeBountyHunter: false,
            fixedDirectionOfMovement: true,
            maxCanistersOnDeath: 0,
            targetableArea: 6400,
            laserPower: 0,
            maxAiMissiles: 0,
            maxAiEnergy: 60,
            bounty: 0.5,
            canBeRockHermit: false
        },
        {
            name: "Boa",
            model: (0, $17751991aa2dcc8b$export$7d04abf91eb22fb).Boa,
            renderingModel: (0, $35806345bc1d62c5$export$5cfea46336e7b8ff)(gl, "ships/boa.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            explosion: (0, $35806345bc1d62c5$export$3b44a5591c39b821)(gl, "ships/boa.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            ...playerDefaults,
            pregameScale: 2,
            maxSpeed: 24,
            canBeTrader: true,
            canBePirate: false,
            canBeBountyHunter: false,
            fixedDirectionOfMovement: false,
            maxCanistersOnDeath: 5,
            targetableArea: 4900,
            laserPower: 3,
            maxAiMissiles: 4,
            maxAiEnergy: 250,
            bounty: 0,
            canBeRockHermit: false
        },
        {
            name: "Boulder",
            model: (0, $17751991aa2dcc8b$export$7d04abf91eb22fb).Boulder,
            renderingModel: (0, $35806345bc1d62c5$export$5cfea46336e7b8ff)(gl, "ships/boulder.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            explosion: (0, $35806345bc1d62c5$export$3b44a5591c39b821)(gl, "ships/boulder.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            ...playerDefaults,
            pregameScale: 4,
            maxSpeed: 12,
            canBeTrader: false,
            canBePirate: false,
            canBeBountyHunter: false,
            fixedDirectionOfMovement: true,
            maxCanistersOnDeath: 0,
            targetableArea: 900,
            laserPower: 0,
            maxAiMissiles: 0,
            maxAiEnergy: 20,
            bounty: 0.1,
            canBeRockHermit: false
        },
        {
            name: "Cargo",
            model: (0, $17751991aa2dcc8b$export$7d04abf91eb22fb).Cargo,
            renderingModel: (0, $35806345bc1d62c5$export$5cfea46336e7b8ff)(gl, "ships/cargo.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            explosion: (0, $35806345bc1d62c5$export$3b44a5591c39b821)(gl, "ships/cargo.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            ...playerDefaults,
            pregameScale: 6,
            maxSpeed: 20,
            canBeTrader: false,
            canBePirate: false,
            canBeBountyHunter: false,
            fixedDirectionOfMovement: true,
            maxCanistersOnDeath: 0,
            targetableArea: 400,
            laserPower: 0,
            maxAiMissiles: 0,
            maxAiEnergy: 17,
            bounty: 0,
            canBeRockHermit: false
        },
        {
            name: "Cobra Mk I",
            model: (0, $17751991aa2dcc8b$export$7d04abf91eb22fb).CobraMk1,
            renderingModel: (0, $35806345bc1d62c5$export$5cfea46336e7b8ff)(gl, "ships/cobra1.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            explosion: (0, $35806345bc1d62c5$export$3b44a5591c39b821)(gl, "ships/cobra1.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            ...playerDefaults,
            pregameScale: 3,
            maxSpeed: 26,
            canBeTrader: false,
            canBePirate: true,
            canBeBountyHunter: false,
            fixedDirectionOfMovement: false,
            maxCanistersOnDeath: 3,
            targetableArea: 9801,
            laserPower: 2,
            maxAiMissiles: 2,
            maxAiEnergy: 90,
            bounty: 7.5,
            canBeRockHermit: false
        },
        {
            name: "Constrictor",
            model: (0, $17751991aa2dcc8b$export$7d04abf91eb22fb).Constrictor,
            renderingModel: (0, $35806345bc1d62c5$export$5cfea46336e7b8ff)(gl, "ships/constric.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            explosion: (0, $35806345bc1d62c5$export$3b44a5591c39b821)(gl, "ships/constric.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            ...playerDefaults,
            pregameScale: 3,
            maxSpeed: 36,
            canBeTrader: false,
            canBePirate: false,
            canBeBountyHunter: false,
            fixedDirectionOfMovement: false,
            maxCanistersOnDeath: 3,
            targetableArea: 4225,
            laserPower: 6,
            maxAiMissiles: 4,
            maxAiEnergy: 252,
            bounty: 0,
            canBeRockHermit: false
        },
        {
            name: "Coriolis",
            model: (0, $17751991aa2dcc8b$export$7d04abf91eb22fb).Coriolis,
            renderingModel: (0, $35806345bc1d62c5$export$5cfea46336e7b8ff)(gl, "ships/coriolis.obj", (0, $9ecda7333d28e490$export$9d35955117db7cdd)),
            explosion: (0, $35806345bc1d62c5$export$3b44a5591c39b821)(gl, "ships/coriolis.obj", (0, $9ecda7333d28e490$export$9d35955117db7cdd)),
            ...playerDefaults,
            pregameScale: 0.25,
            maxSpeed: 0,
            canBeTrader: false,
            canBePirate: false,
            canBeBountyHunter: false,
            fixedDirectionOfMovement: false,
            maxCanistersOnDeath: 0,
            targetableArea: 25600,
            laserPower: 0,
            maxAiMissiles: 6,
            maxAiEnergy: 240,
            bounty: 0,
            canBeRockHermit: false
        },
        {
            name: "Dodo",
            model: (0, $17751991aa2dcc8b$export$7d04abf91eb22fb).Dodo,
            renderingModel: (0, $35806345bc1d62c5$export$5cfea46336e7b8ff)(gl, "ships/dodo.obj", (0, $9ecda7333d28e490$export$9d35955117db7cdd)),
            explosion: (0, $35806345bc1d62c5$export$3b44a5591c39b821)(gl, "ships/dodo.obj", (0, $9ecda7333d28e490$export$9d35955117db7cdd)),
            ...playerDefaults,
            pregameScale: 0.2,
            maxSpeed: 0,
            canBeTrader: false,
            canBePirate: false,
            canBeBountyHunter: false,
            fixedDirectionOfMovement: false,
            maxCanistersOnDeath: 0,
            targetableArea: 32400,
            laserPower: 0,
            maxAiMissiles: 0,
            maxAiEnergy: 240,
            bounty: 0,
            canBeRockHermit: false
        },
        {
            name: "Escape Pod",
            model: (0, $17751991aa2dcc8b$export$7d04abf91eb22fb).EscapePod,
            renderingModel: (0, $35806345bc1d62c5$export$5cfea46336e7b8ff)(gl, "ships/escape.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            explosion: (0, $35806345bc1d62c5$export$3b44a5591c39b821)(gl, "ships/escape.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            ...playerDefaults,
            pregameScale: 6,
            maxSpeed: 8,
            canBeTrader: false,
            canBePirate: false,
            canBeBountyHunter: false,
            fixedDirectionOfMovement: false,
            maxCanistersOnDeath: 0,
            targetableArea: 256,
            laserPower: 0,
            maxAiMissiles: 0,
            maxAiEnergy: 17,
            bounty: 0,
            canBeRockHermit: false
        },
        {
            name: "Fer de Lance",
            model: (0, $17751991aa2dcc8b$export$7d04abf91eb22fb).FerDeLance,
            renderingModel: (0, $35806345bc1d62c5$export$5cfea46336e7b8ff)(gl, "ships/ferdelan.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            explosion: (0, $35806345bc1d62c5$export$3b44a5591c39b821)(gl, "ships/ferdelan.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            ...playerDefaults,
            pregameScale: 3,
            maxSpeed: 30,
            canBeTrader: false,
            canBePirate: false,
            canBeBountyHunter: true,
            fixedDirectionOfMovement: false,
            maxCanistersOnDeath: 0,
            targetableArea: 1600,
            laserPower: 2,
            maxAiMissiles: 3,
            maxAiEnergy: 160,
            bounty: 0,
            canBeRockHermit: false
        },
        {
            name: "Gecko",
            model: (0, $17751991aa2dcc8b$export$7d04abf91eb22fb).Gecko,
            renderingModel: (0, $35806345bc1d62c5$export$5cfea46336e7b8ff)(gl, "ships/gecko.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            explosion: (0, $35806345bc1d62c5$export$3b44a5591c39b821)(gl, "ships/gecko.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            ...playerDefaults,
            pregameScale: 3,
            maxSpeed: 30,
            canBeTrader: false,
            canBePirate: true,
            canBeBountyHunter: false,
            fixedDirectionOfMovement: false,
            maxCanistersOnDeath: 0,
            targetableArea: 9801,
            laserPower: 2,
            maxAiMissiles: 0,
            maxAiEnergy: 70,
            bounty: 5.5,
            canBeRockHermit: true
        },
        {
            name: "Krait",
            model: (0, $17751991aa2dcc8b$export$7d04abf91eb22fb).Krait,
            renderingModel: (0, $35806345bc1d62c5$export$5cfea46336e7b8ff)(gl, "ships/krait.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            explosion: (0, $35806345bc1d62c5$export$3b44a5591c39b821)(gl, "ships/krait.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            ...playerDefaults,
            pregameScale: 2.5,
            maxSpeed: 30,
            canBeTrader: false,
            canBePirate: true,
            canBeBountyHunter: false,
            fixedDirectionOfMovement: false,
            maxCanistersOnDeath: 1,
            targetableArea: 3600,
            laserPower: 2,
            maxAiMissiles: 0,
            maxAiEnergy: 80,
            bounty: 10.0,
            canBeRockHermit: true
        },
        {
            name: "Mamba",
            model: (0, $17751991aa2dcc8b$export$7d04abf91eb22fb).Mamba,
            renderingModel: (0, $35806345bc1d62c5$export$5cfea46336e7b8ff)(gl, "ships/mamba.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            explosion: (0, $35806345bc1d62c5$export$3b44a5591c39b821)(gl, "ships/mamba.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            ...playerDefaults,
            pregameScale: 3,
            maxSpeed: 32,
            canBeTrader: false,
            canBePirate: true,
            canBeBountyHunter: false,
            fixedDirectionOfMovement: false,
            maxCanistersOnDeath: 1,
            targetableArea: 4900,
            laserPower: 2,
            maxAiMissiles: 2,
            maxAiEnergy: 90,
            bounty: 15.0,
            canBeRockHermit: true
        },
        {
            name: "Missile",
            model: (0, $17751991aa2dcc8b$export$7d04abf91eb22fb).Missile,
            renderingModel: (0, $35806345bc1d62c5$export$5cfea46336e7b8ff)(gl, "ships/missile.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            explosion: (0, $35806345bc1d62c5$export$3b44a5591c39b821)(gl, "ships/missile.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            ...playerDefaults,
            pregameScale: 7,
            maxSpeed: 44,
            canBeTrader: false,
            canBePirate: false,
            canBeBountyHunter: false,
            fixedDirectionOfMovement: false,
            maxCanistersOnDeath: 0,
            targetableArea: 1600,
            laserPower: 0,
            maxAiMissiles: 0,
            maxAiEnergy: 2,
            bounty: 0,
            canBeRockHermit: false
        },
        {
            name: "Moray",
            model: (0, $17751991aa2dcc8b$export$7d04abf91eb22fb).Moray,
            renderingModel: (0, $35806345bc1d62c5$export$5cfea46336e7b8ff)(gl, "ships/moray.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            explosion: (0, $35806345bc1d62c5$export$3b44a5591c39b821)(gl, "ships/moray.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            ...playerDefaults,
            pregameScale: 3,
            maxSpeed: 25,
            canBeTrader: false,
            canBePirate: false,
            canBeBountyHunter: false,
            fixedDirectionOfMovement: false,
            maxCanistersOnDeath: 1,
            targetableArea: 900,
            laserPower: 2,
            maxAiMissiles: 0,
            maxAiEnergy: 100,
            bounty: 5.0,
            canBeRockHermit: false
        },
        {
            name: "Python",
            model: (0, $17751991aa2dcc8b$export$7d04abf91eb22fb).Python,
            renderingModel: (0, $35806345bc1d62c5$export$5cfea46336e7b8ff)(gl, "ships/python.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            explosion: (0, $35806345bc1d62c5$export$3b44a5591c39b821)(gl, "ships/python.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            ...playerDefaults,
            pregameScale: 1.5,
            maxSpeed: 20,
            canBeTrader: true,
            canBePirate: false,
            canBeBountyHunter: true,
            fixedDirectionOfMovement: false,
            maxCanistersOnDeath: 5,
            targetableArea: 6400,
            laserPower: 3,
            maxAiMissiles: 3,
            maxAiEnergy: 250,
            bounty: 0,
            canBeRockHermit: false
        },
        {
            name: "Shuttle",
            model: (0, $17751991aa2dcc8b$export$7d04abf91eb22fb).Shuttle,
            renderingModel: (0, $35806345bc1d62c5$export$5cfea46336e7b8ff)(gl, "ships/shuttle.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            explosion: (0, $35806345bc1d62c5$export$3b44a5591c39b821)(gl, "ships/shuttle.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            ...playerDefaults,
            pregameScale: 4,
            maxSpeed: 8,
            canBeTrader: false,
            canBePirate: false,
            canBeBountyHunter: false,
            fixedDirectionOfMovement: false,
            maxCanistersOnDeath: 15,
            targetableArea: 2500,
            laserPower: 0,
            maxAiMissiles: 0,
            maxAiEnergy: 32,
            bounty: 0,
            canBeRockHermit: false
        },
        {
            name: "Sidewinder",
            model: (0, $17751991aa2dcc8b$export$7d04abf91eb22fb).Sidewinder,
            renderingModel: (0, $35806345bc1d62c5$export$5cfea46336e7b8ff)(gl, "ships/sidewind.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            explosion: (0, $35806345bc1d62c5$export$3b44a5591c39b821)(gl, "ships/sidewind.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            ...playerDefaults,
            pregameScale: 3,
            maxSpeed: 37,
            canBeTrader: false,
            canBePirate: true,
            canBeBountyHunter: false,
            fixedDirectionOfMovement: false,
            maxCanistersOnDeath: 0,
            targetableArea: 4225,
            laserPower: 2,
            maxAiMissiles: 0,
            maxAiEnergy: 70,
            bounty: 5.0,
            canBeRockHermit: true
        },
        {
            name: "Thargoid",
            model: (0, $17751991aa2dcc8b$export$7d04abf91eb22fb).Thargoid,
            renderingModel: (0, $35806345bc1d62c5$export$5cfea46336e7b8ff)(gl, "ships/thargoid.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            explosion: (0, $35806345bc1d62c5$export$3b44a5591c39b821)(gl, "ships/thargoid.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            ...playerDefaults,
            pregameScale: 1.2,
            maxSpeed: 39,
            canBeTrader: false,
            canBePirate: false,
            canBeBountyHunter: false,
            fixedDirectionOfMovement: false,
            maxCanistersOnDeath: 7,
            targetableArea: 9801,
            laserPower: 2,
            maxAiMissiles: 6,
            maxAiEnergy: 240,
            bounty: 50.0,
            canBeRockHermit: false
        },
        {
            name: "Transporter",
            model: (0, $17751991aa2dcc8b$export$7d04abf91eb22fb).Transporter,
            renderingModel: (0, $35806345bc1d62c5$export$5cfea46336e7b8ff)(gl, "ships/trans.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            explosion: (0, $35806345bc1d62c5$export$3b44a5591c39b821)(gl, "ships/trans.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            ...playerDefaults,
            pregameScale: 3,
            maxSpeed: 10,
            canBeTrader: false,
            canBePirate: false,
            canBeBountyHunter: false,
            fixedDirectionOfMovement: false,
            maxCanistersOnDeath: 0,
            targetableArea: 2500,
            laserPower: 0,
            maxAiMissiles: 0,
            maxAiEnergy: 32,
            bounty: 0,
            canBeRockHermit: false
        },
        {
            name: "Viper",
            model: (0, $17751991aa2dcc8b$export$7d04abf91eb22fb).Viper,
            renderingModel: (0, $35806345bc1d62c5$export$5cfea46336e7b8ff)(gl, "ships/viper.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            explosion: (0, $35806345bc1d62c5$export$3b44a5591c39b821)(gl, "ships/viper.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            ...playerDefaults,
            pregameScale: 3.5,
            maxSpeed: 32,
            canBeTrader: false,
            canBePirate: false,
            canBeBountyHunter: false,
            fixedDirectionOfMovement: false,
            maxCanistersOnDeath: 0,
            targetableArea: 5625,
            laserPower: 2,
            maxAiMissiles: 1,
            maxAiEnergy: 140,
            bounty: 0,
            canBeRockHermit: false
        },
        {
            name: "Worm",
            model: (0, $17751991aa2dcc8b$export$7d04abf91eb22fb).Worm,
            renderingModel: (0, $35806345bc1d62c5$export$5cfea46336e7b8ff)(gl, "ships/worm.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            explosion: (0, $35806345bc1d62c5$export$3b44a5591c39b821)(gl, "ships/worm.obj", (0, $9ecda7333d28e490$export$36b4d09bff0a6f5b)),
            ...playerDefaults,
            pregameScale: 4,
            maxSpeed: 23,
            canBeTrader: false,
            canBePirate: true,
            canBeBountyHunter: false,
            fixedDirectionOfMovement: false,
            maxCanistersOnDeath: 0,
            targetableArea: 9801,
            laserPower: 1,
            maxAiMissiles: 0,
            maxAiEnergy: 30,
            bounty: 0,
            canBeRockHermit: false
        }
    ];
    const loadedShips = await Promise.all(loadingShips.map((ls)=>ls.renderingModel));
    const explodedShips = await Promise.all(loadingShips.map((ls)=>ls.explosion));
    return loadingShips.map((ls, lsi)=>({
            ...ls,
            renderingModel: loadedShips[lsi],
            explosion: explodedShips[lsi]
        }));
}




function $5c04dc271aaba117$export$441ba46c5fcd50d9(gl) {
    gl.clearColor(0.0, 0.0, 0.0, 1.0);
    gl.clearDepth(1.0);
    gl.disable(gl.DEPTH_TEST);
    gl.depthFunc(gl.LEQUAL);
    gl.enable(gl.BLEND);
    gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
}
function $5c04dc271aaba117$export$5e145c486af18f03(draw2d) {
    const sz = draw2d.size();
    draw2d.rect([
        0,
        0
    ], [
        sz.width,
        (0, $9ecda7333d28e490$export$85309a65275dadab)
    ], (0, $9ecda7333d28e490$export$c4cb53d5b465982a));
    draw2d.rect([
        0,
        sz.height - (0, $9ecda7333d28e490$export$85309a65275dadab)
    ], [
        sz.width,
        (0, $9ecda7333d28e490$export$85309a65275dadab)
    ], (0, $9ecda7333d28e490$export$c4cb53d5b465982a));
    draw2d.rect([
        0,
        0
    ], [
        (0, $9ecda7333d28e490$export$85309a65275dadab),
        sz.height
    ], (0, $9ecda7333d28e490$export$c4cb53d5b465982a));
    draw2d.rect([
        sz.width - (0, $9ecda7333d28e490$export$85309a65275dadab),
        0
    ], [
        (0, $9ecda7333d28e490$export$85309a65275dadab),
        sz.height
    ], (0, $9ecda7333d28e490$export$c4cb53d5b465982a));
}
function $5c04dc271aaba117$export$d1bc072841c808d0(gl, frameBuffer, width, height, x = 0, y = 0) {
    gl.bindFramebuffer(gl.FRAMEBUFFER, frameBuffer);
    gl.viewport(x, y, width, height);
}
function $5c04dc271aaba117$export$792a1e95a9bc00fc(gl, width, height) {
    const texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    const level = 0;
    const internalFormat = gl.RGBA;
    const border = 0;
    const format = gl.RGBA;
    const type = gl.UNSIGNED_BYTE;
    const data = null;
    gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, width, height, border, format, type, data);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    return texture;
}
function $5c04dc271aaba117$export$3fb2efb4293ebbde(width, height, zFar) {
    const fieldOfView = 45 * Math.PI / 180 // in radians
    ;
    const aspect = width / height;
    const zNear = 0.1;
    const projectionMatrix = (0, $26675c4f95835ef1$exports).create();
    // note: glmatrix.js always has the first argument
    // as the destination to receive the result.
    (0, $26675c4f95835ef1$exports).perspective(projectionMatrix, fieldOfView, aspect, zNear, zFar);
    return projectionMatrix;
}


// Our font strip contains characters that are 8 pixels wide and 16 pixels high.
// Each character is positioned at a 16 offset (character 0 - x = 0, character 1 x = 16, character 2 x = 32 etc.)
// There are 96 characters in the strip
function $747b70bb26c9cf6e$export$83674196993caf59(gl, type, source) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
        alert(`An error occurred compiling the shaders: ${gl.getShaderInfoLog(shader)}`);
        gl.deleteShader(shader);
        return null;
    }
    return shader;
}
let $747b70bb26c9cf6e$var$shaderMap = new Map();
function $747b70bb26c9cf6e$export$5f960e5136fd65f5(gl, vsSource, fsSource) {
    const key = `${vsSource}:${fsSource}`;
    let shaderProgram = $747b70bb26c9cf6e$var$shaderMap.get(key);
    if (!shaderProgram) {
        const vertexShader = $747b70bb26c9cf6e$export$83674196993caf59(gl, gl.VERTEX_SHADER, vsSource);
        const fragmentShader = $747b70bb26c9cf6e$export$83674196993caf59(gl, gl.FRAGMENT_SHADER, fsSource);
        shaderProgram = gl.createProgram();
        gl.attachShader(shaderProgram, vertexShader);
        gl.attachShader(shaderProgram, fragmentShader);
        gl.linkProgram(shaderProgram);
        if (!gl.getProgramParameter(shaderProgram, gl.LINK_STATUS)) {
            alert(`Unable to initialize the shader program: ${gl.getProgramInfoLog(shaderProgram)}`);
            return null;
        }
        $747b70bb26c9cf6e$var$shaderMap.set(key, shaderProgram);
    }
    return shaderProgram;
}
function $747b70bb26c9cf6e$export$f7c2b6763dc47773(gl, source) {
    const vertexShader = $747b70bb26c9cf6e$export$83674196993caf59(gl, gl.VERTEX_SHADER, source.vert);
    const fragmentShader = $747b70bb26c9cf6e$export$83674196993caf59(gl, gl.FRAGMENT_SHADER, source.frag);
    const shaderProgram = gl.createProgram();
    gl.attachShader(shaderProgram, vertexShader);
    gl.attachShader(shaderProgram, fragmentShader);
    gl.linkProgram(shaderProgram);
    if (!gl.getProgramParameter(shaderProgram, gl.LINK_STATUS)) {
        alert(`Unable to initialize the shader program: ${gl.getProgramInfoLog(shaderProgram)}`);
        return null;
    }
    return shaderProgram;
}



var $e92e4eb8d35aaf31$exports = {};

$parcel$export($e92e4eb8d35aaf31$exports, "create", () => $e92e4eb8d35aaf31$export$185802fd694ee1f5);
$parcel$export($e92e4eb8d35aaf31$exports, "identity", () => $e92e4eb8d35aaf31$export$f0954fd7d5368655);
$parcel$export($e92e4eb8d35aaf31$exports, "setAxisAngle", () => $e92e4eb8d35aaf31$export$4286ddefc8f49512);
$parcel$export($e92e4eb8d35aaf31$exports, "getAxisAngle", () => $e92e4eb8d35aaf31$export$3f70be5e7d7dc51);
$parcel$export($e92e4eb8d35aaf31$exports, "getAngle", () => $e92e4eb8d35aaf31$export$b363da9ded343252);
$parcel$export($e92e4eb8d35aaf31$exports, "dot", () => $e92e4eb8d35aaf31$export$94132a0e348806d4);
$parcel$export($e92e4eb8d35aaf31$exports, "multiply", () => $e92e4eb8d35aaf31$export$2060d2db72cce88f);
$parcel$export($e92e4eb8d35aaf31$exports, "rotateX", () => $e92e4eb8d35aaf31$export$a59c8716592e09af);
$parcel$export($e92e4eb8d35aaf31$exports, "rotateY", () => $e92e4eb8d35aaf31$export$cf71e4d4ca4d1cfd);
$parcel$export($e92e4eb8d35aaf31$exports, "rotateZ", () => $e92e4eb8d35aaf31$export$ea6eae3365de5b9c);
$parcel$export($e92e4eb8d35aaf31$exports, "calculateW", () => $e92e4eb8d35aaf31$export$fb72b72e8d764d4e);
$parcel$export($e92e4eb8d35aaf31$exports, "exp", () => $e92e4eb8d35aaf31$export$b310ec824aaee37f);
$parcel$export($e92e4eb8d35aaf31$exports, "ln", () => $e92e4eb8d35aaf31$export$876cb1b29620556f);
$parcel$export($e92e4eb8d35aaf31$exports, "pow", () => $e92e4eb8d35aaf31$export$9c297f60e22e3389);
$parcel$export($e92e4eb8d35aaf31$exports, "scale", () => $e92e4eb8d35aaf31$export$dcdf75081b88279d);
$parcel$export($e92e4eb8d35aaf31$exports, "slerp", () => $e92e4eb8d35aaf31$export$1544d9bc2995de08);
$parcel$export($e92e4eb8d35aaf31$exports, "random", () => $e92e4eb8d35aaf31$export$4385e60b38654f68);
$parcel$export($e92e4eb8d35aaf31$exports, "invert", () => $e92e4eb8d35aaf31$export$6897c284b6f9f4dc);
$parcel$export($e92e4eb8d35aaf31$exports, "conjugate", () => $e92e4eb8d35aaf31$export$7679f47e72c62560);
$parcel$export($e92e4eb8d35aaf31$exports, "fromMat3", () => $e92e4eb8d35aaf31$export$272a1eb8e5a4b55b);
$parcel$export($e92e4eb8d35aaf31$exports, "fromEuler", () => $e92e4eb8d35aaf31$export$7a404a587ea85af);
$parcel$export($e92e4eb8d35aaf31$exports, "str", () => $e92e4eb8d35aaf31$export$42d51816ce590c93);
$parcel$export($e92e4eb8d35aaf31$exports, "clone", () => $e92e4eb8d35aaf31$export$9cd59f9826255e47);
$parcel$export($e92e4eb8d35aaf31$exports, "fromValues", () => $e92e4eb8d35aaf31$export$a82be99ed2a44a7d);
$parcel$export($e92e4eb8d35aaf31$exports, "copy", () => $e92e4eb8d35aaf31$export$784d13d8ee351f07);
$parcel$export($e92e4eb8d35aaf31$exports, "set", () => $e92e4eb8d35aaf31$export$adaa4cf7ef1b65be);
$parcel$export($e92e4eb8d35aaf31$exports, "add", () => $e92e4eb8d35aaf31$export$e16d8520af44a096);
$parcel$export($e92e4eb8d35aaf31$exports, "mul", () => $e92e4eb8d35aaf31$export$6e3a27864ab166fe);
$parcel$export($e92e4eb8d35aaf31$exports, "lerp", () => $e92e4eb8d35aaf31$export$3a89f8d6f6bf6c9f);
$parcel$export($e92e4eb8d35aaf31$exports, "length", () => $e92e4eb8d35aaf31$export$f24224f1c91d8156);
$parcel$export($e92e4eb8d35aaf31$exports, "len", () => $e92e4eb8d35aaf31$export$fc1400facf92c78);
$parcel$export($e92e4eb8d35aaf31$exports, "squaredLength", () => $e92e4eb8d35aaf31$export$ab44e1323ffc8376);
$parcel$export($e92e4eb8d35aaf31$exports, "sqrLen", () => $e92e4eb8d35aaf31$export$99d8dd3f32a3435);
$parcel$export($e92e4eb8d35aaf31$exports, "normalize", () => $e92e4eb8d35aaf31$export$a3295358bff77e);
$parcel$export($e92e4eb8d35aaf31$exports, "exactEquals", () => $e92e4eb8d35aaf31$export$f2599a5cf1109d8);
$parcel$export($e92e4eb8d35aaf31$exports, "equals", () => $e92e4eb8d35aaf31$export$e9bab7fafb253603);
$parcel$export($e92e4eb8d35aaf31$exports, "rotationTo", () => $e92e4eb8d35aaf31$export$72d66f5842c00904);
$parcel$export($e92e4eb8d35aaf31$exports, "sqlerp", () => $e92e4eb8d35aaf31$export$699b0866ca50f6cb);
$parcel$export($e92e4eb8d35aaf31$exports, "setAxes", () => $e92e4eb8d35aaf31$export$937ca0a544b2d712);


function $879d8210211d0bfa$export$185802fd694ee1f5() {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(9);
    if ($78ae820aa9ececfa$export$b67359430d3b1b2 != Float32Array) {
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[5] = 0;
        out[6] = 0;
        out[7] = 0;
    }
    out[0] = 1;
    out[4] = 1;
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$b4ad467060d346fe(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[4];
    out[4] = a[5];
    out[5] = a[6];
    out[6] = a[8];
    out[7] = a[9];
    out[8] = a[10];
    return out;
}
function $879d8210211d0bfa$export$9cd59f9826255e47(a) {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(9);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
function $879d8210211d0bfa$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
function $879d8210211d0bfa$export$a82be99ed2a44a7d(m00, m01, m02, m10, m11, m12, m20, m21, m22) {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(9);
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m10;
    out[4] = m11;
    out[5] = m12;
    out[6] = m20;
    out[7] = m21;
    out[8] = m22;
    return out;
}
function $879d8210211d0bfa$export$adaa4cf7ef1b65be(out, m00, m01, m02, m10, m11, m12, m20, m21, m22) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m10;
    out[4] = m11;
    out[5] = m12;
    out[6] = m20;
    out[7] = m21;
    out[8] = m22;
    return out;
}
function $879d8210211d0bfa$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 1;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$9cb09a71b7d66923(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        var a01 = a[1], a02 = a[2], a12 = a[5];
        out[1] = a[3];
        out[2] = a[6];
        out[3] = a01;
        out[5] = a[7];
        out[6] = a02;
        out[7] = a12;
    } else {
        out[0] = a[0];
        out[1] = a[3];
        out[2] = a[6];
        out[3] = a[1];
        out[4] = a[4];
        out[5] = a[7];
        out[6] = a[2];
        out[7] = a[5];
        out[8] = a[8];
    }
    return out;
}
function $879d8210211d0bfa$export$6897c284b6f9f4dc(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    var b01 = a22 * a11 - a12 * a21;
    var b11 = -a22 * a10 + a12 * a20;
    var b21 = a21 * a10 - a11 * a20; // Calculate the determinant
    var det = a00 * b01 + a01 * b11 + a02 * b21;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = b01 * det;
    out[1] = (-a22 * a01 + a02 * a21) * det;
    out[2] = (a12 * a01 - a02 * a11) * det;
    out[3] = b11 * det;
    out[4] = (a22 * a00 - a02 * a20) * det;
    out[5] = (-a12 * a00 + a02 * a10) * det;
    out[6] = b21 * det;
    out[7] = (-a21 * a00 + a01 * a20) * det;
    out[8] = (a11 * a00 - a01 * a10) * det;
    return out;
}
function $879d8210211d0bfa$export$33f3c024b4ae00a1(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    out[0] = a11 * a22 - a12 * a21;
    out[1] = a02 * a21 - a01 * a22;
    out[2] = a01 * a12 - a02 * a11;
    out[3] = a12 * a20 - a10 * a22;
    out[4] = a00 * a22 - a02 * a20;
    out[5] = a02 * a10 - a00 * a12;
    out[6] = a10 * a21 - a11 * a20;
    out[7] = a01 * a20 - a00 * a21;
    out[8] = a00 * a11 - a01 * a10;
    return out;
}
function $879d8210211d0bfa$export$a04698f914c55ed9(a) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    return a00 * (a22 * a11 - a12 * a21) + a01 * (-a22 * a10 + a12 * a20) + a02 * (a21 * a10 - a11 * a20);
}
function $879d8210211d0bfa$export$2060d2db72cce88f(out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    var b00 = b[0], b01 = b[1], b02 = b[2];
    var b10 = b[3], b11 = b[4], b12 = b[5];
    var b20 = b[6], b21 = b[7], b22 = b[8];
    out[0] = b00 * a00 + b01 * a10 + b02 * a20;
    out[1] = b00 * a01 + b01 * a11 + b02 * a21;
    out[2] = b00 * a02 + b01 * a12 + b02 * a22;
    out[3] = b10 * a00 + b11 * a10 + b12 * a20;
    out[4] = b10 * a01 + b11 * a11 + b12 * a21;
    out[5] = b10 * a02 + b11 * a12 + b12 * a22;
    out[6] = b20 * a00 + b21 * a10 + b22 * a20;
    out[7] = b20 * a01 + b21 * a11 + b22 * a21;
    out[8] = b20 * a02 + b21 * a12 + b22 * a22;
    return out;
}
function $879d8210211d0bfa$export$d73ee8ef04f5226a(out, a, v) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8], x = v[0], y = v[1];
    out[0] = a00;
    out[1] = a01;
    out[2] = a02;
    out[3] = a10;
    out[4] = a11;
    out[5] = a12;
    out[6] = x * a00 + y * a10 + a20;
    out[7] = x * a01 + y * a11 + a21;
    out[8] = x * a02 + y * a12 + a22;
    return out;
}
function $879d8210211d0bfa$export$bb628a54ab399bc9(out, a, rad) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8], s = Math.sin(rad), c = Math.cos(rad);
    out[0] = c * a00 + s * a10;
    out[1] = c * a01 + s * a11;
    out[2] = c * a02 + s * a12;
    out[3] = c * a10 - s * a00;
    out[4] = c * a11 - s * a01;
    out[5] = c * a12 - s * a02;
    out[6] = a20;
    out[7] = a21;
    out[8] = a22;
    return out;
}
function $879d8210211d0bfa$export$dcdf75081b88279d(out, a, v) {
    var x = v[0], y = v[1];
    out[0] = x * a[0];
    out[1] = x * a[1];
    out[2] = x * a[2];
    out[3] = y * a[3];
    out[4] = y * a[4];
    out[5] = y * a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
function $879d8210211d0bfa$export$bc9e79e74e9fddf6(out, v) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 1;
    out[5] = 0;
    out[6] = v[0];
    out[7] = v[1];
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$926fc125ff3c666c(out, rad) {
    var s = Math.sin(rad), c = Math.cos(rad);
    out[0] = c;
    out[1] = s;
    out[2] = 0;
    out[3] = -s;
    out[4] = c;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$832ca188ffb1955d(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = v[1];
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$68f5977575fae9bf(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = 0;
    out[3] = a[2];
    out[4] = a[3];
    out[5] = 0;
    out[6] = a[4];
    out[7] = a[5];
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$2ff2bbe382249af7(out, q) {
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var yx = y * x2;
    var yy = y * y2;
    var zx = z * x2;
    var zy = z * y2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - yy - zz;
    out[3] = yx - wz;
    out[6] = zx + wy;
    out[1] = yx + wz;
    out[4] = 1 - xx - zz;
    out[7] = zy - wx;
    out[2] = zx - wy;
    out[5] = zy + wx;
    out[8] = 1 - xx - yy;
    return out;
}
function $879d8210211d0bfa$export$966b25ab6dc1b1f9(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32; // Calculate the determinant
    var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[2] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[3] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[4] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[5] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[6] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[7] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[8] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    return out;
}
function $879d8210211d0bfa$export$b74061472fe7c07(out, width, height) {
    out[0] = 2 / width;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = -2 / height;
    out[5] = 0;
    out[6] = -1;
    out[7] = 1;
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$42d51816ce590c93(a) {
    return "mat3(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ", " + a[8] + ")";
}
function $879d8210211d0bfa$export$326827e8268e9cdb(a) {
    return Math.hypot(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
}
function $879d8210211d0bfa$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    out[6] = a[6] + b[6];
    out[7] = a[7] + b[7];
    out[8] = a[8] + b[8];
    return out;
}
function $879d8210211d0bfa$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    out[6] = a[6] - b[6];
    out[7] = a[7] - b[7];
    out[8] = a[8] - b[8];
    return out;
}
function $879d8210211d0bfa$export$c697bed75648cdb7(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    out[6] = a[6] * b;
    out[7] = a[7] * b;
    out[8] = a[8] * b;
    return out;
}
function $879d8210211d0bfa$export$553579f63bdd7137(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    out[4] = a[4] + b[4] * scale;
    out[5] = a[5] + b[5] * scale;
    out[6] = a[6] + b[6] * scale;
    out[7] = a[7] + b[7] * scale;
    out[8] = a[8] + b[8] * scale;
    return out;
}
function $879d8210211d0bfa$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && a[8] === b[8];
}
function $879d8210211d0bfa$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5], a6 = a[6], a7 = a[7], a8 = a[8];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8];
    return Math.abs(a0 - b0) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a7), Math.abs(b7)) && Math.abs(a8 - b8) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a8), Math.abs(b8));
}
var $879d8210211d0bfa$export$6e3a27864ab166fe = $879d8210211d0bfa$export$2060d2db72cce88f;
var $879d8210211d0bfa$export$f93b5905241a7cca = $879d8210211d0bfa$export$4e2d2ead65e5f7e3;




function $e92e4eb8d35aaf31$export$185802fd694ee1f5() {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(4);
    if ($78ae820aa9ececfa$export$b67359430d3b1b2 != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
    }
    out[3] = 1;
    return out;
}
function $e92e4eb8d35aaf31$export$f0954fd7d5368655(out) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    return out;
}
function $e92e4eb8d35aaf31$export$4286ddefc8f49512(out, axis, rad) {
    rad = rad * 0.5;
    var s = Math.sin(rad);
    out[0] = s * axis[0];
    out[1] = s * axis[1];
    out[2] = s * axis[2];
    out[3] = Math.cos(rad);
    return out;
}
function $e92e4eb8d35aaf31$export$3f70be5e7d7dc51(out_axis, q) {
    var rad = Math.acos(q[3]) * 2.0;
    var s = Math.sin(rad / 2.0);
    if (s > $78ae820aa9ececfa$export$fd293b15f47e270) {
        out_axis[0] = q[0] / s;
        out_axis[1] = q[1] / s;
        out_axis[2] = q[2] / s;
    } else {
        // If s is zero, return any axis (no rotation - axis does not matter)
        out_axis[0] = 1;
        out_axis[1] = 0;
        out_axis[2] = 0;
    }
    return rad;
}
function $e92e4eb8d35aaf31$export$b363da9ded343252(a, b) {
    var dotproduct = $e92e4eb8d35aaf31$export$94132a0e348806d4(a, b);
    return Math.acos(2 * dotproduct * dotproduct - 1);
}
function $e92e4eb8d35aaf31$export$2060d2db72cce88f(out, a, b) {
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var bx = b[0], by = b[1], bz = b[2], bw = b[3];
    out[0] = ax * bw + aw * bx + ay * bz - az * by;
    out[1] = ay * bw + aw * by + az * bx - ax * bz;
    out[2] = az * bw + aw * bz + ax * by - ay * bx;
    out[3] = aw * bw - ax * bx - ay * by - az * bz;
    return out;
}
function $e92e4eb8d35aaf31$export$a59c8716592e09af(out, a, rad) {
    rad *= 0.5;
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var bx = Math.sin(rad), bw = Math.cos(rad);
    out[0] = ax * bw + aw * bx;
    out[1] = ay * bw + az * bx;
    out[2] = az * bw - ay * bx;
    out[3] = aw * bw - ax * bx;
    return out;
}
function $e92e4eb8d35aaf31$export$cf71e4d4ca4d1cfd(out, a, rad) {
    rad *= 0.5;
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var by = Math.sin(rad), bw = Math.cos(rad);
    out[0] = ax * bw - az * by;
    out[1] = ay * bw + aw * by;
    out[2] = az * bw + ax * by;
    out[3] = aw * bw - ay * by;
    return out;
}
function $e92e4eb8d35aaf31$export$ea6eae3365de5b9c(out, a, rad) {
    rad *= 0.5;
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var bz = Math.sin(rad), bw = Math.cos(rad);
    out[0] = ax * bw + ay * bz;
    out[1] = ay * bw - ax * bz;
    out[2] = az * bw + aw * bz;
    out[3] = aw * bw - az * bz;
    return out;
}
function $e92e4eb8d35aaf31$export$fb72b72e8d764d4e(out, a) {
    var x = a[0], y = a[1], z = a[2];
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = Math.sqrt(Math.abs(1.0 - x * x - y * y - z * z));
    return out;
}
function $e92e4eb8d35aaf31$export$b310ec824aaee37f(out, a) {
    var x = a[0], y = a[1], z = a[2], w = a[3];
    var r = Math.sqrt(x * x + y * y + z * z);
    var et = Math.exp(w);
    var s = r > 0 ? et * Math.sin(r) / r : 0;
    out[0] = x * s;
    out[1] = y * s;
    out[2] = z * s;
    out[3] = et * Math.cos(r);
    return out;
}
function $e92e4eb8d35aaf31$export$876cb1b29620556f(out, a) {
    var x = a[0], y = a[1], z = a[2], w = a[3];
    var r = Math.sqrt(x * x + y * y + z * z);
    var t = r > 0 ? Math.atan2(r, w) / r : 0;
    out[0] = x * t;
    out[1] = y * t;
    out[2] = z * t;
    out[3] = 0.5 * Math.log(x * x + y * y + z * z + w * w);
    return out;
}
function $e92e4eb8d35aaf31$export$9c297f60e22e3389(out, a, b) {
    $e92e4eb8d35aaf31$export$876cb1b29620556f(out, a);
    $e92e4eb8d35aaf31$export$dcdf75081b88279d(out, out, b);
    $e92e4eb8d35aaf31$export$b310ec824aaee37f(out, out);
    return out;
}
function $e92e4eb8d35aaf31$export$1544d9bc2995de08(out, a, b, t) {
    // benchmarks:
    //    http://jsperf.com/quaternion-slerp-implementations
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var bx = b[0], by = b[1], bz = b[2], bw = b[3];
    var omega, cosom, sinom, scale0, scale1; // calc cosine
    cosom = ax * bx + ay * by + az * bz + aw * bw; // adjust signs (if necessary)
    if (cosom < 0.0) {
        cosom = -cosom;
        bx = -bx;
        by = -by;
        bz = -bz;
        bw = -bw;
    } // calculate coefficients
    if (1.0 - cosom > $78ae820aa9ececfa$export$fd293b15f47e270) {
        // standard case (slerp)
        omega = Math.acos(cosom);
        sinom = Math.sin(omega);
        scale0 = Math.sin((1.0 - t) * omega) / sinom;
        scale1 = Math.sin(t * omega) / sinom;
    } else {
        // "from" and "to" quaternions are very close
        //  ... so we can do a linear interpolation
        scale0 = 1.0 - t;
        scale1 = t;
    } // calculate final values
    out[0] = scale0 * ax + scale1 * bx;
    out[1] = scale0 * ay + scale1 * by;
    out[2] = scale0 * az + scale1 * bz;
    out[3] = scale0 * aw + scale1 * bw;
    return out;
}
function $e92e4eb8d35aaf31$export$4385e60b38654f68(out) {
    // Implementation of http://planning.cs.uiuc.edu/node198.html
    // TODO: Calling random 3 times is probably not the fastest solution
    var u1 = $78ae820aa9ececfa$export$5ada478c8a628231();
    var u2 = $78ae820aa9ececfa$export$5ada478c8a628231();
    var u3 = $78ae820aa9ececfa$export$5ada478c8a628231();
    var sqrt1MinusU1 = Math.sqrt(1 - u1);
    var sqrtU1 = Math.sqrt(u1);
    out[0] = sqrt1MinusU1 * Math.sin(2.0 * Math.PI * u2);
    out[1] = sqrt1MinusU1 * Math.cos(2.0 * Math.PI * u2);
    out[2] = sqrtU1 * Math.sin(2.0 * Math.PI * u3);
    out[3] = sqrtU1 * Math.cos(2.0 * Math.PI * u3);
    return out;
}
function $e92e4eb8d35aaf31$export$6897c284b6f9f4dc(out, a) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var dot = a0 * a0 + a1 * a1 + a2 * a2 + a3 * a3;
    var invDot = dot ? 1.0 / dot : 0; // TODO: Would be faster to return [0,0,0,0] immediately if dot == 0
    out[0] = -a0 * invDot;
    out[1] = -a1 * invDot;
    out[2] = -a2 * invDot;
    out[3] = a3 * invDot;
    return out;
}
function $e92e4eb8d35aaf31$export$7679f47e72c62560(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] = a[3];
    return out;
}
function $e92e4eb8d35aaf31$export$272a1eb8e5a4b55b(out, m) {
    // Algorithm in Ken Shoemake's article in 1987 SIGGRAPH course notes
    // article "Quaternion Calculus and Fast Animation".
    var fTrace = m[0] + m[4] + m[8];
    var fRoot;
    if (fTrace > 0.0) {
        // |w| > 1/2, may as well choose w > 1/2
        fRoot = Math.sqrt(fTrace + 1.0); // 2w
        out[3] = 0.5 * fRoot;
        fRoot = 0.5 / fRoot; // 1/(4w)
        out[0] = (m[5] - m[7]) * fRoot;
        out[1] = (m[6] - m[2]) * fRoot;
        out[2] = (m[1] - m[3]) * fRoot;
    } else {
        // |w| <= 1/2
        var i = 0;
        if (m[4] > m[0]) i = 1;
        if (m[8] > m[i * 3 + i]) i = 2;
        var j = (i + 1) % 3;
        var k = (i + 2) % 3;
        fRoot = Math.sqrt(m[i * 3 + i] - m[j * 3 + j] - m[k * 3 + k] + 1.0);
        out[i] = 0.5 * fRoot;
        fRoot = 0.5 / fRoot;
        out[3] = (m[j * 3 + k] - m[k * 3 + j]) * fRoot;
        out[j] = (m[j * 3 + i] + m[i * 3 + j]) * fRoot;
        out[k] = (m[k * 3 + i] + m[i * 3 + k]) * fRoot;
    }
    return out;
}
function $e92e4eb8d35aaf31$export$7a404a587ea85af(out, x, y, z) {
    var halfToRad = 0.5 * Math.PI / 180.0;
    x *= halfToRad;
    y *= halfToRad;
    z *= halfToRad;
    var sx = Math.sin(x);
    var cx = Math.cos(x);
    var sy = Math.sin(y);
    var cy = Math.cos(y);
    var sz = Math.sin(z);
    var cz = Math.cos(z);
    out[0] = sx * cy * cz - cx * sy * sz;
    out[1] = cx * sy * cz + sx * cy * sz;
    out[2] = cx * cy * sz - sx * sy * cz;
    out[3] = cx * cy * cz + sx * sy * sz;
    return out;
}
function $e92e4eb8d35aaf31$export$42d51816ce590c93(a) {
    return "quat(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ")";
}
var $e92e4eb8d35aaf31$export$9cd59f9826255e47 = $e38eb280d3b76273$export$9cd59f9826255e47;
var $e92e4eb8d35aaf31$export$a82be99ed2a44a7d = $e38eb280d3b76273$export$a82be99ed2a44a7d;
var $e92e4eb8d35aaf31$export$784d13d8ee351f07 = $e38eb280d3b76273$export$784d13d8ee351f07;
var $e92e4eb8d35aaf31$export$adaa4cf7ef1b65be = $e38eb280d3b76273$export$adaa4cf7ef1b65be;
var $e92e4eb8d35aaf31$export$e16d8520af44a096 = $e38eb280d3b76273$export$e16d8520af44a096;
var $e92e4eb8d35aaf31$export$6e3a27864ab166fe = $e92e4eb8d35aaf31$export$2060d2db72cce88f;
var $e92e4eb8d35aaf31$export$dcdf75081b88279d = $e38eb280d3b76273$export$dcdf75081b88279d;
var $e92e4eb8d35aaf31$export$94132a0e348806d4 = $e38eb280d3b76273$export$94132a0e348806d4;
var $e92e4eb8d35aaf31$export$3a89f8d6f6bf6c9f = $e38eb280d3b76273$export$3a89f8d6f6bf6c9f;
var $e92e4eb8d35aaf31$export$f24224f1c91d8156 = $e38eb280d3b76273$export$f24224f1c91d8156;
var $e92e4eb8d35aaf31$export$fc1400facf92c78 = $e92e4eb8d35aaf31$export$f24224f1c91d8156;
var $e92e4eb8d35aaf31$export$ab44e1323ffc8376 = $e38eb280d3b76273$export$ab44e1323ffc8376;
var $e92e4eb8d35aaf31$export$99d8dd3f32a3435 = $e92e4eb8d35aaf31$export$ab44e1323ffc8376;
var $e92e4eb8d35aaf31$export$a3295358bff77e = $e38eb280d3b76273$export$a3295358bff77e;
var $e92e4eb8d35aaf31$export$f2599a5cf1109d8 = $e38eb280d3b76273$export$f2599a5cf1109d8;
var $e92e4eb8d35aaf31$export$e9bab7fafb253603 = $e38eb280d3b76273$export$e9bab7fafb253603;
var $e92e4eb8d35aaf31$export$72d66f5842c00904 = function() {
    var tmpvec3 = $ab7f6dc0910e1ef7$export$185802fd694ee1f5();
    var xUnitVec3 = $ab7f6dc0910e1ef7$export$a82be99ed2a44a7d(1, 0, 0);
    var yUnitVec3 = $ab7f6dc0910e1ef7$export$a82be99ed2a44a7d(0, 1, 0);
    return function(out, a, b) {
        var dot = $ab7f6dc0910e1ef7$export$94132a0e348806d4(a, b);
        if (dot < -0.999999) {
            $ab7f6dc0910e1ef7$export$bb646b20bb93d339(tmpvec3, xUnitVec3, a);
            if ($ab7f6dc0910e1ef7$export$fc1400facf92c78(tmpvec3) < 0.000001) $ab7f6dc0910e1ef7$export$bb646b20bb93d339(tmpvec3, yUnitVec3, a);
            $ab7f6dc0910e1ef7$export$a3295358bff77e(tmpvec3, tmpvec3);
            $e92e4eb8d35aaf31$export$4286ddefc8f49512(out, tmpvec3, Math.PI);
            return out;
        } else if (dot > 0.999999) {
            out[0] = 0;
            out[1] = 0;
            out[2] = 0;
            out[3] = 1;
            return out;
        } else {
            $ab7f6dc0910e1ef7$export$bb646b20bb93d339(tmpvec3, a, b);
            out[0] = tmpvec3[0];
            out[1] = tmpvec3[1];
            out[2] = tmpvec3[2];
            out[3] = 1 + dot;
            return $e92e4eb8d35aaf31$export$a3295358bff77e(out, out);
        }
    };
}();
var $e92e4eb8d35aaf31$export$699b0866ca50f6cb = function() {
    var temp1 = $e92e4eb8d35aaf31$export$185802fd694ee1f5();
    var temp2 = $e92e4eb8d35aaf31$export$185802fd694ee1f5();
    return function(out, a, b, c, d, t) {
        $e92e4eb8d35aaf31$export$1544d9bc2995de08(temp1, a, d, t);
        $e92e4eb8d35aaf31$export$1544d9bc2995de08(temp2, b, c, t);
        $e92e4eb8d35aaf31$export$1544d9bc2995de08(out, temp1, temp2, 2 * t * (1 - t));
        return out;
    };
}();
var $e92e4eb8d35aaf31$export$937ca0a544b2d712 = function() {
    var matr = $879d8210211d0bfa$export$185802fd694ee1f5();
    return function(out, view, right, up) {
        matr[0] = right[0];
        matr[3] = right[1];
        matr[6] = right[2];
        matr[1] = up[0];
        matr[4] = up[1];
        matr[7] = up[2];
        matr[2] = -view[0];
        matr[5] = -view[1];
        matr[8] = -view[2];
        return $e92e4eb8d35aaf31$export$a3295358bff77e(out, $e92e4eb8d35aaf31$export$272a1eb8e5a4b55b(out, matr));
    };
}();


function $b125b9470601071f$export$f5a01205d395aca(gl, buffers, programInfo) {
    $b125b9470601071f$var$internalSetCommonAttributes(gl, buffers, programInfo, 3);
}
function $b125b9470601071f$export$f1fc9c1971337e7c(gl, buffers, programInfo) {
    $b125b9470601071f$var$internalSetCommonAttributes(gl, buffers, programInfo, 2);
}
function $b125b9470601071f$var$internalSetCommonAttributes(gl, buffers, programInfo, positionBufferComponents) {
    if (buffers.textureCoords !== undefined && programInfo.attribLocations.textureCoords !== undefined) $b125b9470601071f$var$setTextureAttribute(gl, buffers.textureCoords, programInfo.attribLocations.textureCoords);
    if (buffers.position !== undefined && programInfo.attribLocations.vertexPosition !== undefined) $b125b9470601071f$var$setPositionAttribute(gl, buffers.position, programInfo.attribLocations.vertexPosition, positionBufferComponents);
    if (buffers.normals !== undefined && programInfo.attribLocations.vertexNormal !== undefined) $b125b9470601071f$var$setNormalAttribute(gl, buffers.normals, programInfo.attribLocations.vertexNormal);
    if (buffers.color !== undefined && programInfo.attribLocations.vertexColor !== undefined) $b125b9470601071f$var$setColorAttribute(gl, buffers.color, programInfo.attribLocations.vertexColor);
}
function $b125b9470601071f$export$9ed6815acb35f982(gl, programInfo, uniforms, texture, texture2) {
    if (uniforms.projectionMatrix !== undefined && programInfo.uniformLocations.projectionMatrix !== undefined) gl.uniformMatrix4fv(programInfo.uniformLocations.projectionMatrix, false, uniforms.projectionMatrix);
    if (uniforms.modelViewMatrix !== undefined && programInfo.uniformLocations.modelViewMatrix !== undefined) gl.uniformMatrix4fv(programInfo.uniformLocations.modelViewMatrix, false, uniforms.modelViewMatrix);
    if (uniforms.normalMatrix !== undefined && programInfo.uniformLocations.normalMatrix !== undefined) gl.uniformMatrix4fv(programInfo.uniformLocations.normalMatrix, false, uniforms.normalMatrix);
    if (uniforms.lightWorldPosition !== undefined && programInfo.uniformLocations.lightWorldPosition !== undefined) gl.uniform3fv(programInfo.uniformLocations.lightWorldPosition, uniforms.lightWorldPosition);
    if (uniforms.shininess !== undefined && programInfo.uniformLocations.shininess !== undefined) gl.uniform1f(programInfo.uniformLocations.shininess, uniforms.shininess);
    if (uniforms.textureIndex !== undefined && programInfo.uniformLocations.textureSampler !== undefined && texture !== undefined) {
        gl.activeTexture($b125b9470601071f$var$getGLTexture(gl, uniforms.textureIndex));
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.uniform1i(programInfo.uniformLocations.textureSampler, uniforms.textureIndex);
    }
    if (uniforms.textureIndex !== undefined && programInfo.uniformLocations.texture2Sampler !== undefined && texture2 !== undefined) {
        gl.activeTexture($b125b9470601071f$var$getGLTexture(gl, uniforms.textureIndex + 1));
        gl.bindTexture(gl.TEXTURE_2D, texture2);
        gl.uniform1i(programInfo.uniformLocations.texture2Sampler, uniforms.textureIndex + 1);
    }
    if (uniforms.color !== undefined && programInfo.uniformLocations.color !== undefined) gl.uniform4fv(programInfo.uniformLocations.color, uniforms.color);
    if (uniforms.time !== undefined && programInfo.uniformLocations.time !== undefined) gl.uniform1f(programInfo.uniformLocations.time, uniforms.time);
}
function $b125b9470601071f$var$setNormalAttribute(gl, normalsBuffer, vertexNormal) {
    const numComponents = 3;
    const type = gl.FLOAT;
    const normalize = false;
    const stride = 0;
    const offset = 0;
    gl.bindBuffer(gl.ARRAY_BUFFER, normalsBuffer);
    gl.vertexAttribPointer(vertexNormal, numComponents, type, normalize, stride, offset);
    gl.enableVertexAttribArray(vertexNormal);
}
function $b125b9470601071f$var$setColorAttribute(gl, colorsBuffer, vertexColor) {
    const numComponents = 4;
    const type = gl.FLOAT;
    const normalize = false;
    const stride = 0;
    const offset = 0;
    gl.bindBuffer(gl.ARRAY_BUFFER, colorsBuffer);
    gl.vertexAttribPointer(vertexColor, numComponents, type, normalize, stride, offset);
    gl.enableVertexAttribArray(vertexColor);
}
function $b125b9470601071f$var$setPositionAttribute(gl, vertexBuffer, vertexPosition, numComponents) {
    const type = gl.FLOAT // the data in the buffer is 32bit floats
    ;
    const normalize = false // don't normalize
    ;
    const stride = 0 // how many bytes to get from one set of values to the next
    ;
    // 0 = use type and numComponents above
    const offset = 0 // how many bytes inside the buffer to start from
    ;
    gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer);
    gl.vertexAttribPointer(vertexPosition, numComponents, type, normalize, stride, offset);
    gl.enableVertexAttribArray(vertexPosition);
}
function $b125b9470601071f$var$setTextureAttribute(gl, textureCoordsBuffer, textureCoordsPosition) {
    const num = 2 // every coordinate composed of 2 values
    ;
    const type = gl.FLOAT // the data in the buffer is 32-bit float
    ;
    const normalize = false // don't normalize
    ;
    const stride = 0 // how many bytes to get from one set to the next
    ;
    const offset = 0 // how many bytes inside the buffer to start from
    ;
    gl.bindBuffer(gl.ARRAY_BUFFER, textureCoordsBuffer);
    gl.vertexAttribPointer(textureCoordsPosition, num, type, normalize, stride, offset);
    gl.enableVertexAttribArray(textureCoordsPosition);
}
function $b125b9470601071f$var$getGLTexture(gl, index) {
    return index == 0 ? gl.TEXTURE0 : index == 1 ? gl.TEXTURE1 : index == 2 ? gl.TEXTURE2 : index == 3 ? gl.TEXTURE3 : index == 4 ? gl.TEXTURE4 : index == 5 ? gl.TEXTURE5 : gl.TEXTURE0;
}


function $3c047a64f97dc4db$var$initShaderProgram(gl, resources) {
    const shaderProgram = (0, $747b70bb26c9cf6e$export$f7c2b6763dc47773)(gl, resources.shaderSource.text);
    if (!shaderProgram) return null;
    return {
        program: shaderProgram,
        attribLocations: {
            vertexPosition: gl.getAttribLocation(shaderProgram, "aVertexPosition"),
            vertexColor: gl.getAttribLocation(shaderProgram, "aVertexColor"),
            textureCoords: gl.getAttribLocation(shaderProgram, "aTextureCoord")
        },
        uniformLocations: {
            projectionMatrix: gl.getUniformLocation(shaderProgram, "uProjectionMatrix"),
            modelViewMatrix: gl.getUniformLocation(shaderProgram, "uModelViewMatrix"),
            characterOffset: gl.getUniformLocation(shaderProgram, "uCharacterOffset"),
            textureSampler: gl.getUniformLocation(shaderProgram, "uSampler"),
            color: gl.getUniformLocation(shaderProgram, "uColor")
        }
    };
}
function $3c047a64f97dc4db$export$b65634ddab3713db(gl, width, height, flippedY, resources, characterWidth, font) {
    const programInfo = $3c047a64f97dc4db$var$initShaderProgram(gl, resources);
    const square = (0, $35806345bc1d62c5$export$fdbdb3a5cc488d7e)(gl, font !== undefined ? font : resources.textures.font, flippedY, true);
    const projectionMatrix = (0, $26675c4f95835ef1$exports).create();
    (0, $26675c4f95835ef1$exports).ortho(projectionMatrix, 0, width, height, 0, -1, 1.0);
    if (characterWidth === undefined) characterWidth = width / 40.0;
    const characterHeight = characterWidth * 1.2;
    const spacing = 1.0;
    const yMultiplier = flippedY ? -1 : 1;
    const convertToPosition = (characterPosition)=>(0, $4ce98914b6676340$exports).fromValues(characterPosition[0] * (characterWidth + spacing), characterPosition[1] * characterHeight);
    const convertToCharacterCoordinates = (position)=>(0, $4ce98914b6676340$exports).fromValues(Math.floor(position[0] / (characterWidth + spacing)), Math.floor(position[1] / characterHeight));
    const measure = (text)=>{
        return {
            width: (characterWidth + spacing) * text.length,
            height: characterHeight
        };
    };
    const draw = (text, position, useCharacterSpace = true, color = (0, $e38eb280d3b76273$exports).fromValues(1.0, 1.0, 1.0, 1.0))=>{
        gl.useProgram(programInfo.program);
        // Set the shader uniforms
        gl.uniformMatrix4fv(programInfo.uniformLocations.projectionMatrix, false, projectionMatrix);
        let displayPosition = useCharacterSpace ? (0, $ab7f6dc0910e1ef7$exports).fromValues(position[0] * (characterWidth + spacing), position[1] * characterHeight, 1.0) : (0, $ab7f6dc0910e1ef7$exports).fromValues(position[0], position[1], 0.0);
        drawCharacters(text, displayPosition, characterWidth, characterHeight, color, spacing);
    };
    function drawCharacters(text, displayPosition, cw, ch, color, spacing) {
        Array.from(text).forEach((c)=>{
            const modelViewMatrix = (0, $26675c4f95835ef1$exports).fromRotationTranslationScale((0, $26675c4f95835ef1$exports).create(), (0, $e92e4eb8d35aaf31$exports).create(), displayPosition, [
                cw / 2,
                ch / 2 * yMultiplier,
                1.0
            ]);
            (0, $b125b9470601071f$export$f5a01205d395aca)(gl, square, programInfo);
            gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, square.indices);
            (0, $b125b9470601071f$export$9ed6815acb35f982)(gl, programInfo, {
                modelViewMatrix: modelViewMatrix,
                color: color,
                textureIndex: 0
            }, square.texture);
            gl.uniform1f(programInfo.uniformLocations.characterOffset, c.charCodeAt(0) - 32);
            {
                const vertexCount = square.vertexCount;
                const type = gl.UNSIGNED_SHORT;
                const offset = 0;
                gl.drawElements(gl.TRIANGLES, vertexCount, type, offset);
            }
            displayPosition[0] += cw + spacing;
        });
    }
    const drawAtSize = (text, position, cw, ch, spacing, color)=>{
        if (ch <= 0) ch = cw * 1.2;
        gl.useProgram(programInfo.program);
        // Set the shader uniforms
        gl.uniformMatrix4fv(programInfo.uniformLocations.projectionMatrix, false, projectionMatrix);
        let displayPosition = (0, $ab7f6dc0910e1ef7$exports).fromValues(position[0], position[1], 0.0);
        drawCharacters(text, displayPosition, cw, ch, color, spacing);
    };
    return {
        convertToPosition: convertToPosition,
        convertToCharacterCoordinates: convertToCharacterCoordinates,
        draw: draw,
        measure: measure,
        drawAtSize: drawAtSize
    };
}


function $4f8706e1195729d3$export$ce9c08a154b8d529(gl, resources) {
    const text = (0, $3c047a64f97dc4db$export$b65634ddab3713db)(gl, gl.canvas.width, gl.canvas.height, false, resources, 800 / 60, resources.textures.instructionsFont);
    return function renderInstructions(showHelpText) {
        (0, $5c04dc271aaba117$export$441ba46c5fcd50d9)(gl);
        if (showHelpText) {
            let row = 0;
            text.draw("A      fire", [
                1,
                row++
            ]);
            text.draw("S      dive", [
                1,
                row++
            ]);
            text.draw("X      climb", [
                1,
                row++
            ]);
            text.draw(",      roll left", [
                1,
                row++
            ]);
            text.draw(".      roll right", [
                1,
                row++
            ]);
            text.draw("/      decelerate", [
                1,
                row++
            ]);
            text.draw("SPACE  accelerate", [
                1,
                row++
            ]);
            text.draw("J      jump (hold)", [
                1,
                row++
            ]);
            text.draw("C      docking computer (on/off)", [
                1,
                row++
            ]);
            text.draw("H      hyperspace", [
                1,
                row++
            ]);
            row++;
            text.draw("1      front \\ launch", [
                1,
                row++
            ]);
            text.draw("2      rear \\ trade", [
                1,
                row++
            ]);
            text.draw("3      left \\ equipment", [
                1,
                row++
            ]);
            text.draw("4      right", [
                1,
                row++
            ]);
            text.draw("5      galactic map", [
                1,
                row++
            ]);
            text.draw("6      short range chart", [
                1,
                row++
            ]);
            text.draw("7      system details", [
                1,
                row++
            ]);
            text.draw("8      market prices", [
                1,
                row++
            ]);
            text.draw("9      player details", [
                1,
                row++
            ]);
            text.draw("0      inventory", [
                1,
                row++
            ]);
            text.draw("ARROWS cursor on charts", [
                1,
                row++
            ]);
            row++;
            text.draw("[      previous visual effect", [
                1,
                row++
            ]);
            text.draw("]      next visual effect", [
                1,
                row++
            ]);
            text.draw("Q      toggle help", [
                1,
                row++
            ]);
        }
    };
}


// we could do this with a bitmask but this seems more readable

function $27957a4d435d2c0f$export$29fa070abc52b549() {
    return {
        rollLeft: false,
        rollRight: false,
        pitchUp: false,
        pitchDown: false,
        accelerate: false,
        decelerate: false,
        sceneSelection: null,
        cursorLeft: false,
        cursorRight: false,
        cursorUp: false,
        cursorDown: false,
        dockingOn: false,
        jump: false,
        firing: false,
        hyperspace: false,
        mousePosition: (0, $4ce98914b6676340$exports).fromValues(-1, -1),
        mouseDown: false,
        shiftPressed: false,
        nextEffectPressed: false,
        previousEffectPressed: false
    };
}



var $eb309e06665aa479$var$MissileTargettingStatusEnum;
(function(MissileTargettingStatusEnum) {
    MissileTargettingStatusEnum[MissileTargettingStatusEnum["Normal"] = 0] = "Normal";
    MissileTargettingStatusEnum[MissileTargettingStatusEnum["Targetting"] = 1] = "Targetting";
    MissileTargettingStatusEnum[MissileTargettingStatusEnum["LockedOn"] = 2] = "LockedOn";
})($eb309e06665aa479$var$MissileTargettingStatusEnum || ($eb309e06665aa479$var$MissileTargettingStatusEnum = {}));
var $eb309e06665aa479$export$5ec4fea3c362418a;
(function(LegalStatusEnum) {
    LegalStatusEnum[LegalStatusEnum["Clean"] = 0] = "Clean";
    LegalStatusEnum[LegalStatusEnum["Offender"] = 1] = "Offender";
    LegalStatusEnum[LegalStatusEnum["SeriousOffender"] = 2] = "SeriousOffender";
    LegalStatusEnum[LegalStatusEnum["Fugitive"] = 3] = "Fugitive";
})($eb309e06665aa479$export$5ec4fea3c362418a || ($eb309e06665aa479$export$5ec4fea3c362418a = {}));
var $eb309e06665aa479$export$75e1dec82dcaa940;
(function(CombatRatingEnum) {
    CombatRatingEnum[CombatRatingEnum["Harmless"] = 0] = "Harmless";
    CombatRatingEnum[CombatRatingEnum["MostlyHarmless"] = 1] = "MostlyHarmless";
    CombatRatingEnum[CombatRatingEnum["Poor"] = 2] = "Poor";
    CombatRatingEnum[CombatRatingEnum["Average"] = 3] = "Average";
    CombatRatingEnum[CombatRatingEnum["AboveAverage"] = 4] = "AboveAverage";
    CombatRatingEnum[CombatRatingEnum["Competent"] = 5] = "Competent";
    CombatRatingEnum[CombatRatingEnum["Dangerous"] = 6] = "Dangerous";
    CombatRatingEnum[CombatRatingEnum["Deadly"] = 7] = "Deadly";
    CombatRatingEnum[CombatRatingEnum["Elite"] = 8] = "Elite";
})($eb309e06665aa479$export$75e1dec82dcaa940 || ($eb309e06665aa479$export$75e1dec82dcaa940 = {}));
var $eb309e06665aa479$export$8a510af63dd342b2;
(function(LaserTypeEnum) {
    LaserTypeEnum[LaserTypeEnum["None"] = 0] = "None";
    LaserTypeEnum[LaserTypeEnum["Pulse"] = 1] = "Pulse";
    LaserTypeEnum[LaserTypeEnum["Beam"] = 2] = "Beam";
    LaserTypeEnum[LaserTypeEnum["Mining"] = 3] = "Mining";
    LaserTypeEnum[LaserTypeEnum["Military"] = 4] = "Military";
})($eb309e06665aa479$export$8a510af63dd342b2 || ($eb309e06665aa479$export$8a510af63dd342b2 = {}));
const $eb309e06665aa479$export$57ff7eb9c432360c = 0.25;
function $eb309e06665aa479$export$e7386f8c4707b944(resources, currentSystem) {
    const cobra = resources.ships.getCobraMk3([
        0,
        0,
        0
    ], [
        0,
        1,
        0
    ]).blueprint;
    return {
        previousControlState: (0, $27957a4d435d2c0f$export$29fa070abc52b549)(),
        controlState: (0, $27957a4d435d2c0f$export$29fa070abc52b549)(),
        blueprint: cobra,
        pitch: 0.0,
        roll: 0.0,
        speed: 0.0,
        cash: 100.0,
        name: "Jameson",
        legalStatus: 0,
        combatRating: 0,
        isDocked: true,
        dockingComputerFlightExecuter: null,
        fuel: cobra.maxFuel,
        energyBankLevel: cobra.maxEnergy,
        cabinTemperature: 10,
        laserTemperature: 0,
        altitude: cobra.maxAltitude,
        forwardShield: cobra.maxForwardShield,
        aftShield: cobra.maxAftShield,
        missiles: {
            currentNumber: cobra.maxMissiles - 1,
            status: 0
        },
        equipment: {
            largeCargoBay: false,
            ecmSystem: false,
            frontLaser: 1,
            aftLaser: 0,
            portLaser: 0,
            starboardLaser: 0,
            fuelScoops: false,
            escapePod: false,
            energyBomb: false,
            energyUnit: false,
            dockingComputer: true,
            galacticHyperdrive: false
        },
        cargoHoldContents: [],
        galaxyIndex: 0,
        selectedSystem: currentSystem,
        scannerCursor: (0, $4ce98914b6676340$exports).copy((0, $4ce98914b6676340$exports).create(), currentSystem.galacticPosition),
        isInSafeZone: false,
        disableDamping: false,
        isJumping: false,
        lookAt: (0, $ab7f6dc0910e1ef7$exports).fromValues(0, 0, 1),
        isLaserFiring: false,
        isLaserActive: false,
        timeToLaserStateChange: $eb309e06665aa479$export$57ff7eb9c432360c,
        laserOffset: (0, $4ce98914b6676340$exports).fromValues(0, 0)
    };
}


function $42e66745a803db06$export$6ff9e6a1f2205960(controlState) {
    const setControl = (e, newState)=>{
        if (e.key >= "0" && e.key <= "9" && newState) {
            e.preventDefault();
            controlState.sceneSelection = parseInt(e.key);
            return;
        }
        let handled = true;
        switch(e.key){
            case "a":
            case "A":
                controlState.firing = newState;
                break;
            case ",":
                controlState.rollLeft = newState;
                break;
            case ".":
                controlState.rollRight = newState;
                break;
            case "s":
            case "S":
                controlState.pitchDown = newState;
                break;
            case "x":
            case "X":
                controlState.pitchUp = newState;
                break;
            case " ":
                controlState.accelerate = newState;
                break;
            case "/":
                controlState.decelerate = newState;
                break;
            case "j":
            case "J":
                controlState.jump = newState;
                break;
            case "ArrowLeft":
                controlState.cursorLeft = newState;
                break;
            case "ArrowRight":
                controlState.cursorRight = newState;
                break;
            case "ArrowUp":
                controlState.cursorUp = newState;
                break;
            case "ArrowDown":
                controlState.cursorDown = newState;
                break;
            case "h":
            case "H":
                controlState.hyperspace = newState;
                break;
            case "Shift":
                controlState.shiftPressed = newState;
                break;
            case "c":
            case "C":
                controlState.dockingOn = newState;
                break;
            case "[":
                controlState.previousEffectPressed = newState;
                break;
            case "]":
                controlState.nextEffectPressed = newState;
                break;
            default:
                handled = false;
        }
        if (handled) e.preventDefault();
    };
    const keyDown = (e)=>setControl(e, true);
    const keyUp = (e)=>setControl(e, false);
    window.addEventListener("keydown", keyDown);
    window.addEventListener("keyup", keyUp);
    return ()=>{
        window.removeEventListener("keydown", keyDown);
        window.removeEventListener("keyup", keyUp);
    };
}










function $3f19818ab65fc7a7$var$initShaderProgram(gl, resources) {
    const shaderProgram = (0, $747b70bb26c9cf6e$export$f7c2b6763dc47773)(gl, resources.shaderSource.uColor);
    if (!shaderProgram) return null;
    return {
        program: shaderProgram,
        attribLocations: {
            vertexPosition: gl.getAttribLocation(shaderProgram, "aVertexPosition")
        },
        uniformLocations: {
            projectionMatrix: gl.getUniformLocation(shaderProgram, "uProjectionMatrix"),
            modelViewMatrix: gl.getUniformLocation(shaderProgram, "uModelViewMatrix"),
            color: gl.getUniformLocation(shaderProgram, "uColor")
        }
    };
}
function $3f19818ab65fc7a7$var$createVertexBuffer(gl, points) {
    const vertexBuffer = gl.createBuffer();
    //let vertices = [points[0][0], points[0][1], points[1][0], points[1][1], points[2][0], points[2][1]]
    let vertices = [
        points[0][0],
        points[0][1],
        points[1][0],
        points[1][1]
    ];
    gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(vertices), gl.STATIC_DRAW);
    return {
        buffer: vertexBuffer,
        vertCount: vertices.length / 2
    };
}
function $3f19818ab65fc7a7$export$b678b636aadcabb4(gl, width, height, points, resources) {
    const programInfo = $3f19818ab65fc7a7$var$initShaderProgram(gl, resources);
    const vertices = $3f19818ab65fc7a7$var$createVertexBuffer(gl, points);
    const projectionMatrix = (0, $26675c4f95835ef1$exports).create();
    (0, $26675c4f95835ef1$exports).ortho(projectionMatrix, 0, width, height, 0, -1, 1.0);
    const render = function(position, color) {
        const modelViewMatrix = (0, $26675c4f95835ef1$exports).fromTranslation((0, $26675c4f95835ef1$exports).create(), [
            position[0],
            position[1],
            0.0
        ]);
        gl.useProgram(programInfo.program);
        (0, $b125b9470601071f$export$f1fc9c1971337e7c)(gl, {
            position: vertices.buffer
        }, programInfo);
        (0, $b125b9470601071f$export$9ed6815acb35f982)(gl, programInfo, {
            projectionMatrix: projectionMatrix,
            modelViewMatrix: modelViewMatrix,
            color: color
        });
        gl.drawArrays(gl.LINE_STRIP, 0, vertices.vertCount);
    };
    const dispose = ()=>gl.deleteBuffer(vertices.buffer);
    return {
        render: render,
        dispose: dispose
    };
}



function $c08eeab96043bbb3$export$c2db3946751a085d(gl, resources) {
    return function renderNpcLasers(projectionMatrix, ship) {
        if (ship.timeLeftFiringLasers === null) return;
        // The code below is a bit weird but what it does is project the ships position into 2d space
        // It then takes the ships normal orientation, multiplies it by an amount, and projects that in 2d space
        // we then use the "gradient" between the two positions to create a line that is much longer.
        // If I try and do this with a big normal multiplier we end up with the line flipping directions due to the
        // projection math
        const sourcePosition = (0, $97e646fb7d266a2f$export$a3c26af9c425194b)(ship.position, projectionMatrix);
        const target3DPosition = (0, $ab7f6dc0910e1ef7$exports).add((0, $ab7f6dc0910e1ef7$exports).create(), ship.position, (0, $ab7f6dc0910e1ef7$exports).multiply((0, $ab7f6dc0910e1ef7$exports).create(), (0, $ab7f6dc0910e1ef7$exports).normalize((0, $ab7f6dc0910e1ef7$exports).create(), ship.noseOrientation), [
            100,
            100,
            100
        ]));
        const targetPosition = (0, $97e646fb7d266a2f$export$a3c26af9c425194b)(target3DPosition, projectionMatrix);
        const xGrad = (sourcePosition[0] - targetPosition[0]) / (0, $9ecda7333d28e490$export$62ad7b0c781000e9).width;
        const yGrad = (sourcePosition[1] - targetPosition[1]) / (0, $9ecda7333d28e490$export$62ad7b0c781000e9).mainViewHeight;
        const endPosition = (0, $4ce98914b6676340$exports).fromValues(sourcePosition[0] - xGrad * 100000, sourcePosition[1] - yGrad * 100000);
        const { render: render, dispose: dispose } = (0, $3f19818ab65fc7a7$export$b678b636aadcabb4)(gl, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).width, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).mainViewHeight, [
            sourcePosition,
            endPosition
        ], resources);
        render([
            0,
            0
        ], [
            1,
            1,
            0,
            1
        ]);
        dispose();
    };
}


function $f835bf63f0b03176$var$initShaderProgram(gl, resources) {
    const shaderProgram = (0, $747b70bb26c9cf6e$export$f7c2b6763dc47773)(gl, resources.shaderSource.ship);
    if (!shaderProgram) return null;
    return {
        program: shaderProgram,
        attribLocations: {
            vertexPosition: gl.getAttribLocation(shaderProgram, "aVertexPosition"),
            vertexNormal: gl.getAttribLocation(shaderProgram, "aVertexNormal"),
            vertexColor: gl.getAttribLocation(shaderProgram, "aVertexColor")
        },
        uniformLocations: {
            projectionMatrix: gl.getUniformLocation(shaderProgram, "uProjectionMatrix"),
            modelViewMatrix: gl.getUniformLocation(shaderProgram, "uModelViewMatrix"),
            normalMatrix: gl.getUniformLocation(shaderProgram, "uNormalMatrix"),
            lightWorldPosition: gl.getUniformLocation(shaderProgram, "uLightWorldPosition"),
            shininess: gl.getUniformLocation(shaderProgram, "uShininess")
        }
    };
}
function $f835bf63f0b03176$export$c2263a4c08d27cb1(gl, resources, usePreGameScaleFactor = false) {
    const programInfo = $f835bf63f0b03176$var$initShaderProgram(gl, resources);
    const npcLaser = (0, $c08eeab96043bbb3$export$c2db3946751a085d)(gl, resources);
    return function(projectionMatrix, localBubble) {
        localBubble.ships.forEach((ship)=>npcLaser(projectionMatrix, ship));
        // Create a perspective matrix, a special matrix that is
        // used to simulate the distortion of perspective in a camera.
        // Our field of view is 45 degrees, with a width/height
        // ratio that matches the display size of the canvas
        // and we only want to see objects between 0.1 units
        // and 100 units away from the camera.
        gl.useProgram(programInfo.program);
        // Set the shader uniforms
        gl.uniform3fv(programInfo.uniformLocations.lightWorldPosition, localBubble.sun.position);
        //gl.uniform3fv(programInfo.uniformLocations.lightWorldPosition, [0,0,0]) // this puts the light at the player
        (0, $b125b9470601071f$export$9ed6815acb35f982)(gl, programInfo, {
            projectionMatrix: projectionMatrix,
            lightWorldPosition: localBubble.sun.position
        });
        localBubble.ships.forEach((ship)=>{
            // Firstly we point the ship along the nose orientation
            const targetToMatrix = (0, $26675c4f95835ef1$exports).targetTo((0, $26675c4f95835ef1$exports).create(), [
                0,
                0,
                0
            ], ship.noseOrientation, ship.roofOrientation);
            const targetToQuat = (0, $26675c4f95835ef1$exports).getRotation((0, $e92e4eb8d35aaf31$exports).create(), targetToMatrix);
            const viewPosition = ship.position;
            const modelViewMatrix = usePreGameScaleFactor ? (0, $26675c4f95835ef1$exports).fromRotationTranslationScale((0, $26675c4f95835ef1$exports).create(), targetToQuat, viewPosition, [
                ship.blueprint.pregameScale,
                ship.blueprint.pregameScale,
                ship.blueprint.pregameScale
            ]) : (0, $26675c4f95835ef1$exports).fromRotationTranslation((0, $26675c4f95835ef1$exports).create(), targetToQuat, viewPosition);
            const normalMatrix = (0, $26675c4f95835ef1$exports).create();
            (0, $26675c4f95835ef1$exports).invert(normalMatrix, modelViewMatrix);
            (0, $26675c4f95835ef1$exports).transpose(normalMatrix, normalMatrix);
            (0, $b125b9470601071f$export$f5a01205d395aca)(gl, ship.blueprint.renderingModel, programInfo);
            gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, ship.blueprint.renderingModel.indices);
            (0, $b125b9470601071f$export$9ed6815acb35f982)(gl, programInfo, {
                modelViewMatrix: modelViewMatrix,
                normalMatrix: normalMatrix,
                shininess: ship.rendering.shininess
            });
            {
                const vertexCount = ship.blueprint.renderingModel.vertexCount;
                const type = gl.UNSIGNED_SHORT;
                const offset = 0;
                gl.drawElements(gl.TRIANGLES, vertexCount, type, offset);
            }
        });
    };
}


// We might be able to use gl_PointSize to draw the starfield. Maybe.
//  https://webglfundamentals.org/webgl/lessons/webgl-points-lines-triangles.html


function $9db6c6a7dcd1bbc5$var$initShaderProgram(gl, resources) {
    const shaderProgram = (0, $747b70bb26c9cf6e$export$f7c2b6763dc47773)(gl, resources.shaderSource.stardust);
    if (!shaderProgram) return null;
    return {
        program: shaderProgram,
        attribLocations: {
            position: gl.getAttribLocation(shaderProgram, "position")
        },
        uniformLocations: {
            projectionMatrix: gl.getUniformLocation(shaderProgram, "uProjectionMatrix"),
            depth: gl.getUniformLocation(shaderProgram, "uDepth"),
            jumping: gl.getUniformLocation(shaderProgram, "uJumping")
        }
    };
}
function $9db6c6a7dcd1bbc5$var$setPositionAttribute(gl, buffer, programInfo) {
    const numComponents = 3 // pull out 2 values per iteration
    ;
    const type = gl.FLOAT // the data in the buffer is 32bit floats
    ;
    const normalize = false // don't normalize
    ;
    const stride = 0 // how many bytes to get from one set of values to the next
    ;
    // 0 = use type and numComponents above
    const offset = 0 // how many bytes inside the buffer to start from
    ;
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.vertexAttribPointer(programInfo.attribLocations.position, numComponents, type, normalize, stride, offset);
    gl.enableVertexAttribArray(programInfo.attribLocations.position);
}
function $9db6c6a7dcd1bbc5$export$ef8a4b9482c1c86(gl, resources) {
    const programInfo = $9db6c6a7dcd1bbc5$var$initShaderProgram(gl, resources);
    return function(game) {
        const localBubble = game.localBubble;
        const positions = localBubble.stardust.flatMap((pos)=>[
                pos[0],
                pos[1],
                pos[2]
            ]);
        const positionBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(positions), gl.STATIC_DRAW);
        const projectionMatrix = (0, $26675c4f95835ef1$exports).create();
        (0, $26675c4f95835ef1$exports).ortho(projectionMatrix, -0.5, 0.5, -0.5, 0.5, 0, localBubble.clipSpaceRadius);
        gl.useProgram(programInfo.program);
        // Set the shader uniforms
        gl.uniformMatrix4fv(programInfo.uniformLocations.projectionMatrix, false, projectionMatrix);
        gl.uniform1f(programInfo.uniformLocations.depth, localBubble.clipSpaceRadius - 2.0);
        gl.uniform1i(programInfo.uniformLocations.jumping, game.player.isJumping ? 1 : 0);
        $9db6c6a7dcd1bbc5$var$setPositionAttribute(gl, positionBuffer, programInfo);
        {
            const vertexCount = localBubble.stardust.length;
            gl.drawArrays(gl.POINTS, 0, vertexCount);
        }
        gl.deleteBuffer(positionBuffer);
    };
}





function $7c09c43ad23c5647$var$initShaderProgram(gl, resources) {
    const shaderProgram = (0, $747b70bb26c9cf6e$export$f7c2b6763dc47773)(gl, resources.shaderSource.sun);
    if (!shaderProgram) return null;
    return {
        program: shaderProgram,
        attribLocations: {
            vertexPosition: gl.getAttribLocation(shaderProgram, "aVertexPosition"),
            vertexNormal: gl.getAttribLocation(shaderProgram, "aVertexNormal"),
            vertexColor: gl.getAttribLocation(shaderProgram, "aVertexColor"),
            textureCoords: gl.getAttribLocation(shaderProgram, "aTextureCoord")
        },
        uniformLocations: {
            projectionMatrix: gl.getUniformLocation(shaderProgram, "uProjectionMatrix"),
            modelViewMatrix: gl.getUniformLocation(shaderProgram, "uModelViewMatrix"),
            normalMatrix: gl.getUniformLocation(shaderProgram, "uNormalMatrix"),
            textureSampler: gl.getUniformLocation(shaderProgram, "uSampler"),
            mouse: gl.getUniformLocation(shaderProgram, "iMouse"),
            time: gl.getUniformLocation(shaderProgram, "iTime"),
            resolution: gl.getUniformLocation(shaderProgram, "iResolution")
        }
    };
}
function $7c09c43ad23c5647$export$5cc037c742a2c6d1(gl, resources) {
    const programInfo = $7c09c43ad23c5647$var$initShaderProgram(gl, resources);
    let time = 0.0;
    return function(projectionMatrix, localBubble, timeDelta) {
        time += timeDelta;
        gl.useProgram(programInfo.program);
        const sun = localBubble.sun;
        const scale = sun.radius;
        const targetToMatrix = (0, $26675c4f95835ef1$exports).targetTo((0, $26675c4f95835ef1$exports).create(), [
            0,
            0,
            0
        ], sun.noseOrientation, sun.roofOrientation);
        const targetToQuat = (0, $26675c4f95835ef1$exports).getRotation((0, $e92e4eb8d35aaf31$exports).create(), targetToMatrix);
        const modelViewMatrix = (0, $26675c4f95835ef1$exports).fromRotationTranslationScale((0, $26675c4f95835ef1$exports).create(), targetToQuat, sun.position, [
            scale,
            scale,
            1.0
        ]);
        const normalMatrix = (0, $26675c4f95835ef1$exports).create();
        (0, $26675c4f95835ef1$exports).invert(normalMatrix, modelViewMatrix);
        (0, $26675c4f95835ef1$exports).transpose(normalMatrix, normalMatrix);
        const resolution = (0, $4ce98914b6676340$exports).fromValues(256.0, 256.0);
        const mouse = (0, $4ce98914b6676340$exports).fromValues(32, 32);
        (0, $b125b9470601071f$export$f5a01205d395aca)(gl, sun.model, programInfo);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, sun.model.indices);
        (0, $b125b9470601071f$export$9ed6815acb35f982)(gl, programInfo, {
            modelViewMatrix: modelViewMatrix,
            normalMatrix: normalMatrix,
            projectionMatrix: projectionMatrix,
            textureIndex: 0
        }, localBubble.sun.model.texture);
        gl.uniform2fv(programInfo.uniformLocations.mouse, mouse);
        gl.uniform2fv(programInfo.uniformLocations.resolution, resolution);
        gl.uniform1f(programInfo.uniformLocations.time, time);
        {
            const vertexCount = sun.model.vertexCount;
            const type = gl.UNSIGNED_SHORT;
            const offset = 0;
            gl.drawElements(gl.TRIANGLES, vertexCount, type, offset);
        }
    };
}





function $debc6084a1282f62$var$initShaderProgram(gl, resources) {
    const shaderProgram = (0, $747b70bb26c9cf6e$export$f7c2b6763dc47773)(gl, resources.shaderSource.uColor);
    if (!shaderProgram) return null;
    return {
        program: shaderProgram,
        attribLocations: {
            vertexPosition: gl.getAttribLocation(shaderProgram, "aVertexPosition")
        },
        uniformLocations: {
            projectionMatrix: gl.getUniformLocation(shaderProgram, "uProjectionMatrix"),
            modelViewMatrix: gl.getUniformLocation(shaderProgram, "uModelViewMatrix"),
            color: gl.getUniformLocation(shaderProgram, "uColor")
        }
    };
}
function $debc6084a1282f62$var$createVertexBuffer(gl) {
    const vertexBuffer = gl.createBuffer();
    let vertices = [
        0,
        0,
        1,
        0,
        1,
        1,
        1,
        1,
        0,
        1,
        0,
        0
    ].map((p)=>p);
    gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(vertices), gl.STATIC_DRAW);
    return {
        buffer: vertexBuffer,
        vertCount: vertices.length / 2
    };
}
function $debc6084a1282f62$export$d526202d1c30049f(gl, width, height, resources) {
    const programInfo = $debc6084a1282f62$var$initShaderProgram(gl, resources);
    const vertices = $debc6084a1282f62$var$createVertexBuffer(gl);
    const projectionMatrix = (0, $26675c4f95835ef1$exports).create();
    (0, $26675c4f95835ef1$exports).ortho(projectionMatrix, 0, width, height, 0, -1, 1.0);
    return function(position, size, color) {
        const modelViewMatrix = (0, $26675c4f95835ef1$exports).fromRotationTranslationScale((0, $26675c4f95835ef1$exports).create(), (0, $e92e4eb8d35aaf31$exports).create(), [
            position[0],
            position[1],
            0.0
        ], [
            size[0],
            size[1],
            1.0
        ]);
        gl.useProgram(programInfo.program);
        (0, $b125b9470601071f$export$f1fc9c1971337e7c)(gl, {
            position: vertices.buffer
        }, programInfo);
        (0, $b125b9470601071f$export$9ed6815acb35f982)(gl, programInfo, {
            projectionMatrix: projectionMatrix,
            modelViewMatrix: modelViewMatrix,
            color: color
        });
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, vertices.vertCount);
    };
}





function $71c11ec3c9315904$var$initShaderProgram(gl, resources) {
    const shaderProgram = (0, $747b70bb26c9cf6e$export$f7c2b6763dc47773)(gl, resources.shaderSource.uColor);
    if (!shaderProgram) return null;
    return {
        program: shaderProgram,
        attribLocations: {
            vertexPosition: gl.getAttribLocation(shaderProgram, "aVertexPosition")
        },
        uniformLocations: {
            projectionMatrix: gl.getUniformLocation(shaderProgram, "uProjectionMatrix"),
            modelViewMatrix: gl.getUniformLocation(shaderProgram, "uModelViewMatrix"),
            color: gl.getUniformLocation(shaderProgram, "uColor")
        }
    };
}
function $71c11ec3c9315904$var$createVertexBuffer(gl) {
    const vertexBuffer = gl.createBuffer();
    let vertices = [];
    for(let angle = 0; angle <= 360.0; angle++){
        let radians = angle * Math.PI / 180.0;
        const vert1 = [
            Math.sin(radians),
            Math.cos(radians)
        ];
        const vert2 = [
            0.0,
            0.0
        ];
        vertices = vertices.concat(vert1);
        vertices = vertices.concat(vert2);
    }
    gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(vertices), gl.STATIC_DRAW);
    return {
        buffer: vertexBuffer,
        vertCount: vertices.length / 2
    };
}
function $71c11ec3c9315904$export$b7b99c5b53d1b03(gl, width, height, resources) {
    const programInfo = $71c11ec3c9315904$var$initShaderProgram(gl, resources);
    const vertices = $71c11ec3c9315904$var$createVertexBuffer(gl);
    const projectionMatrix = (0, $26675c4f95835ef1$exports).create();
    (0, $26675c4f95835ef1$exports).ortho(projectionMatrix, 0, width, height, 0, -1, 1.0);
    return function(position, radius, color) {
        const modelViewMatrix = (0, $26675c4f95835ef1$exports).fromRotationTranslationScale((0, $26675c4f95835ef1$exports).create(), (0, $e92e4eb8d35aaf31$exports).create(), [
            position[0],
            position[1],
            0.0
        ], [
            radius,
            radius,
            1.0
        ]);
        gl.useProgram(programInfo.program);
        (0, $b125b9470601071f$export$f1fc9c1971337e7c)(gl, {
            position: vertices.buffer
        }, programInfo);
        (0, $b125b9470601071f$export$9ed6815acb35f982)(gl, programInfo, {
            projectionMatrix: projectionMatrix,
            modelViewMatrix: modelViewMatrix,
            color: color
        });
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, vertices.vertCount);
    };
}







function $ee9e5df9a99a98b2$var$initShaderProgram(gl, resources) {
    const shaderProgram = (0, $747b70bb26c9cf6e$export$f7c2b6763dc47773)(gl, resources.shaderSource.simpleTexture);
    if (!shaderProgram) return null;
    return {
        program: shaderProgram,
        attribLocations: {
            vertexPosition: gl.getAttribLocation(shaderProgram, "aVertexPosition"),
            textureCoords: gl.getAttribLocation(shaderProgram, "aTextureCoord")
        },
        uniformLocations: {
            projectionMatrix: gl.getUniformLocation(shaderProgram, "uProjectionMatrix"),
            modelViewMatrix: gl.getUniformLocation(shaderProgram, "uModelViewMatrix"),
            textureSampler: gl.getUniformLocation(shaderProgram, "uSampler")
        }
    };
}
function $ee9e5df9a99a98b2$export$c91d19dba6aae8ce(gl, width, height, resources) {
    const programInfo = $ee9e5df9a99a98b2$var$initShaderProgram(gl, resources);
    const square = (0, $35806345bc1d62c5$export$7c40b2ceeb961577)(gl, [
        1.0,
        0.0,
        0.0,
        1.0
    ], null, true);
    const projectionMatrix = (0, $26675c4f95835ef1$exports).create();
    (0, $26675c4f95835ef1$exports).ortho(projectionMatrix, 0, width, height, 0, -1, 1.0);
    return function(position, size, texture) {
        // the divide by two is because the model has extents of -1.0 to 1.0
        const modelViewMatrix = (0, $26675c4f95835ef1$exports).fromRotationTranslationScale((0, $26675c4f95835ef1$exports).create(), (0, $e92e4eb8d35aaf31$exports).create(), [
            position[0] + size[0] / 2,
            position[1] + size[1] / 2,
            0.0
        ], [
            size[0] / 2,
            size[1] / 2,
            1.0
        ]);
        gl.useProgram(programInfo.program);
        (0, $b125b9470601071f$export$f5a01205d395aca)(gl, square, programInfo);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, square.indices);
        (0, $b125b9470601071f$export$9ed6815acb35f982)(gl, programInfo, {
            projectionMatrix: projectionMatrix,
            modelViewMatrix: modelViewMatrix,
            textureIndex: 0
        }, texture);
        const vertexCount = square.vertexCount;
        const type = gl.UNSIGNED_SHORT;
        const offset = 0;
        gl.drawElements(gl.TRIANGLES, vertexCount, type, offset);
    };
}


function $45ed6fb76a623699$export$6bf5cf98c33b0c4b(gl, flippedY, resources, width, height) {
    return {
        rect: (0, $debc6084a1282f62$export$d526202d1c30049f)(gl, width, height, resources),
        texturedRect: (0, $ee9e5df9a99a98b2$export$c91d19dba6aae8ce)(gl, width, height, resources),
        circle: (0, $71c11ec3c9315904$export$b7b99c5b53d1b03)(gl, width, height, resources),
        text: (0, $3c047a64f97dc4db$export$b65634ddab3713db)(gl, width, height, false, resources),
        size: ()=>({
                width: width,
                height: height
            })
    };
}


var $bd101182371a0deb$export$64585a4aa6616f30;
(function(SceneEnum) {
    SceneEnum[SceneEnum["Front"] = 0] = "Front";
    SceneEnum[SceneEnum["Rear"] = 1] = "Rear";
    SceneEnum[SceneEnum["Left"] = 2] = "Left";
    SceneEnum[SceneEnum["Right"] = 3] = "Right";
    SceneEnum[SceneEnum["LocalMap"] = 4] = "LocalMap";
    SceneEnum[SceneEnum["LongRangeMap"] = 5] = "LongRangeMap";
    SceneEnum[SceneEnum["SystemDetails"] = 6] = "SystemDetails";
    SceneEnum[SceneEnum["PlayerDetails"] = 7] = "PlayerDetails";
    SceneEnum[SceneEnum["Inventory"] = 8] = "Inventory";
    SceneEnum[SceneEnum["Launching"] = 9] = "Launching";
    SceneEnum[SceneEnum["Hyperspace"] = 10] = "Hyperspace";
    SceneEnum[SceneEnum["BuyMarketItems"] = 11] = "BuyMarketItems";
    SceneEnum[SceneEnum["BuyEquipment"] = 12] = "BuyEquipment";
    SceneEnum[SceneEnum["Docking"] = 13] = "Docking";
    SceneEnum[SceneEnum["PlayerExploding"] = 14] = "PlayerExploding";
    SceneEnum[SceneEnum["PriceList"] = 15] = "PriceList";
})($bd101182371a0deb$export$64585a4aa6616f30 || ($bd101182371a0deb$export$64585a4aa6616f30 = {}));





function $58155f1a80e0ee9d$export$5680a79c8fceeba9(draw2d) {
    const xMax = 25 * ((0, $9ecda7333d28e490$export$434491b6b43e3f77).width / 256.0);
    const yMax = 50 * ((0, $9ecda7333d28e490$export$434491b6b43e3f77).height / 256.0);
    const xRange = xMax * 2;
    const yRange = yMax * 2;
    const xScale = draw2d.size().width / xRange / 1.4;
    const yScale = draw2d.size().width / xRange / 1.4;
    const xOffset = -1;
    const yOffset = -1;
    /*function distance(star1: StarSystem, star2: StarSystem) {
        const xDelta = star2.galacticPosition.x - star1.galacticPosition.x
        const yDelta = star2.galacticPosition.y - star1.galacticPosition.y
        return Math.sqrt(xDelta*xDelta + yDelta*yDelta)
    }*/ return function renderLocalChart(game) {
        const viewRect = {
            left: game.currentSystem.galacticPosition[0] - xMax + xOffset,
            top: game.currentSystem.galacticPosition[1] - yMax + yOffset,
            width: xRange,
            height: yRange
        };
        const orange = (0, $e38eb280d3b76273$exports).fromValues(0xf5 / 255.0, 0x9e / 255.0, 0x0b / 255.0, 1.0);
        const currentCenter = (0, $4ce98914b6676340$exports).fromValues((game.currentSystem.galacticPosition[0] - viewRect.left) * xScale, (game.currentSystem.galacticPosition[1] - viewRect.top) * yScale);
        const currentCursor = (0, $4ce98914b6676340$exports).multiply((0, $4ce98914b6676340$exports).create(), (0, $4ce98914b6676340$exports).subtract((0, $4ce98914b6676340$exports).create(), game.player.scannerCursor, [
            viewRect.left,
            viewRect.top
        ]), [
            xScale,
            yScale
        ]);
        draw2d.circle(currentCenter, game.player.fuel / 10.0 * xScale, [
            1.0,
            0.0,
            0.0,
            1.0
        ]);
        draw2d.circle(currentCenter, game.player.fuel / 10.0 * xScale - 2, [
            0.0,
            0.0,
            0.0,
            1.0
        ]);
        const usedTextRows = [];
        game.stars.forEach((star)=>{
            if ((0, $97e646fb7d266a2f$export$3ed9b644ed65412a)(star.galacticPosition, viewRect)) {
                //const xDist = Math.abs(star.galacticPosition.x - game.player.currentSystem.galacticPosition.x)
                //const yDist = Math.abs(star.galacticPosition.y - game.player.currentSystem.galacticPosition.y)
                //if (xDist < xMax && yDist < yMax) {
                const distance = (0, $4ce98914b6676340$exports).distance(star.galacticPosition, game.currentSystem.galacticPosition);
                if (distance < 8) {
                    const center = (0, $4ce98914b6676340$exports).fromValues((star.galacticPosition[0] - viewRect.left) * xScale, (star.galacticPosition[1] - viewRect.top) * yScale);
                    draw2d.circle(center, star.shortRangeDotSize * 2, orange);
                    const characterPosition = draw2d.text.convertToCharacterCoordinates((0, $4ce98914b6676340$exports).fromValues(center[0], center[1]));
                    let row = characterPosition[1];
                    if (usedTextRows[row]) {
                        if (!usedTextRows[row + 1]) row++;
                        else if (!usedTextRows[row - 1]) row--;
                        else row = null;
                    }
                    if (row !== null) {
                        usedTextRows[row] = true;
                        const position = draw2d.text.convertToPosition((0, $4ce98914b6676340$exports).fromValues(characterPosition[0], row));
                        draw2d.text.draw(`${star.name}`, (0, $4ce98914b6676340$exports).fromValues(center[0] + 10, position[1]), false);
                    }
                }
            }
        });
        draw2d.text.draw("SHORT RANGE CHART", [
            10,
            0.5
        ]);
        draw2d.rect([
            0,
            40
        ], [
            draw2d.size().width,
            (0, $9ecda7333d28e490$export$85309a65275dadab)
        ], (0, $9ecda7333d28e490$export$c4cb53d5b465982a));
        draw2d.rect([
            currentCursor[0] - 1.5,
            currentCursor[1] - 10
        ], [
            3,
            -30
        ], [
            1.0,
            1.0,
            1.0,
            1.0
        ]);
        draw2d.rect([
            currentCursor[0] - 1.5,
            currentCursor[1] + 10
        ], [
            3,
            30
        ], [
            1.0,
            1.0,
            1.0,
            1.0
        ]);
        draw2d.rect([
            currentCursor[0] - 10,
            currentCursor[1] - 1.5
        ], [
            -30,
            3
        ], [
            1.0,
            1.0,
            1.0,
            1.0
        ]);
        draw2d.rect([
            currentCursor[0] + 10,
            currentCursor[1] - 1.5
        ], [
            30,
            3
        ], [
            1.0,
            1.0,
            1.0,
            1.0
        ]);
    };
}



var $0f7203ab41e6a747$export$7c72ca51a96cfba1;
(function(EconomyEnum) {
    EconomyEnum[EconomyEnum["RichIndustrial"] = 0] = "RichIndustrial";
    EconomyEnum[EconomyEnum["AverageIndustrial"] = 1] = "AverageIndustrial";
    EconomyEnum[EconomyEnum["PoorIndustrial"] = 2] = "PoorIndustrial";
    EconomyEnum[EconomyEnum["MainlyIndustrial"] = 3] = "MainlyIndustrial";
    EconomyEnum[EconomyEnum["MainlyAgricultural"] = 4] = "MainlyAgricultural";
    EconomyEnum[EconomyEnum["RichAgricultural"] = 5] = "RichAgricultural";
    EconomyEnum[EconomyEnum["AverageAgricultural"] = 6] = "AverageAgricultural";
    EconomyEnum[EconomyEnum["PoorAgricultural"] = 7] = "PoorAgricultural";
})($0f7203ab41e6a747$export$7c72ca51a96cfba1 || ($0f7203ab41e6a747$export$7c72ca51a96cfba1 = {}));
const $0f7203ab41e6a747$export$d2de47ee932c3057 = [
    "Rich Industrial",
    "Average Industrial",
    "Poor Industrial",
    "Mainly Industrial",
    "Mainly Agricultural",
    "Rich Agricultural",
    "Average Agricultural",
    "Poor Agricultural"
];
var $0f7203ab41e6a747$export$b828a23d042058ed;
(function(GovernmentEnum) {
    GovernmentEnum[GovernmentEnum["Anarchy"] = 0] = "Anarchy";
    GovernmentEnum[GovernmentEnum["Feudal"] = 1] = "Feudal";
    GovernmentEnum[GovernmentEnum["MultiGovernment"] = 2] = "MultiGovernment";
    GovernmentEnum[GovernmentEnum["Dictatorship"] = 3] = "Dictatorship";
    GovernmentEnum[GovernmentEnum["Communist"] = 4] = "Communist";
    GovernmentEnum[GovernmentEnum["Confederacy"] = 5] = "Confederacy";
    GovernmentEnum[GovernmentEnum["Democracy"] = 6] = "Democracy";
    GovernmentEnum[GovernmentEnum["CorporateState"] = 7] = "CorporateState";
})($0f7203ab41e6a747$export$b828a23d042058ed || ($0f7203ab41e6a747$export$b828a23d042058ed = {}));
const $0f7203ab41e6a747$export$316a1edc97f1a801 = [
    "Anarchy",
    "Feudal",
    "Multi Government",
    "Dictatorship",
    "Communist",
    "Confederacy",
    "Democracy",
    "Corporate State"
];




function $23fac6550b969d62$export$c2f87357ecfce51f(game) {
    const result = game.stars.reduce((memo, star)=>{
        const thisDistance = (0, $4ce98914b6676340$exports).distance(game.player.scannerCursor, star.galacticPosition);
        if (thisDistance < memo.distance) return {
            star: star,
            distance: thisDistance
        };
        return memo;
    }, {
        star: null,
        distance: 1000
    });
    return result.star;
}


function $4fc51d87e1bc469e$export$21954360f21ec943(draw2d) {
    return function renderLocalChart(game) {
        const system = (0, $23fac6550b969d62$export$c2f87357ecfce51f)(game);
        game.player.scannerCursor = (0, $4ce98914b6676340$exports).copy((0, $4ce98914b6676340$exports).create(), system.galacticPosition);
        game.player.selectedSystem = system;
        const title = `DATA ON ${system.name.toUpperCase()}`;
        draw2d.text.draw(title, [
            19 - title.length / 2,
            0.5
        ]);
        draw2d.rect([
            0,
            40
        ], [
            draw2d.size().width,
            (0, $9ecda7333d28e490$export$85309a65275dadab)
        ], (0, $9ecda7333d28e490$export$c4cb53d5b465982a));
        //draw2d.text.draw("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz", [0,0])
        //if (game.player.currentSystem.seed !== )
        draw2d.text.draw(`Distance:      7.6 Light Years`, [
            1,
            3
        ]);
        draw2d.text.draw(`Economy:${(0, $0f7203ab41e6a747$export$d2de47ee932c3057)[system.economy]}`, [
            1,
            5
        ]);
        draw2d.text.draw(`Government:${(0, $0f7203ab41e6a747$export$316a1edc97f1a801)[system.government]}`, [
            1,
            7
        ]);
        draw2d.text.draw(`Tech.Level:  ${system.technologyLevel + 1}`, [
            1,
            9
        ]);
        draw2d.text.draw(`Population:${system.population / 10.0} Billion`, [
            1,
            11
        ]);
        draw2d.text.draw(`(${system.speciesType})`, [
            1,
            13
        ]);
        draw2d.text.draw(`Gross Productivity: ${system.productivity} M CR`, [
            1,
            15
        ]);
        draw2d.text.draw(`Average Radius: ${system.averageRadius} km`, [
            1,
            17
        ]);
    };
}





function $df8fab82612a90a2$var$legalStatusText(value) {
    value, (0, $eb309e06665aa479$export$5ec4fea3c362418a).Clean;
    return "Clean";
}
function $df8fab82612a90a2$var$ratingText(value) {
    switch(value){
        case (0, $eb309e06665aa479$export$75e1dec82dcaa940).MostlyHarmless:
            return "Mostly Harmless";
        case (0, $eb309e06665aa479$export$75e1dec82dcaa940).Poor:
            return "Poor";
        case (0, $eb309e06665aa479$export$75e1dec82dcaa940).Average:
            return "Average";
        case (0, $eb309e06665aa479$export$75e1dec82dcaa940).AboveAverage:
            return "Above Average";
        case (0, $eb309e06665aa479$export$75e1dec82dcaa940).Competent:
            return "Competent";
        case (0, $eb309e06665aa479$export$75e1dec82dcaa940).Dangerous:
            return "Dangerous";
        case (0, $eb309e06665aa479$export$75e1dec82dcaa940).Deadly:
            return "Deadly";
        case (0, $eb309e06665aa479$export$75e1dec82dcaa940).Elite:
            return "Elite";
        case (0, $eb309e06665aa479$export$75e1dec82dcaa940).Harmless:
        default:
            return "Harmless";
    }
}
function $df8fab82612a90a2$var$laserTypeText(value) {
    switch(value){
        case (0, $eb309e06665aa479$export$8a510af63dd342b2).Pulse:
            return "Pulse Laser";
        case (0, $eb309e06665aa479$export$8a510af63dd342b2).Mining:
            return "Mining Laser";
        case (0, $eb309e06665aa479$export$8a510af63dd342b2).Beam:
            return "Beam Laser";
        case (0, $eb309e06665aa479$export$8a510af63dd342b2).Military:
            return "Military Laser";
        case (0, $eb309e06665aa479$export$8a510af63dd342b2).None:
        default:
            return "None";
    }
}
function $df8fab82612a90a2$export$cbf5e189bb4d37c0(draw2d) {
    return function renderLocalChart(game) {
        const player = game.player;
        const equipment = player.equipment;
        let equipmentLine = 12;
        const title = `COMMANDER ${player.name}`;
        draw2d.text.draw(title, [
            19 - title.length / 2,
            0.5
        ]);
        draw2d.rect([
            0,
            40
        ], [
            draw2d.size().width,
            (0, $9ecda7333d28e490$export$85309a65275dadab)
        ], (0, $9ecda7333d28e490$export$c4cb53d5b465982a));
        draw2d.text.draw(`Present System          :${game.currentSystem.name}`, [
            1,
            3
        ]);
        draw2d.text.draw(`Hyperspace System       :${player.selectedSystem.name}`, [
            1,
            4
        ]);
        draw2d.text.draw(`Condition               :${player.isDocked ? "Docked" : "Space"}`, [
            1,
            5
        ]);
        draw2d.text.draw(`Fuel:${(player.fuel / 10).toLocaleString(undefined, {
            maximumFractionDigits: 1,
            minimumFractionDigits: 1
        })} Light Years`, [
            1,
            6
        ]);
        draw2d.text.draw(`Cash:    ${player.cash.toLocaleString(undefined, {
            maximumFractionDigits: 1,
            minimumFractionDigits: 1
        })} Cr`, [
            1,
            7
        ]);
        draw2d.text.draw(`Legal Status: ${$df8fab82612a90a2$var$legalStatusText(player.legalStatus)}`, [
            1,
            8
        ]);
        draw2d.text.draw(`Rating: ${$df8fab82612a90a2$var$ratingText(player.combatRating)}`, [
            1,
            9
        ]);
        draw2d.text.draw(`EQUIPMENT:`, [
            1,
            11
        ]);
        if (equipment.frontLaser != (0, $eb309e06665aa479$export$8a510af63dd342b2).None) draw2d.text.draw(`Front ${$df8fab82612a90a2$var$laserTypeText(equipment.frontLaser)}`, [
            6,
            equipmentLine++
        ]);
        if (equipment.aftLaser != (0, $eb309e06665aa479$export$8a510af63dd342b2).None) draw2d.text.draw(`Aft ${$df8fab82612a90a2$var$laserTypeText(equipment.aftLaser)}`, [
            6,
            equipmentLine++
        ]);
        if (equipment.portLaser != (0, $eb309e06665aa479$export$8a510af63dd342b2).None) draw2d.text.draw(`Port ${$df8fab82612a90a2$var$laserTypeText(equipment.portLaser)}`, [
            6,
            equipmentLine++
        ]);
        if (equipment.starboardLaser != (0, $eb309e06665aa479$export$8a510af63dd342b2).None) draw2d.text.draw(`Front ${$df8fab82612a90a2$var$laserTypeText(equipment.starboardLaser)}`, [
            6,
            equipmentLine++
        ]);
        if (equipment.fuelScoops) draw2d.text.draw(`Fuel Scoops`, [
            6,
            equipmentLine++
        ]);
        if (equipment.largeCargoBay) draw2d.text.draw(`Large Cargo Bay`, [
            6,
            equipmentLine++
        ]);
        if (equipment.dockingComputer) draw2d.text.draw(`Docking Computer`, [
            6,
            equipmentLine++
        ]);
        if (equipment.ecmSystem) draw2d.text.draw(`E.C.M. System`, [
            6,
            equipmentLine++
        ]);
        if (equipment.galacticHyperdrive) draw2d.text.draw(`Galactic Hyperdrive`, [
            6,
            equipmentLine++
        ]);
    };
}






function $00a40332a0b2526f$var$initShaderProgram(gl, resources) {
    const shaderProgram = (0, $747b70bb26c9cf6e$export$f7c2b6763dc47773)(gl, resources.shaderSource.uColor);
    if (!shaderProgram) return null;
    return {
        program: shaderProgram,
        attribLocations: {
            vertexPosition: gl.getAttribLocation(shaderProgram, "aVertexPosition")
        },
        uniformLocations: {
            projectionMatrix: gl.getUniformLocation(shaderProgram, "uProjectionMatrix"),
            modelViewMatrix: gl.getUniformLocation(shaderProgram, "uModelViewMatrix"),
            color: gl.getUniformLocation(shaderProgram, "uColor")
        }
    };
}
function $00a40332a0b2526f$var$createVertexBuffer(gl, points) {
    const vertexBuffer = gl.createBuffer();
    let vertices = [];
    for(let angle = 0; angle <= 360.0; angle += 360.0 / points){
        let radians = angle * Math.PI / 180.0;
        const vert1 = [
            Math.sin(radians),
            Math.cos(radians)
        ];
        const vert2 = [
            0.0,
            0.0
        ];
        vertices = vertices.concat(vert1);
        vertices = vertices.concat(vert2);
    }
    gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(vertices), gl.STATIC_DRAW);
    return {
        buffer: vertexBuffer,
        vertCount: vertices.length / 2
    };
}
function $00a40332a0b2526f$export$8ae47f9ffc1f412f(gl, width, height, points, resources) {
    const programInfo = $00a40332a0b2526f$var$initShaderProgram(gl, resources);
    const vertices = $00a40332a0b2526f$var$createVertexBuffer(gl, points);
    const projectionMatrix = (0, $26675c4f95835ef1$exports).create();
    (0, $26675c4f95835ef1$exports).ortho(projectionMatrix, 0, width, height, 0, -1, 1.0);
    return function(position, radius, color, rotation = 0) {
        const rotationQuat = (0, $e92e4eb8d35aaf31$exports).rotateZ((0, $e92e4eb8d35aaf31$exports).create(), (0, $e92e4eb8d35aaf31$exports).create(), rotation);
        const modelViewMatrix = (0, $26675c4f95835ef1$exports).fromRotationTranslationScale((0, $26675c4f95835ef1$exports).create(), rotationQuat, [
            position[0],
            position[1],
            0.0
        ], [
            radius,
            radius,
            1.0
        ]);
        gl.useProgram(programInfo.program);
        (0, $b125b9470601071f$export$f1fc9c1971337e7c)(gl, {
            position: vertices.buffer
        }, programInfo);
        (0, $b125b9470601071f$export$9ed6815acb35f982)(gl, programInfo, {
            projectionMatrix: projectionMatrix,
            modelViewMatrix: modelViewMatrix,
            color: color
        });
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, vertices.vertCount);
    };
}



function $25d05cbdd075ca6d$export$e0da0a7235f8db1e(gl, width, height, resources) {
    const octRenderer = (0, $00a40332a0b2526f$export$8ae47f9ffc1f412f)(gl, width, height, 8, resources);
    const centerX = (0, $9ecda7333d28e490$export$62ad7b0c781000e9).width / 2;
    const centerY = (0, $9ecda7333d28e490$export$62ad7b0c781000e9).mainViewHeight / 2;
    const maxRadius = Math.max(centerX, centerY) * 1.2;
    return function renderLaunch(game) {
        if (game.launching === null) return;
        game.launching.outboundRadii.forEach((radius)=>{
            octRenderer([
                centerX,
                centerY
            ], radius * maxRadius, (0, $e38eb280d3b76273$exports).fromValues(1, 1, 1, 1));
            octRenderer([
                centerX,
                centerY
            ], radius * maxRadius - 2, (0, $e38eb280d3b76273$exports).fromValues(0, 0, 0, 1));
        });
        game.launching.inboundRadii.forEach((radius)=>{
            octRenderer([
                centerX,
                centerY
            ], radius * maxRadius, (0, $e38eb280d3b76273$exports).fromValues(0, 0, 0, 1));
        });
    };
}




function $b75e5cdca71ffabb$export$4303a3d4b95f2c6(gl, width, height, resources) {
    const octRenderer = (0, $00a40332a0b2526f$export$8ae47f9ffc1f412f)(gl, width, height, 8, resources);
    const centerX = width / 2;
    const centerY = height / 2;
    const maxRadius = Math.max(centerX, centerY) * 1.2;
    const colors = [
        (0, $e38eb280d3b76273$exports).fromValues(1, 1, 0, 1),
        (0, $e38eb280d3b76273$exports).fromValues(1, 0, 0, 1),
        (0, $e38eb280d3b76273$exports).fromValues(0, 1, 0, 1),
        (0, $e38eb280d3b76273$exports).fromValues(0, 0, 1, 1),
        (0, $e38eb280d3b76273$exports).fromValues(0, 1, 1, 1)
    ];
    return function renderHyperspace(game) {
        if (game.hyperspace === null) return;
        let rotationIndex = 0;
        game.hyperspace.outboundRadii.forEach((radius)=>{
            const rotation = 20 * Math.PI / 180 * rotationIndex;
            rotationIndex++;
            if (rotationIndex > game.hyperspace.rotation) rotationIndex = game.hyperspace.rotation;
            const color = colors[Math.floor(Math.random() * (colors.length - 1))];
            //octRenderer([centerX, centerY], radius*maxRadius, color, rotation)
            octRenderer([
                centerX,
                centerY
            ], radius * maxRadius, color, rotation);
        });
        rotationIndex = 0;
        game.hyperspace.inboundRadii.forEach((radius)=>{
            const rotation = 20 * Math.PI / 180 * rotationIndex;
            rotationIndex++;
            if (rotationIndex > game.hyperspace.rotation) rotationIndex = game.hyperspace.rotation;
            octRenderer([
                centerX,
                centerY
            ], radius * maxRadius, (0, $e38eb280d3b76273$exports).fromValues(0, 0, 0, 1), rotation);
        });
    };
}






class $a212f037e9461f7a$var$BufferArray {
    constructor(numberOfComponents, items){
        this.numberOfComponents = numberOfComponents;
        this.items = items ?? [];
    }
    get numberOfElements() {
        return this.items.length / this.numberOfComponents;
    }
    push(values) {
        values.forEach((value)=>this.items.push(value));
    }
}
// This is based on the webglfundamentals.org example
function $a212f037e9461f7a$var$createSphereVertices(radius, subdivisionsAxis, subdivisionsHeight) {
    if (subdivisionsAxis <= 0 || subdivisionsHeight <= 0) throw Error("subdivisionAxis and subdivisionHeight must be > 0");
    const startLatitudeInRadians = 0;
    const endLatitudeInRadians = Math.PI;
    const startLongitudeInRadians = 0;
    const endLongitudeInRadians = Math.PI * 2;
    const latRange = endLatitudeInRadians - startLatitudeInRadians;
    const longRange = endLongitudeInRadians - startLongitudeInRadians;
    const positions = new $a212f037e9461f7a$var$BufferArray(3);
    const normals = new $a212f037e9461f7a$var$BufferArray(3);
    const texCoords = new $a212f037e9461f7a$var$BufferArray(2);
    // Generate the individual vertices in our vertex buffer.
    for(let y = 0; y <= subdivisionsHeight; y++)for(let x = 0; x <= subdivisionsAxis; x++){
        // Generate a vertex based on its spherical coordinates
        const u = x / subdivisionsAxis;
        const v = y / subdivisionsHeight;
        const theta = longRange * u + startLongitudeInRadians;
        const phi = latRange * v + startLatitudeInRadians;
        const sinTheta = Math.sin(theta);
        const cosTheta = Math.cos(theta);
        const sinPhi = Math.sin(phi);
        const cosPhi = Math.cos(phi);
        const ux = cosTheta * sinPhi;
        const uy = cosPhi;
        const uz = sinTheta * sinPhi;
        positions.push([
            radius * ux,
            radius * uy,
            radius * uz
        ]);
        normals.push([
            ux,
            uy,
            uz
        ]);
        texCoords.push([
            1 - u,
            v
        ]);
    }
    const numVertsAround = subdivisionsAxis + 1;
    const indices = new $a212f037e9461f7a$var$BufferArray(3) // webglUtils.createAugmentedTypedArray(3, subdivisionsAxis * subdivisionsHeight * 2, Uint16Array);
    ;
    for(let x = 0; x < subdivisionsAxis; x++)for(let y = 0; y < subdivisionsHeight; y++){
        if (y === 0) indices.push([
            (y + 0) * numVertsAround + x,
            (y + 1) * numVertsAround + x + 1,
            (y + 1) * numVertsAround + x
        ]);
        if (y === subdivisionsHeight - 1) indices.push([
            (y + 0) * numVertsAround + x,
            (y + 0) * numVertsAround + x + 1,
            (y + 1) * numVertsAround + x
        ]);
        if (y > 0 && y < subdivisionsHeight - 1 && subdivisionsHeight > 2) {
            indices.push([
                (y + 0) * numVertsAround + x,
                (y + 1) * numVertsAround + x + 1,
                (y + 1) * numVertsAround + x
            ]);
            indices.push([
                (y + 0) * numVertsAround + x,
                (y + 0) * numVertsAround + x + 1,
                (y + 1) * numVertsAround + x + 1
            ]);
        }
    }
    return {
        positions: positions,
        normals: normals,
        texcoords: texCoords,
        indices: indices
    };
}
function $a212f037e9461f7a$var$createBuffers(gl, geometry) {
    const positionBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(geometry.positions.items), gl.STATIC_DRAW);
    const normalBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, normalBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(geometry.normals.items), gl.STATIC_DRAW);
    const indexBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, indexBuffer);
    gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(geometry.indices.items), gl.STATIC_DRAW);
    //const colorBuffer = gl.createBuffer()
    //gl.bindBuffer(gl.ARRAY_BUFFER, colorBuffer)
    //gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(colors), gl.STATIC_DRAW)
    const textureCoordBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, textureCoordBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(geometry.texcoords.items), gl.STATIC_DRAW);
    const constraints = (0, $96fe3a99b59d4e0f$export$86f10caa3f7697c2)((0, $96fe3a99b59d4e0f$export$2489206f4a0afd08)(geometry.positions.items));
    return {
        position: positionBuffer,
        color: 0,
        indices: indexBuffer,
        normals: normalBuffer,
        vertexCount: geometry.indices.items.length,
        textureCoords: textureCoordBuffer,
        texture: null,
        boundingBox: (0, $96fe3a99b59d4e0f$export$60b93139888724f0)(constraints),
        boundingBoxSize: (0, $96fe3a99b59d4e0f$export$2a086082147fb4a2)(constraints),
        faceNormal: null
    };
}
function $a212f037e9461f7a$export$18981c191574f69d(gl, options) {
    const geometry = $a212f037e9461f7a$var$createSphereVertices(options.radius, options.subdivisionsAxis, options.subdivisionsHeight);
    const texture = options.glTexture ?? (options.textureFile ? (0, $91201f5d84ae2499$export$19de0130f5adf0ae)(gl, options.textureFile) : null);
    const model = $a212f037e9461f7a$var$createBuffers(gl, geometry);
    model.texture = texture;
    return model;
}




function $0e435564f4ae4a50$var$initShaderProgram(gl, resources) {
    const shaderProgram = (0, $747b70bb26c9cf6e$export$f7c2b6763dc47773)(gl, resources.shaderSource.planet);
    if (!shaderProgram) return null;
    return {
        program: shaderProgram,
        attribLocations: {
            vertexPosition: gl.getAttribLocation(shaderProgram, "aVertexPosition"),
            vertexNormal: gl.getAttribLocation(shaderProgram, "aVertexNormal"),
            textureCoords: gl.getAttribLocation(shaderProgram, "aTextureCoord")
        },
        uniformLocations: {
            projectionMatrix: gl.getUniformLocation(shaderProgram, "uProjectionMatrix"),
            modelViewMatrix: gl.getUniformLocation(shaderProgram, "uModelViewMatrix"),
            normalMatrix: gl.getUniformLocation(shaderProgram, "uNormalMatrix"),
            lightWorldPosition: gl.getUniformLocation(shaderProgram, "uLightWorldPosition"),
            shininess: gl.getUniformLocation(shaderProgram, "uShininess"),
            textureSampler: gl.getUniformLocation(shaderProgram, "uSampler")
        }
    };
}
function $0e435564f4ae4a50$export$ac9693e3f1f86602(gl, resources) {
    const programInfo = $0e435564f4ae4a50$var$initShaderProgram(gl, resources);
    const sphere = (0, $a212f037e9461f7a$export$18981c191574f69d)(gl, {
        radius: 1,
        subdivisionsAxis: 120,
        subdivisionsHeight: 60,
        textureFile: "./meridian.png"
    });
    return function(projectionMatrix, localBubble, timeDelta) {
        gl.useProgram(programInfo.program);
        const planet = localBubble.planet;
        // Firstly we point the ship along the nose orientation
        const targetToMatrix = (0, $26675c4f95835ef1$exports).targetTo((0, $26675c4f95835ef1$exports).create(), [
            0,
            0,
            0
        ], planet.noseOrientation, planet.roofOrientation);
        const targetToQuat = (0, $26675c4f95835ef1$exports).getRotation((0, $e92e4eb8d35aaf31$exports).create(), targetToMatrix);
        const viewPosition = planet.position;
        const scaledRadius = planet.radius * (0, $9ecda7333d28e490$export$44571b2f8b5f4189);
        const scale = (0, $ab7f6dc0910e1ef7$exports).fromValues(scaledRadius, scaledRadius, scaledRadius);
        const modelViewMatrix = (0, $26675c4f95835ef1$exports).fromRotationTranslationScale((0, $26675c4f95835ef1$exports).create(), targetToQuat, viewPosition, scale);
        const normalMatrix = (0, $26675c4f95835ef1$exports).create();
        (0, $26675c4f95835ef1$exports).invert(normalMatrix, modelViewMatrix);
        (0, $26675c4f95835ef1$exports).transpose(normalMatrix, normalMatrix);
        (0, $b125b9470601071f$export$f5a01205d395aca)(gl, sphere, programInfo);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, sphere.indices);
        (0, $b125b9470601071f$export$9ed6815acb35f982)(gl, programInfo, {
            modelViewMatrix: modelViewMatrix,
            normalMatrix: normalMatrix,
            projectionMatrix: projectionMatrix,
            lightWorldPosition: localBubble.sun.position,
            shininess: 128,
            textureIndex: 0
        }, resources.textures.planets[planet.surfaceTextureIndex]);
        {
            const vertexCount = sphere.vertexCount;
            const type = gl.UNSIGNED_SHORT;
            const offset = 0;
            gl.drawElements(gl.TRIANGLES, vertexCount, type, offset);
        }
    };
}



function $24bddcfb2e3a499c$export$244097b88839035f(player) {
    const totalCargo = player.cargoHoldContents.reduce((t, c)=>t + c, 0);
    return player.blueprint.maxCargo + (player.equipment.largeCargoBay ? 12 : 0) - totalCargo;
}


function $fd4c0166ba607453$export$74683782010daf96(draw2d) {
    return function renderMarketPlace(game, priceListOnly) {
        const forSaleBegin = 24;
        const forSaleEnd = 27;
        const cargoHoldBegin = 30;
        const cargoHoldEnd = 34;
        const headerRows = 2;
        let y = priceListOnly ? 2 : 1;
        if (!priceListOnly) {
            const mouseCharacterPosition = draw2d.text.convertToCharacterCoordinates(game.player.controlState.mousePosition);
            if (mouseCharacterPosition[1] > y + 1 && mouseCharacterPosition[1] < y + 2 + game.marketItems.length) {
                const drawPos = draw2d.text.convertToPosition([
                    0,
                    mouseCharacterPosition[1]
                ]);
                const size = draw2d.text.measure("My");
                draw2d.rect(drawPos, [
                    draw2d.size().width,
                    size.height
                ], [
                    1,
                    0,
                    0,
                    1
                ]);
                // TODO: we're breaking out of our otherwise so far clean split between rendering and logic here
                // but it, at the time of writing this, doesn't seem worth going to the effort of putting in a system to
                // pull screen interactivity with the mouse out of the renderer
                // A nice to have. May come back and sort.
                if (game.player.controlState.mouseDown && !game.player.previousControlState.mouseDown) {
                    const itemIndex = mouseCharacterPosition[1] - y - headerRows;
                    const item = game.marketItems[itemIndex];
                    if (mouseCharacterPosition[0] <= forSaleEnd) {
                        // TODO: we also need to do a cargo hold total contents check
                        const units = Math.min((0, $24bddcfb2e3a499c$export$244097b88839035f)(game.player), game.player.controlState.shiftPressed ? 5 : 1, item.quantityForSale);
                        if (units > 0 && units * item.unitPrice < game.player.cash) {
                            item.quantityForSale -= units;
                            game.player.cargoHoldContents[itemIndex] += units;
                            game.player.cash -= units * item.unitPrice;
                        }
                    } else if (mouseCharacterPosition[0] >= cargoHoldBegin) {
                        const units = Math.min(game.player.controlState.shiftPressed ? 5 : 1, game.player.cargoHoldContents[itemIndex]);
                        if (units > 0) {
                            item.quantityForSale += units;
                            game.player.cargoHoldContents[itemIndex] -= units;
                            game.player.cash += units * item.unitPrice;
                        }
                    }
                }
            }
        }
        if (priceListOnly) {
            draw2d.text.draw(`${game.currentSystem.name.toUpperCase()} MARKET PRICES`, [
                5,
                0.5
            ]);
            draw2d.rect([
                0,
                40
            ], [
                draw2d.size().width,
                (0, $9ecda7333d28e490$export$85309a65275dadab)
            ], (0, $9ecda7333d28e490$export$c4cb53d5b465982a));
        }
        draw2d.text.draw("PRODUCT", [
            2,
            y + 1
        ]);
        draw2d.text.draw("UNIT", [
            12,
            y + 1
        ]);
        draw2d.text.draw("UNIT", [
            17,
            y
        ]);
        draw2d.text.draw("PRICE", [
            17,
            y + 1
        ]);
        if (!priceListOnly) {
            draw2d.text.draw("FOR", [
                forSaleBegin,
                y
            ]);
            draw2d.text.draw("SALE", [
                forSaleBegin,
                y + 1
            ]);
            draw2d.text.draw("CARGO", [
                cargoHoldBegin,
                y
            ]);
            draw2d.text.draw("HOLD", [
                cargoHoldBegin,
                y + 1
            ]);
        } else {
            draw2d.text.draw("QUANTITY", [
                forSaleBegin,
                y
            ]);
            draw2d.text.draw("FOR SALE", [
                forSaleBegin,
                y + 1
            ]);
        }
        y += headerRows;
        game.marketItems.map((item, index)=>({
                item: item,
                index: index
            })).forEach(({ item: item, index: index })=>{
            draw2d.text.draw(item.name, [
                1,
                y
            ]);
            draw2d.text.draw(item.unit, [
                14,
                y
            ]);
            draw2d.text.draw(item.unitPrice.toLocaleString(undefined, {
                maximumFractionDigits: 1,
                minimumFractionDigits: 1
            }), [
                17,
                y
            ]);
            if (item.quantityForSale > 0) draw2d.text.draw(`${item.quantityForSale}${item.unit}`, [
                forSaleBegin,
                y
            ]);
            else draw2d.text.draw(" - ", [
                forSaleBegin,
                y
            ]);
            if (!priceListOnly) {
                if (game.player.cargoHoldContents[index] > 0) draw2d.text.draw(`${game.player.cargoHoldContents[index]}${item.unit}`, [
                    cargoHoldBegin,
                    y
                ]);
            }
            y++;
        });
        if (!priceListOnly) {
            draw2d.text.draw(`Cash: ${game.player.cash.toLocaleString(undefined, {
                maximumFractionDigits: 1,
                minimumFractionDigits: 1
            })} Cr`, [
                1,
                y + 1
            ]);
            draw2d.text.draw(`Cargo space: ${(0, $24bddcfb2e3a499c$export$244097b88839035f)(game.player)}`, [
                20,
                y + 1
            ]);
        }
    };
}






// The order of this is important as it, combined with the tech level, determines what items are available
const $a65982f89d2cadd4$export$d180f74c82dcb702 = [
    {
        name: "Fuel",
        price: 0,
        canBuy: (player)=>player.fuel < player.blueprint.maxFuel
    },
    {
        name: "Missile",
        price: 30,
        canBuy: (player)=>player.missiles.currentNumber < 4
    },
    {
        name: "Large Cargo Bay",
        price: 400,
        canBuy: (player)=>!player.equipment.largeCargoBay
    },
    {
        name: "E.C.M. System",
        price: 600,
        canBuy: (player)=>!player.equipment.ecmSystem
    },
    {
        name: "Extra Pulse Lasers",
        price: 400,
        canBuy: (player)=>true
    },
    {
        name: "Extra Beam Lasers",
        price: 1000,
        canBuy: (player)=>true
    },
    {
        name: "Fuel Scoops",
        price: 525,
        canBuy: (player)=>!player.equipment.fuelScoops
    },
    {
        name: "Escape Pod",
        price: 1000,
        canBuy: (player)=>!player.equipment.escapePod
    },
    {
        name: "Energy Bomb",
        price: 900,
        canBuy: (player)=>!player.equipment.energyBomb
    },
    {
        name: "Energy Unit",
        price: 1500,
        canBuy: (player)=>!player.equipment.energyUnit
    },
    {
        name: "Docking Computer",
        price: 1000,
        canBuy: (player)=>!player.equipment.dockingComputer
    },
    {
        name: "Galactic Hyperdrive",
        price: 5000,
        canBuy: (player)=>!player.equipment.galacticHyperdrive
    },
    {
        name: "Extra Military Lasers",
        price: 6000,
        canBuy: (player)=>true
    },
    {
        name: "Extra Mining Lasers",
        price: 800,
        canBuy: (player)=>true
    }
];
function $a65982f89d2cadd4$export$a0b46928513053a2(techLevel) {
    const cutOff = techLevel + 3 >= 12 ? 14 : techLevel + 3;
    return $a65982f89d2cadd4$export$d180f74c82dcb702.slice(0, cutOff);
}


function $cbfbab2b5d08c10d$var$calculateFuelPrice(player) {
    return (player.blueprint.maxFuel - player.fuel) / player.blueprint.maxFuel * 14.0;
}
function $cbfbab2b5d08c10d$var$buyFuel(player) {
    player.cash -= $cbfbab2b5d08c10d$var$calculateFuelPrice(player);
    player.fuel = player.blueprint.maxFuel;
}
function $cbfbab2b5d08c10d$var$buyMissile(player) {
    if (player.missiles.currentNumber < 4) {
        player.cash -= 30;
        player.missiles.currentNumber++;
    }
}
function $cbfbab2b5d08c10d$var$buyItem(player, price, updateEquipment) {
    if (player.cash > price) {
        player.cash -= price;
        updateEquipment(player.equipment);
    }
}
function $cbfbab2b5d08c10d$export$dbb6ecfd06175094(draw2d) {
    return function renderMarketPlace(game) {
        const top = 3;
        const items = (0, $a65982f89d2cadd4$export$a0b46928513053a2)(game.currentSystem.technologyLevel);
        const fuelPrice = $cbfbab2b5d08c10d$var$calculateFuelPrice(game.player);
        const canBuyItem = (index)=>{
            const price = index === 0 ? fuelPrice : items[index].price;
            return items[index].canBuy(game.player) && price <= game.player.cash && price > 0.0;
        };
        const mouseCharacterPosition = draw2d.text.convertToCharacterCoordinates(game.player.controlState.mousePosition);
        if (mouseCharacterPosition[1] >= top && mouseCharacterPosition[1] < top + items.length) {
            const itemIndex = mouseCharacterPosition[1] - top;
            const rowColor = canBuyItem(itemIndex) ? (0, $e38eb280d3b76273$exports).fromValues(1, 0, 0, 1) : (0, $e38eb280d3b76273$exports).fromValues(0.6, 0.0, 0.0, 1.0);
            const drawPos = draw2d.text.convertToPosition([
                0,
                mouseCharacterPosition[1]
            ]);
            const size = draw2d.text.measure("My");
            draw2d.rect(drawPos, [
                draw2d.size().width,
                size.height
            ], rowColor);
            // TODO: we're breaking out of our otherwise so far clean split between rendering and logic here
            // but it, at the time of writing this, doesn't seem worth going to the effort of putting in a system to
            // pull screen interactivity with the mouse out of the renderer
            // A nice to have. May come back and sort.
            if (game.player.controlState.mouseDown && !game.player.previousControlState.mouseDown && canBuyItem(itemIndex)) {
                const item = items[itemIndex];
                switch(itemIndex){
                    case 0:
                        $cbfbab2b5d08c10d$var$buyFuel(game.player);
                        break;
                    case 1:
                        $cbfbab2b5d08c10d$var$buyMissile(game.player);
                        break;
                    case 2:
                        $cbfbab2b5d08c10d$var$buyItem(game.player, item.price, (equipment)=>equipment.largeCargoBay = true);
                        break;
                    case 3:
                        $cbfbab2b5d08c10d$var$buyItem(game.player, item.price, (equipment)=>equipment.ecmSystem = true);
                        break;
                    case 6:
                        $cbfbab2b5d08c10d$var$buyItem(game.player, item.price, (equipment)=>equipment.fuelScoops = true);
                        break;
                    case 7:
                        $cbfbab2b5d08c10d$var$buyItem(game.player, item.price, (equipment)=>equipment.escapePod = true);
                        break;
                    case 8:
                        $cbfbab2b5d08c10d$var$buyItem(game.player, item.price, (equipment)=>equipment.energyBomb = true);
                        break;
                    case 9:
                        $cbfbab2b5d08c10d$var$buyItem(game.player, item.price, (equipment)=>equipment.energyUnit = true);
                        break;
                    case 10:
                        $cbfbab2b5d08c10d$var$buyItem(game.player, item.price, (equipment)=>equipment.dockingComputer = true);
                        break;
                    case 11:
                        $cbfbab2b5d08c10d$var$buyItem(game.player, item.price, (equipment)=>equipment.galacticHyperdrive = true);
                        break;
                    case 2:
                        $cbfbab2b5d08c10d$var$buyItem(game.player, item.price, (equipment)=>equipment.largeCargoBay = true);
                        break;
                }
            }
        }
        draw2d.text.draw("EQUIP SHIP", [
            14,
            0.5
        ]);
        draw2d.rect([
            0,
            40
        ], [
            draw2d.size().width,
            (0, $9ecda7333d28e490$export$85309a65275dadab)
        ], (0, $9ecda7333d28e490$export$c4cb53d5b465982a));
        items.map((item, index)=>({
                item: item,
                index: index
            })).forEach(({ item: item, index: index })=>{
            const color = canBuyItem(index) ? (0, $e38eb280d3b76273$exports).fromValues(1.0, 1.0, 1.0, 1.0) : (0, $e38eb280d3b76273$exports).fromValues(0.6, 0.6, 0.6, 1.0);
            draw2d.text.draw(item.name, [
                1,
                top + index
            ], true, color);
            const itemPrice = (index === 0 ? fuelPrice : item.price).toLocaleString(undefined, {
                maximumFractionDigits: 1,
                minimumFractionDigits: 1
            });
            draw2d.text.draw(itemPrice, [
                37 - itemPrice.length,
                top + index
            ], true, color);
        });
        draw2d.text.draw(`Cash: ${game.player.cash.toLocaleString(undefined, {
            maximumFractionDigits: 1,
            minimumFractionDigits: 1
        })} Cr`, [
            1,
            21
        ]);
    };
}




function $b58dc11078c241fd$export$432d5306247eeba1(draw2d) {
    const xScale = draw2d.size().width / (0, $9ecda7333d28e490$export$434491b6b43e3f77).width;
    const yScale = draw2d.size().width / (0, $9ecda7333d28e490$export$434491b6b43e3f77).width;
    const top = 40 + yScale;
    return function renderGalaxyChart(game) {
        const currentCenter = (0, $4ce98914b6676340$exports).fromValues(game.currentSystem.galacticPosition[0] * xScale, game.currentSystem.galacticPosition[1] * yScale + top);
        const currentCursor = (0, $4ce98914b6676340$exports).add((0, $4ce98914b6676340$exports).create(), (0, $4ce98914b6676340$exports).multiply((0, $4ce98914b6676340$exports).create(), game.player.scannerCursor, [
            xScale,
            yScale
        ]), [
            0,
            top
        ]);
        draw2d.circle(currentCenter, game.player.fuel / 10.0 * xScale, [
            1.0,
            0.0,
            0.0,
            1.0
        ]);
        draw2d.circle(currentCenter, game.player.fuel / 10.0 * xScale - 2, [
            0.0,
            0.0,
            0.0,
            1.0
        ]);
        game.stars.forEach((star)=>{
            const center = (0, $4ce98914b6676340$exports).fromValues(star.galacticPosition[0] * xScale, star.galacticPosition[1] * yScale + top);
            draw2d.circle(center, 2, (0, $9ecda7333d28e490$export$c4cb53d5b465982a));
        });
        draw2d.text.draw(`GALACTIC CHART  ${game.player.galaxyIndex + 1}`, [
            10,
            0.5
        ]);
        draw2d.rect([
            0,
            40
        ], [
            draw2d.size().width,
            (0, $9ecda7333d28e490$export$85309a65275dadab)
        ], (0, $9ecda7333d28e490$export$c4cb53d5b465982a));
        draw2d.rect([
            0,
            top + (0, $9ecda7333d28e490$export$434491b6b43e3f77).height * yScale
        ], [
            draw2d.size().width,
            (0, $9ecda7333d28e490$export$85309a65275dadab)
        ], (0, $9ecda7333d28e490$export$c4cb53d5b465982a));
        draw2d.rect([
            currentCursor[0] - 1.5,
            currentCursor[1] - 10
        ], [
            3,
            -10
        ], [
            1.0,
            1.0,
            1.0,
            1.0
        ]);
        draw2d.rect([
            currentCursor[0] - 1.5,
            currentCursor[1] + 10
        ], [
            3,
            10
        ], [
            1.0,
            1.0,
            1.0,
            1.0
        ]);
        draw2d.rect([
            currentCursor[0] - 10,
            currentCursor[1] - 1.5
        ], [
            -10,
            3
        ], [
            1.0,
            1.0,
            1.0,
            1.0
        ]);
        draw2d.rect([
            currentCursor[0] + 10,
            currentCursor[1] - 1.5
        ], [
            10,
            3
        ], [
            1.0,
            1.0,
            1.0,
            1.0
        ]);
    };
}




function $dc26274eaf943b50$var$legalStatusText(value) {
    value, (0, $eb309e06665aa479$export$5ec4fea3c362418a).Clean;
    return "Clean";
}
function $dc26274eaf943b50$var$ratingText(value) {
    switch(value){
        case (0, $eb309e06665aa479$export$75e1dec82dcaa940).MostlyHarmless:
            return "Mostly Harmless";
        case (0, $eb309e06665aa479$export$75e1dec82dcaa940).Poor:
            return "Poor";
        case (0, $eb309e06665aa479$export$75e1dec82dcaa940).Average:
            return "Average";
        case (0, $eb309e06665aa479$export$75e1dec82dcaa940).AboveAverage:
            return "Above Average";
        case (0, $eb309e06665aa479$export$75e1dec82dcaa940).Competent:
            return "Competent";
        case (0, $eb309e06665aa479$export$75e1dec82dcaa940).Dangerous:
            return "Dangerous";
        case (0, $eb309e06665aa479$export$75e1dec82dcaa940).Deadly:
            return "Deadly";
        case (0, $eb309e06665aa479$export$75e1dec82dcaa940).Elite:
            return "Elite";
        case (0, $eb309e06665aa479$export$75e1dec82dcaa940).Harmless:
        default:
            return "Harmless";
    }
}
function $dc26274eaf943b50$var$laserTypeText(value) {
    switch(value){
        case (0, $eb309e06665aa479$export$8a510af63dd342b2).Pulse:
            return "Pulse Laser";
        case (0, $eb309e06665aa479$export$8a510af63dd342b2).Mining:
            return "Mining Laser";
        case (0, $eb309e06665aa479$export$8a510af63dd342b2).Beam:
            return "Beam Laser";
        case (0, $eb309e06665aa479$export$8a510af63dd342b2).Military:
            return "Military Laser";
        case (0, $eb309e06665aa479$export$8a510af63dd342b2).None:
        default:
            return "None";
    }
}
function $dc26274eaf943b50$export$cd11eb0d0ab14395(draw2d) {
    return function renderInventory(game) {
        const player = game.player;
        draw2d.text.draw("INVENTORY", [
            15,
            0.5
        ]);
        draw2d.rect([
            0,
            40
        ], [
            draw2d.size().width,
            (0, $9ecda7333d28e490$export$85309a65275dadab)
        ], (0, $9ecda7333d28e490$export$c4cb53d5b465982a));
        draw2d.text.draw(`Fuel:${(player.fuel / 10).toLocaleString(undefined, {
            maximumFractionDigits: 1,
            minimumFractionDigits: 1
        })} Light Years`, [
            1,
            3
        ]);
        draw2d.text.draw(`Cash:     ${player.cash.toLocaleString(undefined, {
            maximumFractionDigits: 1,
            minimumFractionDigits: 1
        })} Cr`, [
            1,
            4
        ]);
        let y = 6;
        game.marketItems.map((item, index)=>({
                item: item,
                index: index
            })).forEach(({ item: item, index: index })=>{
            if (game.player.cargoHoldContents[index] > 0) {
                const quantity = game.player.cargoHoldContents[index];
                draw2d.text.draw(item.name, [
                    1,
                    y
                ]);
                draw2d.text.draw(`${quantity}${item.unit}`, [
                    quantity >= 10 ? 15 : 16,
                    y
                ]);
                y++;
            }
        });
    /*
    let equipmentLine = 12

    const title = `COMMANDER ${player.name}`
    draw2d.text.draw(title, [19 - title.length / 2, 0.5])
    draw2d.rect([0, 40], [draw2d.size().width, frameWidth], frameColor)

    draw2d.text.draw(`Present System          :${game.currentSystem.name}`, [1, 3])
    draw2d.text.draw(`Hyperspace System       :${player.selectedSystem.name}`, [1, 4])
    draw2d.text.draw(`Condition               :${player.isDocked ? "Docked" : "Space"}`, [1, 5])

    draw2d.text.draw(
      `Cash:    ${player.cash.toLocaleString(undefined, { maximumFractionDigits: 1, minimumFractionDigits: 1 })} Cr`,
      [1, 7],
    )
    draw2d.text.draw(`Legal Status: ${legalStatusText(player.legalStatus)}`, [1, 8])
    draw2d.text.draw(`Rating: ${ratingText(player.combatRating)}`, [1, 9])
    draw2d.text.draw(`EQUIPMENT:`, [1, 11])
    if (equipment.frontLaser != LaserTypeEnum.None) {
      draw2d.text.draw(`Front ${laserTypeText(equipment.frontLaser)}`, [6, equipmentLine++])
    }
    if (equipment.aftLaser != LaserTypeEnum.None) {
      draw2d.text.draw(`Aft ${laserTypeText(equipment.aftLaser)}`, [6, equipmentLine++])
    }
    if (equipment.portLaser != LaserTypeEnum.None) {
      draw2d.text.draw(`Port ${laserTypeText(equipment.portLaser)}`, [6, equipmentLine++])
    }
    if (equipment.starboardLaser != LaserTypeEnum.None) {
      draw2d.text.draw(`Front ${laserTypeText(equipment.starboardLaser)}`, [6, equipmentLine++])
    }
    if (equipment.fuelScoops) {
      draw2d.text.draw(`Fuel Scoops`, [6, equipmentLine++])
    }
    if (equipment.largeCargoBay) {
      draw2d.text.draw(`Large Cargo Bay`, [6, equipmentLine++])
    }
    if (equipment.dockingComputer) {
      draw2d.text.draw(`Docking Computer`, [6, equipmentLine++])
    }
    if (equipment.ecmSystem) {
      draw2d.text.draw(`E.C.M. System`, [6, equipmentLine++])
    }
    if (equipment.galacticHyperdrive) {
      draw2d.text.draw(`Galactic Hyperdrive`, [6, equipmentLine++])
    }*/ };
}





function $dc618e9d4c457f4b$export$3e36fa149a71d9a(draw2d, game) {
    if (game.currentScene !== (0, $bd101182371a0deb$export$64585a4aa6616f30).Front && game.currentScene !== (0, $bd101182371a0deb$export$64585a4aa6616f30).Rear) return;
    if (game.currentScene === (0, $bd101182371a0deb$export$64585a4aa6616f30).Front && game.player.equipment.frontLaser === (0, $eb309e06665aa479$export$8a510af63dd342b2).None) return;
    if (game.currentScene === (0, $bd101182371a0deb$export$64585a4aa6616f30).Rear && game.player.equipment.aftLaser === (0, $eb309e06665aa479$export$8a510af63dd342b2).None) return;
    const centerX = (0, $9ecda7333d28e490$export$62ad7b0c781000e9).width / 2;
    const centerY = (0, $9ecda7333d28e490$export$62ad7b0c781000e9).mainViewHeight / 2;
    draw2d.rect([
        centerX,
        centerY - (0, $9ecda7333d28e490$export$62ad7b0c781000e9).crosshairSpace - (0, $9ecda7333d28e490$export$62ad7b0c781000e9).crosshairLength
    ], [
        (0, $9ecda7333d28e490$export$85309a65275dadab),
        (0, $9ecda7333d28e490$export$62ad7b0c781000e9).crosshairLength
    ], (0, $9ecda7333d28e490$export$c4cb53d5b465982a));
    draw2d.rect([
        centerX,
        centerY + (0, $9ecda7333d28e490$export$62ad7b0c781000e9).crosshairSpace
    ], [
        (0, $9ecda7333d28e490$export$85309a65275dadab),
        (0, $9ecda7333d28e490$export$62ad7b0c781000e9).crosshairLength
    ], (0, $9ecda7333d28e490$export$c4cb53d5b465982a));
    draw2d.rect([
        centerX - (0, $9ecda7333d28e490$export$62ad7b0c781000e9).crosshairSpace - (0, $9ecda7333d28e490$export$62ad7b0c781000e9).crosshairLength,
        centerY
    ], [
        (0, $9ecda7333d28e490$export$62ad7b0c781000e9).crosshairLength,
        (0, $9ecda7333d28e490$export$85309a65275dadab)
    ], (0, $9ecda7333d28e490$export$c4cb53d5b465982a));
    draw2d.rect([
        centerX + (0, $9ecda7333d28e490$export$62ad7b0c781000e9).crosshairSpace,
        centerY
    ], [
        (0, $9ecda7333d28e490$export$62ad7b0c781000e9).crosshairLength,
        (0, $9ecda7333d28e490$export$85309a65275dadab)
    ], (0, $9ecda7333d28e490$export$c4cb53d5b465982a));
}





function $d5c198a06f108321$var$initShaderProgram(gl, resources) {
    const shaderProgram = (0, $747b70bb26c9cf6e$export$f7c2b6763dc47773)(gl, resources.shaderSource.uColor);
    if (!shaderProgram) return null;
    return {
        program: shaderProgram,
        attribLocations: {
            vertexPosition: gl.getAttribLocation(shaderProgram, "aVertexPosition")
        },
        uniformLocations: {
            projectionMatrix: gl.getUniformLocation(shaderProgram, "uProjectionMatrix"),
            modelViewMatrix: gl.getUniformLocation(shaderProgram, "uModelViewMatrix"),
            color: gl.getUniformLocation(shaderProgram, "uColor")
        }
    };
}
function $d5c198a06f108321$var$createVertexBuffer(gl, points) {
    const vertexBuffer = gl.createBuffer();
    let vertices = [
        points[0][0],
        points[0][1],
        points[1][0],
        points[1][1],
        points[2][0],
        points[2][1]
    ];
    gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(vertices), gl.STATIC_DRAW);
    return {
        buffer: vertexBuffer,
        vertCount: vertices.length / 2
    };
}
function $d5c198a06f108321$export$42ff6b2700910242(gl, width, height, points, resources) {
    const programInfo = $d5c198a06f108321$var$initShaderProgram(gl, resources);
    const vertices = $d5c198a06f108321$var$createVertexBuffer(gl, points);
    const projectionMatrix = (0, $26675c4f95835ef1$exports).create();
    (0, $26675c4f95835ef1$exports).ortho(projectionMatrix, 0, width, height, 0, -1, 1.0);
    const render = function(position, color) {
        const modelViewMatrix = (0, $26675c4f95835ef1$exports).fromTranslation((0, $26675c4f95835ef1$exports).create(), [
            position[0],
            position[1],
            0.0
        ]);
        gl.useProgram(programInfo.program);
        (0, $b125b9470601071f$export$f1fc9c1971337e7c)(gl, {
            position: vertices.buffer
        }, programInfo);
        (0, $b125b9470601071f$export$9ed6815acb35f982)(gl, programInfo, {
            projectionMatrix: projectionMatrix,
            modelViewMatrix: modelViewMatrix,
            color: color
        });
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, vertices.vertCount);
    };
    const dispose = ()=>gl.deleteBuffer(vertices.buffer);
    return {
        render: render,
        dispose: dispose
    };
}




function $ff70f9ad4c1f9f0b$export$8b45d388560ce005(gl, resources) {
    let { render: leftLaser } = (0, $d5c198a06f108321$export$42ff6b2700910242)(gl, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).width, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).mainViewHeight, [
        (0, $4ce98914b6676340$exports).fromValues(50, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).mainViewHeight),
        (0, $4ce98914b6676340$exports).fromValues((0, $9ecda7333d28e490$export$62ad7b0c781000e9).width / 2, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).mainViewHeight / 2),
        (0, $4ce98914b6676340$exports).fromValues(100, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).mainViewHeight)
    ], resources);
    let { render: rightLaser } = (0, $d5c198a06f108321$export$42ff6b2700910242)(gl, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).width, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).mainViewHeight, [
        (0, $4ce98914b6676340$exports).fromValues((0, $9ecda7333d28e490$export$62ad7b0c781000e9).width - 50, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).mainViewHeight + (0, $9ecda7333d28e490$export$62ad7b0c781000e9).crosshairSpace * 2),
        (0, $4ce98914b6676340$exports).fromValues((0, $9ecda7333d28e490$export$62ad7b0c781000e9).width / 2, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).mainViewHeight / 2),
        (0, $4ce98914b6676340$exports).fromValues((0, $9ecda7333d28e490$export$62ad7b0c781000e9).width - 100, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).mainViewHeight + (0, $9ecda7333d28e490$export$62ad7b0c781000e9).crosshairSpace * 2)
    ], resources);
    return function renderLasers(game) {
        if (game.player.isLaserActive) {
            leftLaser(game.player.laserOffset, [
                1.0,
                0.0,
                0.0,
                1.0
            ]);
            rightLaser(game.player.laserOffset, [
                1.0,
                0.0,
                0.0,
                1.0
            ]);
        }
    };
}






function $8e187f13c9bf8ecf$var$initShaderProgram(gl, resources) {
    const shaderProgram = (0, $747b70bb26c9cf6e$export$f7c2b6763dc47773)(gl, resources.shaderSource.ship);
    if (!shaderProgram) return null;
    return {
        program: shaderProgram,
        attribLocations: {
            vertexPosition: gl.getAttribLocation(shaderProgram, "aVertexPosition"),
            vertexNormal: gl.getAttribLocation(shaderProgram, "aVertexNormal"),
            vertexColor: gl.getAttribLocation(shaderProgram, "aVertexColor")
        },
        uniformLocations: {
            projectionMatrix: gl.getUniformLocation(shaderProgram, "uProjectionMatrix"),
            modelViewMatrix: gl.getUniformLocation(shaderProgram, "uModelViewMatrix"),
            normalMatrix: gl.getUniformLocation(shaderProgram, "uNormalMatrix"),
            lightWorldPosition: gl.getUniformLocation(shaderProgram, "uLightWorldPosition"),
            shininess: gl.getUniformLocation(shaderProgram, "uShininess")
        }
    };
}
function $8e187f13c9bf8ecf$export$ebfad39d147ebc11(gl, resources, usePreGameScaleFactor = false) {
    const programInfo = $8e187f13c9bf8ecf$var$initShaderProgram(gl, resources);
    const npcLaser = (0, $c08eeab96043bbb3$export$c2db3946751a085d)(gl, resources);
    return function(projectionMatrix, localBubble) {
        // Create a perspective matrix, a special matrix that is
        // used to simulate the distortion of perspective in a camera.
        // Our field of view is 45 degrees, with a width/height
        // ratio that matches the display size of the canvas
        // and we only want to see objects between 0.1 units
        // and 100 units away from the camera.
        gl.useProgram(programInfo.program);
        // Set the shader uniforms
        gl.uniform3fv(programInfo.uniformLocations.lightWorldPosition, localBubble.sun.position);
        //gl.uniform3fv(programInfo.uniformLocations.lightWorldPosition, [0,0,0]) // this puts the light at the player
        (0, $b125b9470601071f$export$9ed6815acb35f982)(gl, programInfo, {
            projectionMatrix: projectionMatrix,
            lightWorldPosition: localBubble.sun.position
        });
        localBubble.explosions.forEach((explosion)=>{
            explosion.positions.forEach((part, index)=>{
                const offsetNoseOrientation = (0, $ab7f6dc0910e1ef7$exports).add((0, $ab7f6dc0910e1ef7$exports).create(), part.noseOrientationDelta, part.noseOrientation);
                const offsetRoofOrientation = (0, $ab7f6dc0910e1ef7$exports).add((0, $ab7f6dc0910e1ef7$exports).create(), part.roofOrientationDelta, part.roofOrientation);
                const renderingModel = explosion.parts[index];
                const targetToMatrix = (0, $26675c4f95835ef1$exports).targetTo((0, $26675c4f95835ef1$exports).create(), [
                    0,
                    0,
                    0
                ], offsetNoseOrientation, offsetRoofOrientation);
                const targetToQuat = (0, $26675c4f95835ef1$exports).getRotation((0, $e92e4eb8d35aaf31$exports).create(), targetToMatrix);
                const viewPosition = part.position;
                const modelViewMatrix = (0, $26675c4f95835ef1$exports).fromRotationTranslation((0, $26675c4f95835ef1$exports).create(), targetToQuat, viewPosition);
                const normalMatrix = (0, $26675c4f95835ef1$exports).create();
                (0, $26675c4f95835ef1$exports).invert(normalMatrix, modelViewMatrix);
                (0, $26675c4f95835ef1$exports).transpose(normalMatrix, normalMatrix);
                (0, $b125b9470601071f$export$f5a01205d395aca)(gl, renderingModel, programInfo);
                gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, renderingModel.indices);
                (0, $b125b9470601071f$export$9ed6815acb35f982)(gl, programInfo, {
                    modelViewMatrix: modelViewMatrix,
                    normalMatrix: normalMatrix,
                    shininess: part.shininess
                });
                {
                    const vertexCount = renderingModel.vertexCount;
                    const type = gl.UNSIGNED_SHORT;
                    const offset = 0;
                    gl.drawElements(gl.TRIANGLES, vertexCount, type, offset);
                }
            });
        // Firstly we point the ship along the nose orientation
        });
    };
}


function $7e5deaabc493d9b4$export$e2220727691e9940(gl, resources) {
    const viewportWidth = (0, $9ecda7333d28e490$export$62ad7b0c781000e9).width;
    const viewportHeight = (0, $9ecda7333d28e490$export$62ad7b0c781000e9).mainViewHeight;
    const draw2d = (0, $45ed6fb76a623699$export$6bf5cf98c33b0c4b)(gl, false, resources, viewportWidth, viewportHeight);
    const shipRenderer = (0, $f835bf63f0b03176$export$c2263a4c08d27cb1)(gl, resources);
    const explosionRenderer = (0, $8e187f13c9bf8ecf$export$ebfad39d147ebc11)(gl, resources);
    const stardustRenderer = (0, $9db6c6a7dcd1bbc5$export$ef8a4b9482c1c86)(gl, resources);
    const sunRenderer = (0, $7c09c43ad23c5647$export$5cc037c742a2c6d1)(gl, resources);
    const planetRenderer = (0, $0e435564f4ae4a50$export$ac9693e3f1f86602)(gl, resources);
    const localChartRenderer = (0, $58155f1a80e0ee9d$export$5680a79c8fceeba9)(draw2d);
    const longRangeChartRenderer = (0, $b58dc11078c241fd$export$432d5306247eeba1)(draw2d);
    const systemDetailsRenderer = (0, $4fc51d87e1bc469e$export$21954360f21ec943)(draw2d);
    const playerDetailsRenderer = (0, $df8fab82612a90a2$export$cbf5e189bb4d37c0)(draw2d);
    const launchingRenderer = (0, $25d05cbdd075ca6d$export$e0da0a7235f8db1e)(gl, viewportWidth, viewportHeight, resources);
    const hyperspaceRenderer = (0, $b75e5cdca71ffabb$export$4303a3d4b95f2c6)(gl, viewportWidth, viewportHeight, resources);
    const buyMarketItemsRenderer = (0, $fd4c0166ba607453$export$74683782010daf96)(draw2d);
    const buyEquipmentRenderer = (0, $cbfbab2b5d08c10d$export$dbb6ecfd06175094)(draw2d);
    const inventoryRenderer = (0, $dc26274eaf943b50$export$cd11eb0d0ab14395)(draw2d);
    const laserRenderer = (0, $ff70f9ad4c1f9f0b$export$8b45d388560ce005)(gl, resources);
    let flashOn = true;
    let flashOnTime = 0;
    return (game, timeDelta)=>{
        const projectionMatrix = (0, $5c04dc271aaba117$export$3fb2efb4293ebbde)(viewportWidth, viewportHeight, game.localBubble.clipSpaceRadius);
        const cameraMatrix = (0, $26675c4f95835ef1$exports).lookAt((0, $26675c4f95835ef1$exports).create(), game.player.lookAt, [
            0,
            0,
            0
        ], [
            0,
            1,
            0
        ]);
        const viewMatrix = (0, $26675c4f95835ef1$exports).invert((0, $26675c4f95835ef1$exports).create(), cameraMatrix);
        const viewProjectionMatrix = (0, $26675c4f95835ef1$exports).multiply((0, $26675c4f95835ef1$exports).create(), projectionMatrix, viewMatrix);
        flashOnTime += timeDelta;
        if (flashOnTime > 1.5) {
            flashOnTime = 0;
            flashOn = !flashOn;
        }
        switch(game.currentScene){
            case (0, $bd101182371a0deb$export$64585a4aa6616f30).Front:
                gl.enable(gl.DEPTH_TEST);
                shipRenderer(viewProjectionMatrix, game.localBubble);
                explosionRenderer(viewProjectionMatrix, game.localBubble);
                sunRenderer(viewProjectionMatrix, game.localBubble, timeDelta);
                planetRenderer(viewProjectionMatrix, game.localBubble, timeDelta);
                stardustRenderer(game);
                gl.disable(gl.DEPTH_TEST);
                break;
            case (0, $bd101182371a0deb$export$64585a4aa6616f30).LocalMap:
                localChartRenderer(game);
                break;
            case (0, $bd101182371a0deb$export$64585a4aa6616f30).LongRangeMap:
                longRangeChartRenderer(game);
                break;
            case (0, $bd101182371a0deb$export$64585a4aa6616f30).SystemDetails:
                systemDetailsRenderer(game);
                break;
            case (0, $bd101182371a0deb$export$64585a4aa6616f30).PlayerDetails:
                playerDetailsRenderer(game);
                break;
            case (0, $bd101182371a0deb$export$64585a4aa6616f30).Docking:
            case (0, $bd101182371a0deb$export$64585a4aa6616f30).Launching:
                launchingRenderer(game);
                break;
            case (0, $bd101182371a0deb$export$64585a4aa6616f30).Hyperspace:
                hyperspaceRenderer(game);
                break;
            case (0, $bd101182371a0deb$export$64585a4aa6616f30).BuyMarketItems:
                buyMarketItemsRenderer(game, false);
                break;
            case (0, $bd101182371a0deb$export$64585a4aa6616f30).PriceList:
                buyMarketItemsRenderer(game, true);
                break;
            case (0, $bd101182371a0deb$export$64585a4aa6616f30).BuyEquipment:
                buyEquipmentRenderer(game);
                break;
            case (0, $bd101182371a0deb$export$64585a4aa6616f30).Inventory:
                inventoryRenderer(game);
                break;
        }
        gl.disable(gl.DEPTH_TEST);
        (0, $dc618e9d4c457f4b$export$3e36fa149a71d9a)(draw2d, game);
        laserRenderer(game);
        if (game.hyperspace !== null && game.hyperspace.countdown > 0) {
            draw2d.text.draw(game.hyperspace.countdown.toString(), [
                0.5,
                0.5
            ]);
            const hyperspaceText = `HYPERSPACE - ${game.player.selectedSystem.name}`;
            const xPos = 19 - hyperspaceText.length / 2;
            draw2d.text.draw(hyperspaceText, [
                xPos,
                21.5
            ]);
        }
        if (game.player.dockingComputerFlightExecuter !== null && flashOn) draw2d.text.draw("DOCKING COMPUTER ON", [
            9.5,
            21.5
        ]);
        game.diagnostics.map((item, index)=>({
                item: item,
                index: index
            })).forEach(({ item: item, index: index })=>{
            draw2d.text.draw(item, [
                1,
                index + 1
            ]);
        });
    };
}




const $30ca83481a6c4629$var$maxStars = 128;
const $30ca83481a6c4629$var$timeFromBackToFront = 3.0 // at top speed, so we'd divide this by the players max speed * their actual speed
;
const $30ca83481a6c4629$var$distancePerSecond = 1.0 / $30ca83481a6c4629$var$timeFromBackToFront;
const $30ca83481a6c4629$var$distancePerSecondAtBack = $30ca83481a6c4629$var$distancePerSecond / 5.0;
const $30ca83481a6c4629$var$visibilityThreshold = 0.6;
function $30ca83481a6c4629$var$createRandomStar(minDistance = 0.0) {
    return (0, $ab7f6dc0910e1ef7$exports).fromValues(Math.random() - 0.5, Math.random() - 0.5, Math.random() * (1.0 - minDistance) + minDistance);
}
function $30ca83481a6c4629$export$d5cb0c6f4618347b() {
    const stars = [];
    for(let star = 0; star < $30ca83481a6c4629$var$maxStars; star++)stars.push($30ca83481a6c4629$var$createRandomStar(0.0));
    return stars;
}
function $30ca83481a6c4629$export$1e4bb0e0f3e56ff(game, timeDelta) {
    //const speedUnit = localBubble.player.speed > 0.0 ? 1.0/localBubble.player.speed/2.0 : 0.0005
    game.localBubble.stardust = game.localBubble.stardust.map((sd)=>{
        const z = sd[2];
        const playerSpeed = Math.max(game.player.speed / game.player.blueprint.maxSpeed, 0.02) * (game.player.isJumping ? (0, $9ecda7333d28e490$export$1829b8ee747d5960) : 1);
        const speed = ((1 - z) * $30ca83481a6c4629$var$distancePerSecondAtBack * 10 + $30ca83481a6c4629$var$distancePerSecondAtBack) * timeDelta * playerSpeed;
        let newZ = sd[2] - speed;
        if (newZ <= 0.0) newZ = 0.0;
        const xy = (0, $4ce98914b6676340$exports).fromValues(sd[0], sd[1]);
        (0, $4ce98914b6676340$exports).normalize(xy, xy);
        (0, $4ce98914b6676340$exports).scale(xy, xy, speed);
        const newPosition = (0, $ab7f6dc0910e1ef7$exports).fromValues(xy[0] + sd[0], xy[1] + sd[1], newZ);
        if (newPosition[0] >= -$30ca83481a6c4629$var$visibilityThreshold && newPosition[0] <= $30ca83481a6c4629$var$visibilityThreshold && newPosition[1] >= -$30ca83481a6c4629$var$visibilityThreshold && newPosition[1] <= $30ca83481a6c4629$var$visibilityThreshold) {
            (0, $ab7f6dc0910e1ef7$exports).rotateZ(newPosition, newPosition, [
                0,
                0,
                0
            ], game.player.roll * timeDelta);
            // we can't rotate around x as put positions are really 2D with z used for colour
            (0, $ab7f6dc0910e1ef7$exports).add(newPosition, newPosition, [
                0,
                game.player.pitch * timeDelta * 2,
                0
            ]);
            return newPosition;
        }
        //return createRandomStar(0.5)
        return $30ca83481a6c4629$var$createRandomStar();
    });
}



const $6ec5efda3130c6d1$var$littleEndian = true;
class $6ec5efda3130c6d1$export$e8860d2caf3028e4 {
    constructor(from){
        this.dataView = new DataView(new ArrayBuffer(6));
        if (typeof from === "number") {
            // creating for a galaxy
            this.dataView.setUint16(0, 0x5a4a, $6ec5efda3130c6d1$var$littleEndian);
            this.dataView.setUint16(2, 0x0248, $6ec5efda3130c6d1$var$littleEndian);
            this.dataView.setUint16(4, 0xb753, $6ec5efda3130c6d1$var$littleEndian);
        } else {
            const src = from;
            this.dataView.setUint16(0, src.getUint16(0, $6ec5efda3130c6d1$var$littleEndian), $6ec5efda3130c6d1$var$littleEndian);
            this.dataView.setUint16(2, src.getUint16(2, $6ec5efda3130c6d1$var$littleEndian), $6ec5efda3130c6d1$var$littleEndian);
            this.dataView.setUint16(4, src.getUint16(4, $6ec5efda3130c6d1$var$littleEndian), $6ec5efda3130c6d1$var$littleEndian);
        }
    }
    copy() {
        return new $6ec5efda3130c6d1$export$e8860d2caf3028e4(this.dataView);
    }
    // we return if the carry flag was set by the last addition as this is sometimes used in the procedural
    // generation
    twist() {
        // anding with 0xFFFF emulates adding two 16-bit numbers together
        const tmp = this.s0 + this.s1 & 0xffff;
        this.s0 = this.s1;
        this.s1 = this.s2;
        const newS2 = tmp + this.s1;
        this.s2 = newS2 & 0xffff;
        return newS2 > this.s2;
    }
    get s0() {
        return this.dataView.getUint16(0, $6ec5efda3130c6d1$var$littleEndian);
    }
    set s0(value) {
        this.dataView.setUint16(0, value, $6ec5efda3130c6d1$var$littleEndian);
    }
    get s0_lo() {
        return this.dataView.getUint8(0);
    }
    get s0_hi() {
        return this.dataView.getUint8(1);
    }
    get s1() {
        return this.dataView.getUint16(2, $6ec5efda3130c6d1$var$littleEndian);
    }
    set s1(value) {
        this.dataView.setUint16(2, value, $6ec5efda3130c6d1$var$littleEndian);
    }
    get s1_lo() {
        return this.dataView.getUint8(2);
    }
    get s1_hi() {
        return this.dataView.getUint8(3);
    }
    get s2() {
        return this.dataView.getUint16(4, $6ec5efda3130c6d1$var$littleEndian);
    }
    set s2(value) {
        this.dataView.setUint16(4, value, $6ec5efda3130c6d1$var$littleEndian);
    }
    get s2_lo() {
        return this.dataView.getUint8(4);
    }
    get s2_hi() {
        return this.dataView.getUint8(5);
    }
}


const $03414c65b730b853$var$textTokens = [
    "AL",
    "LE",
    "XE",
    "GE",
    "ZA",
    "CE",
    "BI",
    "SO",
    "US",
    "ES",
    "AR",
    "MA",
    "IN",
    "DI",
    "RE",
    "A",
    "ER",
    "AT",
    "EN",
    "BE",
    "RA",
    "LA",
    "VE",
    "TI",
    "ED",
    "OR",
    "QU",
    "AN",
    "TE",
    "IS",
    "RI",
    "ON"
];
function $03414c65b730b853$export$db98e2531f619faf(seeds) {
    const seedCopy = seeds.copy();
    const numberOfPairs = seedCopy.s0_lo.isBitSet(6) ? 4 : 3;
    const pairs = [];
    let isCarrySet = false;
    for(let counter = 0; counter < numberOfPairs; counter++){
        const possiblePairIndex = seedCopy.s2_hi.getBitRange(0, 5);
        if (possiblePairIndex > 0) pairs.push($03414c65b730b853$var$textTokens[possiblePairIndex]);
        isCarrySet = seedCopy.twist();
    }
    return {
        systemName: pairs.join("").capitalize(),
        carryFlag: isCarrySet
    };
}


const $810e8b655d424331$var$size = [
    "Large",
    "Fierce",
    "Small"
];
const $810e8b655d424331$var$adjective = [
    "Green",
    "Red",
    "Yellow",
    "Blue",
    "Black",
    "Harmless"
];
const $810e8b655d424331$var$style = [
    "Slimy",
    "Bug-Eyed",
    "Horned",
    "Bony",
    "Fat",
    "Furry"
];
const $810e8b655d424331$var$type = [
    "Rodents",
    "Frogs",
    "Lizards",
    "Lobsters",
    "Birds",
    "Humanoids",
    "Felines",
    "Insects"
];
function $810e8b655d424331$export$75e5b0ed3d99573c(seed) {
    if (!seed.s2_lo.isBitSet(7)) return "Human Colonials";
    const components = [];
    const sizeIndex = seed.s2_hi.getBitRange(2, 3);
    if (sizeIndex < $810e8b655d424331$var$size.length) components.push($810e8b655d424331$var$size[sizeIndex]);
    const adjectiveIndex = seed.s2_hi.getBitRange(5, 3);
    if (adjectiveIndex < $810e8b655d424331$var$adjective.length) components.push($810e8b655d424331$var$adjective[adjectiveIndex]);
    const styleIndex = (seed.s0_hi ^ seed.s1_hi).getBitRange(0, 3);
    if (styleIndex < $810e8b655d424331$var$style.length) components.push($810e8b655d424331$var$style[styleIndex]);
    const typeIndex = (seed.s2_hi.getBitRange(0, 2) + styleIndex).getBitRange(0, 3);
    components.push($810e8b655d424331$var$type[typeIndex]);
    return components.join(" ");
}




function $63a19d81de8b1ecf$export$9b22a5e057226331(seed, surfaceTextureIndex) {
    const economy = seed.s0_hi.getBitRange(0, 3);
    const flippedEconomy = seed.s0_hi.flipBitRange(0, 3);
    const government = seed.s1_lo.getBitRange(3, 3);
    const techLevel = flippedEconomy + (seed.s1_hi & 3) + Math.ceil(government / 2);
    const population = techLevel * 4 + economy + government + 1;
    const systemNameResult = (0, $03414c65b730b853$export$db98e2531f619faf)(seed);
    return {
        seed: seed.copy(),
        name: systemNameResult.systemName,
        economy: economy,
        government: government,
        // when displayed this has to have 1 added to it (range 0 to 14 is displayed as 0 to 15)
        technologyLevel: techLevel,
        population: population,
        speciesType: (0, $810e8b655d424331$export$75e5b0ed3d99573c)(seed),
        productivity: (flippedEconomy + 3) * (government + 4) * population * 8,
        averageRadius: ((seed.s2_hi & 0xf) + 11) * 256 + seed.s1_hi,
        description: "",
        // the positions are 8-bits but a galaxy looks to be sized 102.4x51.2 so we scale here
        // https://www.bbcelite.com/master/main/workspace/zp.html#qq8
        // galacticPosition: { x: seed.s1_hi, y: seed.s0_hi },
        galacticPosition: (0, $4ce98914b6676340$exports).fromValues(seed.s1_hi * ((0, $9ecda7333d28e490$export$434491b6b43e3f77).width / 256), seed.s0_hi * ((0, $9ecda7333d28e490$export$434491b6b43e3f77).height / 256)),
        planetDistance: seed.s0_hi & 7,
        sunDistance: seed.s1_hi & 7,
        sunXYOffset: seed.s2_hi & 3,
        longRangeDotSize: seed.s2_lo.getBitRange(4, 3) & 5,
        // the short range dot size is based on the bit in s2_lo and the carry flag resulting from the
        // print name operation on the short range scanner - to make this accurate I will need to carefully
        // replicate that routine - or at least figure out what is responsible for the final carry flag
        // on first pass I thought it was the twist, but its not. Need to go back through.
        shortRangeDotSize: (seed.s2_lo & 1) + 2 + (systemNameResult.carryFlag ? 1 : 0),
        surfaceTextureIndex: surfaceTextureIndex
    };
}
function $63a19d81de8b1ecf$export$63d40191cbb22c8e(galaxyNumber, numberOfSurfaceTextures) {
    const seed = new (0, $6ec5efda3130c6d1$export$e8860d2caf3028e4)(galaxyNumber);
    const systems = [];
    // each galaxy contains 256 stars
    for(var counter = 0; counter < 256; counter++){
        systems.push($63a19d81de8b1ecf$export$9b22a5e057226331(seed, Math.floor(counter % numberOfSurfaceTextures)));
        // we twist four times to get to the next system
        seed.twist();
        seed.twist();
        seed.twist();
        seed.twist();
    }
    return systems;
}







function $df800c9583f9a815$export$d66d7ef6ea76940b(shipInstance, player, timeDelta) {
    $df800c9583f9a815$var$applyTactics(shipInstance);
    $df800c9583f9a815$var$moveShipBySpeed(shipInstance, timeDelta);
    $df800c9583f9a815$var$applyAcceleration(shipInstance, timeDelta);
    $df800c9583f9a815$var$rotateLocationInSpaceByPlayerPitchAndRoll(shipInstance, player, timeDelta);
    $df800c9583f9a815$var$moveShipByPlayerSpeed(shipInstance, player, timeDelta);
    $df800c9583f9a815$var$rotateAccordingToPlayerPitchAndRoll(shipInstance, player, timeDelta);
    $df800c9583f9a815$var$rotateShipByPitchAndRoll(shipInstance, timeDelta);
}
function $df800c9583f9a815$export$b32e759bae671b00(explosion, player, timeDelta) {
    explosion.positions.forEach((part, index)=>{
        $df800c9583f9a815$var$moveExplosionBySpeed(explosion, part, explosion.componentRelativeSpeed[index], timeDelta);
        $df800c9583f9a815$var$rotateLocationInSpaceByPlayerPitchAndRoll(part, player, timeDelta);
        $df800c9583f9a815$var$moveShipByPlayerSpeed(part, player, timeDelta);
        $df800c9583f9a815$var$rotateAccordingToPlayerPitchAndRoll(part, player, timeDelta);
        $df800c9583f9a815$var$rotateShipByPitchAndRoll(part, timeDelta);
    });
}
function $df800c9583f9a815$var$applyTactics(shipInstance) {
// update the ships tactics
}
function $df800c9583f9a815$var$moveShipBySpeed(shipInstance, timeDelta) {
    // move the ship by its speed along its orientation vector
    const speed = shipInstance.speed * timeDelta * (0, $9ecda7333d28e490$export$b7fc5ebeb91e65aa);
    const transform = (0, $ab7f6dc0910e1ef7$exports).multiply((0, $ab7f6dc0910e1ef7$exports).create(), shipInstance.fixedDirectionOfMovement ?? shipInstance.noseOrientation, [
        speed,
        speed,
        speed
    ]);
    shipInstance.position = (0, $ab7f6dc0910e1ef7$exports).add((0, $ab7f6dc0910e1ef7$exports).create(), shipInstance.position, transform);
}
function $df800c9583f9a815$var$moveExplosionBySpeed(explosion, shipInstance, localSpeed, timeDelta) {
    // move the ship by its speed along its orientation vector
    const velocity = (0, $ab7f6dc0910e1ef7$exports).add((0, $ab7f6dc0910e1ef7$exports).create(), explosion.overallVelocity, localSpeed);
    const frameVelocity = (0, $ab7f6dc0910e1ef7$exports).multiply((0, $ab7f6dc0910e1ef7$exports).create(), velocity, [
        timeDelta,
        timeDelta,
        timeDelta
    ]);
    /*const transform = vec3.multiply(
    vec3.create(),
    shipInstance.fixedDirectionOfMovement ?? shipInstance.noseOrientation,
    frameVelocity,
  )*/ shipInstance.position = (0, $ab7f6dc0910e1ef7$exports).add((0, $ab7f6dc0910e1ef7$exports).create(), shipInstance.position, frameVelocity);
}
function $df800c9583f9a815$var$applyAcceleration(shipInstance, timeDelta) {
// apply acceleration if required and then zero acceleration as its a one off operation
}
function $df800c9583f9a815$var$rotateLocationInSpaceByPlayerPitchAndRoll(shipInstance, player, timeDelta) {
    (0, $7f388262d447fe43$export$b0c15eba69b661a3)(shipInstance, player.roll * timeDelta, player.pitch * timeDelta);
}
function $df800c9583f9a815$var$moveShipByPlayerSpeed(shipInstance, player, timeDelta) {
    // I want to specify the velocities in the units given in the Elite manual but want the in game velocity to be
    // accurate to the original - this fudge factor lands us in about the right ballpark
    const velocity = (0, $7f388262d447fe43$export$c0dacefa48ee416f)(player, timeDelta);
    (0, $ab7f6dc0910e1ef7$exports).add(shipInstance.position, shipInstance.position, velocity);
}
function $df800c9583f9a815$var$rotateAccordingToPlayerPitchAndRoll(shipInstance, player, timeDelta) {
    const roll = player.roll * timeDelta;
    const pitch = player.pitch * timeDelta;
    (0, $7f388262d447fe43$export$ba956a95b4dd3faa)(shipInstance, roll, pitch);
    shipInstance.boundingBox.forEach((v)=>{
        (0, $ab7f6dc0910e1ef7$exports).rotateZ(v, v, [
            0,
            0,
            0
        ], player.roll * timeDelta);
        (0, $ab7f6dc0910e1ef7$exports).rotateX(v, v, [
            0,
            0,
            0
        ], player.pitch * timeDelta);
    });
    if (shipInstance.fixedDirectionOfMovement !== null) {
        (0, $ab7f6dc0910e1ef7$exports).rotateZ(shipInstance.fixedDirectionOfMovement, shipInstance.fixedDirectionOfMovement, [
            0,
            0,
            0
        ], roll);
        (0, $ab7f6dc0910e1ef7$exports).rotateX(shipInstance.fixedDirectionOfMovement, shipInstance.fixedDirectionOfMovement, [
            0,
            0,
            0
        ], pitch);
        (0, $ab7f6dc0910e1ef7$exports).normalize(shipInstance.fixedDirectionOfMovement, shipInstance.fixedDirectionOfMovement);
    }
}
function $df800c9583f9a815$var$rotateShipByPitchAndRoll(shipInstance, timeDelta) {
    // For roll we need to rotate our roof axis and right axis around our nose orientation
    const rollRotationMatrix = (0, $26675c4f95835ef1$exports).create();
    (0, $26675c4f95835ef1$exports).rotate(rollRotationMatrix, rollRotationMatrix, shipInstance.roll * timeDelta, shipInstance.noseOrientation);
    // For pitch we need to rotate our nose axis and roof axis around the right axis
    const pitchRotationMatrix = (0, $26675c4f95835ef1$exports).create();
    (0, $26675c4f95835ef1$exports).rotate(pitchRotationMatrix, pitchRotationMatrix, shipInstance.pitch * timeDelta, shipInstance.rightOrientation);
    (0, $ab7f6dc0910e1ef7$exports).transformMat4(shipInstance.roofOrientation, shipInstance.roofOrientation, rollRotationMatrix);
    (0, $ab7f6dc0910e1ef7$exports).transformMat4(shipInstance.rightOrientation, shipInstance.rightOrientation, rollRotationMatrix);
    (0, $ab7f6dc0910e1ef7$exports).transformMat4(shipInstance.noseOrientation, shipInstance.noseOrientation, pitchRotationMatrix);
    (0, $ab7f6dc0910e1ef7$exports).transformMat4(shipInstance.roofOrientation, shipInstance.roofOrientation, pitchRotationMatrix);
    (0, $ab7f6dc0910e1ef7$exports).normalize(shipInstance.noseOrientation, shipInstance.noseOrientation);
    (0, $ab7f6dc0910e1ef7$exports).normalize(shipInstance.roofOrientation, shipInstance.roofOrientation);
    (0, $ab7f6dc0910e1ef7$exports).normalize(shipInstance.rightOrientation, shipInstance.rightOrientation);
    // we also need to rotate our bounding box
    shipInstance.boundingBox = shipInstance.boundingBox.map((v)=>{
        const newVector = (0, $ab7f6dc0910e1ef7$exports).transformMat4((0, $ab7f6dc0910e1ef7$exports).create(), v, rollRotationMatrix);
        (0, $ab7f6dc0910e1ef7$exports).transformMat4(newVector, newVector, pitchRotationMatrix);
        return newVector;
    });
}





function $ecbd1cf281df251f$export$34f1ce8181b383e1(game, timeDelta) {
    $ecbd1cf281df251f$var$rotateLocationInSpaceByPlayerPitchAndRoll(game.localBubble.sun, game.player, timeDelta);
    $ecbd1cf281df251f$var$rotateLocationInSpaceByPlayerPitchAndRoll(game.localBubble.planet, game.player, timeDelta);
    $ecbd1cf281df251f$var$moveBodyByPlayerSpeed(game.localBubble.planet, game.player, timeDelta);
    $ecbd1cf281df251f$var$moveBodyByPlayerSpeed(game.localBubble.sun, game.player, timeDelta);
    $ecbd1cf281df251f$var$rotateOrientationVectorsAccordingToPlayerPitchAndRoll(game.localBubble.sun, game.player, timeDelta);
    $ecbd1cf281df251f$var$rotateOrientationVectorsAccordingToPlayerPitchAndRoll(game.localBubble.planet, game.player, timeDelta);
    $ecbd1cf281df251f$var$rotateBodyByPitchAndRoll(game.localBubble.planet, timeDelta);
}
function $ecbd1cf281df251f$var$moveBodyByPlayerSpeed(body, player, timeDelta) {
    const velocity = (0, $7f388262d447fe43$export$c0dacefa48ee416f)(player, timeDelta);
    (0, $ab7f6dc0910e1ef7$exports).add(body.position, body.position, velocity);
}
function $ecbd1cf281df251f$var$rotateLocationInSpaceByPlayerPitchAndRoll(body, player, timeDelta) {
    (0, $ab7f6dc0910e1ef7$exports).rotateZ(body.position, body.position, [
        0,
        0,
        0
    ], player.roll * timeDelta);
    (0, $ab7f6dc0910e1ef7$exports).rotateX(body.position, body.position, [
        0,
        0,
        0
    ], player.pitch * timeDelta);
}
function $ecbd1cf281df251f$var$rotateOrientationVectorsAccordingToPlayerPitchAndRoll(body, player, timeDelta) {
    (0, $7f388262d447fe43$export$ba956a95b4dd3faa)(body, player.roll * timeDelta, player.pitch * timeDelta);
}
function $ecbd1cf281df251f$var$rotateBodyByPitchAndRoll(shipInstance, timeDelta) {
    // For roll we need to rotate our roof axis and right axis around our nose orientation
    const rollRotationMatrix = (0, $26675c4f95835ef1$exports).create();
    (0, $26675c4f95835ef1$exports).rotate(rollRotationMatrix, rollRotationMatrix, shipInstance.roll * timeDelta, shipInstance.noseOrientation);
    // For pitch we need to rotate our nose axis and roof axis around the right axis
    const pitchRotationMatrix = (0, $26675c4f95835ef1$exports).create();
    (0, $26675c4f95835ef1$exports).rotate(pitchRotationMatrix, pitchRotationMatrix, shipInstance.pitch * timeDelta, shipInstance.rightOrientation);
    (0, $ab7f6dc0910e1ef7$exports).transformMat4(shipInstance.roofOrientation, shipInstance.roofOrientation, rollRotationMatrix);
    (0, $ab7f6dc0910e1ef7$exports).transformMat4(shipInstance.rightOrientation, shipInstance.rightOrientation, rollRotationMatrix);
    (0, $ab7f6dc0910e1ef7$exports).transformMat4(shipInstance.noseOrientation, shipInstance.noseOrientation, pitchRotationMatrix);
    (0, $ab7f6dc0910e1ef7$exports).transformMat4(shipInstance.roofOrientation, shipInstance.roofOrientation, pitchRotationMatrix);
    (0, $ab7f6dc0910e1ef7$exports).normalize(shipInstance.noseOrientation, shipInstance.noseOrientation);
    (0, $ab7f6dc0910e1ef7$exports).normalize(shipInstance.roofOrientation, shipInstance.roofOrientation);
    (0, $ab7f6dc0910e1ef7$exports).normalize(shipInstance.rightOrientation, shipInstance.rightOrientation);
}






function $7c4b522d1b3b0f4e$export$dccc6650b89af30b(position, noseOrientation, roofOrientation, sideOrientation, boxSize) {
    // we figure this out by first calcualting the players position relative to the ship (this is the negative
    // of the position of the ship), then we rotate that point by the rotation of the ship.
    // Now we have a position that is in the same co-ordinate system as the un-rotated bounding box of the ship
    // and we can check to see if that overlaps the position
    //
    // TODO: If we do this I'm not sure its worth maintaining the axis aligned bounding boxes in realtime...
    // we should probably just set them to the maximum possible extent when we load the model.
    const rotatedPosition = (0, $7f388262d447fe43$export$ca0109456ce3ba30)((0, $7f388262d447fe43$export$58abe552d7cf95ed)(position), noseOrientation, roofOrientation, sideOrientation);
    //console.log(`RP: [${rotatedPosition[0]},${rotatedPosition[1]},${rotatedPosition[2]}]`)
    //console.log(rotatedPosition)
    return rotatedPosition[0] >= -(boxSize[0] / 2) && rotatedPosition[0] <= boxSize[0] / 2 && rotatedPosition[1] >= -(boxSize[1] / 2) && rotatedPosition[1] <= boxSize[1] / 2 && rotatedPosition[2] >= -(boxSize[2] / 2) && rotatedPosition[2] <= boxSize[2] / 2;
}
function $7c4b522d1b3b0f4e$export$331ba56e639cb554(shipInstance) {
    const boundingBoxSize = shipInstance.blueprint.renderingModel.boundingBoxSize;
    const largestAxis = Math.max(boundingBoxSize[0], boundingBoxSize[1], boundingBoxSize[2]);
    const shipDistance = (0, $ab7f6dc0910e1ef7$exports).length(shipInstance.position);
    // start with a range check, I believe this is all the original game does and in a super efficient way with just a
    // high byte not zero check, which makes sense given the constraints of the hardware
    // we use a range check just to determine if we need to do a more precise check
    // an improvement here would be to calculate the maximum distance of the bounding box rather than this fudged
    // approximation - the largest distance is from the center of the cube to one of the corners
    if (shipDistance <= largestAxis * 2) {
        // then do an axis aligned bounding box check
        const axisAlignedBoundingBoxConstraints = (0, $96fe3a99b59d4e0f$export$86f10caa3f7697c2)(shipInstance.boundingBox);
        // the bounding box is centered on 0,0,0 so rather than check the player against the box we check
        // the ships position against the box - its the same check in reverse if that makes sense!
        const position = shipInstance.position;
        const isInBox = position[0] >= axisAlignedBoundingBoxConstraints.min[0] && position[0] <= axisAlignedBoundingBoxConstraints.max[0] && position[1] >= axisAlignedBoundingBoxConstraints.min[1] && position[1] <= axisAlignedBoundingBoxConstraints.max[1] && position[2] >= axisAlignedBoundingBoxConstraints.min[2] && position[2] <= axisAlignedBoundingBoxConstraints.max[2];
        if (isInBox) return $7c4b522d1b3b0f4e$export$dccc6650b89af30b(shipInstance.position, shipInstance.noseOrientation, shipInstance.roofOrientation, shipInstance.rightOrientation, shipInstance.blueprint.renderingModel.boundingBoxSize);
        return false;
    // there is room for future improvement here - we could do a separating axis type test against the rotated
    // box rather than the axis aligned box or, if we want to be really precise, against the exact shape of the
    // ship (they are all convex so shouldn't be too hardto do)
    // however because the player has no real visible presence in the game world it doesn't need to be 100% accurate
    // it just needs to feel fair
    }
    return false;
}
function $7c4b522d1b3b0f4e$var$isValidDockingApproach(game) {
    if (game.localBubble.station === null) return false;
    const station = game.localBubble.station;
    const dockingPortLocationRelativeToStationCenter = // the docking port is on the surface of the face that the nose orientation intersects (i.e. the nose
    // orientation points in the direction of the docking port) and is located half the depth of the station
    // from its center
    (0, $ab7f6dc0910e1ef7$exports).multiply((0, $ab7f6dc0910e1ef7$exports).create(), station.noseOrientation, [
        0,
        0,
        station.blueprint.renderingModel.boundingBoxSize[2] / 2
    ]);
    const dockingPortLocationRelativeToPlayer = (0, $ab7f6dc0910e1ef7$exports).add((0, $ab7f6dc0910e1ef7$exports).create(), dockingPortLocationRelativeToStationCenter, station.position);
    const dotProduct = (0, $ab7f6dc0910e1ef7$exports).dot([
        1,
        0,
        0
    ], station.roofOrientation);
    return dotProduct > 0.9;
}









function $7e36221daabf296b$export$ca2420a423e4a650(game) {
    game.player.isDocked = true;
    game.player.dockingComputerFlightExecuter = null;
    game.player.speed = 0;
    game.player.roll = 0;
    game.player.pitch = 0;
    // remove all ships but the station from the local bubble
    game.localBubble.ships = game.localBubble.ships.filter((s)=>s.role === (0, $cf8fd949337d3b75$export$a3bb2a5ab3320756).Station);
    game.currentScene = (0, $bd101182371a0deb$export$64585a4aa6616f30).PlayerDetails;
}
function $7e36221daabf296b$export$d0667d599235e64b(game) {
    if (game.localBubble.station === null) return false;
    const station = game.localBubble.station;
    const stationHalfSize = game.localBubble.station.blueprint.renderingModel.boundingBoxSize[2] / 2;
    const gatePosition = (0, $ab7f6dc0910e1ef7$exports).add((0, $ab7f6dc0910e1ef7$exports).create(), game.localBubble.station.position, (0, $ab7f6dc0910e1ef7$exports).multiply((0, $ab7f6dc0910e1ef7$exports).create(), game.localBubble.station.noseOrientation, [
        stationHalfSize,
        stationHalfSize,
        stationHalfSize
    ]));
    const dockingBox = (0, $ab7f6dc0910e1ef7$exports).multiply((0, $ab7f6dc0910e1ef7$exports).create(), // we just need a big number for Z as the check below is a 3d check, that we're here means we're already colliding
    // but theres a danger unless the gate is deep that depending on the collision we might not quite be in the depth at
    // the position of the gate
    [
        20,
        60,
        8
    ], [
        (0, $9ecda7333d28e490$export$9d35955117db7cdd),
        (0, $9ecda7333d28e490$export$9d35955117db7cdd),
        (0, $9ecda7333d28e490$export$9d35955117db7cdd)
    ]);
    console.log(`GP: [${gatePosition[0]},${gatePosition[1]},${gatePosition[2]}]`);
    console.log(`DB: [${dockingBox[0]},${dockingBox[1]},${dockingBox[2]}]`);
    if ((0, $7c4b522d1b3b0f4e$export$dccc6650b89af30b)(gatePosition, station.noseOrientation, station.roofOrientation, station.rightOrientation, dockingBox)) {
        const roughPitchToStation = Math.asin(game.localBubble.station.position[1] / (0, $4ce98914b6676340$exports).length([
            game.localBubble.station.position[2],
            game.localBubble.station.position[1]
        ]));
        const roughPitchToStationDegrees = Math.abs((0, $7f388262d447fe43$export$c41dd2a8460d3196)(roughPitchToStation));
        console.log(`GATE PITCH: ${roughPitchToStationDegrees}`);
        if (roughPitchToStationDegrees <= 20) {
            const stationRollRadians = (0, $7f388262d447fe43$export$a4787b691d7e1d4a)(station);
            const stationRollDegrees = (0, $7f388262d447fe43$export$c41dd2a8460d3196)(stationRollRadians);
            console.log(`GATE ROLL: ${stationRollDegrees}`);
            if (stationRollDegrees >= 90 - (0, $9ecda7333d28e490$export$c2e6e7197b9c2387) && stationRollDegrees <= 90 + (0, $9ecda7333d28e490$export$c2e6e7197b9c2387)) return true;
        }
    }
    return false;
}








const $a60dc5dcdcda56e4$var$logOutput = document.getElementById("game-console");
const $a60dc5dcdcda56e4$var$maxHistory = 200;
function $a60dc5dcdcda56e4$export$bef1f36f5486a6a3(message) {
    const logItem = document.createElement("div");
    logItem.style.padding = "3px";
    logItem.style.color = "rgb(0,255,0)";
    logItem.innerText = message;
    if ($a60dc5dcdcda56e4$var$logOutput.children.length === $a60dc5dcdcda56e4$var$maxHistory) $a60dc5dcdcda56e4$var$logOutput.children[$a60dc5dcdcda56e4$var$maxHistory - 1].remove();
    $a60dc5dcdcda56e4$var$logOutput.insertAdjacentElement("afterbegin", logItem);
}


// this is heavily based on the main loop in the original game amazingly documented here by Mark Moxon:
// https://www.bbcelite.com/master/main/subroutine/main_game_loop_part_2_of_6.html
const $be805f4417810c46$var$spawnSequence = [
    $be805f4417810c46$var$spawnDockingTrader,
    $be805f4417810c46$var$spawnFriendly,
    $be805f4417810c46$var$spawnCop,
    $be805f4417810c46$var$spawnEnemy
];
function $be805f4417810c46$export$aec00cc462888d2c(resources, game, timeDelta) {
    if (game.disableSpawning) return;
    if (game.player.isDocked) return;
    // when we are jumping we spawn more often
    game.timeUntilNextSpawnChance -= timeDelta * (game.player.isJumping ? 2 : 1);
    if (game.timeUntilNextSpawnChance > 0) return;
    (0, $a60dc5dcdcda56e4$export$bef1f36f5486a6a3)("Beginning spawn");
    game.timeUntilNextSpawnChance = (0, $96fe3a99b59d4e0f$export$6262649942ae2f7)();
    $be805f4417810c46$var$spawnSequence.reduce((result, func)=>result ? result : func(resources, game), false);
}
function $be805f4417810c46$var$spawnDockingTrader(resources, game) {
    (0, $a60dc5dcdcda56e4$export$bef1f36f5486a6a3)("Chance to spawn docking trader");
    if (!game.player.isInSafeZone) return false;
    if (Math.random() > 0.25) return false;
    if ($be805f4417810c46$var$countOfJunkInLocalBubble(game) >= 3) return false;
    // we need to spawn a trader and attach the docking computer flight path to it
    //return false
    return true;
}
function $be805f4417810c46$var$spawnFriendly(resources, game) {
    (0, $a60dc5dcdcda56e4$export$bef1f36f5486a6a3)("Chance to spawn friendly");
    if (Math.random() > 0.13) return false;
    if ($be805f4417810c46$var$countOfJunkInLocalBubble(game) >= 3) return false;
    // we place a friendly object roughly in front of the player heading towards the player just outside of the scanner range
    const range = (0, $9ecda7333d28e490$export$10ee23b02de09a46)[0] / 2;
    const position = (0, $ab7f6dc0910e1ef7$exports).fromValues(Math.random() * range - range / 2, Math.random() * range - range / 2, -(0, $9ecda7333d28e490$export$10ee23b02de09a46)[2] * 1.2);
    const noseOrientation = (0, $ab7f6dc0910e1ef7$exports).fromValues(0, 0, 1);
    if (Math.random() > 0.5) $be805f4417810c46$var$spawnInstanceOfTrader(resources, game, position, noseOrientation);
    else if (Math.random() < 0.985) $be805f4417810c46$var$spawnInstanceOfAsteroidOrBoulder(resources, game, position, noseOrientation);
    else $be805f4417810c46$var$spawnInstanceOfCargo(resources, game, position, noseOrientation);
    return true;
}
function $be805f4417810c46$var$spawnCop(resources, game) {
    return false;
}
function $be805f4417810c46$var$spawnEnemy(resources, game) {
    (0, $a60dc5dcdcda56e4$export$bef1f36f5486a6a3)("Chance to spawn enemy");
    if (game.player.isInSafeZone) return false;
    game.extraVesselsSpawningDelay--;
    if (game.extraVesselsSpawningDelay >= 0) return false;
    game.extraVesselsSpawningDelay = 0;
    const randomFactor = Math.round(Math.random() * 255);
    const governmentCompare = randomFactor & 7;
    if (game.currentSystem.government !== (0, $0f7203ab41e6a747$export$b828a23d042058ed).Anarchy) {
        if (randomFactor > 90) return false;
        if (governmentCompare < game.currentSystem.government) return false;
    }
    if (governmentCompare < game.currentSystem.government && game.currentSystem.government !== (0, $0f7203ab41e6a747$export$b828a23d042058ed).Anarchy) return false;
    if (Math.random() > 0.39) {
        // spawn pirates
        const numberOfPirates = Math.round(Math.random() * 4);
        console.log(`Spawning ${numberOfPirates} pirates`);
        game.extraVesselsSpawningDelay += numberOfPirates;
        const centerPosition = $be805f4417810c46$var$randomPositionInFrontOfPlayer();
        const rangeFromCenter = 1000;
        for(let pirateIndex = 0; pirateIndex < numberOfPirates; pirateIndex++){
            const position = (0, $ab7f6dc0910e1ef7$exports).fromValues(centerPosition[0] + Math.random() * rangeFromCenter - rangeFromCenter / 2, centerPosition[1] + Math.random() * rangeFromCenter - rangeFromCenter / 2, centerPosition[2] + Math.random() * rangeFromCenter - rangeFromCenter / 2);
            $be805f4417810c46$var$spawnInstanceOfPirate(resources, game, position, [
                0,
                0,
                1
            ]);
        }
    } else {
        console.log(`Spawning bounty hunter`);
        // spawn bounty hunter or thargoid
        game.extraVesselsSpawningDelay++;
        const position = $be805f4417810c46$var$randomPositionInFrontOfPlayer();
        $be805f4417810c46$var$spawnInstanceOfBountyHunter(resources, game, position, [
            0,
            0,
            1
        ]);
    }
    return true;
}
function $be805f4417810c46$var$alwaysSpawnFriendly(resources, game) {
    const noseOrientation = (0, $ab7f6dc0910e1ef7$exports).fromValues(0, 0, 1);
    $be805f4417810c46$var$spawnInstanceOfTrader(resources, game, $be805f4417810c46$var$randomPositionInFrontOfPlayer(), noseOrientation);
    return true;
}
function $be805f4417810c46$var$countOfJunkInLocalBubble(game) {
    return game.localBubble.ships.filter((s)=>s.role == (0, $cf8fd949337d3b75$export$a3bb2a5ab3320756).Asteroid || (0, $cf8fd949337d3b75$export$a3bb2a5ab3320756).Cargo).length;
}
function $be805f4417810c46$var$randomPositionInFrontOfPlayer() {
    const range = (0, $9ecda7333d28e490$export$10ee23b02de09a46)[0] / 2;
    return (0, $ab7f6dc0910e1ef7$exports).fromValues(Math.random() * range - range / 2, Math.random() * range - range / 2, -(0, $9ecda7333d28e490$export$10ee23b02de09a46)[2] * 1.2);
}
function $be805f4417810c46$var$spawnInstanceOfTrader(resources, game, position, noseOrientation) {
    (0, $a60dc5dcdcda56e4$export$bef1f36f5486a6a3)("Spawning trader");
    const shipIndirectIndex = Math.floor(resources.ships.traderIndexes.length * Math.random());
    const shipIndex = resources.ships.traderIndexes[shipIndirectIndex];
    const ship = resources.ships.getIndexedShip(shipIndex, position, noseOrientation);
    $be805f4417810c46$var$setStartingSpeed(ship);
    ship.roll = Math.random() * (ship.blueprint.maxRollSpeed / 4);
    ship.role = (0, $cf8fd949337d3b75$export$a3bb2a5ab3320756).Trader;
    ship.missiles = Math.random() > 0.5 ? 1 : 0;
    game.localBubble.ships.push(ship);
    return ship;
}
function $be805f4417810c46$var$spawnInstanceOfBountyHunter(resources, game, position, noseOrientation) {
    (0, $a60dc5dcdcda56e4$export$bef1f36f5486a6a3)("Spawning bounty hunter");
    const shipIndirectIndex = Math.floor(resources.ships.bountyHunterIndexes.length * Math.random());
    const shipIndex = resources.ships.bountyHunterIndexes[shipIndirectIndex];
    const ship = resources.ships.getIndexedShip(shipIndex, position, noseOrientation);
    $be805f4417810c46$var$setStartingSpeed(ship);
    ship.roll = Math.random() * (ship.blueprint.maxRollSpeed / 4);
    ship.role = (0, $cf8fd949337d3b75$export$a3bb2a5ab3320756).BountyHunter;
    ship.aggressionLevel = 28;
    ship.hasECM = true;
    ship.aiEnabled = true;
    game.localBubble.ships.push(ship);
    return ship;
}
function $be805f4417810c46$var$spawnInstanceOfPirate(resources, game, position, noseOrientation) {
    (0, $a60dc5dcdcda56e4$export$bef1f36f5486a6a3)("Spawning pirate");
    const shipIndirectIndex = Math.floor(resources.ships.pirateIndexes.length * Math.random());
    const shipIndex = resources.ships.pirateIndexes[shipIndirectIndex];
    const ship = resources.ships.getIndexedShip(shipIndex, position, noseOrientation);
    $be805f4417810c46$var$setStartingSpeed(ship);
    ship.roll = Math.random() * (ship.blueprint.maxRollSpeed / 4);
    ship.role = (0, $cf8fd949337d3b75$export$a3bb2a5ab3320756).Pirate;
    ship.hasECM = Math.random() < 0.22;
    game.localBubble.ships.push(ship);
    return ship;
}
function $be805f4417810c46$var$spawnInstanceOfAsteroidOrBoulder(resources, game, position, noseOrientation) {
    const ship = (Math.random() > 0.5 ? resources.ships.getAsteroid : resources.ships.getBoulder)(position, noseOrientation);
    (0, $a60dc5dcdcda56e4$export$bef1f36f5486a6a3)(`Spawning ${ship.blueprint.name.toLowerCase()}`);
    $be805f4417810c46$var$setStartingSpeed(ship);
    ship.roll = Math.random() * ship.blueprint.maxRollSpeed;
    ship.pitch = Math.random() * ship.blueprint.maxPitchSpeed;
    game.localBubble.ships.push(ship);
}
function $be805f4417810c46$var$spawnInstanceOfCargo(resources, game, position, noseOrientation) {
    (0, $a60dc5dcdcda56e4$export$bef1f36f5486a6a3)("Spawning cargo");
    const ship = resources.ships.getCargo(position, noseOrientation);
    $be805f4417810c46$var$setStartingSpeed(ship);
    ship.roll = Math.random() * ship.blueprint.maxRollSpeed;
    ship.pitch = Math.random() * ship.blueprint.maxPitchSpeed;
    game.localBubble.ships.push(ship);
}
function $be805f4417810c46$var$setStartingSpeed(ship) {
    ship.speed = Math.random() * (ship.blueprint.maxSpeed / 2) + ship.blueprint.maxSpeed / 2;
}



function $5716fef5a1405610$export$d20596e0e06d0f5f(missile, game, resources, timeDelta) {}



function $3a4e741d3d8e4e75$var$spawnLaunchingTransporterOrShuttle(station, game, resources) {
    if (!game.player.isInSafeZone || game.localBubble.station === null) return false;
    if (Math.random() > 0.25) return false;
    const ship = (Math.random() > 0.5 ? resources.ships.getShuttle : resources.ships.getTransporter)(station.position, station.noseOrientation);
    ship.speed = Math.random() * ship.blueprint.maxSpeed / 2 + ship.blueprint.maxSpeed / 2;
    ship.roll = game.localBubble.station.roll;
    ship.role = (0, $cf8fd949337d3b75$export$a3bb2a5ab3320756).Trader;
    ship.missiles = Math.random() > 0.5 ? 1 : 0;
    game.localBubble.ships.push(ship);
}
function $3a4e741d3d8e4e75$export$9f5053a2dcf541a5(station, game, resources) {
    if (station.attitude === (0, $cf8fd949337d3b75$export$6c83a620f27ed611).Hostile) ;
    else if (Math.random() < 0.008) $3a4e741d3d8e4e75$var$spawnLaunchingTransporterOrShuttle(station, game, resources);
}



function $e1468ee491bf9589$var$spawnRockHermit(rockHermit, game, resources) {
    if (Math.random() > 0.22) return;
    const shipIndirectIndex = Math.floor(resources.ships.rockHermitIndexes.length * Math.random());
    const shipIndex = resources.ships.rockHermitIndexes[shipIndirectIndex];
    const ship = resources.ships.getIndexedShip(shipIndex, rockHermit.position, rockHermit.noseOrientation);
    ship.speed = Math.random() * ship.blueprint.maxSpeed / 2 + ship.blueprint.maxSpeed / 2;
    ship.roll = Math.random() * (ship.blueprint.maxRollSpeed / 4);
    ship.role = (0, $cf8fd949337d3b75$export$a3bb2a5ab3320756).Pirate;
    ship.missiles = Math.random() > 0.5 ? 1 : 0;
    ship.hasECM = Math.random() > 0.5;
    ship.aiEnabled = true;
    ship.aggressionLevel = 28;
    game.localBubble.ships.push(ship);
    rockHermit.aiEnabled = false;
    rockHermit.hasECM = false;
}
function $e1468ee491bf9589$export$ca1905661b69a3b6(rockHermit, game, resources) {
    if (Math.random() > 0.22) return;
    $e1468ee491bf9589$var$spawnRockHermit(rockHermit, game, resources);
}




function $2c6188b13a977f22$export$59385cb69aef2982(ship, game) {
    if (game.player.legalStatus === (0, $eb309e06665aa479$export$5ec4fea3c362418a).SeriousOffender || game.player.legalStatus === (0, $eb309e06665aa479$export$5ec4fea3c362418a).Fugitive) {
        ship.attitude = (0, $cf8fd949337d3b75$export$6c83a620f27ed611).Hostile;
        // the ship having bounty hunter tactics applied isn't necessarily a bounty hunter but it becomes one if switched to hostile
        ship.role = (0, $cf8fd949337d3b75$export$a3bb2a5ab3320756).BountyHunter;
    }
}


function $df518e8416363912$export$d0bb7f7204828ad7(trader, game) {
    if (Math.random() > 0.8) // 20% of the time traders activate as bounty hunters
    (0, $2c6188b13a977f22$export$59385cb69aef2982)(trader, game);
}







function $badd9ef59c9ce2ab$export$efe3956dd1ded964(player) {
    // The original game stores various bits of info in a single byte but then also uses the total value of the byte in
    // various comparisons. To keep this code "modern" I've broken the flag out into properties (we're not exactly worrying
    // about performance and memory here!) but the original tactics routines use this value for various comparisons.
    // This function composes the original value from the properties
    return (player.hasECM ? 1 : 0) | (player.aggressionLevel & 31) << 1 | (player.attitude === (0, $cf8fd949337d3b75$export$6c83a620f27ed611).Hostile ? 64 : 0) | (player.aiEnabled ? 128 : 0);
}



// Elite far away check looks at the high byte of Z being greater than 3 so a distance >= 768
// The Elite scanner range in the original game is 13056 (0x3300). 768 is = 768/13056 of that (as in 0.0588)
// so we calculate the distance relative to our scanner range in the same way
const $6292afd546ad4c14$var$isFarAwayRange = 768 / 13056 * (0, $9ecda7333d28e490$export$10ee23b02de09a46)[2];
function $6292afd546ad4c14$var$isFarAway(ship) {
    // The original game just uses Z for its is far away check using the calculation outlined above
    // it then looks for the high byte of x or y being 0 (ignoring bit 0)
    // we're not byte pushing or cpu constrained so we simplify this to just look at the overall
    // length of the vector
    // We also change it so that when heading away from the player the ship will try and move further off than the trigger
    // to initially begin turning away
    //return ship.position[2] > isFarAwayRange
    if (ship.tacticsState.flyingTowards === (0, $cf8fd949337d3b75$export$d0bfecb5b13bed3c).AwayFromPlayer) return (0, $ab7f6dc0910e1ef7$exports).length(ship.position) > (0, $9ecda7333d28e490$export$10ee23b02de09a46)[2] / 4;
    return (0, $ab7f6dc0910e1ef7$exports).length(ship.position) > $6292afd546ad4c14$var$isFarAwayRange;
}
function $6292afd546ad4c14$export$e3a4e7508cb991e(ship, position) {}
function $6292afd546ad4c14$export$dda79b3caaf17338(ship) {
    if (ship.roll === 0 && ship.tacticsState.canApplyTactics) {
        (0, $a60dc5dcdcda56e4$export$bef1f36f5486a6a3)("Rolling by noticeable amount");
        ship.roll = ship.blueprint.maxRollSpeed;
    }
}
function $6292afd546ad4c14$export$b8e13444f86cf35f(ship, game, timeDelta) {
    if (ship.role === (0, $cf8fd949337d3b75$export$a3bb2a5ab3320756).Station) return;
    if (ship.tacticsState.canApplyTactics) {
        if ($6292afd546ad4c14$var$isFarAway(ship)) {
            const aiFlagValue = (0, $badd9ef59c9ce2ab$export$efe3956dd1ded964)(ship);
            const aiRoll = Math.floor(Math.random() * 127) + 128;
            (0, $a60dc5dcdcda56e4$export$bef1f36f5486a6a3)(`AI Flag: ${aiFlagValue}      AI Roll: ${aiRoll}`);
            // this random check basically says the more aggressive the ship
            // the more likely it is to head towards us, the less aggressive the
            // more likely it is to head away
            if (aiRoll > aiFlagValue) $6292afd546ad4c14$var$headShipAwayFromPlayer(ship, game);
            else $6292afd546ad4c14$var$headShipTowardsPlayer(ship, game);
        }
    }
    // If a ship gets too close to the player always head it away irrespective of the tactics timing
    if (!$6292afd546ad4c14$var$isFarAway(ship)) $6292afd546ad4c14$var$headShipAwayFromPlayer(ship, game);
    // This actually does the manouvering
    $6292afd546ad4c14$var$headTowards(ship, game, timeDelta);
}
function $6292afd546ad4c14$var$headShipTowardsPlayer(ship, game) {
    (0, $a60dc5dcdcda56e4$export$bef1f36f5486a6a3)(`${ship.role} heading towards player`);
    ship.tacticsState.flyingTowards = (0, $cf8fd949337d3b75$export$d0bfecb5b13bed3c).Player;
    const minSpeed = ship.blueprint.maxSpeed / 4;
    const orientationDotProduct = (0, $ab7f6dc0910e1ef7$exports).dot(ship.noseOrientation, [
        0,
        0,
        -1
    ]);
    //if (orientationDotProduct > 0 && ship.speed > minSpeed) ship.acceleration = AccelerationModeEnum.Decelerating
    //else ship.acceleration = AccelerationModeEnum.Accelerating
    ship.acceleration = (0, $cf8fd949337d3b75$export$568b6dd3ac70608c).Accelerating;
}
function $6292afd546ad4c14$var$headShipAwayFromPlayer(ship, game) {
    if (ship.role === (0, $cf8fd949337d3b75$export$a3bb2a5ab3320756).Trader) {
        ship.tacticsState.flyingTowards = (0, $cf8fd949337d3b75$export$d0bfecb5b13bed3c).Planet;
        (0, $a60dc5dcdcda56e4$export$bef1f36f5486a6a3)("Trader flying towards planet");
    } else //log(`${ship.role} heading away from player`)
    ship.tacticsState.flyingTowards = (0, $cf8fd949337d3b75$export$d0bfecb5b13bed3c).AwayFromPlayer;
    ship.acceleration = (0, $cf8fd949337d3b75$export$568b6dd3ac70608c).Accelerating;
}
function $6292afd546ad4c14$var$headTowards(ship, game, timeDelta) {
    const direction = ship.tacticsState.flyingTowards === (0, $cf8fd949337d3b75$export$d0bfecb5b13bed3c).Planet ? (0, $ab7f6dc0910e1ef7$exports).subtract((0, $ab7f6dc0910e1ef7$exports).create(), game.localBubble.planet.position, ship.position) : ship.tacticsState.flyingTowards === (0, $cf8fd949337d3b75$export$d0bfecb5b13bed3c).AwayFromPlayer ? ship.position : (0, $ab7f6dc0910e1ef7$exports).multiply((0, $ab7f6dc0910e1ef7$exports).create(), ship.position, [
        -1,
        -1,
        -1
    ]) // towards the player
    ;
    const normalisedDirection = (0, $ab7f6dc0910e1ef7$exports).normalize((0, $ab7f6dc0910e1ef7$exports).create(), direction);
    const orientationDotProduct = (0, $ab7f6dc0910e1ef7$exports).dot((0, $ab7f6dc0910e1ef7$exports).normalize((0, $ab7f6dc0910e1ef7$exports).create(), ship.noseOrientation), normalisedDirection);
    let angle = Math.acos(orientationDotProduct < -1 ? -1 : orientationDotProduct > 1 ? 1 : orientationDotProduct);
    const roofDotProduct = (0, $ab7f6dc0910e1ef7$exports).dot(normalisedDirection, ship.roofOrientation);
    // If we're facing away from the target direction then we always pitch, if we're facing then we only pitch towards our
    // target direction if it is not at a small angle
    if (Math.abs(roofDotProduct) > 0.005 || orientationDotProduct < 0) {
        ship.pitch += ship.blueprint.pitchAcceleration * timeDelta * (roofDotProduct > 0 ? -1 : 1);
        if (ship.pitch > ship.blueprint.maxPitchSpeed) ship.pitch = ship.blueprint.maxPitchSpeed;
        else if (ship.pitch < -ship.blueprint.maxPitchSpeed) ship.pitch = -ship.blueprint.maxPitchSpeed;
        // this prevents the ship from oscillating around the players position when coming head on
        if (ship.pitch > 0 && ship.pitch > angle) ship.pitch = angle;
        else if (ship.pitch < 0 && ship.pitch < angle) ship.pitch = angle;
    } else {
        // otherwise we start stopping our pitch motion
        let delta = ship.blueprint.pitchAcceleration * timeDelta;
        if (ship.pitch < 0) {
            ship.pitch += delta;
            if (ship.pitch > 0) ship.pitch = 0;
        } else if (ship.pitch > 0) {
            ship.pitch -= delta;
            if (ship.pitch < 0) ship.pitch = 0;
        }
    }
    const sideDotProduct = (0, $ab7f6dc0910e1ef7$exports).dot(normalisedDirection, ship.rightOrientation);
    if (Math.abs(sideDotProduct) > 0.001) {
        ship.roll += ship.blueprint.rollAcceleration * timeDelta * (sideDotProduct > 0 ? 1 : -1);
        if (ship.roll > ship.blueprint.maxRollSpeed) ship.roll = ship.blueprint.maxRollSpeed;
        else if (ship.roll < -ship.blueprint.maxRollSpeed) ship.roll = -ship.blueprint.maxRollSpeed;
    } else {
        let delta = ship.blueprint.rollAcceleration * timeDelta;
        if (ship.roll < 0) {
            ship.roll += delta;
            if (ship.roll > 0) ship.roll = 0;
        }
        if (ship.roll > 0) {
            ship.roll -= delta;
            if (ship.roll < 0) ship.roll = 0;
        }
        ship.roll = 0;
    }
    const accelerationValue = ship.acceleration === (0, $cf8fd949337d3b75$export$568b6dd3ac70608c).Accelerating ? 1 : ship.acceleration === (0, $cf8fd949337d3b75$export$568b6dd3ac70608c).Decelerating ? -1 : 0;
    ship.speed += ship.blueprint.speedAcceleration * accelerationValue * timeDelta;
    if (ship.speed > ship.blueprint.maxSpeed) ship.speed = ship.blueprint.maxSpeed;
    else if (ship.speed < 0) ship.speed = 0;
}


function $45d5a94bf2da6b0f$export$8f75b9e0c8d2ddf9(missile, game, resources) {}





function $937b5f6a8eb5e2a0$export$6e761a196b0245(ship, game, resources) {
    if (Math.random() > 0.22) return;
    const model = Math.random() < 0.61 ? (0, $17751991aa2dcc8b$export$7d04abf91eb22fb).Worm : (0, $17751991aa2dcc8b$export$7d04abf91eb22fb).Sidewinder;
    const newShip = resources.ships.getInstanceOfModel(model, ship.position, ship.rightOrientation);
    newShip.hasECM = true;
    newShip.aiEnabled = true;
    newShip.aggressionLevel = 28;
    newShip.attitude = (0, $cf8fd949337d3b75$export$6c83a620f27ed611).Hostile;
    game.localBubble.ships.push(newShip);
}


function $67f70d8a48e55b4f$export$1bb0e76f4ac08391(ship, game, resources) {}
function $67f70d8a48e55b4f$export$7020c6031ad554a5(ship, game, resources) {}
function $67f70d8a48e55b4f$export$9fff364eebe8d91f(ship, game, resources) {}



function $36c359bd978d3258$export$8ea6d7993aec7bf(game, resources, timeDelta) {
    // TODO: In the original game this operated on a couple of ships from the full set each
    // time through the game loop. The percentages are all based on that. When I have the logic
    // time need to rework this outer part a little so that it approximates the original else
    // the world will be rather hectic
    game.localBubble.ships.forEach((ship)=>{
        ship.energy = Math.min(ship.energy + 1, ship.blueprint.maxAiEnergy);
        ship.tacticsState.timeUntilNextStateChange -= timeDelta;
        if (ship.tacticsState.timeUntilNextStateChange < 0) {
            ship.tacticsState.timeUntilNextStateChange = (0, $9ecda7333d28e490$export$8ec305b97fc6225c);
            ship.tacticsState.canApplyTactics = true;
        }
        switch(ship.role){
            // This is tactics part 2 of 7
            // https://www.bbcelite.com/master/main/subroutine/tactics_part_2_of_7.html
            case (0, $cf8fd949337d3b75$export$a3bb2a5ab3320756).Missile:
                (0, $5716fef5a1405610$export$d20596e0e06d0f5f)(ship, game, resources, timeDelta);
                break;
            case (0, $cf8fd949337d3b75$export$a3bb2a5ab3320756).Station:
                (0, $3a4e741d3d8e4e75$export$9f5053a2dcf541a5)(ship, game, resources);
                break;
            case (0, $cf8fd949337d3b75$export$a3bb2a5ab3320756).RockHermit:
                (0, $e1468ee491bf9589$export$ca1905661b69a3b6)(ship, game, resources);
                break;
            // This is tactics part 3 of 7
            // https://www.bbcelite.com/master/main/subroutine/tactics_part_3_of_7.html
            case (0, $cf8fd949337d3b75$export$a3bb2a5ab3320756).Thargon:
                (0, $45d5a94bf2da6b0f$export$8f75b9e0c8d2ddf9)(ship, game, resources);
                break;
            case (0, $cf8fd949337d3b75$export$a3bb2a5ab3320756).Trader:
                (0, $df518e8416363912$export$d0bb7f7204828ad7)(ship, game);
                break;
            case (0, $cf8fd949337d3b75$export$a3bb2a5ab3320756).BountyHunter:
                (0, $2c6188b13a977f22$export$59385cb69aef2982)(ship, game);
                break;
        }
        // TODO: some ships might be docking and we have to handle that here if so
        if (ship.attitude === (0, $cf8fd949337d3b75$export$6c83a620f27ed611).Friendly) (0, $6292afd546ad4c14$export$e3a4e7508cb991e)(ship, game.localBubble.planet.position);
        if (ship.attitude === (0, $cf8fd949337d3b75$export$6c83a620f27ed611).Hostile && ship.role === (0, $cf8fd949337d3b75$export$a3bb2a5ab3320756).Pirate && game.player.isInSafeZone) ship.aggressionLevel = 0;
        // Tactics part 4 of 7
        // https://www.bbcelite.com/master/main/subroutine/tactics_part_4_of_7.html
        if (ship.blueprint.model === (0, $17751991aa2dcc8b$export$7d04abf91eb22fb).Anaconda) (0, $937b5f6a8eb5e2a0$export$6e761a196b0245)(ship, game, resources);
        // Original game uses this percentage but its based on its loop timing system
        // if (Math.random() < 0.0025) {
        if (Math.random() < 0.05) (0, $6292afd546ad4c14$export$dda79b3caaf17338)(ship);
        if (ship.energy > ship.blueprint.maxAiEnergy / 2) // Tactics part 5 of 7
        // https://www.bbcelite.com/master/main/subroutine/tactics_part_5_of_7.html
        (0, $67f70d8a48e55b4f$export$7020c6031ad554a5)(ship, game, resources);
        else if (ship.energy > ship.blueprint.maxAiEnergy / 8) // Tactics part 6 of 7
        // https://www.bbcelite.com/master/main/subroutine/tactics_part_6_of_7.html
        (0, $67f70d8a48e55b4f$export$1bb0e76f4ac08391)(ship, game, resources);
        else if (ship.hasEscapePod) // A bit more from tactics part 4 of 7
        // https://www.bbcelite.com/master/main/subroutine/tactics_part_4_of_7.html
        (0, $67f70d8a48e55b4f$export$9fff364eebe8d91f)(ship, game, resources);
        // Tactics part 7 of 7
        // https://www.bbcelite.com/master/main/subroutine/tactics_part_7_of_7.html
        (0, $6292afd546ad4c14$export$b8e13444f86cf35f)(ship, game, timeDelta);
        ship.tacticsState.canApplyTactics = false;
    });
}






function $4ee50fbf22ce7c2e$export$c4c6d1d027c5e212(game, resources, timeDelta) {
    const laserEnergy = 1;
    const previousActiveState = game.player.isLaserActive;
    // the laser pulse state change is always running - this stops players from tapping the fire key quickly
    // to shoot fire than the interval allows
    game.player.timeToLaserStateChange -= timeDelta;
    // this block of code prevents the player from hammering the fire key for faster firing
    if (!game.player.isLaserFiring) {
        // if we were firing and the players laser was active then we need to make sure we wait a full laser pulse
        // until we can fire again
        if (game.player.previousControlState.firing && game.player.isLaserActive) game.player.timeToLaserStateChange += (0, $eb309e06665aa479$export$57ff7eb9c432360c);
        // if we're not firing then stop the counter at zero - this means that when the player fires again
        // we won't wait for the next pulse but will do so immediately
        if (game.player.timeToLaserStateChange < 0) game.player.timeToLaserStateChange = 0;
        game.player.isLaserActive = false;
        return;
    }
    // handle an actual firing situation
    if (game.player.timeToLaserStateChange < 0) {
        game.player.timeToLaserStateChange = (0, $eb309e06665aa479$export$57ff7eb9c432360c);
        game.player.isLaserActive = !game.player.isLaserActive;
        if (game.player.isLaserActive && game.player.energyBankLevel <= laserEnergy + 1) game.player.isLaserActive = false;
        if (game.player.isLaserActive && !previousActiveState) {
            // we "fire" when the pulse turns on
            game.player.laserTemperature++;
            game.player.energyBankLevel -= laserEnergy;
            if (game.player.laserTemperature === game.player.blueprint.maxLaserTemperature) game.currentScene = (0, $bd101182371a0deb$export$64585a4aa6616f30).PlayerExploding;
            game.player.laserOffset = (0, $4ce98914b6676340$exports).fromValues((0, $9ecda7333d28e490$export$62ad7b0c781000e9).crosshairSpace / 2 * Math.random() - (0, $9ecda7333d28e490$export$62ad7b0c781000e9).crosshairSpace / 4, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).crosshairSpace / 2 * Math.random() - (0, $9ecda7333d28e490$export$62ad7b0c781000e9).crosshairSpace / 4);
            $4ee50fbf22ce7c2e$var$processLaserHits(game, resources);
        }
    }
}
function $4ee50fbf22ce7c2e$var$createLaserCollisionQuad(ship) {
    const xy = (v)=>(0, $4ce98914b6676340$exports).fromValues(v[0], v[1]);
    const translatedBoundingBox = ship.boundingBox.map((v)=>(0, $ab7f6dc0910e1ef7$exports).add((0, $ab7f6dc0910e1ef7$exports).create(), v, ship.position));
    return translatedBoundingBox.reduce(([leftMost, rightMost, topMost, bottomMost], v)=>[
            v[0] < leftMost[0] ? xy(v) : leftMost,
            v[0] > rightMost[0] ? xy(v) : rightMost,
            v[1] > topMost[1] ? xy(v) : topMost,
            v[1] < bottomMost[1] ? xy(v) : bottomMost
        ], [
        (0, $4ce98914b6676340$exports).fromValues(10000, 0),
        (0, $4ce98914b6676340$exports).fromValues(-10000, 0),
        (0, $4ce98914b6676340$exports).fromValues(0, -10000),
        (0, $4ce98914b6676340$exports).fromValues(0, 10000)
    ]);
}
function $4ee50fbf22ce7c2e$var$createTrianglesFromQuad(quad) {
    return [
        [
            quad[0],
            quad[1],
            quad[2]
        ],
        [
            quad[2],
            quad[3],
            quad[0]
        ]
    ];
}
// barycentric approach
function $4ee50fbf22ce7c2e$var$isPointInTriangle(point, [p1, p2, p3]) {
    let a = ((p2[1] - p3[1]) * (point[0] - p3[0]) + (p3[0] - p2[0]) * (point[1] - p3[1])) / ((p2[1] - p3[1]) * (p1[0] - p3[0]) + (p3[0] - p2[0]) * (p1[1] - p3[1]));
    let b = ((p3[1] - p1[1]) * (point[0] - p3[0]) + (p1[0] - p3[0]) * (point[1] - p3[1])) / ((p2[1] - p3[1]) * (p1[0] - p3[0]) + (p3[0] - p2[0]) * (p1[1] - p3[1]));
    let c = 1.0 - a - b;
    return a >= 0 && a <= 1 && b >= 0 && b <= 1 && c >= 0 && c <= 1;
}
function $4ee50fbf22ce7c2e$var$processLaserHits(game, resources) {
    // all we are really interested in for deciding if a player has hit a ship is the intersection of the bounding
    // box of the ship onto a 2d plane. That results in a quad that we can then split into two triangles and use
    // barycentric co-ordinates to determine if the laser has hit the ship
    // this isn't how the original did it - it used some bit tricks basically
    const hit = game.localBubble.ships.reduce((hit, ship)=>{
        if (ship.position[2] > 0) return hit;
        if (hit !== null && hit.position[2] > ship.position[2]) return hit;
        const quad = $4ee50fbf22ce7c2e$var$createLaserCollisionQuad(ship);
        const triangles = $4ee50fbf22ce7c2e$var$createTrianglesFromQuad(quad);
        //const testPoint = game.player.laserOffset
        const testPoint = (0, $4ce98914b6676340$exports).fromValues(0, 0);
        if ($4ee50fbf22ce7c2e$var$isPointInTriangle(testPoint, triangles[0]) || $4ee50fbf22ce7c2e$var$isPointInTriangle(testPoint, triangles[1])) return ship;
        return hit;
    }, null);
    if (hit === null) resources.soundEffects.playerLaserMiss();
    else {
        hit.isDestroyed = true;
        resources.soundEffects.shipExplosion();
    }
}




function $91a919d6f3654a98$export$a19a08edb9e0deb0(game, timeDelta) {
    game.localBubble.ships.forEach((ship)=>{
        if (ship.isDestroyed) {
            const newExplosion = {
                parts: ship.blueprint.explosion,
                positions: ship.blueprint.explosion.map((e)=>{
                    const { noseOrientation: noseOrientation, roofOrientation: roofOrientation, sideOrientation: sideOrientation } = (0, $97e646fb7d266a2f$export$eb65091739aed595)(e.faceNormal);
                    return {
                        position: ship.position,
                        noseOrientation: noseOrientation,
                        roofOrientation: roofOrientation,
                        rightOrientation: sideOrientation,
                        roll: ship.roll + Math.random() - 0.5,
                        pitch: ship.pitch + Math.random() - 0.5,
                        fixedDirectionOfMovement: null,
                        boundingBox: [],
                        // Our faces have their own normals for lighting and the way they are facing, however the vertices of the
                        // faces are expressed based on the orientation of the ships nose. Therefore when we come to display the
                        // explosion we need to adjust our face orientation such that it is expressed in the same alignment as
                        // the ships nose orientation.
                        noseOrientationDelta: (0, $ab7f6dc0910e1ef7$exports).subtract((0, $ab7f6dc0910e1ef7$exports).create(), ship.noseOrientation, noseOrientation),
                        roofOrientationDelta: (0, $ab7f6dc0910e1ef7$exports).subtract((0, $ab7f6dc0910e1ef7$exports).create(), ship.roofOrientation, roofOrientation),
                        shininess: ship.rendering.shininess
                    };
                }),
                timeUntilDissipate: 30.0,
                // the explosion has an overall velocity based on the source objects velocity
                overallVelocity: (0, $ab7f6dc0910e1ef7$exports).fromValues(ship.noseOrientation[0] * ship.speed, ship.noseOrientation[1] * ship.speed, ship.noseOrientation[2] * ship.speed),
                // each component then has a velocity based on its original normal
                componentRelativeSpeed: ship.blueprint.explosion.map((e)=>{
                    //return vec3.fromValues(0, 0, 0)
                    const randomisedNormal = (0, $ab7f6dc0910e1ef7$exports).add((0, $ab7f6dc0910e1ef7$exports).create(), e.faceNormal, [
                        Math.random() * (e.faceNormal[0] > 0 ? 1 : -1),
                        Math.random() / 4 * (e.faceNormal[1] > 0 ? 1 : -1),
                        Math.random() / 4 * (e.faceNormal[2] > 0 ? 1 : -1)
                    ]);
                    return (0, $ab7f6dc0910e1ef7$exports).multiply((0, $ab7f6dc0910e1ef7$exports).create(), randomisedNormal, [
                        5 + Math.random() * 10,
                        5 + Math.random() * 10,
                        5 + Math.random() * 10
                    ]);
                })
            };
            game.localBubble.explosions.push(newExplosion);
        }
    });
    game.localBubble.ships = game.localBubble.ships.filter((s)=>!s.isDestroyed);
}


function $e9924a6cb48a3f06$export$fd32dc42244e67dd(resources, game, timeDelta) {
    game.localBubble.ships.forEach((ship)=>{
        (0, $df800c9583f9a815$export$d66d7ef6ea76940b)(ship, game.player, timeDelta);
    });
    game.localBubble.explosions.forEach((explosion)=>(0, $df800c9583f9a815$export$b32e759bae671b00)(explosion, game.player, timeDelta));
    $e9924a6cb48a3f06$var$updateStationAndSafeZone(game);
    (0, $ecbd1cf281df251f$export$34f1ce8181b383e1)(game, timeDelta);
    (0, $30ca83481a6c4629$export$1e4bb0e0f3e56ff)(game, timeDelta);
    $e9924a6cb48a3f06$var$handleCollisions(game);
    (0, $4ee50fbf22ce7c2e$export$c4c6d1d027c5e212)(game, resources, timeDelta);
    (0, $be805f4417810c46$export$aec00cc462888d2c)(resources, game, timeDelta);
    (0, $36c359bd978d3258$export$8ea6d7993aec7bf)(game, resources, timeDelta);
    // this should be done at the end of the loop
    (0, $91a919d6f3654a98$export$a19a08edb9e0deb0)(game, timeDelta);
// Useful diagnostic when working on manual docking or with the docking computer - shows the station roll and pitch
//stationPitchAndRoll(game)
// Another useful docking diagnostic - shows the nose, roll and pitch angles between the player and the station
//stationAngles(game)
// And another
//stationDistance(game)
}
function $e9924a6cb48a3f06$var$updateStationAndSafeZone(game) {
    if (game.localBubble.station !== null) {
        const distance = (0, $ab7f6dc0910e1ef7$exports).length(game.localBubble.station.position);
        game.player.isInSafeZone = distance < game.localBubble.planet.radius * 2;
    //if (distance > game.localBubble.planet.radius * 2) {
    //    game.localBubble.ships = game.localBubble.ships.filter(s => s.role !== ShipRoleEnum.Station)
    //    game.localBubble.station = null
    //}
    }
}
function $e9924a6cb48a3f06$var$handleCollisions(game) {
    game.localBubble.ships.forEach((ship)=>{
        if ((0, $7c4b522d1b3b0f4e$export$331ba56e639cb554)(ship)) {
            console.log(`COLLISION - ${ship.blueprint.name}`);
            if (ship.role === (0, $cf8fd949337d3b75$export$a3bb2a5ab3320756).Station) {
                if ((0, $7e36221daabf296b$export$d0667d599235e64b)(game)) game.currentScene = (0, $bd101182371a0deb$export$64585a4aa6616f30).Docking;
                else game.currentScene = (0, $bd101182371a0deb$export$64585a4aa6616f30).PlayerExploding;
                return;
            }
        }
    });
}






function $3cf1252b922542ff$export$469d2fddf4d55933(game, resources) {
    game.localBubble.ships = [];
    $3cf1252b922542ff$var$positionPlayerInOrbit(game);
    $3cf1252b922542ff$var$spawnSpaceStation(game, resources);
    $3cf1252b922542ff$var$positionSun(game);
    $3cf1252b922542ff$var$launchPlayer(game.player);
// Add the below in if you want to leave aarker for space station roof orientation
//const cobra = resources.ships.getCobraMk3([1000,1000,1000],[0,0,-1])
//game.localBubble.ships.push(cobra)
}
function $3cf1252b922542ff$var$spawnSpaceStation(game, resources) {
    const station = resources.ships.getCoriolis([
        0,
        0,
        0
    ], [
        0,
        0,
        -1
    ]);
    station.position = [
        0,
        0,
        station.blueprint.renderingModel.boundingBoxSize[1] / 2 + 5
    ];
    station.roll = (0, $7f388262d447fe43$export$f994db713d41a0b0)(game.player);
    game.localBubble.ships.push(station);
    game.localBubble.station = station;
}
function $3cf1252b922542ff$var$positionPlayerInOrbit(game) {
    const planet = game.localBubble.planet;
    const sun = game.localBubble.sun;
    const player = game.player;
    planet.radius = game.currentSystem.averageRadius // set the planets radius to that of the current system
    ;
    // to position the player in orbit what we actually do is move the world bubble so that the player is at
    // a distance of (planet radius * 2) from the planet and facing it
    // to do this we:
    //  1. Move the objects in the world such that the planet is at 0,0,0 along with the player.
    //     In reality we only need to move the sun and the star as we've cleared the ships array at the start of this process
    //  2. Apply a random pitch and roll to the player and move the objects accordingly.
    //     The player doesn't actually move - we just do that rotation as if they did
    //  3. Move the ships in the world such that the planet is at 0,0,-(planetradius*2)
    // Step 1
    const translateDelta = (0, $ab7f6dc0910e1ef7$exports).subtract((0, $ab7f6dc0910e1ef7$exports).create(), [
        0,
        0,
        0
    ], planet.position);
    (0, $7f388262d447fe43$export$d947e5f4f4c48d48)(planet, translateDelta);
    //move(sun,translateDelta)
    // Step 2
    const randomRoll = Math.random() * Math.PI * 2;
    const randomPitch = Math.random() * Math.PI * 2;
    (0, $7f388262d447fe43$export$b0c15eba69b661a3)(sun, randomRoll, randomPitch);
    (0, $7f388262d447fe43$export$ba956a95b4dd3faa)(sun, randomRoll, randomPitch);
    // Step 3 (we also reset the orientation as the planet will now be directly ahead of the player)
    (0, $7f388262d447fe43$export$d947e5f4f4c48d48)(planet, [
        0,
        0,
        -planet.radius * 2
    ]);
    planet.noseOrientation = [
        0,
        0,
        1
    ];
    planet.roofOrientation = [
        0,
        1,
        0
    ];
    planet.rightOrientation = [
        1,
        0,
        0
    ];
    planet.pitch = 0.01;
    planet.roll = 0.02;
    planet.surfaceTextureIndex = game.currentSystem.surfaceTextureIndex;
}
function $3cf1252b922542ff$var$positionSun(game) {
    const sun = game.localBubble.sun;
    const sunDirectionVector = (0, $ab7f6dc0910e1ef7$exports).normalize((0, $ab7f6dc0910e1ef7$exports).create(), [
        Math.random() * 2 - 1,
        Math.random() * 2 - 1,
        Math.random() * 2 - 1
    ]);
    const approximateDistance = (0, $9ecda7333d28e490$export$f4fcb3cca4d405d6) - 1000000;
    const sunPosition = (0, $ab7f6dc0910e1ef7$exports).multiply((0, $ab7f6dc0910e1ef7$exports).create(), sunDirectionVector, [
        approximateDistance,
        approximateDistance,
        approximateDistance
    ]);
    // orient it to the player
    const sunNoseOrientation = (0, $ab7f6dc0910e1ef7$exports).multiply((0, $ab7f6dc0910e1ef7$exports).create(), sunDirectionVector, [
        -1,
        -1,
        -1
    ]);
    const sunRoofOrientation = (0, $ab7f6dc0910e1ef7$exports).rotateX((0, $ab7f6dc0910e1ef7$exports).create(), sunNoseOrientation, [
        0,
        0,
        0
    ], 90 * Math.PI / 180);
    const sunRightOrientation = (0, $ab7f6dc0910e1ef7$exports).rotateY((0, $ab7f6dc0910e1ef7$exports).create(), sunNoseOrientation, [
        0,
        0,
        0
    ], 90 * Math.PI / 180);
    sun.position = sunPosition;
    sun.noseOrientation = sunNoseOrientation;
    sun.roofOrientation = sunRoofOrientation;
    sun.rightOrientation = sunRightOrientation;
}
function $3cf1252b922542ff$var$launchPlayer(player) {
    player.isDocked = false;
    player.speed = player.blueprint.maxSpeed * 0.25;
    player.roll = (0, $7f388262d447fe43$export$f994db713d41a0b0)(player);
}


function $a647a9549876774f$export$d5571bbd07644815(game, resources, onLaunched) {
    let now = 0;
    let outboundMultiplier = 1;
    let inboundOffset = 0;
    const offsets = [
        1 / 32.0,
        0.0625,
        0.125,
        0.25,
        0.5,
        1
    ];
    game.launching = null;
    // A bit rough and ready but an approximation of the launch tunnel from the original
    return function updateLaunching(deltaTime) {
        if (game.launching === null) game.launching = {
            inboundRadii: [],
            outboundRadii: [
                ...offsets
            ].sort((a, b)=>b - a)
        };
        now += deltaTime;
        if (outboundMultiplier < 8) {
            if (now > 0.1) {
                for(let index = 1; index < offsets.length; index++){
                    const delta = (offsets[index] - offsets[index - 1]) / 8.0 * outboundMultiplier;
                    game.launching.outboundRadii.push(offsets[index - 1] + delta);
                }
                now = 0;
                outboundMultiplier++;
                game.launching.outboundRadii = game.launching.outboundRadii.sort((a, b)=>b - a);
            }
        } else if (outboundMultiplier === 8) {
            if (now > 0.1) {
                now = 0;
                if (inboundOffset < offsets.length - 1) {
                    game.launching.inboundRadii.push(offsets[inboundOffset]);
                    inboundOffset++;
                } else {
                    // we've finished launching so update the local bubble and set the scene to the front view
                    (0, $3cf1252b922542ff$export$469d2fddf4d55933)(game, resources);
                    game.currentScene = (0, $bd101182371a0deb$export$64585a4aa6616f30).Front;
                    onLaunched();
                }
            }
        }
    };
}








function $9b6a55bc09f958a0$export$1ba2009df3d0c193(game, context, timeDelta) {
    const tolerance = 0.002;
    let rollAngle = 0;
    let pitchAngle = 0;
    const invertedPosition = (0, $ab7f6dc0910e1ef7$exports).multiply((0, $ab7f6dc0910e1ef7$exports).create(), context, [
        -1,
        -1,
        -1
    ]);
    const normalisedTarget = (0, $ab7f6dc0910e1ef7$exports).normalize((0, $ab7f6dc0910e1ef7$exports).create(), invertedPosition);
    /// TODO: generalise this as we'll need it elsewhere
    // This is quite funny. Everything was working when I was at my desk plugged into 60Hz monitors - game locked to 60fps. But in the afternoon
    // I retired to the sofa where I was just using my laptop which runs at 120Hz - game locked to 120fps. With this
    // framerate we end up with precision issues - we end up with normalised vectors that have a length > 1 by
    // an infinitesimal amount (for example Z will be 1 but X and Y will be 0.0000000000001) but its just enough to
    // create havoc!
    // Made me chuckle because the original game has to clean up number inaccuracies too.
    if (normalisedTarget[2] === 1 || normalisedTarget[2] === -1) {
        normalisedTarget[0] = 0;
        normalisedTarget[1] = 0;
    }
    const facingTowardsDotProduct = (0, $ab7f6dc0910e1ef7$exports).dot([
        0,
        0,
        -1
    ], normalisedTarget);
    const facingTowards = facingTowardsDotProduct < 0;
    const pitchDotProduct = (0, $ab7f6dc0910e1ef7$exports).dot([
        0,
        1,
        0
    ], normalisedTarget);
    const remainingPitchAngle = Math.acos(pitchDotProduct) - Math.PI / 2;
    if (facingTowards && pitchDotProduct === 0) pitchAngle = 0;
    else if (pitchDotProduct < 0) pitchAngle = facingTowards ? Math.max(-Math.abs(remainingPitchAngle / timeDelta), -game.player.blueprint.maxPitchSpeed) : -game.player.blueprint.maxPitchSpeed;
    else pitchAngle = facingTowards ? Math.min(Math.abs(remainingPitchAngle / timeDelta), game.player.blueprint.maxPitchSpeed) : game.player.blueprint.maxPitchSpeed;
    const rollDotProduct = (0, $ab7f6dc0910e1ef7$exports).dot([
        1,
        0,
        0
    ], normalisedTarget);
    const absRollDotProduct = Math.abs(rollDotProduct);
    const rollAngleRemainingRadians = Math.abs(Math.acos(rollDotProduct) - Math.PI / 2);
    const rollDirection = rollDotProduct * pitchAngle >= 0 ? 1 : -1;
    if (absRollDotProduct < tolerance) rollAngle = 0;
    else {
        rollAngle = Math.min(rollAngleRemainingRadians / timeDelta, game.player.blueprint.maxRollSpeed);
        rollAngle *= rollDirection;
    }
    game.player.roll = rollAngle;
    return rollAngle === 0;
}
function $9b6a55bc09f958a0$export$9ef8ede4a3763776(game, position, timeDelta) {
    // TODO: Because this relies on the orientation set at the start of this stage over long distances
    // it is not very accurate. We need to come back and make this refine its trajectory as it goes
    const distance = (0, $ab7f6dc0910e1ef7$exports).length(position);
    if (distance > 2) game.player.speed = distance < 5 ? game.player.blueprint.maxSpeed / 4 : game.player.blueprint.maxSpeed;
    else {
        console.log(`DONE MOVE: ${distance}`);
        game.player.speed = 0;
        game.player.pitch = 0;
        game.player.roll = 0;
    }
    //game.diagnostics.push(`D: ${distance}`)
    return game.player.speed === 0;
}
function $9b6a55bc09f958a0$export$effdf3f6aa6f987b(game, ship) {
    const stationRollRadians = (0, $7f388262d447fe43$export$a4787b691d7e1d4a)(ship);
    const stationRollDegrees = (0, $7f388262d447fe43$export$c41dd2a8460d3196)(stationRollRadians);
    //game.diagnostics.push(`SRD: ${stationRollDegrees}`)
    if (stationRollDegrees >= 90 - (0, $9ecda7333d28e490$export$c2e6e7197b9c2387) / 2 && stationRollDegrees <= 90 + (0, $9ecda7333d28e490$export$c2e6e7197b9c2387) / 2) {
        game.player.roll = -ship.roll;
        return true;
    }
    game.player.roll = ship.roll / 2;
    return false;
}
function $9b6a55bc09f958a0$export$6a76419e658d8345(game, context, timeDelta) {
    const tolerance = 0.00125;
    let pitchAngle = 0;
    const invertedPosition = (0, $ab7f6dc0910e1ef7$exports).multiply((0, $ab7f6dc0910e1ef7$exports).create(), context, [
        -1,
        -1,
        -1
    ]);
    const normalisedTarget = (0, $ab7f6dc0910e1ef7$exports).normalize((0, $ab7f6dc0910e1ef7$exports).create(), invertedPosition);
    /// TODO: generalise this as we'll need it elsewhere
    // This is quite funny. Everything was working when I was at my desk plugged into 60Hz monitors - game locked to 60fps. But in the afternoon
    // I retired to the sofa where I was just using my laptop which runs at 120Hz - game locked to 120fps. With this
    // framerate we end up with precision issues - we end up with normalised vectors that have a length > 1 by
    // an infinitesimal amount (for example Z will be 1 but X and Y will be 0.0000000000001) but its just enough to
    // create havoc!
    // Made me chuckle because the original game has to clean up number inaccuracies too.
    if (normalisedTarget[2] === 1 || normalisedTarget[2] === -1) {
        normalisedTarget[0] = 0;
        normalisedTarget[1] = 0;
    }
    const facingTowardsDotProduct = (0, $ab7f6dc0910e1ef7$exports).dot([
        0,
        0,
        -1
    ], normalisedTarget);
    const facingTowards = facingTowardsDotProduct < 0;
    const pitchDotProduct = (0, $ab7f6dc0910e1ef7$exports).dot([
        0,
        1,
        0
    ], normalisedTarget);
    const remainingPitchAngle = Math.acos(pitchDotProduct) - Math.PI / 2;
    if (facingTowards && Math.abs(pitchDotProduct) < tolerance) pitchAngle = 0;
    else if (pitchDotProduct < 0) pitchAngle = facingTowards ? Math.max(-Math.abs(remainingPitchAngle / timeDelta), -game.player.blueprint.maxPitchSpeed) : -game.player.blueprint.maxPitchSpeed;
    else pitchAngle = facingTowards ? Math.min(Math.abs(remainingPitchAngle / timeDelta), game.player.blueprint.maxPitchSpeed) : game.player.blueprint.maxPitchSpeed;
    game.player.pitch = pitchAngle;
    //game.diagnostics.push(`PDP: ${pitchDotProduct}`)
    return facingTowards && Math.abs(pitchDotProduct) < tolerance;
}
function $9b6a55bc09f958a0$export$f763ca1cc6e4a0d7(game, _, timeDelta) {
    if (game.player.speed > 0) {
        game.player.speed -= game.player.blueprint.speedAcceleration * timeDelta;
        if (game.player.speed <= 0) game.player.speed = 0;
    }
    if (game.player.roll > 0) {
        game.player.roll -= game.player.blueprint.rollAcceleration * timeDelta;
        if (game.player.roll < 0) game.player.roll = 0;
    } else if (game.player.roll < 0) {
        game.player.roll += game.player.blueprint.rollAcceleration * timeDelta;
        if (game.player.roll > 0) game.player.roll = 0;
    }
    if (game.player.pitch > 0) {
        game.player.pitch -= game.player.blueprint.pitchAcceleration * timeDelta;
        if (game.player.pitch < 0) game.player.pitch = 0;
    } else if (game.player.pitch < 0) {
        game.player.pitch += game.player.blueprint.pitchAcceleration * timeDelta;
        if (game.player.pitch > 0) game.player.pitch = 0;
    }
    return game.player.speed === 0 && game.player.pitch === 0 && game.player.roll === 0;
}
function $9b6a55bc09f958a0$export$71dfdd4a9f2bc500(game, _, timeDelta) {
    game.player.speed = 0;
    game.player.roll = 0;
    game.player.pitch = 0;
    return true;
}
function $9b6a55bc09f958a0$export$b76d55803a43ea05(game, _, timeDelta) {
    const oneThirdSpeed = game.player.blueprint.maxSpeed / 3;
    if (game.player.speed < oneThirdSpeed) game.player.speed += game.player.blueprint.speedAcceleration * timeDelta;
    if (game.player.speed >= oneThirdSpeed) {
        game.player.speed = oneThirdSpeed;
        return true;
    }
    return false;
}



function $ae56051b8286153c$var$isFlightPlanPositionProviderStage(func) {
    return func.length === 1;
}
function $ae56051b8286153c$var$isFlightPlanManeuverStage(func) {
    return func.length === 3;
}
function $ae56051b8286153c$var$isFlightPlanActionStage(func) {
    return func.length === 2;
}
function $ae56051b8286153c$export$874b3fedf57432cf(game, stages) {
    const initialPositionVector = (0, $ab7f6dc0910e1ef7$exports).create();
    let currentStageIndex = 0;
    let positionProvider = (_)=>initialPositionVector;
    let previousStageIndex = -1;
    return function(game, timeDelta) {
        if (currentStageIndex >= stages.length) return;
        if (previousStageIndex != currentStageIndex) {
            console.log(stages[currentStageIndex].name);
            previousStageIndex = currentStageIndex;
        }
        const stage = stages[currentStageIndex];
        if ($ae56051b8286153c$var$isFlightPlanPositionProviderStage(stage)) {
            positionProvider = stage;
            currentStageIndex++;
        } else if ($ae56051b8286153c$var$isFlightPlanManeuverStage(stage)) {
            const stageIsComplete = stage(game, positionProvider(game), timeDelta);
            if (stageIsComplete) currentStageIndex++;
        } else if ($ae56051b8286153c$var$isFlightPlanActionStage(stage)) {
            stage(game, positionProvider(game));
            currentStageIndex++;
        }
    };
}


function $7a4daaaa78a51a01$export$b1f4180c25ff3948(game) {
    let station = game.localBubble.station;
    const frontDistance = station.blueprint.renderingModel.boundingBoxSize[2] * 2;
    const gateDistance = station.blueprint.renderingModel.boundingBoxSize[2] / 2;
    // The function signature is important as we use that to determine what to do with the response
    const matchRotationToStation = (game, context, timeDelta)=>(0, $9b6a55bc09f958a0$export$effdf3f6aa6f987b)(game, station);
    const holdUntilDocked = (game, context, timeDelta)=>game.player.isDocked;
    const setToFrontPoint = (_)=>(0, $ab7f6dc0910e1ef7$exports).add((0, $ab7f6dc0910e1ef7$exports).create(), station.position, (0, $ab7f6dc0910e1ef7$exports).multiply((0, $ab7f6dc0910e1ef7$exports).create(), station.noseOrientation, [
            frontDistance,
            frontDistance,
            frontDistance
        ]));
    const setToDockingPort = (_)=>(0, $ab7f6dc0910e1ef7$exports).add((0, $ab7f6dc0910e1ef7$exports).create(), station.position, (0, $ab7f6dc0910e1ef7$exports).multiply((0, $ab7f6dc0910e1ef7$exports).create(), station.noseOrientation, [
            gateDistance,
            gateDistance,
            gateDistance
        ]));
    return (0, $ae56051b8286153c$export$874b3fedf57432cf)(game, [
        (0, $9b6a55bc09f958a0$export$f763ca1cc6e4a0d7),
        setToFrontPoint,
        (0, $9b6a55bc09f958a0$export$1ba2009df3d0c193),
        (0, $9b6a55bc09f958a0$export$6a76419e658d8345),
        (0, $9b6a55bc09f958a0$export$9ef8ede4a3763776),
        (0, $9b6a55bc09f958a0$export$71dfdd4a9f2bc500),
        setToDockingPort,
        (0, $9b6a55bc09f958a0$export$1ba2009df3d0c193),
        (0, $9b6a55bc09f958a0$export$6a76419e658d8345),
        matchRotationToStation,
        (0, $9b6a55bc09f958a0$export$b76d55803a43ea05),
        holdUntilDocked
    ]);
}










var $4201279bb1ce70f6$export$266137087bc184a6;
(function(RenderEffect) {
    RenderEffect[RenderEffect["None"] = 0] = "None";
    RenderEffect[RenderEffect["CRT"] = 1] = "CRT";
    RenderEffect[RenderEffect["AmberCRT"] = 2] = "AmberCRT";
    RenderEffect[RenderEffect["GreenCRT"] = 3] = "GreenCRT";
    RenderEffect[RenderEffect["VCR"] = 4] = "VCR";
})($4201279bb1ce70f6$export$266137087bc184a6 || ($4201279bb1ce70f6$export$266137087bc184a6 = {}));
const $4201279bb1ce70f6$var$globalRenderEffects = [
    0,
    1,
    2,
    3,
    4
];
function $4201279bb1ce70f6$export$b9078b15078e248(currentEffect) {
    const index = $4201279bb1ce70f6$var$globalRenderEffects.indexOf(currentEffect);
    if (index + 1 >= $4201279bb1ce70f6$var$globalRenderEffects.length) return $4201279bb1ce70f6$var$globalRenderEffects[0];
    return $4201279bb1ce70f6$var$globalRenderEffects[index + 1];
}
function $4201279bb1ce70f6$export$e5234cdd7d162a18(currentEffect) {
    const index = $4201279bb1ce70f6$var$globalRenderEffects.indexOf(currentEffect);
    if (index - 1 < 0) return $4201279bb1ce70f6$var$globalRenderEffects[$4201279bb1ce70f6$var$globalRenderEffects.length - 1];
    return $4201279bb1ce70f6$var$globalRenderEffects[index - 1];
}
function $4201279bb1ce70f6$var$initShaderProgram(gl, shaderSource) {
    const shaderProgram = (0, $747b70bb26c9cf6e$export$f7c2b6763dc47773)(gl, shaderSource);
    if (!shaderProgram) return null;
    return {
        program: shaderProgram,
        attribLocations: {
            vertexPosition: gl.getAttribLocation(shaderProgram, "aVertexPosition"),
            textureCoords: gl.getAttribLocation(shaderProgram, "aTextureCoord")
        },
        uniformLocations: {
            projectionMatrix: gl.getUniformLocation(shaderProgram, "uProjectionMatrix"),
            modelViewMatrix: gl.getUniformLocation(shaderProgram, "uModelViewMatrix"),
            textureSampler: gl.getUniformLocation(shaderProgram, "uSampler"),
            texture2Sampler: gl.getUniformLocation(shaderProgram, "uNoise"),
            resolution: gl.getUniformLocation(shaderProgram, "iResolution"),
            time: gl.getUniformLocation(shaderProgram, "iTime")
        }
    };
}
function $4201279bb1ce70f6$var$createRenderer(gl, width, height, source, noise) {
    const programInfo = $4201279bb1ce70f6$var$initShaderProgram(gl, source);
    const square = (0, $35806345bc1d62c5$export$7c40b2ceeb961577)(gl, [
        1.0,
        0.0,
        0.0,
        1.0
    ], null, true);
    const projectionMatrix = (0, $26675c4f95835ef1$exports).create();
    (0, $26675c4f95835ef1$exports).ortho(projectionMatrix, 0, width, height, 0, -1, 1.0);
    const resolution = (0, $4ce98914b6676340$exports).fromValues(width, height);
    return function(position, size, texture, time) {
        // the divide by two is because the model has extents of -1.0 to 1.0
        const modelViewMatrix = (0, $26675c4f95835ef1$exports).fromRotationTranslationScale((0, $26675c4f95835ef1$exports).create(), (0, $e92e4eb8d35aaf31$exports).create(), [
            position[0] + size[0] / 2,
            position[1] + size[1] / 2,
            0.0
        ], [
            size[0] / 2,
            size[1] / 2,
            1.0
        ]);
        gl.useProgram(programInfo.program);
        (0, $b125b9470601071f$export$f5a01205d395aca)(gl, square, programInfo);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, square.indices);
        (0, $b125b9470601071f$export$9ed6815acb35f982)(gl, programInfo, {
            projectionMatrix: projectionMatrix,
            modelViewMatrix: modelViewMatrix,
            textureIndex: 0,
            time: time
        }, texture, noise);
        gl.uniform2fv(programInfo.uniformLocations.resolution, resolution);
        const vertexCount = square.vertexCount;
        const type = gl.UNSIGNED_SHORT;
        const offset = 0;
        gl.drawElements(gl.TRIANGLES, vertexCount, type, offset);
    };
}
function $4201279bb1ce70f6$var$createFrameBuffer(gl, width, height) {
    const frameBufferTexture = (0, $5c04dc271aaba117$export$792a1e95a9bc00fc)(gl, width, height);
    const frameBuffer = gl.createFramebuffer();
    gl.bindFramebuffer(gl.FRAMEBUFFER, frameBuffer);
    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, frameBufferTexture, 0);
    const depthBuffer = gl.createRenderbuffer();
    gl.bindRenderbuffer(gl.RENDERBUFFER, depthBuffer);
    gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_COMPONENT32F, width, height);
    gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT, gl.RENDERBUFFER, depthBuffer);
    return [
        frameBuffer,
        frameBufferTexture
    ];
}
function $4201279bb1ce70f6$export$230dc02396b6bf57(gl, resources, sceneRenderer, dashboardRenderer) {
    // This sets up a frame buffer that will render to a texture and attaches a depth buffer to it
    const [frameBuffer, frameBufferTexture] = $4201279bb1ce70f6$var$createFrameBuffer(gl, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).width, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).totalHeight);
    const [flightSceneFrameBuffer, flightSceneFrameBufferTexture] = $4201279bb1ce70f6$var$createFrameBuffer(gl, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).width, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).mainViewHeight);
    //const flightSceneFrameBufferTexture = createFrameBufferTexture(gl, dimensions.width, dimensions.mainViewHeight)
    //const flightSceneFrameBuffer = gl.createFramebuffer()
    const createGlobalRenderEffect = (src)=>$4201279bb1ce70f6$var$createRenderer(gl, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).width, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).totalHeight, src, resources.textures.noise);
    const createFlightSceneRenderEffect = (src)=>$4201279bb1ce70f6$var$createRenderer(gl, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).width, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).mainViewHeight, src, resources.textures.noise);
    var globalEffects = new Map([
        [
            0,
            createGlobalRenderEffect(resources.shaderSource.simpleTexture)
        ],
        [
            1,
            createGlobalRenderEffect(resources.shaderSource.crt)
        ],
        [
            2,
            createGlobalRenderEffect(resources.shaderSource.amberCrt)
        ],
        [
            3,
            createGlobalRenderEffect(resources.shaderSource.greenCrt)
        ],
        [
            4,
            createGlobalRenderEffect(resources.shaderSource.vcr)
        ]
    ]);
    let time = 0.0;
    const flightSceneMotionBlur = createFlightSceneRenderEffect(resources.shaderSource.motionBlur);
    const flightSceneCopy = createFlightSceneRenderEffect(resources.shaderSource.simpleTexture);
    const draw2d = (0, $45ed6fb76a623699$export$6bf5cf98c33b0c4b)(gl, false, resources, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).width, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).mainViewHeight);
    const applyFlightSceneMotionBlur = (effectTime)=>flightSceneMotionBlur([
            0,
            0
        ], [
            (0, $9ecda7333d28e490$export$62ad7b0c781000e9).width,
            (0, $9ecda7333d28e490$export$62ad7b0c781000e9).mainViewHeight
        ], flightSceneFrameBufferTexture, effectTime);
    const applyFlightSceneCopy = (effectTime)=>flightSceneCopy([
            0,
            0
        ], [
            (0, $9ecda7333d28e490$export$62ad7b0c781000e9).width,
            (0, $9ecda7333d28e490$export$62ad7b0c781000e9).mainViewHeight
        ], flightSceneFrameBufferTexture, effectTime);
    return (game, timeDelta, effect)=>{
        time += timeDelta;
        // First draw our flight scene to a texture so that we can apply post processing effects to it
        (0, $5c04dc271aaba117$export$d1bc072841c808d0)(gl, flightSceneFrameBuffer, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).width, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).mainViewHeight);
        (0, $5c04dc271aaba117$export$441ba46c5fcd50d9)(gl);
        sceneRenderer(game, timeDelta);
        // Now select the frame buffer pointing at a texture that represents our composed scene (flight scene + dashboard)
        // and draw the texture from the flight scene, using the appropriate effect, along with the dashboard (no effect)
        (0, $5c04dc271aaba117$export$d1bc072841c808d0)(gl, frameBuffer, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).width, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).mainViewHeight, 0, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).dashboardHeight);
        (0, $5c04dc271aaba117$export$441ba46c5fcd50d9)(gl);
        if (game.player.isJumping) applyFlightSceneMotionBlur(time);
        else applyFlightSceneCopy(time);
        (0, $5c04dc271aaba117$export$5e145c486af18f03)(draw2d);
        // draw the dashboard
        gl.viewport(0, 0, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).width, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).dashboardHeight);
        dashboardRenderer(game, timeDelta);
        // finally target the output buffer and render our texture applying a whole screen post processing effect if
        // required
        (0, $5c04dc271aaba117$export$d1bc072841c808d0)(gl, null, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).width, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).totalHeight);
        globalEffects.get(effect)([
            0,
            0
        ], [
            (0, $9ecda7333d28e490$export$62ad7b0c781000e9).width,
            (0, $9ecda7333d28e490$export$62ad7b0c781000e9).totalHeight
        ], frameBufferTexture, time);
    };
}


function $e8bc5ab7351ec04f$export$fd37dabcec2bc46f(game, resources, timeDelta) {
    const player = game.player;
    if (!player.isDocked) {
        if (!$e8bc5ab7351ec04f$var$applyDockingComputer(game, resources, timeDelta)) {
            $e8bc5ab7351ec04f$var$applyRoll(player, timeDelta);
            $e8bc5ab7351ec04f$var$applyPitch(player, timeDelta);
            $e8bc5ab7351ec04f$var$applyAcceleration(player, timeDelta);
            $e8bc5ab7351ec04f$var$applyJump(game, resources);
            $e8bc5ab7351ec04f$var$applyHyperspace(game);
        }
        $e8bc5ab7351ec04f$var$applyLasers(game, timeDelta);
    }
    if (game.hyperspace === null) $e8bc5ab7351ec04f$var$applyCursors(player, timeDelta);
    $e8bc5ab7351ec04f$var$applyEffects(game);
}
function $e8bc5ab7351ec04f$var$applyLasers(game, timeDelta) {
    game.player.isLaserFiring = game.player.controlState.firing;
}
function $e8bc5ab7351ec04f$var$applyEffects(game) {
    if (game.player.controlState.nextEffectPressed && !game.player.previousControlState.nextEffectPressed) game.renderEffect = (0, $4201279bb1ce70f6$export$b9078b15078e248)(game.renderEffect);
    else if (game.player.controlState.previousEffectPressed && !game.player.previousControlState.previousEffectPressed) game.renderEffect = (0, $4201279bb1ce70f6$export$e5234cdd7d162a18)(game.renderEffect);
}
function $e8bc5ab7351ec04f$var$applyDockingComputer(game, resources, timeDelta) {
    if (game.player.equipment.dockingComputer && game.player.controlState.dockingOn && !game.player.previousControlState.dockingOn) {
        if (game.player.dockingComputerFlightExecuter === null) game.player.dockingComputerFlightExecuter = (0, $7a4daaaa78a51a01$export$b1f4180c25ff3948)(game);
        else game.player.dockingComputerFlightExecuter = null;
    }
    if (!game.player.dockingComputerFlightExecuter) return false;
    game.player.dockingComputerFlightExecuter(game, timeDelta);
    return true;
}
function $e8bc5ab7351ec04f$var$applyHyperspace(game) {
    if (game.player.controlState.hyperspace) {
        game.player.controlState.hyperspace = false;
        if (game.hyperspace === null) {
            const selectedSystem = (0, $23fac6550b969d62$export$c2f87357ecfce51f)(game);
            game.player.selectedSystem = selectedSystem;
            if (selectedSystem !== game.currentSystem) {
                const distance = (0, $4ce98914b6676340$exports).length((0, $4ce98914b6676340$exports).subtract((0, $4ce98914b6676340$exports).create(), game.player.selectedSystem.galacticPosition, game.currentSystem.galacticPosition));
                if (distance * 10 <= game.player.fuel) game.hyperspace = {
                    rotation: 0,
                    countdown: 15,
                    outboundRadii: [],
                    inboundRadii: []
                };
            }
        }
    }
}
function $e8bc5ab7351ec04f$var$shipsOnEdgeOfScannerRange(ships) {
    for(var shipIndex = 0; shipIndex < ships.length; shipIndex++){
        const ship = ships[shipIndex];
        const normalisedPosition = (0, $ab7f6dc0910e1ef7$exports).divide((0, $ab7f6dc0910e1ef7$exports).create(), ship.position, (0, $9ecda7333d28e490$export$10ee23b02de09a46));
        //const scannerRelativeDistance = vec3.length(normalisedPosition)
        if (Math.abs(normalisedPosition[0]) < 1.2 && Math.abs(normalisedPosition[1]) < 1.2 && Math.abs(normalisedPosition[2]) < 1.2) return true;
    }
    return false;
}
function $e8bc5ab7351ec04f$var$applyJump(game, resources) {
    const shipsForcingAbort = $e8bc5ab7351ec04f$var$shipsOnEdgeOfScannerRange(game.localBubble.ships);
    if (game.player.isJumping && shipsForcingAbort) resources.soundEffects.jumpBlocked();
    game.player.isJumping = game.player.controlState.jump && !shipsForcingAbort;
/*if (game.player.controlState.jump) {
        const distance = vec3.length(game.localBubble.planet.position)
        const translation = vec3.fromValues(0, 0, (distance / 2))
        move(game.localBubble.planet, translation)
        move(game.localBubble.sun, translation)
        game.localBubble.ships.forEach(ship => {
            move(ship, translation)
        })
        game.player.controlState.jump = false
    }*/ }
function $e8bc5ab7351ec04f$var$applyCursors(player, timeDelta) {
    let xDelta = 0;
    let yDelta = 0;
    if (player.controlState.cursorLeft) xDelta -= 10 * timeDelta;
    if (player.controlState.cursorRight) xDelta += 10 * timeDelta;
    if (player.controlState.cursorUp) yDelta -= 10 * timeDelta;
    if (player.controlState.cursorDown) yDelta += 10 * timeDelta;
    (0, $4ce98914b6676340$exports).add(player.scannerCursor, player.scannerCursor, [
        xDelta,
        yDelta
    ]);
}
function $e8bc5ab7351ec04f$var$applyAcceleration(player, timeDelta) {
    if (player.controlState.accelerate) {
        player.speed += player.blueprint.speedAcceleration * timeDelta;
        if (player.speed > player.blueprint.maxSpeed) player.speed = player.blueprint.maxSpeed;
    }
    if (player.controlState.decelerate) {
        player.speed -= player.blueprint.speedAcceleration * timeDelta;
        if (player.speed < 0.0) player.speed = 0.0;
    }
}
function $e8bc5ab7351ec04f$var$applyRoll(player, timeDelta) {
    if (player.controlState.rollRight) {
        if (!player.previousControlState.rollRight && player.roll < 0) player.roll = 0;
        else {
            player.roll += player.blueprint.rollAcceleration * timeDelta;
            if (player.roll > player.blueprint.maxRollSpeed) player.roll = player.blueprint.maxRollSpeed;
        }
    } else if (player.roll > 0 && !player.disableDamping) {
        player.roll -= player.blueprint.rollDeceleration * timeDelta;
        if (player.roll < 0) player.roll = 0;
    }
    if (player.controlState.rollLeft) {
        if (!player.previousControlState.rollLeft && player.roll > 0) player.roll = 0;
        else {
            player.roll -= player.blueprint.rollAcceleration * timeDelta;
            if (player.roll < -player.blueprint.maxRollSpeed) player.roll = -player.blueprint.maxRollSpeed;
        }
    } else if (player.roll < 0 && !player.disableDamping) {
        player.roll += player.blueprint.rollDeceleration * timeDelta;
        if (player.roll > 0) player.roll = 0;
    }
}
function $e8bc5ab7351ec04f$var$applyPitch(player, timeDelta) {
    if (player.controlState.pitchDown) {
        if (!player.previousControlState.pitchDown && player.pitch < 0) player.pitch = 0;
        else {
            player.pitch += player.blueprint.pitchAcceleration * timeDelta;
            if (player.pitch > player.blueprint.maxPitchSpeed) player.pitch = player.blueprint.maxPitchSpeed;
        }
    } else if (player.pitch > 0 && !player.disableDamping) {
        player.pitch -= player.blueprint.pitchDeceleration * timeDelta;
        if (player.pitch < 0) player.pitch = 0;
    }
    if (player.controlState.pitchUp) {
        if (!player.previousControlState.pitchUp && player.pitch > 0) player.pitch = 0;
        else {
            player.pitch -= player.blueprint.pitchAcceleration * timeDelta;
            if (player.pitch < -player.blueprint.maxPitchSpeed) player.pitch = -player.blueprint.maxPitchSpeed;
        }
    } else if (player.pitch < 0 && !player.disableDamping) {
        player.pitch += player.blueprint.pitchDeceleration * timeDelta;
        if (player.pitch > 0) player.pitch = 0;
    }
}






const $df1a71e231df3d97$var$marketItemBaseStats = [
    // The source for this can be found here: https://www.bbcelite.com/master/main/variable/qq23.html
    {
        name: "Food",
        price: 19,
        economicFactor: -2,
        unit: "t",
        quantity: 6,
        mask: 1
    },
    {
        name: "Textiles",
        price: 20,
        economicFactor: -1,
        unit: "t",
        quantity: 10,
        mask: 3
    },
    {
        name: "Radioactives",
        price: 65,
        economicFactor: -3,
        unit: "t",
        quantity: 2,
        mask: 7
    },
    {
        name: "Slaves",
        price: 40,
        economicFactor: -5,
        unit: "t",
        quantity: 226,
        mask: 31
    },
    {
        name: "Liquor/Wines",
        price: 83,
        economicFactor: -5,
        unit: "t",
        quantity: 251,
        mask: 15
    },
    {
        name: "Luxuries",
        price: 196,
        economicFactor: 8,
        unit: "t",
        quantity: 54,
        mask: 3
    },
    {
        name: "Narcotics",
        price: 235,
        economicFactor: 29,
        unit: "t",
        quantity: 8,
        mask: 120
    },
    {
        name: "Computers",
        price: 154,
        economicFactor: 14,
        unit: "t",
        quantity: 56,
        mask: 3
    },
    {
        name: "Machinery",
        price: 117,
        economicFactor: 6,
        unit: "t",
        quantity: 40,
        mask: 7
    },
    {
        name: "Alloys",
        price: 78,
        economicFactor: 1,
        unit: "t",
        quantity: 17,
        mask: 31
    },
    {
        name: "Firearms",
        price: 124,
        economicFactor: 13,
        unit: "t",
        quantity: 29,
        mask: 7
    },
    {
        name: "Furs",
        price: 176,
        economicFactor: -9,
        unit: "t",
        quantity: 220,
        mask: 63
    },
    {
        name: "Minerals",
        price: 32,
        economicFactor: -1,
        unit: "t",
        quantity: 53,
        mask: 3
    },
    {
        name: "Gold",
        price: 97,
        economicFactor: -1,
        unit: "kg",
        quantity: 66,
        mask: 7
    },
    {
        name: "Platinum",
        price: 171,
        economicFactor: -2,
        unit: "kg",
        quantity: 55,
        mask: 31
    },
    {
        name: "Gem-Stones",
        price: 45,
        economicFactor: -1,
        unit: "g",
        quantity: 250,
        mask: 15
    },
    {
        name: "Alien items",
        price: 53,
        economicFactor: 15,
        unit: "t",
        quantity: 0,
        mask: 7
    }
];
function $df1a71e231df3d97$export$7d1098b46d65e487(system) {
    const random = ()=>Math.floor(Math.random() * 256);
    return $df1a71e231df3d97$var$marketItemBaseStats.map((base)=>{
        const unitPrice = (base.price + (random() & base.mask) + system.economy * base.economicFactor) * 4 / 10;
        //const unitPrice = ((((base.price + (random() & base.mask) + system.economy)) * base.economicFactor) * 4)/10
        const quantityForSale = Math.max(0, (base.quantity + (random() & base.mask) - system.economy * base.economicFactor) % 64);
        return {
            name: base.name,
            unit: base.unit,
            unitPrice: unitPrice,
            quantityForSale: quantityForSale
        };
    });
}


function $cb9a6519a824abf6$export$cae95f51fff0a0c5(game, resources) {
    const distance = (0, $4ce98914b6676340$exports).distance(game.currentSystem.galacticPosition, game.player.selectedSystem.galacticPosition);
    game.player.fuel = Math.max(0, game.player.fuel - Math.floor(distance * 10));
    game.hyperspace = null;
    game.currentSystem = game.player.selectedSystem;
    game.localBubble.ships = [];
    game.localBubble.station = null;
    $cb9a6519a824abf6$var$positionPlayerAwayFromPlanet(game);
    $cb9a6519a824abf6$var$positionSun(game);
    $cb9a6519a824abf6$var$spawnStationInOrbit(game, resources);
    game.marketItems = (0, $df1a71e231df3d97$export$7d1098b46d65e487)(game.currentSystem);
}
// TODO: come back to the below when fresher, I've a horrible feeling its nonsense
function $cb9a6519a824abf6$var$positionPlayerAwayFromPlanet(game) {
    const planet = game.localBubble.planet;
    planet.radius = game.currentSystem.averageRadius;
    // create a random directional vector for the planet then move it to a random distance suitable for hyperspace
    // exit along that vector
    // we place the planet roughly in front of the player
    const planetDirectionVector = (0, $ab7f6dc0910e1ef7$exports).normalize((0, $ab7f6dc0910e1ef7$exports).create(), [
        Math.random() * 2 - 1,
        Math.random() * 2 - 1,
        Math.random() - 1
    ]);
    const approximateDistance = (0, $9ecda7333d28e490$export$f4fcb3cca4d405d6) / (Math.random() * 192 + 96);
    const planetPosition = (0, $ab7f6dc0910e1ef7$exports).multiply((0, $ab7f6dc0910e1ef7$exports).create(), planetDirectionVector, [
        approximateDistance,
        approximateDistance,
        approximateDistance
    ]);
    // orient it to the player
    const planetNoseOrientation = (0, $ab7f6dc0910e1ef7$exports).multiply((0, $ab7f6dc0910e1ef7$exports).create(), planetDirectionVector, [
        -1,
        -1,
        -1
    ]);
    const planetRoofOrientation = (0, $ab7f6dc0910e1ef7$exports).rotateX((0, $ab7f6dc0910e1ef7$exports).create(), planetNoseOrientation, [
        0,
        0,
        0
    ], 90 * Math.PI / 180);
    const planetRightOrientation = (0, $ab7f6dc0910e1ef7$exports).rotateY((0, $ab7f6dc0910e1ef7$exports).create(), planetNoseOrientation, [
        0,
        0,
        0
    ], 90 * Math.PI / 180);
    planet.position = planetPosition;
    planet.noseOrientation = planetNoseOrientation;
    planet.roofOrientation = planetRoofOrientation;
    planet.rightOrientation = planetRightOrientation;
    planet.pitch = 0.01;
    planet.roll = 0.02;
    planet.surfaceTextureIndex = game.currentSystem.surfaceTextureIndex;
}
function $cb9a6519a824abf6$var$spawnStationInOrbit(game, resources) {
    const distance = (0, $7f388262d447fe43$export$370625d67a2003b1)(game);
    // 1. Position the station a random direction away from the planet but on the player side of the planet
    const randomDirection = (0, $ab7f6dc0910e1ef7$exports).normalize((0, $ab7f6dc0910e1ef7$exports).create(), (0, $ab7f6dc0910e1ef7$exports).fromValues(Math.random() * 2 - 1, Math.random() * 2 - 1, -Math.random()));
    const translation = (0, $ab7f6dc0910e1ef7$exports).multiply((0, $ab7f6dc0910e1ef7$exports).create(), randomDirection, [
        distance,
        distance,
        distance
    ]);
    const position = (0, $ab7f6dc0910e1ef7$exports).add((0, $ab7f6dc0910e1ef7$exports).create(), game.localBubble.planet.position, translation);
    const station = resources.ships.getCoriolis([
        0,
        0,
        0
    ], [
        0,
        0,
        -1
    ]);
    station.position = position;
    station.roll = (0, $7f388262d447fe43$export$f994db713d41a0b0)(game.player);
    // 2. Orient the station so that the gate is facing the planet
    station.noseOrientation = (0, $ab7f6dc0910e1ef7$exports).multiply((0, $ab7f6dc0910e1ef7$exports).create(), randomDirection, [
        -1,
        -1,
        -1
    ]);
    station.roofOrientation = (0, $ab7f6dc0910e1ef7$exports).rotateX((0, $ab7f6dc0910e1ef7$exports).create(), station.noseOrientation, [
        0,
        0,
        0
    ], (0, $7f388262d447fe43$export$c9fcf1a7df975d78)(-90));
    station.rightOrientation = (0, $ab7f6dc0910e1ef7$exports).rotateY((0, $ab7f6dc0910e1ef7$exports).create(), station.noseOrientation, [
        0,
        0,
        0
    ], (0, $7f388262d447fe43$export$c9fcf1a7df975d78)(90));
    game.localBubble.ships.push(station);
    game.localBubble.station = station;
}
function $cb9a6519a824abf6$var$positionSun(game) {
    const sun = game.localBubble.sun;
    // roughly behind the player
    sun.position = (0, $ab7f6dc0910e1ef7$exports).fromValues(0, 0, (0, $9ecda7333d28e490$export$f4fcb3cca4d405d6) + 1000);
    sun.noseOrientation = (0, $ab7f6dc0910e1ef7$exports).fromValues(0, 0, 1);
    sun.roofOrientation = (0, $ab7f6dc0910e1ef7$exports).fromValues(0, 1, 0);
    sun.rightOrientation = (0, $ab7f6dc0910e1ef7$exports).fromValues(1, 0, 0);
    const randomPitch = Math.random() * (45 * (Math.PI / 180));
    const randomRoll = Math.random() * (45 * (Math.PI / 180));
    (0, $7f388262d447fe43$export$b0c15eba69b661a3)(sun, randomRoll, randomPitch);
    (0, $7f388262d447fe43$export$ba956a95b4dd3faa)(sun, randomRoll, randomPitch);
    game.localBubble.sun.initialOrientation = (0, $ab7f6dc0910e1ef7$exports).normalize((0, $ab7f6dc0910e1ef7$exports).create(), (0, $ab7f6dc0910e1ef7$exports).subtract((0, $ab7f6dc0910e1ef7$exports).create(), game.localBubble.planet.position, game.localBubble.sun.position));
}


function $2ea19b29885aa7a7$export$f17cd0049afe59ef(game, resources, onComplete) {
    let now = 0;
    let rotationTime = 0;
    let outboundMultiplier = 1;
    let inboundOffset = 0;
    const offsets = [
        1 / 32.0,
        0.0625,
        0.125,
        0.25,
        0.5,
        1,
        1.5
    ];
    // A bit rough and ready but an approximation of the launch tunnel from the original
    return function updateHyperspace(deltaTime) {
        if (game.hyperspace === null) return;
        //if (now === 0) {
        //    game.hyperspace.outboundRadii = [...offsets].sort((a:number,b:number) => b-a)
        //}
        now += deltaTime;
        rotationTime += deltaTime;
        if (rotationTime > 0.1) {
            rotationTime = 0;
            game.hyperspace.rotation++;
        }
        if (outboundMultiplier < 8) {
            if (now > 0.1) {
                for(let index = 1; index < offsets.length; index++){
                    const delta = (offsets[index] - offsets[index - 1]) / 8.0 * outboundMultiplier;
                    game.hyperspace.outboundRadii.push(offsets[index - 1] + delta);
                }
                now = 0;
                outboundMultiplier++;
                game.hyperspace.outboundRadii = game.hyperspace.outboundRadii.sort((a, b)=>b - a);
            }
        } else if (outboundMultiplier === 8) {
            if (now > 0.1) {
                now = 0;
                if (inboundOffset < offsets.length - 1) {
                    game.hyperspace.inboundRadii.push(offsets[inboundOffset]);
                    inboundOffset++;
                } else {
                    // we've finished launching so update the local bubble and set the scene to the front view
                    (0, $cb9a6519a824abf6$export$cae95f51fff0a0c5)(game, resources);
                    game.currentScene = (0, $bd101182371a0deb$export$64585a4aa6616f30).Front;
                    onComplete();
                }
            }
        }
    };
}



function $5bb8629b8b1b5839$export$d1b7f95f9a71e040(game, resources, onDocked) {
    let now = 0;
    let outboundMultiplier = 1;
    let inboundOffset = 0;
    const offsets = [
        1 / 32.0,
        0.0625,
        0.125,
        0.25,
        0.5,
        1
    ].reverse();
    game.launching = null;
    game.player.dockingComputerFlightExecuter = null;
    // A bit rough and ready but an approximation of the launch tunnel from the original
    return function updateDocking(deltaTime) {
        if (game.launching === null) game.launching = {
            inboundRadii: [],
            outboundRadii: [
                ...offsets
            ].sort((a, b)=>b - a)
        };
        now += deltaTime;
        if (outboundMultiplier < 8) {
            if (now > 0.1) {
                for(let index = 1; index < offsets.length; index++){
                    const delta = (offsets[index] - offsets[index - 1]) / 8.0 * outboundMultiplier;
                    game.launching.outboundRadii.push(offsets[index - 1] + delta);
                }
                now = 0;
                outboundMultiplier++;
                game.launching.outboundRadii = game.launching.outboundRadii.sort((a, b)=>b - a);
            }
        } else if (outboundMultiplier === 8) {
            if (now > 0.1) {
                now = 0;
                if (inboundOffset < offsets.length - 1) {
                    game.launching.inboundRadii.push(offsets[inboundOffset]);
                    inboundOffset++;
                } else {
                    (0, $7e36221daabf296b$export$ca2420a423e4a650)(game);
                    onDocked();
                }
            }
        }
    };
}




function $c38ef676b8d5429a$var$applySceneSelection(game) {
    if (game.player.controlState.sceneSelection === null) return;
    if (game.player.isDocked) // scenes are slightly different when docked
    switch(game.player.controlState.sceneSelection){
        case 1:
            game.currentScene = (0, $bd101182371a0deb$export$64585a4aa6616f30).Launching;
            break;
        case 2:
            game.currentScene = (0, $bd101182371a0deb$export$64585a4aa6616f30).BuyMarketItems;
            break;
        case 3:
            game.currentScene = (0, $bd101182371a0deb$export$64585a4aa6616f30).BuyEquipment;
            break;
        case 5:
            game.currentScene = (0, $bd101182371a0deb$export$64585a4aa6616f30).LongRangeMap;
            break;
        case 6:
            game.currentScene = (0, $bd101182371a0deb$export$64585a4aa6616f30).LocalMap;
            break;
        case 7:
            game.currentScene = (0, $bd101182371a0deb$export$64585a4aa6616f30).SystemDetails;
            break;
        case 8:
            game.currentScene = (0, $bd101182371a0deb$export$64585a4aa6616f30).PriceList;
            break;
        case 9:
            game.currentScene = (0, $bd101182371a0deb$export$64585a4aa6616f30).PlayerDetails;
            break;
        case 0:
            game.currentScene = (0, $bd101182371a0deb$export$64585a4aa6616f30).Inventory;
            break;
    }
    else switch(game.player.controlState.sceneSelection){
        case 1:
            game.currentScene = (0, $bd101182371a0deb$export$64585a4aa6616f30).Front;
            break;
        case 5:
            game.currentScene = (0, $bd101182371a0deb$export$64585a4aa6616f30).LongRangeMap;
            break;
        case 6:
            game.currentScene = (0, $bd101182371a0deb$export$64585a4aa6616f30).LocalMap;
            break;
        case 7:
            game.currentScene = (0, $bd101182371a0deb$export$64585a4aa6616f30).SystemDetails;
            break;
        case 8:
            game.currentScene = (0, $bd101182371a0deb$export$64585a4aa6616f30).PriceList;
            break;
        case 9:
            game.currentScene = (0, $bd101182371a0deb$export$64585a4aa6616f30).PlayerDetails;
            break;
        case 0:
            game.currentScene = (0, $bd101182371a0deb$export$64585a4aa6616f30).Inventory;
            break;
    }
    game.player.controlState.sceneSelection = null;
}
function $c38ef676b8d5429a$var$applyHyperspaceCountdown(game, hyperspaceClock, deltaTime) {
    if (hyperspaceClock === null && game.hyperspace !== null) hyperspaceClock = 0;
    else if (hyperspaceClock !== null) {
        if (hyperspaceClock > 0.1 && game.hyperspace !== null) {
            game.hyperspace.countdown--;
            if (game.hyperspace.countdown === 0) game.currentScene = (0, $bd101182371a0deb$export$64585a4aa6616f30).Hyperspace;
            else hyperspaceClock = 0;
        } else hyperspaceClock += deltaTime;
    }
    return hyperspaceClock;
}
function $c38ef676b8d5429a$var$shouldRunFlightLoop(game) {
    return !game.player.isDocked && game.currentScene != (0, $bd101182371a0deb$export$64585a4aa6616f30).Hyperspace && game.currentScene != (0, $bd101182371a0deb$export$64585a4aa6616f30).Launching && game.currentScene != (0, $bd101182371a0deb$export$64585a4aa6616f30).PlayerExploding && game.currentScene != (0, $bd101182371a0deb$export$64585a4aa6616f30).Docking;
}
function $c38ef676b8d5429a$var$getLookAt(currentScene) {
    switch(currentScene){
        case (0, $bd101182371a0deb$export$64585a4aa6616f30).Rear:
            return [
                0,
                0,
                -1
            ];
        case (0, $bd101182371a0deb$export$64585a4aa6616f30).Left:
            return [
                -1,
                0,
                0
            ];
        case (0, $bd101182371a0deb$export$64585a4aa6616f30).Right:
            return [
                1,
                0,
                0
            ];
        case (0, $bd101182371a0deb$export$64585a4aa6616f30).Front:
        default:
            return [
                0,
                0,
                1
            ];
    }
}
function $c38ef676b8d5429a$var$createApplyCameraShake() {
    let time = 0;
    const maxXDelta = 0.01;
    const maxYDelta = 0.01;
    const maxXRange = 0.1;
    const maxYRange = 0.1;
    const timeBetweenShake = 0.04;
    return function applyCameraShake(game, timeDelta) {
        if (game.player.isJumping) {
            time += timeDelta;
            if (time > timeBetweenShake) {
                time = 0;
                const xDelta = (Math.random() - 0.5) * maxXDelta;
                const yDelta = (Math.random() - 0.5) * maxYDelta;
                if (game.currentScene == (0, $bd101182371a0deb$export$64585a4aa6616f30).Front) {
                    const c = game.player.lookAt;
                    c[0] += xDelta;
                    c[1] += yDelta;
                    if (c[0] > maxXRange) c[0] = maxXRange;
                    else if (c[0] < -maxYRange) c[0] = -maxXRange;
                    if (c[1] > maxYRange) c[1] = maxYRange;
                    else if (c[1] < -maxYRange) c[1] = -maxYRange;
                    game.player.lookAt = c;
                }
            }
        } else {
            const lookAt = $c38ef676b8d5429a$var$getLookAt(game.currentScene);
            game.player.lookAt = (0, $ab7f6dc0910e1ef7$exports).fromValues(lookAt[0], lookAt[1], lookAt[2]);
        }
    };
}
function $c38ef676b8d5429a$export$a8807a6e1749a4af(resources, game, renderer) {
    let then = 0;
    let deltaTime = 0;
    let launchingLoop = null;
    let dockingLoop = null;
    let hyperspaceLoop = null;
    let hyperspaceClock = null;
    let frameRateCounter = (0, $96fe3a99b59d4e0f$export$33998d8024edc958)();
    let applyCameraShake = $c38ef676b8d5429a$var$createApplyCameraShake();
    const scene = {
        update: (now, _)=>{
            now *= 0.001 // convert to seconds
            ;
            deltaTime = now - then;
            then = now;
            game.diagnostics = [];
            hyperspaceClock = $c38ef676b8d5429a$var$applyHyperspaceCountdown(game, hyperspaceClock, deltaTime);
            $c38ef676b8d5429a$var$applySceneSelection(game);
            (0, $e8bc5ab7351ec04f$export$fd37dabcec2bc46f)(game, resources, deltaTime);
            if ($c38ef676b8d5429a$var$shouldRunFlightLoop(game)) {
                (0, $e9924a6cb48a3f06$export$fd32dc42244e67dd)(resources, game, deltaTime);
                applyCameraShake(game, deltaTime);
            }
            if (game.currentScene === (0, $bd101182371a0deb$export$64585a4aa6616f30).Launching) {
                if (launchingLoop === null) {
                    launchingLoop = (0, $a647a9549876774f$export$d5571bbd07644815)(game, resources, ()=>launchingLoop = null);
                    resources.soundEffects.launch();
                }
                launchingLoop(deltaTime);
            } else if (game.currentScene === (0, $bd101182371a0deb$export$64585a4aa6616f30).Hyperspace) {
                if (hyperspaceLoop === null) {
                    hyperspaceLoop = (0, $2ea19b29885aa7a7$export$f17cd0049afe59ef)(game, resources, ()=>hyperspaceLoop = null);
                    resources.soundEffects.hyperspace();
                }
                hyperspaceLoop(deltaTime);
            } else if (game.currentScene === (0, $bd101182371a0deb$export$64585a4aa6616f30).Docking) {
                if (dockingLoop === null) {
                    dockingLoop = (0, $5bb8629b8b1b5839$export$d1b7f95f9a71e040)(game, resources, ()=>dockingLoop = null);
                    resources.soundEffects.docked();
                }
                dockingLoop(deltaTime);
            }
            if (game.isFPSEnabled) game.diagnostics.push(`FPS: ${frameRateCounter(deltaTime)}`);
            renderer(game, deltaTime, game.renderEffect);
            game.player.previousControlState = {
                ...game.player.controlState
            };
            return null;
        }
    };
    return scene;
}









function $352e63380b440c40$var$initShaderProgram(gl, resources) {
    const shaderProgram = (0, $747b70bb26c9cf6e$export$f7c2b6763dc47773)(gl, resources.shaderSource.simpleTexture);
    if (!shaderProgram) return null;
    return {
        program: shaderProgram,
        attribLocations: {
            vertexPosition: gl.getAttribLocation(shaderProgram, "aVertexPosition"),
            textureCoords: gl.getAttribLocation(shaderProgram, "aTextureCoord")
        },
        uniformLocations: {
            projectionMatrix: gl.getUniformLocation(shaderProgram, "uProjectionMatrix"),
            modelViewMatrix: gl.getUniformLocation(shaderProgram, "uModelViewMatrix"),
            textureSampler: gl.getUniformLocation(shaderProgram, "uSampler")
        }
    };
}
function $352e63380b440c40$export$390983923daa0a07(gl, resources, projectionMatrix, scale) {
    const programInfo = $352e63380b440c40$var$initShaderProgram(gl, resources);
    const model = (0, $35806345bc1d62c5$export$fdbdb3a5cc488d7e)(gl, resources.textures.scanner, true, false, true);
    const rotate = (0, $e92e4eb8d35aaf31$exports).rotateX((0, $e92e4eb8d35aaf31$exports).create(), (0, $e92e4eb8d35aaf31$exports).create(), -90 * (Math.PI / 180));
    const position = (0, $ab7f6dc0910e1ef7$exports).fromValues(0, 0, 0);
    const modelViewMatrix = (0, $26675c4f95835ef1$exports).fromRotationTranslationScale((0, $26675c4f95835ef1$exports).create(), rotate, position, scale);
    return function() {
        gl.useProgram(programInfo.program);
        (0, $b125b9470601071f$export$f5a01205d395aca)(gl, model, programInfo);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, model.indices);
        (0, $b125b9470601071f$export$9ed6815acb35f982)(gl, programInfo, {
            projectionMatrix: projectionMatrix,
            modelViewMatrix: modelViewMatrix,
            textureIndex: 0
        }, model.texture);
        {
            const vertexCount = model.vertexCount;
            const type = gl.UNSIGNED_SHORT;
            const offset = 0;
            gl.drawElements(gl.TRIANGLES, vertexCount, type, offset);
        }
    };
}







// TODO: We need to rework this to use the shared style
const $7d498e888a28b7e9$var$vsSource = `#version 300 es
    precision highp float;
    in vec4 aVertexPosition;
    
    uniform mat4 uModelViewMatrix;
    uniform mat4 uProjectionMatrix;
    

    void main(void) {
      gl_Position = uProjectionMatrix * uModelViewMatrix * aVertexPosition;
    }
  `;
const $7d498e888a28b7e9$var$fsSource = `#version 300 es
precision highp float;

uniform vec4 uColor;

out lowp vec4 outputColor;

void main(void) {
    outputColor = uColor;
}
`;
function $7d498e888a28b7e9$var$initShaderProgram(gl) {
    const shaderProgram = (0, $747b70bb26c9cf6e$export$5f960e5136fd65f5)(gl, $7d498e888a28b7e9$var$vsSource, $7d498e888a28b7e9$var$fsSource);
    if (!shaderProgram) return null;
    return {
        program: shaderProgram,
        attribLocations: {
            vertexPosition: gl.getAttribLocation(shaderProgram, "aVertexPosition")
        },
        uniformLocations: {
            projectionMatrix: gl.getUniformLocation(shaderProgram, "uProjectionMatrix"),
            modelViewMatrix: gl.getUniformLocation(shaderProgram, "uModelViewMatrix"),
            color: gl.getUniformLocation(shaderProgram, "uColor")
        }
    };
}
function $7d498e888a28b7e9$var$setPositionAttribute(gl, buffers, programInfo) {
    const numComponents = 3 // pull out 2 values per iteration
    ;
    const type = gl.FLOAT // the data in the buffer is 32bit floats
    ;
    const normalize = false // don't normalize
    ;
    const stride = 0 // how many bytes to get from one set of values to the next
    ;
    // 0 = use type and numComponents above
    const offset = 0 // how many bytes inside the buffer to start from
    ;
    gl.bindBuffer(gl.ARRAY_BUFFER, buffers.position);
    gl.vertexAttribPointer(programInfo.attribLocations.vertexPosition, numComponents, type, normalize, stride, offset);
    gl.enableVertexAttribArray(programInfo.attribLocations.vertexPosition);
}
function $7d498e888a28b7e9$export$101d6b93d8995371(gl, projectionMatrix, scale) {
    // TODO: we need to position this on the bottom middle i.e (-1.0,2.0 to 1.0,0.0)
    const verticalLine = [
        0.5,
        0.0,
        0.0,
        1.5,
        0.0,
        0.0,
        1.5,
        1.0,
        0.0,
        0.5,
        1.0,
        0.0
    ];
    const lineCap = [
        -0.5,
        0.0,
        0.0,
        1.5,
        0.0,
        0.0,
        1.5,
        1,
        0.0,
        -0.5,
        1,
        0.0
    ];
    const verticalLineModel = (0, $35806345bc1d62c5$export$7c40b2ceeb961577)(gl, [
        0.0,
        1.0,
        0.0,
        1.0
    ], verticalLine);
    const lineCapModel = (0, $35806345bc1d62c5$export$7c40b2ceeb961577)(gl, [
        0.0,
        1.0,
        0.0,
        1.0
    ], lineCap);
    const programInfo = $7d498e888a28b7e9$var$initShaderProgram(gl);
    return function(game) {
        if (game.player.isDocked) return;
        game.localBubble.ships.forEach((ship)=>{
            const normalisedPosition = (0, $ab7f6dc0910e1ef7$exports).divide((0, $ab7f6dc0910e1ef7$exports).create(), ship.position, (0, $9ecda7333d28e490$export$10ee23b02de09a46));
            if (Math.abs(normalisedPosition[0]) > 1.0 || Math.abs(normalisedPosition[1]) > 1.0 || Math.abs(normalisedPosition[2]) > 1.0) // out of scanning range
            return;
            const scannerPosition = (0, $ab7f6dc0910e1ef7$exports).multiply((0, $ab7f6dc0910e1ef7$exports).create(), [
                normalisedPosition[0],
                0.05,
                normalisedPosition[2]
            ], scale);
            let yScale = normalisedPosition[1] * scale[1];
            const verticalLineModelViewMatrix = (0, $26675c4f95835ef1$exports).fromRotationTranslationScale((0, $26675c4f95835ef1$exports).create(), (0, $e92e4eb8d35aaf31$exports).create(), scannerPosition, [
                0.1,
                yScale,
                1.0
            ]);
            const lineCapPosition = (0, $ab7f6dc0910e1ef7$exports).add((0, $ab7f6dc0910e1ef7$exports).create(), scannerPosition, [
                0,
                yScale - 0.05,
                0
            ]);
            const lineCapModelViewMatrix = (0, $26675c4f95835ef1$exports).fromRotationTranslationScale((0, $26675c4f95835ef1$exports).create(), (0, $e92e4eb8d35aaf31$exports).create(), lineCapPosition, [
                0.1,
                0.1,
                1.0
            ]);
            gl.useProgram(programInfo.program);
            $7d498e888a28b7e9$var$setPositionAttribute(gl, verticalLineModel, programInfo);
            gl.uniformMatrix4fv(programInfo.uniformLocations.modelViewMatrix, false, verticalLineModelViewMatrix);
            gl.uniformMatrix4fv(programInfo.uniformLocations.projectionMatrix, false, projectionMatrix);
            if (ship.role === (0, $cf8fd949337d3b75$export$a3bb2a5ab3320756).Cargo || ship.role === (0, $cf8fd949337d3b75$export$a3bb2a5ab3320756).Asteroid) gl.uniform4f(programInfo.uniformLocations.color, 1.0, 0.0, 0.0, 1.0);
            else gl.uniform4f(programInfo.uniformLocations.color, 0.0, 1.0, 0.0, 1.0);
            gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, verticalLineModel.indices);
            {
                const vertexCount = verticalLineModel.vertexCount;
                const type = gl.UNSIGNED_SHORT;
                const offset = 0;
                gl.drawElements(gl.TRIANGLES, vertexCount, type, offset);
            }
            $7d498e888a28b7e9$var$setPositionAttribute(gl, lineCapModel, programInfo);
            gl.uniformMatrix4fv(programInfo.uniformLocations.modelViewMatrix, false, lineCapModelViewMatrix);
            gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, lineCapModel.indices);
            {
                const vertexCount = lineCapModel.vertexCount;
                const type = gl.UNSIGNED_SHORT;
                const offset = 0;
                gl.drawElements(gl.TRIANGLES, vertexCount, type, offset);
            }
        });
    };
}


function $3980585c82451ad4$var$setup(gl) {
    gl.clearColor(0.0, 0.0, 0.0, 1.0);
    gl.clearDepth(1.0);
    gl.enable(gl.DEPTH_TEST);
    gl.enable(gl.BLEND);
    gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
    gl.depthFunc(gl.LEQUAL);
    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
}
function $3980585c82451ad4$var$drawCompass(width, sidePanelWidth, draw2d, game) {
    const compassRadius = 33.0;
    const innerCompassRadius = compassRadius - (0, $9ecda7333d28e490$export$85309a65275dadab);
    const compassCenter = (0, $4ce98914b6676340$exports).fromValues(width - sidePanelWidth - (0, $9ecda7333d28e490$export$85309a65275dadab) - compassRadius, compassRadius);
    draw2d.rect([
        compassCenter[0] - compassRadius,
        0
    ], [
        (0, $9ecda7333d28e490$export$85309a65275dadab),
        compassRadius
    ], (0, $9ecda7333d28e490$export$c4cb53d5b465982a));
    draw2d.rect([
        compassCenter[0] - compassRadius + (0, $9ecda7333d28e490$export$85309a65275dadab),
        0
    ], [
        compassRadius * 2 - (0, $9ecda7333d28e490$export$85309a65275dadab),
        compassRadius
    ], [
        1,
        0,
        0,
        1
    ]);
    draw2d.rect(compassCenter, [
        compassRadius,
        compassRadius
    ], [
        1,
        0,
        0,
        1
    ]);
    draw2d.rect([
        compassCenter[0],
        compassRadius * 2 - (0, $9ecda7333d28e490$export$85309a65275dadab)
    ], [
        compassRadius,
        (0, $9ecda7333d28e490$export$85309a65275dadab)
    ], (0, $9ecda7333d28e490$export$c4cb53d5b465982a));
    draw2d.circle(compassCenter, compassRadius, (0, $9ecda7333d28e490$export$c4cb53d5b465982a));
    draw2d.circle(compassCenter, compassRadius - (0, $9ecda7333d28e490$export$85309a65275dadab), [
        0,
        0,
        0,
        1
    ]);
    // TODO: fish out the space station
    //const compassPointsTowards = game.player.isInSafeZone && game.localBubble.station !== null ? game.localBubble.station.position : game.localBubble.planet.position
    const compassPointsTowards = game.localBubble.station !== null ? game.localBubble.station.position : game.localBubble.planet.position;
    const directionVector = (0, $ab7f6dc0910e1ef7$exports).normalize((0, $ab7f6dc0910e1ef7$exports).create(), compassPointsTowards);
    const compassWidth = 8.0;
    const compassHeight = 6.0;
    const xPos = innerCompassRadius * directionVector[0] - compassWidth / 2;
    const yPos = (innerCompassRadius - compassHeight / 2) * directionVector[1] * -1 - compassHeight / 2;
    const compassColor = directionVector[2] < 0 ? (0, $e38eb280d3b76273$exports).fromValues(1, 1, 1, 1) : (0, $e38eb280d3b76273$exports).fromValues(0.5, 0.5, 0.5, 1);
    draw2d.rect([
        compassCenter[0] + xPos,
        compassCenter[1] + yPos
    ], [
        compassWidth,
        compassHeight
    ], compassColor);
    return compassCenter;
}
function $3980585c82451ad4$var$drawHud(draw2d, width, height, game) {
    const sidePanelWidth = width / 5.0;
    const barHeight = (height - (0, $9ecda7333d28e490$export$85309a65275dadab)) / 7;
    const barSpacing = 8;
    const leftStartBarX = sidePanelWidth / 7 * 2;
    const rightStartBarX = width - sidePanelWidth;
    const barWidth = sidePanelWidth - leftStartBarX;
    for(let barIndex = 1; barIndex <= 6; barIndex++){
        draw2d.rect([
            leftStartBarX,
            barIndex * barHeight
        ], [
            barWidth,
            3
        ], [
            0.0,
            1.0,
            0.0,
            1.0
        ]);
        draw2d.rect([
            rightStartBarX,
            barIndex * barHeight
        ], [
            barWidth,
            3
        ], [
            0.0,
            1.0,
            0.0,
            1.0
        ]);
    }
    function drawBar(isLeft, row, value, maxValue, color) {
        const unitScale = barWidth / maxValue;
        const x = isLeft ? leftStartBarX : rightStartBarX;
        const y = row * barHeight + barSpacing + 1;
        draw2d.rect([
            x,
            y
        ], [
            value * unitScale,
            barHeight - barSpacing * 2
        ], color);
    }
    function drawPositionalBar(isLeft, row, value, maxValue) {
        const barSize = 4.0;
        const unitScale = (barWidth - barSize) / 2 / maxValue;
        const x = (isLeft ? leftStartBarX : rightStartBarX) + value * unitScale + barWidth / 2 - barSize / 2;
        const y = row * barHeight + 3.0;
        draw2d.rect([
            x,
            y
        ], [
            barSize,
            barHeight - 2.0
        ], (0, $e38eb280d3b76273$exports).fromValues(1.0, 1.0, 1.0, 1.0));
    }
    function maxEnergyBankLevel(index) {
        return index === 0 ? 63 : 64;
    }
    function energyBankLevel(index) {
        const reversedIndex = 3 - index;
        const energyLevelBase = 64 * reversedIndex;
        const energyInBar = Math.max(0, Math.min(maxEnergyBankLevel(index), game.player.energyBankLevel - energyLevelBase));
        return energyInBar;
    }
    // missiles
    const missileRow = 7;
    const missileSpacing = 5;
    let missileSize = barHeight - missileSpacing * 2;
    let missileX = sidePanelWidth - missileSpacing - missileSize;
    const missileY = (missileRow - 1) * barHeight + missileSpacing + 1;
    for(let missileIndex = 0; missileIndex < game.player.missiles.currentNumber; missileIndex++){
        const missileColor = (0, $e38eb280d3b76273$exports).fromValues(0.0, 1.0, 0.0, 1.0);
        draw2d.rect([
            missileX,
            missileY
        ], [
            missileSize,
            missileSize
        ], missileColor);
        missileX -= missileSpacing + missileSize;
    }
    const ch = barHeight - 6;
    const cw = ch / 1.2;
    const tl = (0, $9ecda7333d28e490$export$85309a65275dadab) * 2;
    const tr = rightStartBarX + barWidth + 3;
    const topOffset = 4;
    const standardBarColor = (0, $e38eb280d3b76273$exports).fromValues(1.0, 0.0, 1.0, 1.0);
    drawBar(true, 0, game.player.forwardShield, game.player.blueprint.maxForwardShield, standardBarColor);
    draw2d.text.drawAtSize("FS", [
        tl,
        topOffset
    ], cw, ch, 0, (0, $e38eb280d3b76273$exports).fromValues(0.0, 1.0, 1.0, 1.0));
    drawBar(true, 1, game.player.aftShield, game.player.blueprint.maxAftShield, standardBarColor);
    draw2d.text.drawAtSize("AS", [
        tl,
        topOffset + barHeight
    ], cw, ch, 0, (0, $e38eb280d3b76273$exports).fromValues(0.0, 1.0, 1.0, 1.0));
    drawBar(true, 2, game.player.fuel, game.player.blueprint.maxFuel, (0, $e38eb280d3b76273$exports).fromValues(1.0, 1.0, 0.0, 1.0));
    draw2d.text.drawAtSize("FV", [
        tl,
        topOffset + barHeight * 2
    ], cw, ch, 0, (0, $e38eb280d3b76273$exports).fromValues(0.0, 1.0, 1.0, 1.0));
    drawBar(true, 3, game.player.cabinTemperature, game.player.blueprint.maxCabinTemperature, game.player.cabinTemperature / game.player.blueprint.maxCabinTemperature > 0.8 ? (0, $e38eb280d3b76273$exports).fromValues(1, 0, 0, 1) : (0, $e38eb280d3b76273$exports).fromValues(1, 1, 1, 1));
    draw2d.text.drawAtSize("CT", [
        tl,
        topOffset + barHeight * 3
    ], cw, ch, 0, standardBarColor);
    drawBar(true, 4, game.player.laserTemperature, game.player.blueprint.maxLaserTemperature, game.player.laserTemperature / game.player.blueprint.maxLaserTemperature > 0.8 ? (0, $e38eb280d3b76273$exports).fromValues(1, 0, 0, 1) : (0, $e38eb280d3b76273$exports).fromValues(1, 1, 1, 1));
    draw2d.text.drawAtSize("LT", [
        tl,
        topOffset + barHeight * 4
    ], cw, ch, 0, standardBarColor);
    drawBar(true, 5, game.player.altitude, game.player.blueprint.maxAltitude, (0, $e38eb280d3b76273$exports).fromValues(1.0, 1.0, 0.0, 1.0));
    draw2d.text.drawAtSize("AL", [
        tl,
        topOffset + barHeight * 5
    ], cw, ch, 0, standardBarColor);
    drawBar(false, 0, game.player.speed, game.player.blueprint.maxSpeed, game.player.speed / game.player.blueprint.maxSpeed > 0.8 ? (0, $e38eb280d3b76273$exports).fromValues(1, 0, 0, 1) : (0, $e38eb280d3b76273$exports).fromValues(1, 1, 1, 1));
    draw2d.text.drawAtSize("SP", [
        tr,
        topOffset
    ], cw, ch, 0, (0, $e38eb280d3b76273$exports).fromValues(0.0, 1.0, 1.0, 1.0));
    drawPositionalBar(false, 1, game.player.roll, game.player.blueprint.maxRollSpeed);
    draw2d.text.drawAtSize("RL", [
        tr,
        topOffset + barHeight
    ], cw, ch, 0, (0, $e38eb280d3b76273$exports).fromValues(0.0, 1.0, 1.0, 1.0));
    drawPositionalBar(false, 2, -game.player.pitch, game.player.blueprint.maxPitchSpeed);
    draw2d.text.drawAtSize("DC", [
        tr,
        topOffset + barHeight * 2
    ], cw, ch, 0, (0, $e38eb280d3b76273$exports).fromValues(0.0, 1.0, 1.0, 1.0));
    drawBar(false, 3, energyBankLevel(0), maxEnergyBankLevel(0), standardBarColor);
    draw2d.text.drawAtSize("1", [
        tr + cw / 2,
        topOffset + barHeight * 3
    ], cw, ch, 0, standardBarColor);
    drawBar(false, 4, energyBankLevel(1), maxEnergyBankLevel(1), standardBarColor);
    draw2d.text.drawAtSize("2", [
        tr + cw / 2,
        topOffset + barHeight * 4
    ], cw, ch, 0, standardBarColor);
    drawBar(false, 5, energyBankLevel(2), maxEnergyBankLevel(2), standardBarColor);
    draw2d.text.drawAtSize("3", [
        tr + cw / 2,
        topOffset + barHeight * 5
    ], cw, ch, 0, standardBarColor);
    drawBar(false, 6, energyBankLevel(3), maxEnergyBankLevel(3), standardBarColor);
    draw2d.text.drawAtSize("4", [
        tr + cw / 2,
        topOffset + barHeight * 6
    ], cw, ch, 0, standardBarColor);
    const compassCenter = $3980585c82451ad4$var$drawCompass(width, sidePanelWidth, draw2d, game);
    if (game.player.isInSafeZone && !game.player.isDocked) {
        const safeZoneW = 30;
        const safeZoneH = 30;
        const safeZone = (0, $4ce98914b6676340$exports).fromValues(compassCenter[0] - safeZoneW / 2 + 2, //rightStartBarX - safeZoneW - safeZoneW/2,
        draw2d.size().height - safeZoneH * 1.5);
        draw2d.text.drawAtSize("S", safeZone, safeZoneW, safeZoneH, 0, [
            1,
            1,
            1,
            1
        ]);
    }
}
function $3980585c82451ad4$var$drawFrame(draw2d, width, height) {
    draw2d.rect([
        0,
        0
    ], [
        (0, $9ecda7333d28e490$export$85309a65275dadab),
        height
    ], (0, $9ecda7333d28e490$export$c4cb53d5b465982a));
    draw2d.rect([
        0,
        height - (0, $9ecda7333d28e490$export$85309a65275dadab)
    ], [
        width,
        height - (0, $9ecda7333d28e490$export$85309a65275dadab)
    ], (0, $9ecda7333d28e490$export$c4cb53d5b465982a));
    draw2d.rect([
        width - (0, $9ecda7333d28e490$export$85309a65275dadab),
        0
    ], [
        (0, $9ecda7333d28e490$export$85309a65275dadab),
        height
    ], (0, $9ecda7333d28e490$export$c4cb53d5b465982a));
    draw2d.rect([
        width / 5,
        0
    ], [
        (0, $9ecda7333d28e490$export$85309a65275dadab),
        height
    ], (0, $9ecda7333d28e490$export$c4cb53d5b465982a));
    draw2d.rect([
        width - width / 5 - (0, $9ecda7333d28e490$export$85309a65275dadab),
        0
    ], [
        (0, $9ecda7333d28e490$export$85309a65275dadab),
        height
    ], (0, $9ecda7333d28e490$export$c4cb53d5b465982a));
}
function $3980585c82451ad4$export$afa2fb5336f66138(gl, resources, width, height) {
    // this is the co-ordinate space for the scanner, the model for the scanner is 2 units wide and deep
    // (its a square -1,-1,0 at the top left, 1,1,0 at the bottom right)
    const scannerScale = (0, $ab7f6dc0910e1ef7$exports).fromValues(2.7, 1, 1);
    const fieldOfView = 45 * Math.PI / 180 // in radians
    ;
    const aspect = width / height;
    const zNear = 0.1;
    const zFar = 512.0;
    const perspectiveMatrix = (0, $26675c4f95835ef1$exports).create();
    (0, $26675c4f95835ef1$exports).perspective(perspectiveMatrix, fieldOfView, aspect, zNear, zFar);
    const eye = (0, $ab7f6dc0910e1ef7$exports).fromValues(0, 2, 2.2);
    const center = (0, $ab7f6dc0910e1ef7$exports).fromValues(0, 0, 0);
    const up = (0, $ab7f6dc0910e1ef7$exports).fromValues(0, 1, 0);
    const cameraMatrix = (0, $26675c4f95835ef1$exports).lookAt((0, $26675c4f95835ef1$exports).create(), eye, center, up);
    const projectionMatrix = (0, $26675c4f95835ef1$exports).create();
    (0, $26675c4f95835ef1$exports).multiply(projectionMatrix, cameraMatrix, projectionMatrix);
    (0, $26675c4f95835ef1$exports).multiply(projectionMatrix, perspectiveMatrix, projectionMatrix);
    const draw2d = (0, $45ed6fb76a623699$export$6bf5cf98c33b0c4b)(gl, true, resources, width, height);
    const scannerBackgroundRenderer = (0, $352e63380b440c40$export$390983923daa0a07)(gl, resources, projectionMatrix, scannerScale);
    const scannerShipRenderer = (0, $7d498e888a28b7e9$export$101d6b93d8995371)(gl, projectionMatrix, scannerScale);
    return (game, _)=>{
        gl.disable(gl.DEPTH_TEST);
        scannerBackgroundRenderer();
        scannerShipRenderer(game);
        $3980585c82451ad4$var$drawFrame(draw2d, width, height);
        $3980585c82451ad4$var$drawHud(draw2d, width, height, game);
    };
}






function $b1f5dc8e9ea362b8$export$10a20274f2224dff(controlState) {
    const mouseMove = (e)=>controlState.mousePosition = (0, $4ce98914b6676340$exports).fromValues(e.x, e.y);
    const mouseDown = ()=>controlState.mouseDown = true;
    const mouseUp = ()=>controlState.mouseDown = false;
    window.addEventListener("mousemove", mouseMove);
    window.addEventListener("mousedown", mouseDown);
    window.addEventListener("mouseup", mouseUp);
    return ()=>{
        window.removeEventListener("mousedown", mouseDown);
        window.removeEventListener("mouseup", mouseUp);
        window.removeEventListener("mousemove", mouseMove);
    };
}




function $3a67941509983683$export$b5ae43e0dad5dc51(resources, gl, renderEffect) {
    //const clipSpaceRadius = 2048
    const clipSpaceRadius = (0, $9ecda7333d28e490$export$f4fcb3cca4d405d6);
    // TODO: The ship models are currently pointing the wrong way round, wwe need to rotate them around Y 180 degrees
    // when we load them!
    const ships = [];
    // NOTE: the plan for positioning the sun and planet is that they are opposite each other so we create them
    // simply axis aligned as below and then just randomise the nose orientation of the player (rotating the world
    // around).
    const localBubble = {
        sun: {
            position: [
                0,
                0,
                clipSpaceRadius - 100
            ],
            noseOrientation: [
                0,
                0,
                -1
            ],
            initialOrientation: [
                0,
                0,
                -1
            ],
            roofOrientation: [
                0,
                1,
                0
            ],
            rightOrientation: [
                1,
                0,
                0
            ],
            color: [
                1.0,
                0.0,
                0.0
            ],
            radius: 1300000,
            pitch: 0.0,
            roll: 0.0,
            surfaceTextureIndex: 0,
            model: (0, $35806345bc1d62c5$export$fdbdb3a5cc488d7e)(gl, resources.textures.starmask),
            fixedDirectionOfMovement: null,
            boundingBox: []
        },
        planet: {
            position: [
                0,
                0,
                -clipSpaceRadius / 2
            ],
            noseOrientation: [
                0,
                0,
                1
            ],
            initialOrientation: [
                0,
                0,
                1
            ],
            roofOrientation: [
                0,
                1,
                0
            ],
            rightOrientation: [
                -1,
                0,
                0
            ],
            color: [
                0.0,
                0.0,
                0.8
            ],
            radius: 1,
            pitch: 0.0,
            roll: 0.0,
            surfaceTextureIndex: 0,
            model: (0, $35806345bc1d62c5$export$7c40b2ceeb961577)(gl, [
                0.0,
                0.0,
                0.8,
                1.0
            ]),
            fixedDirectionOfMovement: null,
            boundingBox: []
        },
        clipSpaceRadius: clipSpaceRadius,
        ships: ships,
        explosions: [],
        station: null,
        stardust: (0, $30ca83481a6c4629$export$d5cb0c6f4618347b)(),
        sunPlanetLightingDirection: [
            0,
            0,
            0
        ]
    };
    localBubble.sunPlanetLightingDirection = (0, $ab7f6dc0910e1ef7$exports).normalize((0, $ab7f6dc0910e1ef7$exports).create(), (0, $ab7f6dc0910e1ef7$exports).subtract((0, $ab7f6dc0910e1ef7$exports).create(), localBubble.sun.position, localBubble.planet.position));
    const stars = (0, $63a19d81de8b1ecf$export$63d40191cbb22c8e)(0, resources.textures.planets.length);
    const startingSystem = stars.find((s)=>s.name === "Lave");
    const game = {
        disableSpawning: false,
        player: (0, $eb309e06665aa479$export$e7386f8c4707b944)(resources, startingSystem),
        stars: stars,
        localBubble: localBubble,
        currentScene: (0, $bd101182371a0deb$export$64585a4aa6616f30).PlayerDetails,
        launching: null,
        hyperspace: null,
        currentSystem: startingSystem,
        marketItems: (0, $df1a71e231df3d97$export$7d1098b46d65e487)(startingSystem),
        diagnostics: [],
        renderEffect: renderEffect,
        isFPSEnabled: false,
        timeUntilNextSpawnChance: (0, $96fe3a99b59d4e0f$export$6262649942ae2f7)(),
        extraVesselsSpawningDelay: 0
    };
    game.player.cargoHoldContents = game.marketItems.map(()=>0);
    (0, $42e66745a803db06$export$6ff9e6a1f2205960)(game.player.controlState);
    (0, $b1f5dc8e9ea362b8$export$10a20274f2224dff)(game.player.controlState);
    const sceneRenderer = (0, $7e5deaabc493d9b4$export$e2220727691e9940)(gl, resources);
    const dashboardRenderer = (0, $3980585c82451ad4$export$afa2fb5336f66138)(gl, resources, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).width, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).dashboardHeight);
    const rootRenderer = (0, $4201279bb1ce70f6$export$230dc02396b6bf57)(gl, resources, sceneRenderer, dashboardRenderer);
    return (0, $c38ef676b8d5429a$export$a8807a6e1749a4af)(resources, game, rootRenderer);
}











function $6d4365015ed4a8c1$export$86cc99eb9511c343(gl, resources) {
    const shipRenderer = (0, $f835bf63f0b03176$export$c2263a4c08d27cb1)(gl, resources, true);
    const draw2d = (0, $45ed6fb76a623699$export$6bf5cf98c33b0c4b)(gl, false, resources, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).width, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).mainViewHeight);
    return (game, timeDelta)=>{
        const projectionMatrix = (0, $5c04dc271aaba117$export$3fb2efb4293ebbde)((0, $9ecda7333d28e490$export$62ad7b0c781000e9).width, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).mainViewHeight, game.localBubble.clipSpaceRadius);
        (0, $5c04dc271aaba117$export$441ba46c5fcd50d9)(gl);
        gl.enable(gl.DEPTH_TEST);
        shipRenderer(projectionMatrix, game.localBubble);
        gl.disable(gl.DEPTH_TEST);
        (0, $5c04dc271aaba117$export$5e145c486af18f03)(draw2d);
        draw2d.text.draw("---- webGLite ----", [
            10,
            1
        ]);
        draw2d.text.draw("based on Elite", [
            12,
            2.5
        ]);
        draw2d.text.draw("by Ian Bell and David Braben", [
            4.5,
            4
        ]);
        draw2d.text.draw("Press Space Or Fire, Commander", [
            3.5,
            21
        ]);
    };
}










const $9ce04bb90bffbd17$var$startingZ = -(0, $9ecda7333d28e490$export$10ee23b02de09a46)[2];
const $9ce04bb90bffbd17$var$targetZ = -(0, $9ecda7333d28e490$export$10ee23b02de09a46)[2] / 24.0;
function $9ce04bb90bffbd17$export$c296e03a32415357(resources, gl) {
    const clipSpaceRadius = Math.abs($9ce04bb90bffbd17$var$startingZ);
    const startingShip = 0;
    // TODO: The ship models are currently pointing the wrong way round, wwe need to rotate them around Y 180 degrees
    // when we load them!
    const ships = [
        //resources.ships.getCobraMk3(vec3.fromValues(0, 0.0, -scannerRadialWorldRange[2] / 24.0), vec3.fromValues(0.0, 0.0, -1.0))
        resources.ships.getIndexedShip(startingShip, (0, $ab7f6dc0910e1ef7$exports).fromValues(0, 0.0, $9ce04bb90bffbd17$var$startingZ), (0, $ab7f6dc0910e1ef7$exports).fromValues(0.0, 0.0, -1))
    ];
    ships[0].roll = ships[0].blueprint.maxRollSpeed;
    ships[0].pitch = ships[0].blueprint.maxPitchSpeed * 2;
    const localBubble = {
        sun: {
            position: [
                0,
                0,
                clipSpaceRadius - 1
            ],
            noseOrientation: [
                0,
                0,
                -1
            ],
            initialOrientation: [
                0,
                0,
                -1
            ],
            roofOrientation: [
                0,
                1,
                0
            ],
            rightOrientation: [
                1,
                0,
                0
            ],
            color: [
                1.0,
                0.0,
                0.0
            ],
            radius: 1300000,
            pitch: 0.0,
            roll: 0.0,
            surfaceTextureIndex: 0,
            model: (0, $35806345bc1d62c5$export$fdbdb3a5cc488d7e)(gl, resources.textures.starmask),
            fixedDirectionOfMovement: null,
            boundingBox: []
        },
        planet: {
            position: [
                0,
                0,
                -clipSpaceRadius / 2
            ],
            noseOrientation: [
                0,
                0,
                1
            ],
            initialOrientation: [
                0,
                0,
                1
            ],
            roofOrientation: [
                0,
                1,
                0
            ],
            rightOrientation: [
                -1,
                0,
                0
            ],
            color: [
                0.0,
                0.0,
                0.8
            ],
            radius: 1,
            pitch: 0.0,
            roll: 0.0,
            surfaceTextureIndex: 0,
            model: (0, $35806345bc1d62c5$export$7c40b2ceeb961577)(gl, [
                0.0,
                0.0,
                0.8,
                1.0
            ]),
            fixedDirectionOfMovement: null,
            boundingBox: []
        },
        clipSpaceRadius: clipSpaceRadius,
        ships: ships,
        explosions: [],
        station: null,
        stardust: (0, $30ca83481a6c4629$export$d5cb0c6f4618347b)(),
        sunPlanetLightingDirection: [
            0,
            0,
            0
        ]
    };
    const stars = (0, $63a19d81de8b1ecf$export$63d40191cbb22c8e)(0, resources.textures.planets.length);
    const startingSystem = stars.find((s)=>s.name === "Lave");
    const game = {
        disableSpawning: true,
        player: (0, $eb309e06665aa479$export$e7386f8c4707b944)(resources, startingSystem),
        stars: stars,
        localBubble: localBubble,
        currentScene: (0, $bd101182371a0deb$export$64585a4aa6616f30).Front,
        launching: null,
        hyperspace: null,
        currentSystem: startingSystem,
        marketItems: (0, $df1a71e231df3d97$export$7d1098b46d65e487)(startingSystem),
        diagnostics: [],
        renderEffect: (0, $4201279bb1ce70f6$export$266137087bc184a6).None,
        isFPSEnabled: false,
        timeUntilNextSpawnChance: 0,
        extraVesselsSpawningDelay: 0
    };
    const sceneRenderer = (0, $6d4365015ed4a8c1$export$86cc99eb9511c343)(gl, resources);
    const dashboardRenderer = (0, $3980585c82451ad4$export$afa2fb5336f66138)(gl, resources, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).width, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).dashboardHeight);
    const rootRenderer = (0, $4201279bb1ce70f6$export$230dc02396b6bf57)(gl, resources, sceneRenderer, dashboardRenderer);
    return $9ce04bb90bffbd17$var$createPregameLoop(game, gl, resources, rootRenderer);
}
function $9ce04bb90bffbd17$var$createPregameLoop(game, gl, resources, renderer) {
    const timeToStay = 6.0;
    let then = 0;
    let deltaTime = 0;
    let isMovingIn = true;
    let isMovingOut = false;
    let timeSinceMovedIn = 0;
    let currentShipIndex = 0;
    let speed = $9ce04bb90bffbd17$var$startingZ / 1.5;
    let startGame = false;
    function createShip() {
        game.localBubble.ships[0] = resources.ships.getIndexedShip(currentShipIndex, (0, $ab7f6dc0910e1ef7$exports).fromValues(0, 0.0, $9ce04bb90bffbd17$var$startingZ), (0, $ab7f6dc0910e1ef7$exports).fromValues(0.0, 0.0, -1));
        game.localBubble.ships[0].roll = game.localBubble.ships[0].blueprint.maxRollSpeed;
        game.localBubble.ships[0].pitch = -game.localBubble.ships[0].blueprint.maxPitchSpeed * 2;
    }
    function nextShip() {
        currentShipIndex++;
        if (currentShipIndex >= resources.ships.numberOfShips) currentShipIndex = 0;
        createShip();
    }
    function previousShip() {
        currentShipIndex--;
        if (currentShipIndex < 0) currentShipIndex = resources.ships.numberOfShips - 1;
        createShip();
    }
    const keyDown = (e)=>{
        const existingPosition = game.localBubble.ships[0].position;
        const existingRoll = game.localBubble.ships[0].roll;
        const existingPitch = game.localBubble.ships[0].pitch;
        if (e.key === "ArrowRight") nextShip();
        else if (e.key === "ArrowLeft") previousShip();
        else if (e.key === " ") startGame = true;
        else if (e.key === "]") game.renderEffect = (0, $4201279bb1ce70f6$export$b9078b15078e248)(game.renderEffect);
        else if (e.key === "[") game.renderEffect = (0, $4201279bb1ce70f6$export$e5234cdd7d162a18)(game.renderEffect);
        if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
            game.localBubble.ships[0].position = existingPosition;
            game.localBubble.ships[0].roll = existingRoll;
            game.localBubble.ships[0].pitch = existingPitch;
        }
    };
    window.addEventListener("keydown", keyDown);
    let isFirst = true;
    const scene = {
        update: (now, viewportExtent)=>{
            // we skip the first frame of the pregame screen as the time we will be given is based on the render time
            // and that initial number is large, if its used for the frame time then the initial ship will appear past the
            // camera
            if (!isFirst) {
                if (startGame) {
                    window.removeEventListener("keydown", keyDown);
                    return (0, $3a67941509983683$export$b5ae43e0dad5dc51)(resources, gl, game.renderEffect);
                }
                now *= 0.001 // convert to seconds
                ;
                deltaTime = now - then;
                then = now;
                (0, $df800c9583f9a815$export$d66d7ef6ea76940b)(game.localBubble.ships[0], game.player, deltaTime);
                // we can't use the ships speed to move it in as that follows the direction of the nose orientation
                if (isMovingIn) {
                    game.localBubble.ships[0].position[2] -= speed * deltaTime;
                    if (game.localBubble.ships[0].position[2] >= $9ce04bb90bffbd17$var$targetZ) {
                        isMovingIn = false;
                        timeSinceMovedIn = now;
                    }
                } else if (isMovingOut) {
                    game.localBubble.ships[0].position[2] += speed * deltaTime;
                    if (game.localBubble.ships[0].position[2] <= $9ce04bb90bffbd17$var$startingZ) {
                        nextShip();
                        isMovingIn = true;
                        isMovingOut = false;
                    }
                } else if (now > timeSinceMovedIn + timeToStay) isMovingOut = true;
                renderer(game, deltaTime, game.renderEffect);
            } else {
                resources.soundEffects.bootUp();
                then = now * 0.001;
                isFirst = false;
            }
            return null;
        }
    };
    return scene;
}



















function $577c312a7fe3efa5$export$f11e41bd49c0a144(resources, gl, ships) {
    //const clipSpaceRadius = 2048
    const clipSpaceRadius = (0, $9ecda7333d28e490$export$f4fcb3cca4d405d6);
    const localBubble = {
        sun: {
            position: [
                0,
                0,
                clipSpaceRadius - 100
            ],
            noseOrientation: [
                0,
                0,
                -1
            ],
            initialOrientation: [
                0,
                0,
                -1
            ],
            roofOrientation: [
                0,
                1,
                0
            ],
            rightOrientation: [
                1,
                0,
                0
            ],
            color: [
                1.0,
                0.0,
                0.0
            ],
            radius: 1300000,
            pitch: 0.0,
            roll: 0.0,
            surfaceTextureIndex: 0,
            model: (0, $35806345bc1d62c5$export$fdbdb3a5cc488d7e)(gl, resources.textures.starmask),
            fixedDirectionOfMovement: null,
            boundingBox: []
        },
        planet: {
            position: [
                0,
                0,
                -clipSpaceRadius / 2
            ],
            noseOrientation: [
                0,
                0,
                1
            ],
            initialOrientation: [
                0,
                0,
                1
            ],
            roofOrientation: [
                0,
                1,
                0
            ],
            rightOrientation: [
                -1,
                0,
                0
            ],
            color: [
                0.0,
                0.0,
                0.8
            ],
            radius: 1,
            pitch: 0.0,
            roll: 0.0,
            surfaceTextureIndex: 0,
            model: (0, $35806345bc1d62c5$export$7c40b2ceeb961577)(gl, [
                0.0,
                0.0,
                0.8,
                1.0
            ]),
            fixedDirectionOfMovement: null,
            boundingBox: []
        },
        clipSpaceRadius: clipSpaceRadius,
        ships: [],
        explosions: [],
        station: null,
        stardust: (0, $30ca83481a6c4629$export$d5cb0c6f4618347b)(),
        sunPlanetLightingDirection: [
            0,
            0,
            0
        ]
    };
    localBubble.sunPlanetLightingDirection = (0, $ab7f6dc0910e1ef7$exports).normalize((0, $ab7f6dc0910e1ef7$exports).create(), (0, $ab7f6dc0910e1ef7$exports).subtract((0, $ab7f6dc0910e1ef7$exports).create(), localBubble.sun.position, localBubble.planet.position));
    const stars = (0, $63a19d81de8b1ecf$export$63d40191cbb22c8e)(0, resources.textures.planets.length);
    const startingSystem = stars.find((s)=>s.name === "Lave");
    const game = {
        disableSpawning: true,
        player: (0, $eb309e06665aa479$export$e7386f8c4707b944)(resources, startingSystem),
        stars: stars,
        localBubble: localBubble,
        currentScene: (0, $bd101182371a0deb$export$64585a4aa6616f30).Front,
        launching: null,
        hyperspace: null,
        currentSystem: startingSystem,
        marketItems: (0, $df1a71e231df3d97$export$7d1098b46d65e487)(startingSystem),
        diagnostics: [],
        renderEffect: (0, $4201279bb1ce70f6$export$266137087bc184a6).None,
        isFPSEnabled: false,
        timeUntilNextSpawnChance: (0, $96fe3a99b59d4e0f$export$6262649942ae2f7)(),
        extraVesselsSpawningDelay: 0
    };
    game.player.isDocked = false;
    game.player.cargoHoldContents = game.marketItems.map(()=>0);
    game.player.selectedSystem = stars.find((s)=>s.name === "Diso");
    (0, $cb9a6519a824abf6$export$cae95f51fff0a0c5)(game, resources);
    game.localBubble.ships = [
        ...game.localBubble.ships,
        ...ships
    ];
    (0, $42e66745a803db06$export$6ff9e6a1f2205960)(game.player.controlState);
    (0, $b1f5dc8e9ea362b8$export$10a20274f2224dff)(game.player.controlState);
    const sceneRenderer = (0, $7e5deaabc493d9b4$export$e2220727691e9940)(gl, resources);
    const dashboardRenderer = (0, $3980585c82451ad4$export$afa2fb5336f66138)(gl, resources, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).width, (0, $9ecda7333d28e490$export$62ad7b0c781000e9).dashboardHeight);
    const rootRenderer = (0, $4201279bb1ce70f6$export$230dc02396b6bf57)(gl, resources, sceneRenderer, dashboardRenderer);
    return (0, $c38ef676b8d5429a$export$a8807a6e1749a4af)(resources, game, rootRenderer);
}




var $8ea87c6c8079e3ba$export$6f7445b210ee7c55;
(function(StartingSceneEnum) {
    StartingSceneEnum[StartingSceneEnum["Pregame"] = 0] = "Pregame";
    StartingSceneEnum[StartingSceneEnum["Docked"] = 1] = "Docked";
    StartingSceneEnum[StartingSceneEnum["NamedScene"] = 2] = "NamedScene";
})($8ea87c6c8079e3ba$export$6f7445b210ee7c55 || ($8ea87c6c8079e3ba$export$6f7445b210ee7c55 = {}));
const $8ea87c6c8079e3ba$var$sceneMap = new Map([
    [
        "trader",
        $8ea87c6c8079e3ba$var$soloTrader
    ],
    [
        "pirate",
        $8ea87c6c8079e3ba$var$soloPirate
    ]
]);
function $8ea87c6c8079e3ba$export$fe15db9887c58f74(scene, resources, gl, namedScene) {
    switch(scene){
        case 1:
            return (0, $3a67941509983683$export$b5ae43e0dad5dc51)(resources, gl, (0, $4201279bb1ce70f6$export$266137087bc184a6).None);
        case 2:
            // eventually be good to let scenes be loaded from JSON but for now we'll just use a function map
            const ships = $8ea87c6c8079e3ba$var$sceneMap.get(namedScene ?? "trader")(resources);
            return (0, $577c312a7fe3efa5$export$f11e41bd49c0a144)(resources, gl, ships);
        case 0:
        default:
            return (0, $9ce04bb90bffbd17$export$c296e03a32415357)(resources, gl);
    }
}
function $8ea87c6c8079e3ba$var$soloTrader(resources) {
    const trader = resources.ships.getInstanceOfModel((0, $17751991aa2dcc8b$export$7d04abf91eb22fb).CobraMk3, [
        0,
        0,
        -(0, $9ecda7333d28e490$export$10ee23b02de09a46)[2] / 3
    ], [
        0,
        0,
        1
    ]);
    return [
        trader
    ];
}
function $8ea87c6c8079e3ba$var$soloPirate(resources) {
    const pirate = resources.ships.getInstanceOfModel((0, $17751991aa2dcc8b$export$7d04abf91eb22fb).Python, [
        0,
        0,
        -(0, $9ecda7333d28e490$export$10ee23b02de09a46)[2] / 4
    ], [
        0,
        0,
        1
    ]);
    pirate.role = (0, $cf8fd949337d3b75$export$a3bb2a5ab3320756).Pirate;
    pirate.aiEnabled = true;
    pirate.aggressionLevel = 28;
    pirate.attitude = (0, $cf8fd949337d3b75$export$6c83a620f27ed611).Hostile;
    //pirate.speed = pirate.blueprint.maxSpeed / 2
    return [
        pirate
    ];
}


Number.prototype.isBitSet = function(bit) {
    return (this & 1 << bit) > 0;
};
Number.prototype.getBitRange = function(startIndex, size) {
    return this >> startIndex & (1 << size) - 1;
};
Number.prototype.flipBitRange = function(startIndex, size) {
    return this >> startIndex & (1 << size) - 1 ^ (1 << size) - 1;
};
Number.prototype.setBitRange = function(startIndex, size, value) {
    const mask = (1 << size) - 1;
    return this & ~(mask << startIndex) | (value & mask) << startIndex;
};
Number.prototype.clearBitRange = function(startIndex, size) {
    const mask = (1 << size) - 1;
    return this & ~(mask << startIndex);
};
String.prototype.capitalize = function() {
    const lower = this.toLowerCase();
    return `${this.charAt(0).toUpperCase()}${lower.slice(1)}`;
};


async function $d697ff602b899504$var$mount(viewCanvas, docCanvas) {
    const gl = viewCanvas.getContext("webgl2");
    if (gl === null) {
        console.error("Your browser doesn't support WebGL");
        return;
    }
    let showHelpText = true;
    window.addEventListener("keydown", (ev)=>{
        if (ev.key.toLowerCase() === "q") showHelpText = !showHelpText;
    });
    const docGl = docCanvas.getContext("webgl2");
    const viewportExtent = {
        width: gl.canvas.width,
        height: gl.canvas.height
    };
    const resources = await (0, $899aa7500e099a06$export$d3d08d944062d7e)(gl, docGl);
    const renderInstructions = (0, $4f8706e1195729d3$export$ce9c08a154b8d529)(docGl, resources);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const isSkipStart = urlSearchParams.get("skipStart") !== null;
    const namedScene = urlSearchParams.get("namedScene");
    let scene = (0, $8ea87c6c8079e3ba$export$fe15db9887c58f74)(isSkipStart ? (0, $8ea87c6c8079e3ba$export$6f7445b210ee7c55).Docked : namedScene !== null ? (0, $8ea87c6c8079e3ba$export$6f7445b210ee7c55).NamedScene : (0, $8ea87c6c8079e3ba$export$6f7445b210ee7c55).Pregame, resources, gl, namedScene);
    /*new URLSearchParams(window.location.search).get("skipStart") !== null
    ? createGameScene(resources, gl, RenderEffect.None)
    : createPregameScene(resources, gl)*/ function render(now) {
        scene = scene.update(now, viewportExtent) ?? scene;
        requestAnimationFrame(render);
        renderInstructions(showHelpText);
    }
    requestAnimationFrame(render);
}
$d697ff602b899504$var$mount(document.getElementById("viewcanvas"), document.getElementById("doccanvas"));


//# sourceMappingURL=index.be1a6030.js.map
